import { jsx as t, jsxs as h, Fragment as D } from "react/jsx-runtime";
import me, { forwardRef as Go, createElement as vo, useState as O, useRef as se, useEffect as Q, useMemo as ae, useCallback as pe, useLayoutEffect as ln, createContext as sn, useContext as dn } from "react";
import Le from "react-dom";
import { useQueryClient as $o, useQuery as cn } from "@tanstack/react-query";
function xs(e) {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}
function Cs(e) {
  return new Date(e).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric"
  });
}
function ks(e) {
  const o = new Date(e), n = (/* @__PURE__ */ new Date()).getTime() - o.getTime(), i = Math.floor(n / (1e3 * 60 * 60 * 24));
  return i === 0 ? "Today" : i === 1 ? "Yesterday" : i < 7 ? `${i} days ago` : o.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric"
  });
}
function vs(e, o) {
  return o > 0 ? Math.round(e * 100 / o) : 0;
}
function Ss(e) {
  return e.toLowerCase().replace(/[^\w\s-]/g, "").replace(/\s+/g, "-").replace(/--+/g, "-").substring(0, 50);
}
function ws(e) {
  return {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  }[e] || 400;
}
function Bs(e, o) {
  return e.length <= o ? e : e.slice(0, o - 3) + "...";
}
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pn = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), gn = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (o, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), et = (e) => {
  const o = gn(e);
  return o.charAt(0).toUpperCase() + o.slice(1);
}, vr = (...e) => e.filter((o, r, n) => !!o && o.trim() !== "" && n.indexOf(o) === r).join(" ").trim(), mn = (e) => {
  for (const o in e)
    if (o.startsWith("aria-") || o === "role" || o === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var un = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hn = Go(
  ({
    color: e = "currentColor",
    size: o = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: i = "",
    children: s,
    iconNode: l,
    ...m
  }, p) => vo(
    "svg",
    {
      ref: p,
      ...un,
      width: o,
      height: o,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(o) : r,
      className: vr("lucide", i),
      ...!s && !mn(m) && { "aria-hidden": "true" },
      ...m
    },
    [
      ...l.map(([y, c]) => vo(y, c)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ce = (e, o) => {
  const r = Go(
    ({ className: n, ...i }, s) => vo(hn, {
      ref: s,
      iconNode: o,
      className: vr(
        `lucide-${pn(et(e))}`,
        `lucide-${e}`,
        n
      ),
      ...i
    })
  );
  return r.displayName = et(e), r;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yn = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], _e = ce("check", yn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bn = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], fn = ce("chevron-down", bn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xn = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], so = ce("chevron-right", xn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cn = [
  ["path", { d: "M21.801 10A10 10 0 1 1 17 3.335", key: "yps3ct" }],
  ["path", { d: "m9 11 3 3L22 4", key: "1pflzl" }]
], kn = ce("circle-check-big", Cn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vn = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], Sn = ce("circle-x", vn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wn = [
  ["circle", { cx: "12", cy: "12", r: "1", key: "41hilf" }],
  ["circle", { cx: "12", cy: "5", r: "1", key: "gxeob9" }],
  ["circle", { cx: "12", cy: "19", r: "1", key: "lyex9k" }]
], Bn = ce("ellipsis-vertical", wn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zn = [
  [
    "path",
    {
      d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
      key: "1nclc0"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], Fn = ce("eye", zn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const In = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], Yo = ce("info", In);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pn = [
  ["path", { d: "M12 2v4", key: "3427ic" }],
  ["path", { d: "m16.2 7.8 2.9-2.9", key: "r700ao" }],
  ["path", { d: "M18 12h4", key: "wj9ykh" }],
  ["path", { d: "m16.2 16.2 2.9 2.9", key: "1bxg5t" }],
  ["path", { d: "M12 18v4", key: "jadmvz" }],
  ["path", { d: "m4.9 19.1 2.9-2.9", key: "bwix9q" }],
  ["path", { d: "M2 12h4", key: "j09sii" }],
  ["path", { d: "m4.9 4.9 2.9 2.9", key: "giyufr" }]
], Tn = ce("loader", Pn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mn = [
  ["path", { d: "m16 17 5-5-5-5", key: "1bji2h" }],
  ["path", { d: "M21 12H9", key: "dn1m92" }],
  ["path", { d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4", key: "1uf3rs" }]
], yo = ce("log-out", Mn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const En = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], Wn = ce("maximize-2", En);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const An = [
  ["path", { d: "m14 10 7-7", key: "oa77jy" }],
  ["path", { d: "M20 10h-6V4", key: "mjg0md" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M4 14h6v6", key: "rmj7iw" }]
], Rn = ce("minimize-2", An);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Hn = [
  ["rect", { width: "20", height: "14", x: "2", y: "3", rx: "2", key: "48i651" }],
  ["line", { x1: "8", x2: "16", y1: "21", y2: "21", key: "1svkeh" }],
  ["line", { x1: "12", x2: "12", y1: "17", y2: "21", key: "vw1qmm" }]
], Sr = ce("monitor", Hn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ln = [
  [
    "path",
    {
      d: "M12 22a1 1 0 0 1 0-20 10 9 0 0 1 10 9 5 5 0 0 1-5 5h-2.25a1.75 1.75 0 0 0-1.4 2.8l.3.4a1.75 1.75 0 0 1-1.4 2.8z",
      key: "e79jfc"
    }
  ],
  ["circle", { cx: "13.5", cy: "6.5", r: ".5", fill: "currentColor", key: "1okk4w" }],
  ["circle", { cx: "17.5", cy: "10.5", r: ".5", fill: "currentColor", key: "f64h9f" }],
  ["circle", { cx: "6.5", cy: "12.5", r: ".5", fill: "currentColor", key: "qy21gx" }],
  ["circle", { cx: "8.5", cy: "7.5", r: ".5", fill: "currentColor", key: "fotxhn" }]
], ot = ce("palette", Ln);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Nn = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], wr = ce("pencil", Nn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const On = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "M12 5v14", key: "s699le" }]
], Qo = ce("plus", On);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Dn = [
  ["path", { d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8", key: "1357e3" }],
  ["path", { d: "M3 3v5h5", key: "1xhq8a" }]
], Br = ce("rotate-ccw", Dn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jn = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], co = ce("search", jn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gn = [
  [
    "path",
    {
      d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
      key: "1i5ecw"
    }
  ],
  ["circle", { cx: "12", cy: "12", r: "3", key: "1v7zrd" }]
], So = ce("settings", Gn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const $n = [
  ["rect", { width: "14", height: "20", x: "5", y: "2", rx: "2", ry: "2", key: "1yt0o3" }],
  ["path", { d: "M12 18h.01", key: "mhygvu" }]
], zr = ce("smartphone", $n);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yn = [
  ["path", { d: "M12 3v12", key: "1x0j5s" }],
  ["path", { d: "m17 8-5-5-5 5", key: "7q97r8" }],
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }]
], Fr = ce("upload", Yn);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qn = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Ae = ce("x", Qn), d = {
  // Primary colors
  primary: "#031425",
  white: "#fff",
  // Grays
  gray_light: "#e8e8ed",
  gray_medium: "#7e8fa8",
  gray_dark: "#3a3a3a",
  gray_border: "#bec7d3",
  // Blues
  blue: "#5572b7",
  blue_dark: "#181d56",
  blue_light: "#f6f8fa",
  // Greens
  green: "#71c285",
  green_light: "#9ee0d0",
  // Reds
  red: "#ff534a",
  red_light: "#ffeeed",
  // Yellows
  yellow: "#ffbd32",
  yellow_light: "#fff8ea",
  // Background colors
  bg_light: "#f7f8f9",
  bg_white: "#ffffff",
  // Glassmorphism & Modern UI
  glass_bg: "rgba(255, 255, 255, 0.85)",
  glass_bg_strong: "rgba(255, 255, 255, 0.95)",
  border_subtle: "rgba(255, 255, 255, 0.6)",
  border_glass: "rgba(0, 0, 0, 0.06)",
  shadow_soft: "rgba(0, 0, 0, 0.04)",
  shadow_medium: "rgba(0, 0, 0, 0.08)",
  overlay_light: "rgba(255, 255, 255, 0.5)"
}, Ir = () => typeof window > "u" ? !1 : window.self !== window.top, po = () => {
  var e, o;
  return typeof window > "u" ? document.body : window.self !== window.top && ((o = (e = window.parent) == null ? void 0 : e.document) != null && o.body) ? window.parent.document.body : document.body;
}, wo = () => {
  var e;
  return typeof window > "u" ? document : window.self !== window.top && ((e = window.parent) != null && e.document) ? window.parent.document : document;
}, Xn = async () => {
  if (typeof window > "u") return !0;
  try {
    const o = (await fetch(window.location.href, { method: "HEAD" })).headers.get("Content-Security-Policy");
    return !(o != null && o.includes("frame-ancestors 'none'"));
  } catch {
    return !0;
  }
}, Jn = () => {
  const [e, o] = O({ x: 0, y: 0 }), [r, n] = O(!1), i = se({ x: 0, y: 0 }), s = (l) => {
    n(!0), i.current = {
      x: l.clientX - e.x,
      y: l.clientY - e.y
    };
  };
  return Q(() => {
    const l = (p) => {
      r && o({
        x: p.clientX - i.current.x,
        y: p.clientY - i.current.y
      });
    }, m = () => {
      n(!1);
    };
    if (r) {
      const p = wo();
      return p.addEventListener("mousemove", l), p.addEventListener("mouseup", m), () => {
        p.removeEventListener("mousemove", l), p.removeEventListener("mouseup", m);
      };
    }
  }, [r]), { dragOffset: e, isDragging: r, handleMouseDown: s };
};
function tt(e, o) {
  if (!e) return !0;
  if (typeof e == "string")
    return !!o[e];
  const { field: r, value: n, operator: i } = e, s = o[r];
  return i === "includes" && n !== void 0 ? typeof s == "string" && s.includes(n) : i === "not_equals" && n !== void 0 ? s !== n : i === "equals" || n !== void 0 ? s === n : !!s;
}
const Zn = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  h6: "H6",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell",
  carousel: "Carousel",
  "Card Container": "Card Container",
  title: "Title",
  price: "Price",
  "Retailer Icons": "Retailer Icons",
  image: "Image"
};
function Pr(e) {
  return Zn[e] || e;
}
function Un(e, o) {
  const [r, n] = O("desktop"), [i, s] = O(""), [l, m] = O(null), [p, y] = O(
    /* @__PURE__ */ new Set()
  ), c = ae(
    () => e.some((I) => I.responsive),
    [e]
  ), g = ae(() => r === "mobile" && c ? e.filter((I) => I.responsive).map(
    (I) => ({
      ...I,
      key: `mobile_${I.key}`,
      label: I.label
    })
  ).filter((I) => tt(I.condition, o)) : e.filter((I) => !I.key.startsWith("mobile_")).filter((I) => tt(I.condition, o)), [e, r, c, o]), C = ae(() => {
    const I = [], S = {};
    return g.forEach((v) => {
      if (v.group)
        S[v.group] || (S[v.group] = []), S[v.group].push(v);
      else {
        const T = v.key.match(/^elementStyles\.([^.]+)\./);
        if (T) {
          const W = T[1];
          S[W] || (S[W] = []), S[W].push(v);
        } else
          I.push(v);
      }
    }), { baseFields: I, groups: S };
  }, [g]), w = ae(() => {
    const I = [];
    return I.push({
      name: "All",
      key: "__all__",
      count: g.length
    }), C.baseFields.length > 0 && I.push({
      name: "General",
      key: "__general__",
      count: C.baseFields.length
    }), Object.entries(C.groups).forEach(([S, v]) => {
      I.push({
        name: Pr(S),
        key: S,
        count: v.length
      });
    }), I;
  }, [g, C]), k = w.length > 3, x = k || g.length >= 8, f = pe(
    (I, S) => S ? I.label.toLowerCase().includes(S) || (I.group ? I.group.toLowerCase().includes(S) : !1) || I.key.toLowerCase().includes(S) : !0,
    []
  ), B = ae(() => {
    const I = i.toLowerCase().trim();
    let S = C.baseFields, v = { ...C.groups };
    if (I) {
      S = S.filter((W) => f(W, I));
      const T = {};
      Object.entries(v).forEach(([W, F]) => {
        const N = F.filter((z) => f(z, I));
        N.length > 0 && (T[W] = N);
      }), v = T;
    }
    return l && l !== "__all__" && (l === "__general__" ? v = {} : (S = [], v = v[l] ? { [l]: v[l] } : {})), { baseFields: S, groups: v };
  }, [C, i, l, f]), P = ae(() => {
    const I = i.toLowerCase().trim();
    if (!I) return null;
    const S = {};
    return S.__general__ = C.baseFields.filter(
      (v) => f(v, I)
    ).length, Object.entries(C.groups).forEach(([v, T]) => {
      S[v] = T.filter((W) => f(W, I)).length;
    }), S.__all__ = Object.values(S).reduce((v, T) => v + T, 0), S;
  }, [i, C, f]), u = B.baseFields.length + Object.values(B.groups).reduce(
    (I, S) => I + S.length,
    0
  ), R = !l || l === "__all__", b = pe((I) => {
    y((S) => {
      const v = new Set(S);
      return v.has(I) ? v.delete(I) : v.add(I), v;
    });
  }, []);
  return {
    activeTab: r,
    setActiveTab: n,
    hasResponsiveFields: c,
    searchQuery: i,
    setSearchQuery: s,
    activeCategory: l,
    setActiveCategory: m,
    categoryList: w,
    hasSidebar: k,
    hasSearchBar: x,
    displayedGroupedFields: B,
    totalDisplayedFields: u,
    isShowingAllCategories: R,
    searchMatchCounts: P,
    collapsedGroups: p,
    toggleGroupCollapse: b
  };
}
function Vn(e) {
  return `
    @keyframes edit-panel-slideIn {
      from {
        opacity: 0;
        transform: translateY(-8px) scale(0.98);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    .edit-panel-close {
      transition: all 0.15s ease;
    }

    .edit-panel-close:hover {
      background-color: ${d.overlay_light};
      color: ${d.primary};
      transform: scale(1.1);
    }

    .edit-panel-input:focus,
    .edit-panel-select:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
    }

    .edit-panel-input:hover:not(:focus),
    .edit-panel-select:hover:not(:focus) {
      border-color: ${d.gray_border};
    }

    .edit-panel-color-text:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
      background: ${d.white};
    }

    .edit-panel-color-swatch:hover {
      border-color: ${d.gray_border};
      transform: scale(1.05);
    }

    .edit-panel-reset-field:hover {
      opacity: 1 !important;
      color: ${d.blue} !important;
    }

    .drag-handle {
      cursor: ${e ? "grabbing" : "grab"};
      transition: background-color 0.15s ease;
    }

    .drag-handle:hover {
      background-color: ${d.overlay_light};
    }

    .edit-panel-save-button {
      background: linear-gradient(135deg, ${d.blue} 0%, ${d.blue_dark} 100%);
      color: ${d.white};
      border: none;
      padding: 10px 18px;
      border-radius: 10px;
      font-size: 12px;
      font-weight: 600;
      cursor: pointer;
      transition: all 0.15s ease;
      box-shadow: 0 2px 8px rgba(85, 114, 183, 0.25);
      letter-spacing: 0.3px;
    }

    .edit-panel-save-button:hover:not(:disabled) {
      transform: translateY(-1px);
      box-shadow: 0 4px 16px rgba(85, 114, 183, 0.35);
    }

    .edit-panel-save-button:active:not(:disabled) {
      transform: translateY(0);
    }

    .edit-panel-save-button:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none;
    }

    /* Custom scrollbar for fields area */
    .edit-panel-content::-webkit-scrollbar {
      width: 6px;
    }

    .edit-panel-content::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-content::-webkit-scrollbar-thumb {
      background: ${d.gray_border};
      border-radius: 3px;
    }

    .edit-panel-content::-webkit-scrollbar-thumb:hover {
      background: ${d.gray_medium};
    }

    /* Custom scrollbar for sidebar */
    .edit-panel-sidebar::-webkit-scrollbar {
      width: 4px;
    }

    .edit-panel-sidebar::-webkit-scrollbar-track {
      background: transparent;
    }

    .edit-panel-sidebar::-webkit-scrollbar-thumb {
      background: ${d.gray_border};
      border-radius: 2px;
    }

    .edit-panel-sidebar-item {
      transition: all 0.12s ease;
    }

    .edit-panel-sidebar-item:hover {
      background-color: rgba(85, 114, 183, 0.08) !important;
    }

    .edit-panel-search:focus {
      border-color: ${d.blue};
      box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.08);
    }

    .edit-panel-group-header {
      cursor: pointer;
      transition: color 0.12s ease;
      user-select: none;
    }

    .edit-panel-group-header:hover {
      color: ${d.blue} !important;
    }
  `;
}
const _n = {
  sm: {
    padding: "6px 14px",
    fontSize: "12px",
    borderRadius: "8px",
    gap: "5px"
  },
  md: {
    padding: "10px 18px",
    fontSize: "13px",
    borderRadius: "10px",
    gap: "6px"
  },
  lg: {
    padding: "12px 24px",
    fontSize: "14px",
    borderRadius: "12px",
    gap: "8px"
  }
}, qn = {
  sm: {
    padding: "6px",
    fontSize: "12px",
    borderRadius: "8px",
    width: "28px",
    height: "28px"
  },
  md: {
    padding: "8px",
    fontSize: "13px",
    borderRadius: "10px",
    width: "34px",
    height: "34px"
  },
  lg: {
    padding: "10px",
    fontSize: "14px",
    borderRadius: "12px",
    width: "42px",
    height: "42px"
  }
}, Kn = (e, o, r) => {
  switch (e) {
    case "primary":
      return {
        background: r ? d.blue_dark : o ? `linear-gradient(135deg, ${d.blue_dark} 0%, #252b6e 100%)` : `linear-gradient(135deg, ${d.blue_dark} 0%, #1f2463 100%)`,
        color: d.white,
        border: "none",
        boxShadow: o ? "0 4px 14px rgba(24, 29, 86, 0.35)" : "0 2px 8px rgba(24, 29, 86, 0.2)",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "secondary":
      return {
        background: r ? d.gray_border : d.gray_light,
        color: d.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "danger":
      return {
        background: r ? "linear-gradient(135deg, #e63e37 0%, #d13530 100%)" : o ? `linear-gradient(135deg, ${d.red} 0%, #e63e37 100%)` : `linear-gradient(135deg, ${d.red} 0%, #e63e37 100%)`,
        color: d.white,
        border: "none",
        boxShadow: o ? "0 4px 12px rgba(255, 83, 74, 0.35)" : "0 2px 6px rgba(255, 83, 74, 0.25)",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "ghost":
      return {
        background: r ? "rgba(0, 0, 0, 0.08)" : o ? "rgba(0, 0, 0, 0.04)" : "transparent",
        color: d.primary,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    case "outline":
      return {
        background: r ? d.blue_light : o ? "rgba(24, 29, 86, 0.04)" : d.white,
        color: d.blue_dark,
        border: `2px solid ${d.blue_dark}`,
        boxShadow: "none",
        transform: o && !r ? "translateY(-1px)" : "none"
      };
    case "icon":
      return {
        background: r ? "rgba(0, 0, 0, 0.1)" : o ? "rgba(0, 0, 0, 0.05)" : "transparent",
        color: d.gray_medium,
        border: "none",
        boxShadow: "none",
        transform: "none"
      };
    default:
      return {};
  }
}, oe = Go(
  ({
    variant: e = "primary",
    size: o = "md",
    leftIcon: r,
    rightIcon: n,
    isLoading: i = !1,
    pill: s = !1,
    disabled: l,
    children: m,
    style: p,
    ...y
  }, c) => {
    const [g, C] = O(!1), [w, k] = O(!1), x = l || i, f = e === "icon" ? qn[o] : _n[o], B = s ? "200px" : f.borderRadius, P = {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontWeight: 600,
      cursor: x ? "not-allowed" : "pointer",
      opacity: x ? 0.5 : 1,
      transition: "all 0.2s ease",
      outline: "none",
      whiteSpace: "nowrap",
      fontFamily: "inherit",
      ...f,
      borderRadius: B,
      ...Kn(
        e,
        !x && g,
        !x && w
      ),
      ...p
    };
    return /* @__PURE__ */ t(
      "button",
      {
        ref: c,
        disabled: x,
        style: P,
        onMouseEnter: () => C(!0),
        onMouseLeave: () => {
          C(!1), k(!1);
        },
        onMouseDown: () => k(!0),
        onMouseUp: () => k(!1),
        ...y,
        children: i ? /* @__PURE__ */ t(ei, { size: o }) : /* @__PURE__ */ h(D, { children: [
          r && /* @__PURE__ */ t(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: r
            }
          ),
          m,
          n && /* @__PURE__ */ t(
            "span",
            {
              style: {
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center"
              },
              children: n
            }
          )
        ] })
      }
    );
  }
);
oe.displayName = "Button";
const ei = ({ size: e }) => {
  const o = e === "sm" ? 12 : e === "md" ? 14 : 16;
  return /* @__PURE__ */ h(
    "svg",
    {
      width: o,
      height: o,
      viewBox: "0 0 24 24",
      fill: "none",
      style: {
        animation: "bc-button-spin 1s linear infinite"
      },
      children: [
        /* @__PURE__ */ t("style", { children: `
          @keyframes bc-button-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        ` }),
        /* @__PURE__ */ t(
          "circle",
          {
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "3",
            strokeLinecap: "round",
            strokeDasharray: "32",
            strokeDashoffset: "12"
          }
        )
      ]
    }
  );
}, qe = ({
  title: e,
  message: o,
  confirmLabel: r = "Save",
  cancelLabel: n = "Discard",
  dismissLabel: i = "Cancel",
  onConfirm: s,
  onCancel: l,
  onDismiss: m,
  isLoading: p = !1
}) => {
  const y = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: `
        .confirm-dialog-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000010;
        }

        .confirm-dialog-container {
          background: ${d.white};
          border-radius: 12px;
          box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
          max-width: 400px;
          width: 90%;
          padding: 24px;
        }

        .confirm-dialog-title {
          margin: 0 0 12px;
          font-size: 18px;
          font-weight: 600;
          color: ${d.primary};
        }

        .confirm-dialog-message {
          margin: 0 0 24px;
          font-size: 14px;
          color: ${d.gray_medium};
          line-height: 1.5;
        }

        .confirm-dialog-actions {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .confirm-dialog-actions-right {
          display: flex;
          gap: 12px;
        }
      ` }),
    /* @__PURE__ */ t("div", { className: "confirm-dialog-overlay", onClick: l, children: /* @__PURE__ */ h(
      "div",
      {
        className: "confirm-dialog-container",
        onClick: (c) => c.stopPropagation(),
        children: [
          /* @__PURE__ */ t("h3", { className: "confirm-dialog-title", children: e }),
          /* @__PURE__ */ t("p", { className: "confirm-dialog-message", children: o }),
          /* @__PURE__ */ h("div", { className: "confirm-dialog-actions", children: [
            /* @__PURE__ */ t("div", { children: m && /* @__PURE__ */ t(
              oe,
              {
                variant: "ghost",
                size: "sm",
                onClick: m,
                disabled: p,
                children: i
              }
            ) }),
            /* @__PURE__ */ h("div", { className: "confirm-dialog-actions-right", children: [
              /* @__PURE__ */ t(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: l,
                  disabled: p,
                  children: n
                }
              ),
              /* @__PURE__ */ t(
                oe,
                {
                  variant: "primary",
                  size: "sm",
                  onClick: s,
                  isLoading: p,
                  disabled: p,
                  children: r
                }
              )
            ] })
          ] })
        ]
      }
    ) })
  ] });
  return Le.createPortal(y, po());
}, oi = ({
  displayName: e,
  isDirty: o,
  isSaving: r,
  onReset: n,
  onSave: i,
  onClose: s,
  handleMouseDown: l
}) => /* @__PURE__ */ h(
  "div",
  {
    className: "drag-handle",
    onMouseDown: l,
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "16px 20px",
      borderBottom: `1px solid ${d.border_glass}`,
      borderRadius: "20px 20px 0 0",
      userSelect: "none"
    },
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "12px",
            flex: 1
          },
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  display: "grid",
                  gridTemplateColumns: "repeat(2, 1fr)",
                  gap: "3px",
                  opacity: 0.3
                },
                children: [...Array(6)].map((m, p) => /* @__PURE__ */ t(
                  "div",
                  {
                    style: {
                      width: "4px",
                      height: "4px",
                      background: d.gray_medium,
                      borderRadius: "1px"
                    }
                  },
                  p
                ))
              }
            ),
            /* @__PURE__ */ t(
              "h3",
              {
                style: {
                  fontSize: "13px",
                  fontWeight: 600,
                  color: d.primary,
                  margin: 0,
                  letterSpacing: "0.2px"
                },
                children: e || "Edit Properties"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ h("div", { style: { display: "flex", gap: "8px", alignItems: "center" }, children: [
        o && n && /* @__PURE__ */ t(
          oe,
          {
            variant: "ghost",
            size: "sm",
            onClick: n,
            disabled: r,
            "aria-label": "Reset changes",
            leftIcon: /* @__PURE__ */ t(Br, { size: 14 }),
            children: "Reset"
          }
        ),
        o && i && /* @__PURE__ */ t(
          oe,
          {
            variant: "primary",
            size: "sm",
            onClick: i,
            disabled: r,
            isLoading: r,
            "aria-label": "Save changes",
            type: "submit",
            children: "Save"
          }
        ),
        /* @__PURE__ */ t(oe, { variant: "icon", size: "md", onClick: s, "aria-label": "Close", children: /* @__PURE__ */ t(Ae, { size: 18 }) })
      ] })
    ]
  }
), ti = ({
  searchQuery: e,
  setSearchQuery: o,
  searchInputRef: r
}) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      padding: "12px 20px",
      borderBottom: `1px solid ${d.border_glass}`
    },
    children: /* @__PURE__ */ h("div", { style: { position: "relative" }, children: [
      /* @__PURE__ */ t(
        co,
        {
          size: 14,
          style: {
            position: "absolute",
            left: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            color: d.gray_medium,
            pointerEvents: "none"
          }
        }
      ),
      /* @__PURE__ */ t(
        "input",
        {
          ref: r,
          type: "text",
          value: e,
          onChange: (n) => o(n.target.value),
          onKeyDown: (n) => {
            var i;
            n.key === "Escape" && (o(""), (i = r.current) == null || i.blur());
          },
          placeholder: "Search properties...",
          className: "edit-panel-search",
          style: {
            width: "100%",
            padding: "8px 30px 8px 32px",
            fontSize: "12px",
            border: `1px solid ${d.border_glass}`,
            borderRadius: "10px",
            background: d.bg_light,
            color: d.primary,
            outline: "none",
            transition: "border-color 0.15s, box-shadow 0.15s",
            fontFamily: "inherit",
            boxSizing: "border-box"
          }
        }
      ),
      e && /* @__PURE__ */ t(
        "button",
        {
          onClick: () => {
            var n;
            o(""), (n = r.current) == null || n.focus();
          },
          style: {
            position: "absolute",
            right: "6px",
            top: "50%",
            transform: "translateY(-50%)",
            background: "none",
            border: "none",
            cursor: "pointer",
            padding: "2px",
            display: "inline-flex",
            alignItems: "center",
            color: d.gray_medium
          },
          children: /* @__PURE__ */ t(Ae, { size: 12 })
        }
      )
    ] })
  }
), ri = ({
  activeTab: e,
  setActiveTab: o
}) => /* @__PURE__ */ h(
  "div",
  {
    style: {
      display: "flex",
      gap: "0",
      padding: "0 20px",
      borderBottom: `1px solid ${d.border_glass}`
    },
    children: [
      /* @__PURE__ */ h(
        "button",
        {
          onClick: () => o("desktop"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "desktop" ? `2px solid ${d.blue}` : "2px solid transparent",
            color: e === "desktop" ? d.blue : d.gray_medium,
            fontSize: "12px",
            fontWeight: e === "desktop" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ t(Sr, { size: 14 }),
            "Desktop"
          ]
        }
      ),
      /* @__PURE__ */ h(
        "button",
        {
          onClick: () => o("mobile"),
          style: {
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "10px 16px",
            background: "none",
            border: "none",
            borderBottom: e === "mobile" ? `2px solid ${d.blue}` : "2px solid transparent",
            color: e === "mobile" ? d.blue : d.gray_medium,
            fontSize: "12px",
            fontWeight: e === "mobile" ? 600 : 500,
            cursor: "pointer",
            transition: "all 0.15s ease"
          },
          children: [
            /* @__PURE__ */ t(zr, { size: 14 }),
            "Mobile"
          ]
        }
      )
    ]
  }
), ni = ({
  categoryList: e,
  activeCategory: o,
  setActiveCategory: r,
  searchMatchCounts: n
}) => /* @__PURE__ */ t(
  "div",
  {
    className: "edit-panel-sidebar",
    style: {
      width: "160px",
      minWidth: "160px",
      borderRight: `1px solid ${d.border_glass}`,
      overflowY: "auto",
      padding: "8px 0"
    },
    children: e.map((i) => {
      const s = o === i.key || !o && i.key === "__all__", l = n ? n[i.key] ?? 0 : i.count, m = n !== null && l === 0;
      return /* @__PURE__ */ h(
        "button",
        {
          className: "edit-panel-sidebar-item",
          onClick: () => r(
            s && i.key !== "__all__" ? null : i.key
          ),
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "7px 16px 7px 20px",
            background: s ? "rgba(85, 114, 183, 0.1)" : "none",
            border: "none",
            borderLeft: s ? `3px solid ${d.blue}` : "3px solid transparent",
            cursor: "pointer",
            fontSize: "11px",
            fontWeight: s ? 600 : 500,
            color: s ? d.blue : d.gray_medium,
            textAlign: "left",
            opacity: m ? 0.35 : 1,
            fontFamily: "inherit"
          },
          children: [
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap"
                },
                children: i.name
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: "10px",
                  fontWeight: 500,
                  color: s ? d.blue : d.gray_border,
                  marginLeft: "6px",
                  flexShrink: 0
                },
                children: n ? l : i.count
              }
            )
          ]
        },
        i.key
      );
    })
  }
), ii = ({ value: e, onChange: o }) => {
  const [r, n] = O(e || "");
  return Q(() => {
    n(e || "");
  }, [e]), /* @__PURE__ */ t(
    "input",
    {
      type: "text",
      value: r,
      onChange: (s) => {
        const l = s.target.value;
        n(l), o(l);
      },
      className: "edit-panel-input",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${d.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: d.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: d.white,
        outline: "none"
      }
    }
  );
}, ai = ({
  value: e,
  onChange: o,
  field: r
}) => {
  var n, i;
  return /* @__PURE__ */ t(
    "select",
    {
      value: e ?? ((i = (n = r.options) == null ? void 0 : n[0]) == null ? void 0 : i.value) ?? "",
      onChange: (s) => o(s.target.value),
      className: "edit-panel-select",
      style: {
        width: "100%",
        padding: "12px 14px",
        border: `1px solid ${d.border_glass}`,
        borderRadius: "10px",
        fontSize: "13px",
        color: d.primary,
        boxSizing: "border-box",
        transition: "all 0.15s ease",
        background: d.white,
        cursor: "pointer",
        outline: "none",
        appearance: "none",
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 12px center",
        paddingRight: "36px"
      },
      children: (r.options ?? []).map((s) => /* @__PURE__ */ t("option", { value: s.value, children: s.label }, s.value))
    }
  );
};
function go() {
  return (go = Object.assign || function(e) {
    for (var o = 1; o < arguments.length; o++) {
      var r = arguments[o];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }).apply(this, arguments);
}
function Tr(e, o) {
  if (e == null) return {};
  var r, n, i = {}, s = Object.keys(e);
  for (n = 0; n < s.length; n++) o.indexOf(r = s[n]) >= 0 || (i[r] = e[r]);
  return i;
}
function Bo(e) {
  var o = se(e), r = se(function(n) {
    o.current && o.current(n);
  });
  return o.current = e, r.current;
}
var Ke = function(e, o, r) {
  return o === void 0 && (o = 0), r === void 0 && (r = 1), e > r ? r : e < o ? o : e;
}, Ve = function(e) {
  return "touches" in e;
}, zo = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, rt = function(e, o, r) {
  var n = e.getBoundingClientRect(), i = Ve(o) ? function(s, l) {
    for (var m = 0; m < s.length; m++) if (s[m].identifier === l) return s[m];
    return s[0];
  }(o.touches, r) : o;
  return { left: Ke((i.pageX - (n.left + zo(e).pageXOffset)) / n.width), top: Ke((i.pageY - (n.top + zo(e).pageYOffset)) / n.height) };
}, nt = function(e) {
  !Ve(e) && e.preventDefault();
}, Mr = me.memo(function(e) {
  var o = e.onMove, r = e.onKey, n = Tr(e, ["onMove", "onKey"]), i = se(null), s = Bo(o), l = Bo(r), m = se(null), p = se(!1), y = ae(function() {
    var w = function(f) {
      nt(f), (Ve(f) ? f.touches.length > 0 : f.buttons > 0) && i.current ? s(rt(i.current, f, m.current)) : x(!1);
    }, k = function() {
      return x(!1);
    };
    function x(f) {
      var B = p.current, P = zo(i.current), u = f ? P.addEventListener : P.removeEventListener;
      u(B ? "touchmove" : "mousemove", w), u(B ? "touchend" : "mouseup", k);
    }
    return [function(f) {
      var B = f.nativeEvent, P = i.current;
      if (P && (nt(B), !function(R, b) {
        return b && !Ve(R);
      }(B, p.current) && P)) {
        if (Ve(B)) {
          p.current = !0;
          var u = B.changedTouches || [];
          u.length && (m.current = u[0].identifier);
        }
        P.focus(), s(rt(P, B, m.current)), x(!0);
      }
    }, function(f) {
      var B = f.which || f.keyCode;
      B < 37 || B > 40 || (f.preventDefault(), l({ left: B === 39 ? 0.05 : B === 37 ? -0.05 : 0, top: B === 40 ? 0.05 : B === 38 ? -0.05 : 0 }));
    }, x];
  }, [l, s]), c = y[0], g = y[1], C = y[2];
  return Q(function() {
    return C;
  }, [C]), me.createElement("div", go({}, n, { onTouchStart: c, onMouseDown: c, className: "react-colorful__interactive", ref: i, onKeyDown: g, tabIndex: 0, role: "slider" }));
}), Xo = function(e) {
  return e.filter(Boolean).join(" ");
}, Er = function(e) {
  var o = e.color, r = e.left, n = e.top, i = n === void 0 ? 0.5 : n, s = Xo(["react-colorful__pointer", e.className]);
  return me.createElement("div", { className: s, style: { top: 100 * i + "%", left: 100 * r + "%" } }, me.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: o } }));
}, ue = function(e, o, r) {
  return o === void 0 && (o = 0), r === void 0 && (r = Math.pow(10, o)), Math.round(r * e) / r;
}, li = function(e) {
  return gi(Fo(e));
}, Fo = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? ue(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? ue(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, si = function(e) {
  return pi(ci(e));
}, di = function(e) {
  var o = e.s, r = e.v, n = e.a, i = (200 - o) * r / 100;
  return { h: ue(e.h), s: ue(i > 0 && i < 200 ? o * r / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: ue(i / 2), a: ue(n, 2) };
}, Io = function(e) {
  var o = di(e);
  return "hsl(" + o.h + ", " + o.s + "%, " + o.l + "%)";
}, ci = function(e) {
  var o = e.h, r = e.s, n = e.v, i = e.a;
  o = o / 360 * 6, r /= 100, n /= 100;
  var s = Math.floor(o), l = n * (1 - r), m = n * (1 - (o - s) * r), p = n * (1 - (1 - o + s) * r), y = s % 6;
  return { r: ue(255 * [n, m, l, l, p, n][y]), g: ue(255 * [p, n, n, m, l, l][y]), b: ue(255 * [l, l, p, n, n, m][y]), a: ue(i, 2) };
}, eo = function(e) {
  var o = e.toString(16);
  return o.length < 2 ? "0" + o : o;
}, pi = function(e) {
  var o = e.r, r = e.g, n = e.b, i = e.a, s = i < 1 ? eo(ue(255 * i)) : "";
  return "#" + eo(o) + eo(r) + eo(n) + s;
}, gi = function(e) {
  var o = e.r, r = e.g, n = e.b, i = e.a, s = Math.max(o, r, n), l = s - Math.min(o, r, n), m = l ? s === o ? (r - n) / l : s === r ? 2 + (n - o) / l : 4 + (o - r) / l : 0;
  return { h: ue(60 * (m < 0 ? m + 6 : m)), s: ue(s ? l / s * 100 : 0), v: ue(s / 255 * 100), a: i };
}, mi = me.memo(function(e) {
  var o = e.hue, r = e.onChange, n = Xo(["react-colorful__hue", e.className]);
  return me.createElement("div", { className: n }, me.createElement(Mr, { onMove: function(i) {
    r({ h: 360 * i.left });
  }, onKey: function(i) {
    r({ h: Ke(o + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": ue(o), "aria-valuemax": "360", "aria-valuemin": "0" }, me.createElement(Er, { className: "react-colorful__hue-pointer", left: o / 360, color: Io({ h: o, s: 100, v: 100, a: 1 }) })));
}), ui = me.memo(function(e) {
  var o = e.hsva, r = e.onChange, n = { backgroundColor: Io({ h: o.h, s: 100, v: 100, a: 1 }) };
  return me.createElement("div", { className: "react-colorful__saturation", style: n }, me.createElement(Mr, { onMove: function(i) {
    r({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    r({ s: Ke(o.s + 100 * i.left, 0, 100), v: Ke(o.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + ue(o.s) + "%, Brightness " + ue(o.v) + "%" }, me.createElement(Er, { className: "react-colorful__saturation-pointer", top: 1 - o.v / 100, left: o.s / 100, color: Io(o) })));
}), Wr = function(e, o) {
  if (e === o) return !0;
  for (var r in e) if (e[r] !== o[r]) return !1;
  return !0;
}, hi = function(e, o) {
  return e.toLowerCase() === o.toLowerCase() || Wr(Fo(e), Fo(o));
};
function yi(e, o, r) {
  var n = Bo(r), i = O(function() {
    return e.toHsva(o);
  }), s = i[0], l = i[1], m = se({ color: o, hsva: s });
  Q(function() {
    if (!e.equal(o, m.current.color)) {
      var y = e.toHsva(o);
      m.current = { hsva: y, color: o }, l(y);
    }
  }, [o, e]), Q(function() {
    var y;
    Wr(s, m.current.hsva) || e.equal(y = e.fromHsva(s), m.current.color) || (m.current = { hsva: s, color: y }, n(y));
  }, [s, e, n]);
  var p = pe(function(y) {
    l(function(c) {
      return Object.assign({}, c, y);
    });
  }, []);
  return [s, p];
}
var bi = typeof window < "u" ? ln : Q, fi = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, it = /* @__PURE__ */ new Map(), xi = function(e) {
  bi(function() {
    var o = e.current ? e.current.ownerDocument : document;
    if (o !== void 0 && !it.has(o)) {
      var r = o.createElement("style");
      r.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, it.set(o, r);
      var n = fi();
      n && r.setAttribute("nonce", n), o.head.appendChild(r);
    }
  }, []);
}, Ci = function(e) {
  var o = e.className, r = e.colorModel, n = e.color, i = n === void 0 ? r.defaultColor : n, s = e.onChange, l = Tr(e, ["className", "colorModel", "color", "onChange"]), m = se(null);
  xi(m);
  var p = yi(r, i, s), y = p[0], c = p[1], g = Xo(["react-colorful", o]);
  return me.createElement("div", go({}, l, { ref: m, className: g }), me.createElement(ui, { hsva: y, onChange: c }), me.createElement(mi, { hue: y.h, onChange: c, className: "react-colorful__last-control" }));
}, ki = { defaultColor: "000", toHsva: li, fromHsva: function(e) {
  return si({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: hi }, vi = function(e) {
  return me.createElement(Ci, go({}, e, { colorModel: ki }));
};
const at = (e) => {
  const o = e.startsWith("#") ? e : `#${e}`, r = o.slice(0, 7).padEnd(7, "0"), n = o.slice(7, 9) || "ff", i = parseInt(n, 16), s = Math.round(i / 255 * 100);
  return { hex: r, opacity: s };
}, De = (e, o) => {
  const r = Math.round(o / 100 * 255).toString(16).padStart(2, "0");
  return `${(e.startsWith("#") ? e : `#${e}`).slice(0, 7)}${r}`;
}, lt = (e) => {
  const o = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(o) ? `#${o.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(o) ? `#${o.toLowerCase()}` : null;
}, Ar = ({
  value: e,
  onChange: o,
  className: r
}) => {
  const { hex: n, opacity: i } = at(
    e || "#000000ff"
  ), [s, l] = O(n), [m, p] = O(i), [y, c] = O(
    i < 100 ? e || "#000000ff" : n
  );
  Q(() => {
    const { hex: x, opacity: f } = at(
      e || "#000000ff"
    );
    l(x), p(f), c(f < 100 ? e || "#000000ff" : x);
  }, [e]);
  const g = (x) => {
    l(x), c(m < 100 ? De(x, m) : x), o(De(x, m));
  }, C = (x) => {
    const f = x.target.value;
    c(f);
    const B = lt(f);
    if (B)
      if (B.length === 9) {
        const P = B.slice(0, 7), u = B.slice(7, 9), R = parseInt(u, 16), b = Math.round(R / 255 * 100);
        l(P), p(b), o(B);
      } else
        l(B), o(De(B, m));
  }, w = () => {
    const x = lt(y);
    if (x)
      if (x.length === 9)
        c(x);
      else {
        const f = De(x, m);
        c(m < 100 ? f : x);
      }
    else {
      const f = De(s, m);
      c(m < 100 ? f : s);
    }
  }, k = (x) => {
    const f = parseInt(x.target.value, 10);
    p(f);
    const B = De(s, f);
    o(B), c(f < 100 ? B : s);
  };
  return /* @__PURE__ */ h("div", { className: `bc-color-picker ${r || ""}`, children: [
    /* @__PURE__ */ t("style", { children: `
        .bc-color-picker {
          width: 200px;
        }

        .bc-color-picker .react-colorful {
          width: 100%;
          height: auto;
        }

        .bc-color-picker .react-colorful__saturation {
          border-radius: 8px;
          height: 150px;
        }

        .bc-color-picker .react-colorful__hue {
          height: 14px;
          border-radius: 7px;
          margin-top: 16px;
        }

        .bc-color-picker .react-colorful__pointer {
          width: 20px;
          height: 20px;
        }

        .bc-color-picker-hex-input {
          width: 100%;
          margin-top: 16px;
          padding: 8px 10px;
          border: 1px solid ${d.border_glass};
          border-radius: 8px;
          font-size: 13px;
          color: ${d.primary};
          font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
          background: ${d.bg_light};
          outline: none;
          box-sizing: border-box;
          text-align: center;
          transition: all 0.15s ease;
        }

        .bc-color-picker-hex-input:focus {
          border-color: ${d.blue};
          box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.12);
          background: ${d.white};
        }

        .bc-color-picker-opacity-container {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-top: 12px;
        }

        .bc-color-picker-opacity-slider {
          flex: 1;
          height: 14px;
          -webkit-appearance: none;
          appearance: none;
          background: linear-gradient(to right, white 0%, ${s} 100%);
          border-radius: 7px;
          outline: none;
          cursor: pointer;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          appearance: none;
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${d.white};
          border: 2px solid ${d.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
          transition: transform 0.1s ease;
        }

        .bc-color-picker-opacity-slider::-webkit-slider-thumb:hover {
          transform: scale(1.1);
        }

        .bc-color-picker-opacity-slider::-moz-range-thumb {
          width: 20px;
          height: 20px;
          border-radius: 50%;
          background: ${d.white};
          border: 2px solid ${d.white};
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          cursor: pointer;
        }

        .bc-color-picker-opacity-value {
          min-width: 36px;
          font-size: 12px;
          font-weight: 500;
          color: ${d.gray_medium};
          text-align: right;
          user-select: none;
        }
      ` }),
    /* @__PURE__ */ t(vi, { color: s, onChange: g }),
    /* @__PURE__ */ t(
      "input",
      {
        type: "text",
        value: y,
        onChange: C,
        onBlur: w,
        placeholder: "#000000 or #000000ff",
        className: "bc-color-picker-hex-input",
        maxLength: 9
      }
    ),
    /* @__PURE__ */ h("div", { className: "bc-color-picker-opacity-container", children: [
      /* @__PURE__ */ t(
        "input",
        {
          type: "range",
          min: "0",
          max: "100",
          value: m,
          onChange: k,
          className: "bc-color-picker-opacity-slider",
          style: {
            background: `linear-gradient(to right, white 0%, ${s} 100%)`
          }
        }
      ),
      /* @__PURE__ */ t("span", { className: "bc-color-picker-opacity-value", children: m })
    ] })
  ] });
}, Si = "data:image/png;base64,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", Po = ({
  color: e,
  size: o = 32,
  borderRadius: r = 4,
  className: n,
  style: i
}) => /* @__PURE__ */ h(
  "div",
  {
    className: n,
    style: {
      position: "relative",
      width: o,
      height: o,
      borderRadius: r,
      overflow: "hidden",
      ...i
    },
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${Si})`,
            backgroundSize: "100% 100%",
            backgroundRepeat: "repeat",
            borderRadius: "inherit"
          }
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            backgroundColor: e,
            display: "block",
            borderRadius: "inherit"
          }
        }
      )
    ]
  }
), wi = (e) => typeof e == "object" && e !== null && "type" in e && "value" in e && (e.type === "theme" || e.type === "custom"), a = (e) => ({
  type: "theme",
  value: e
}), Ie = (e) => ({
  type: "custom",
  value: e
}), je = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, st = (e) => {
  const o = e.replace(/^#/, "");
  return /^[0-9A-Fa-f]{6}$/i.test(o) ? `#${o.toLowerCase()}` : /^[0-9A-Fa-f]{8}$/i.test(o) ? `#${o.toLowerCase()}` : null;
}, Bi = ({
  value: e,
  onChange: o,
  field: r,
  themeColors: n,
  openColorPicker: i,
  setOpenColorPicker: s
}) => {
  const m = wi(e) && e.type === "theme" ? e.value : "", p = ae(() => {
    if (!e) return "#000000ff";
    if (typeof e == "string")
      return je(e);
    if (e.type === "custom")
      return je(e.value);
    if (e.type === "theme") {
      const v = n[e.value];
      return v ? je(v) : "#000000ff";
    }
    return "#000000ff";
  }, [e, n]), y = () => "#" + Math.floor(Math.random() * 16777215).toString(16).padStart(6, "0"), c = (v) => {
    if (v === "") {
      const T = y();
      o({ type: "custom", value: T });
    } else
      o({ type: "theme", value: v });
  }, g = (v) => {
    o({ type: "custom", value: v });
  }, C = i === r.key, w = p, k = se(null), x = se(null), [f, B] = me.useState(!1), P = (v) => {
    const T = je(v);
    return T.length === 9 && T.slice(7, 9).toLowerCase() === "ff" ? T.slice(0, 7) : T;
  }, [u, R] = O(() => P(w));
  Q(() => {
    R(P(p));
  }, [p]);
  const b = (v) => {
    const T = v.target.value;
    R(T);
    const W = st(T);
    if (W) {
      const F = je(W);
      g(F);
    }
  }, I = () => {
    const v = st(u);
    if (!v)
      R(P(w));
    else {
      const T = je(v);
      R(P(T));
    }
  }, S = 300;
  return Q(() => {
    if (C && x.current) {
      const v = x.current.getBoundingClientRect(), W = window.innerHeight - v.bottom, F = v.top;
      B(W < S && F > W);
    }
  }, [C]), Q(() => {
    if (!C) return;
    const v = (T) => {
      k.current && !k.current.contains(T.target) && s(null);
    };
    return document.addEventListener("mousedown", v, !0), () => {
      document.removeEventListener("mousedown", v, !0);
    };
  }, [C, s]), /* @__PURE__ */ h(
    "div",
    {
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "center"
      },
      children: [
        /* @__PURE__ */ h(
          "select",
          {
            value: m,
            onChange: (v) => c(v.target.value),
            className: "edit-panel-select",
            style: {
              flex: 1,
              padding: "12px 14px",
              border: `1px solid ${d.border_glass}`,
              borderRadius: "10px",
              fontSize: "13px",
              color: d.primary,
              boxSizing: "border-box",
              transition: "all 0.15s ease",
              background: d.white,
              cursor: "pointer",
              maxWidth: "110px",
              outline: "none",
              appearance: "none",
              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right 10px center",
              paddingRight: "30px"
            },
            children: [
              /* @__PURE__ */ t("option", { value: "", children: "Custom" }),
              Object.keys(n).map((v) => /* @__PURE__ */ t("option", { value: v, children: v }, v))
            ]
          }
        ),
        /* @__PURE__ */ h("div", { ref: k, style: { position: "relative" }, children: [
          /* @__PURE__ */ t(
            "button",
            {
              ref: x,
              type: "button",
              onClick: () => s(C ? null : r.key),
              className: "edit-panel-color-swatch",
              style: {
                width: "42px",
                height: "42px",
                border: `2px solid ${d.border_glass}`,
                borderRadius: "10px",
                cursor: "pointer",
                padding: "3px",
                transition: "all 0.15s ease",
                backgroundColor: d.white,
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
              },
              "aria-label": "Open color picker",
              children: /* @__PURE__ */ t(
                Po,
                {
                  color: w,
                  style: { width: "100%", height: "100%" },
                  borderRadius: 6
                }
              )
            }
          ),
          C && /* @__PURE__ */ t(
            "div",
            {
              className: "edit-panel-color-popover",
              style: {
                position: "absolute",
                ...f ? { bottom: "calc(100% + 8px)" } : { top: "calc(100% + 8px)" },
                left: "50%",
                transform: "translateX(-50%)",
                zIndex: 10,
                backgroundColor: d.white,
                borderRadius: "12px",
                padding: "12px",
                boxShadow: `0 8px 24px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`
              },
              onClick: (v) => v.stopPropagation(),
              children: /* @__PURE__ */ t(
                Ar,
                {
                  value: w,
                  onChange: g
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            value: u,
            onChange: b,
            onBlur: I,
            className: "edit-panel-color-text",
            placeholder: "#000000 or #000000ff",
            maxLength: 9,
            style: {
              width: "100px",
              padding: "12px 10px",
              border: `1px solid ${d.border_glass}`,
              borderRadius: "10px",
              fontSize: "12px",
              color: d.primary,
              fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace",
              background: d.white,
              outline: "none",
              transition: "all 0.15s ease",
              cursor: "text"
            },
            onFocus: (v) => v.target.select()
          }
        )
      ]
    }
  );
}, zi = ({
  value: e,
  onChange: o,
  field: r
}) => /* @__PURE__ */ t(
  "input",
  {
    type: "number",
    value: e || 0,
    min: r.min,
    max: r.max,
    step: r.step || 1,
    onChange: (n) => o(parseFloat(n.target.value)),
    className: "edit-panel-input",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      outline: "none"
    }
  }
), Fi = ({ value: e, onChange: o }) => {
  const r = !!e;
  return /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      role: "switch",
      "aria-checked": r,
      onClick: () => o(!r),
      className: "edit-panel-toggle",
      style: {
        width: "48px",
        height: "28px",
        borderRadius: "14px",
        border: "none",
        padding: "2px",
        cursor: "pointer",
        transition: "all 0.2s ease",
        background: r ? d.blue : d.gray_light,
        display: "flex",
        alignItems: "center",
        justifyContent: r ? "flex-end" : "flex-start"
      },
      children: /* @__PURE__ */ t(
        "span",
        {
          style: {
            width: "24px",
            height: "24px",
            borderRadius: "12px",
            background: d.white,
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
            transition: "all 0.2s ease"
          }
        }
      )
    }
  );
}, Ii = ({
  value: e,
  onChange: o,
  themeFonts: r
}) => /* @__PURE__ */ h(
  "select",
  {
    value: e || "inherit",
    onChange: (n) => o(n.target.value),
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ t("option", { value: "inherit", children: "Inherit (System Font)" }),
      Object.entries(r).map(([n, i]) => /* @__PURE__ */ t("option", { value: n, children: i.name }, n))
    ]
  }
), To = "bc-widget-panel-opened", Mo = "bc-widget-upload-icon-request", Rr = (e) => {
  const o = new CustomEvent(To, {
    detail: { widgetId: e },
    bubbles: !0
  });
  document.dispatchEvent(o);
}, Hr = (e) => {
  const o = (r) => {
    e(r.detail.widgetId);
  };
  return document.addEventListener(To, o), () => {
    document.removeEventListener(To, o);
  };
}, Pi = () => {
  const e = new CustomEvent(Mo, { bubbles: !0 });
  document.dispatchEvent(e);
}, Ti = (e) => {
  const o = () => {
    e();
  };
  return document.addEventListener(Mo, o), () => {
    document.removeEventListener(Mo, o);
  };
}, dt = "__upload_new__", Mi = ({
  value: e,
  onChange: o,
  themeIcons: r
}) => /* @__PURE__ */ h(
  "select",
  {
    value: e || "default",
    onChange: (i) => {
      const s = i.target.value;
      if (s === dt) {
        Pi();
        return;
      }
      o(s);
    },
    className: "edit-panel-select",
    style: {
      width: "100%",
      padding: "12px 14px",
      border: `1px solid ${d.border_glass}`,
      borderRadius: "10px",
      fontSize: "13px",
      color: d.primary,
      boxSizing: "border-box",
      transition: "all 0.15s ease",
      background: d.white,
      cursor: "pointer",
      outline: "none",
      appearance: "none",
      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 12px center",
      paddingRight: "36px"
    },
    children: [
      /* @__PURE__ */ t("option", { value: "default", children: "Default" }),
      Object.entries(r).map(([i, s]) => /* @__PURE__ */ t("option", { value: i, children: s.name }, i)),
      /* @__PURE__ */ t("option", { value: dt, children: "Upload new..." })
    ]
  }
);
function Ei(e, o) {
  const r = o.values[e.key];
  switch (e.type) {
    case "text":
      return /* @__PURE__ */ t(
        ii,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "options":
      return /* @__PURE__ */ t(
        ai,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "color":
      return /* @__PURE__ */ t(
        Bi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeColors: o.themeColors,
          openColorPicker: o.openColorPicker,
          setOpenColorPicker: o.setOpenColorPicker
        }
      );
    case "number":
      return /* @__PURE__ */ t(
        zi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "toggle":
      return /* @__PURE__ */ t(
        Fi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e
        }
      );
    case "font":
      return /* @__PURE__ */ t(
        Ii,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeFonts: o.themeFonts
        }
      );
    case "icon":
      return /* @__PURE__ */ t(
        Mi,
        {
          value: r,
          onChange: (n) => o.onChange(e.key, n),
          field: e,
          themeIcons: o.themeIcons
        }
      );
    default:
      return null;
  }
}
const Wi = (e) => {
  const { field: o, savedKeys: r, studioLockedKeys: n, onResetField: i } = e, s = r == null ? void 0 : r.has(o.key), l = n == null ? void 0 : n.has(o.key);
  return /* @__PURE__ */ h(
    "div",
    {
      style: {
        minWidth: 0,
        opacity: l ? 0.5 : 1,
        pointerEvents: l ? "none" : void 0
      },
      children: [
        /* @__PURE__ */ h(
          "label",
          {
            style: {
              display: "flex",
              alignItems: "center",
              gap: "4px",
              fontSize: "11px",
              fontWeight: 600,
              color: d.gray_medium,
              marginBottom: "8px",
              textTransform: "uppercase",
              letterSpacing: "0.5px"
            },
            children: [
              o.label,
              l && /* @__PURE__ */ t(
                "span",
                {
                  title: "Edit this property from Concierge Studio",
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    color: d.blue,
                    marginLeft: "2px",
                    flexShrink: 0,
                    cursor: "help",
                    pointerEvents: "auto"
                  },
                  children: /* @__PURE__ */ t(Yo, { size: 10 })
                }
              ),
              !l && s && i && /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => i(o.key),
                  title: "Reset to default",
                  className: "edit-panel-reset-field",
                  style: {
                    background: "none",
                    border: "none",
                    padding: "1px",
                    cursor: "pointer",
                    display: "inline-flex",
                    alignItems: "center",
                    color: d.gray_medium,
                    opacity: 0.5,
                    transition: "opacity 0.15s, color 0.15s",
                    marginLeft: "2px",
                    flexShrink: 0
                  },
                  children: /* @__PURE__ */ t(Br, { size: 10 })
                }
              )
            ]
          }
        ),
        Ei(o, e)
      ]
    }
  );
}, ct = ({ label: e, count: o, isCollapsed: r, onClick: n, marginBottom: i }) => /* @__PURE__ */ h(
  "button",
  {
    className: "edit-panel-group-header",
    onClick: n,
    style: {
      display: "flex",
      alignItems: "center",
      gap: "6px",
      fontSize: "12px",
      fontWeight: 700,
      color: d.primary,
      margin: 0,
      padding: 0,
      paddingBottom: "8px",
      marginBottom: i ?? 0,
      borderTop: "none",
      borderRight: "none",
      borderLeft: "none",
      borderBottom: `2px solid ${d.border_glass}`,
      textTransform: "uppercase",
      letterSpacing: "0.5px",
      background: "none",
      width: "100%",
      textAlign: "left",
      fontFamily: "inherit"
    },
    children: [
      r ? /* @__PURE__ */ t(so, { size: 14 }) : /* @__PURE__ */ t(fn, { size: 14 }),
      e,
      /* @__PURE__ */ t(
        "span",
        {
          style: {
            fontSize: "10px",
            fontWeight: 500,
            color: d.gray_medium,
            marginLeft: "auto"
          },
          children: o
        }
      )
    ]
  }
), pt = ({
  fields: e,
  itemProps: o
}) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "16px"
    },
    children: e.map((r) => /* @__PURE__ */ t(Wi, { field: r, ...o }, r.key))
  }
), Ai = ({
  displayedGroupedFields: e,
  totalDisplayedFields: o,
  isShowingAllCategories: r,
  collapsedGroups: n,
  toggleGroupCollapse: i,
  searchQuery: s,
  setSearchQuery: l,
  fieldItemProps: m
}) => {
  if (o === 0)
    return /* @__PURE__ */ t(
      "div",
      {
        className: "edit-panel-content",
        style: {
          padding: "16px 20px 20px",
          overflowY: "auto",
          overflowX: "hidden",
          flex: 1
        },
        children: /* @__PURE__ */ h(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "40px 20px",
              color: d.gray_medium,
              gap: "8px"
            },
            children: [
              /* @__PURE__ */ t(co, { size: 24, style: { opacity: 0.3 } }),
              /* @__PURE__ */ t("span", { style: { fontSize: "12px", fontWeight: 500 }, children: "No matching properties" }),
              s && /* @__PURE__ */ t(
                "button",
                {
                  onClick: () => l(""),
                  style: {
                    background: "none",
                    border: `1px solid ${d.border_glass}`,
                    borderRadius: "8px",
                    padding: "6px 12px",
                    fontSize: "11px",
                    color: d.blue,
                    cursor: "pointer",
                    fontFamily: "inherit",
                    marginTop: "4px"
                  },
                  children: "Clear search"
                }
              )
            ]
          }
        )
      }
    );
  const p = Object.keys(e.groups).length > 0;
  return /* @__PURE__ */ t(
    "div",
    {
      className: "edit-panel-content",
      style: {
        padding: "16px 20px 20px",
        overflowY: "auto",
        overflowX: "hidden",
        flex: 1
      },
      children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "20px"
          },
          children: [
            e.baseFields.length > 0 && /* @__PURE__ */ h(D, { children: [
              r && p && /* @__PURE__ */ t(
                ct,
                {
                  label: "General",
                  count: e.baseFields.length,
                  isCollapsed: n.has("__general__"),
                  onClick: () => i("__general__")
                }
              ),
              (!r || !n.has("__general__") || !p) && /* @__PURE__ */ t(
                pt,
                {
                  fields: e.baseFields,
                  itemProps: m
                }
              )
            ] }),
            Object.entries(e.groups).map(
              ([y, c]) => {
                const g = r && n.has(y);
                return /* @__PURE__ */ h("div", { children: [
                  r && /* @__PURE__ */ t(
                    ct,
                    {
                      label: Pr(y),
                      count: c.length,
                      isCollapsed: g,
                      onClick: () => i(y),
                      marginBottom: g ? 0 : "16px"
                    }
                  ),
                  !g && /* @__PURE__ */ t(pt, { fields: c, itemProps: m })
                ] }, y);
              }
            )
          ]
        }
      )
    }
  );
}, Lr = ({
  displayName: e,
  fields: o,
  values: r,
  initialValues: n,
  onChange: i,
  onClose: s,
  onReset: l,
  screenPosition: m,
  onSave: p,
  isSaving: y = !1,
  savedKeys: c,
  studioLockedKeys: g,
  onResetField: C,
  themeColors: w = {},
  themeFonts: k = {},
  themeIcons: x = {}
}) => {
  const { dragOffset: f, isDragging: B, handleMouseDown: P } = Jn(), u = se(null), R = se(null), [b, I] = O(null), [S, v] = O(!1), {
    activeTab: T,
    setActiveTab: W,
    hasResponsiveFields: F,
    searchQuery: N,
    setSearchQuery: z,
    activeCategory: A,
    setActiveCategory: j,
    categoryList: Z,
    hasSidebar: M,
    hasSearchBar: L,
    displayedGroupedFields: G,
    totalDisplayedFields: H,
    isShowingAllCategories: $,
    searchMatchCounts: Y,
    collapsedGroups: q,
    toggleGroupCollapse: X
  } = Un(o, r), V = ae(() => n ? JSON.stringify(r) !== JSON.stringify(n) : !1, [r, n]), re = () => {
    V ? v(!0) : s();
  }, K = () => {
    v(!1), l && l(), s();
  }, te = () => {
    v(!1), s();
  }, ee = async () => {
    p && p(), v(!1);
  };
  Q(() => {
    if (!b) return;
    const ye = wo(), Be = (ke) => {
      const Pe = ke.target;
      !Pe.closest(".edit-panel-color-popover") && !Pe.closest(".edit-panel-color-swatch") && I(null);
    };
    return ye.addEventListener("mousedown", Be, !0), () => {
      ye.removeEventListener("mousedown", Be, !0);
    };
  }, [b]), Q(() => {
    if (!Ir()) return;
    const ye = wo(), Be = "edit-panel-styles";
    if (!ye.getElementById(Be)) {
      const ke = ye.createElement("style");
      ke.id = Be, ke.textContent = `
        @keyframes edit-panel-slideIn {
          from {
            opacity: 0;
            transform: translateY(-8px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }
      `, ye.head.appendChild(ke);
    }
    return () => {
      const ke = ye.getElementById(Be);
      ke && ke.remove();
    };
  }, []);
  const he = {
    values: r,
    onChange: i,
    savedKeys: c,
    studioLockedKeys: g,
    onResetField: C,
    themeColors: w,
    themeFonts: k,
    themeIcons: x,
    openColorPicker: b,
    setOpenColorPicker: I
  }, Re = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: Vn(B) }),
    /* @__PURE__ */ h(
      "div",
      {
        ref: u,
        style: {
          position: "fixed",
          top: m.y + f.y,
          left: m.x + f.x,
          background: d.glass_bg_strong,
          backdropFilter: "blur(24px)",
          WebkitBackdropFilter: "blur(24px)",
          border: `1px solid ${d.border_subtle}`,
          borderRadius: "20px",
          boxShadow: `
            0 8px 40px ${d.shadow_medium},
            0 20px 60px ${d.shadow_soft},
            0 0 0 1px ${d.border_glass}
          `,
          zIndex: 999999,
          width: M ? "800px" : "620px",
          maxWidth: M ? "800px" : "620px",
          maxHeight: "450px",
          display: "flex",
          flexDirection: "column",
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          animation: "edit-panel-slideIn 0.2s ease-out"
        },
        onClick: (ye) => ye.stopPropagation(),
        onMouseDown: (ye) => ye.stopPropagation(),
        children: [
          /* @__PURE__ */ t(
            oi,
            {
              displayName: e,
              isDirty: V,
              isSaving: y,
              onReset: l,
              onSave: p,
              onClose: re,
              handleMouseDown: P
            }
          ),
          L && /* @__PURE__ */ t(
            ti,
            {
              searchQuery: N,
              setSearchQuery: z,
              searchInputRef: R
            }
          ),
          F && /* @__PURE__ */ t(ri, { activeTab: T, setActiveTab: W }),
          /* @__PURE__ */ h("div", { style: { display: "flex", flex: 1, overflow: "hidden" }, children: [
            M && /* @__PURE__ */ t(
              ni,
              {
                categoryList: Z,
                activeCategory: A,
                setActiveCategory: j,
                searchMatchCounts: Y
              }
            ),
            /* @__PURE__ */ t(
              Ai,
              {
                displayedGroupedFields: G,
                totalDisplayedFields: H,
                isShowingAllCategories: $,
                collapsedGroups: q,
                toggleGroupCollapse: X,
                searchQuery: N,
                setSearchQuery: z,
                fieldItemProps: he
              }
            )
          ] })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ h(D, { children: [
    Le.createPortal(Re, po()),
    S && /* @__PURE__ */ t(
      qe,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: ee,
        onCancel: K,
        onDismiss: te,
        isLoading: y
      }
    )
  ] });
}, xe = {
  THEME_ID: "bc_themeId",
  EDIT_MODE: "bc_editMode",
  EDIT_THEME_TOKEN: "bc_editThemeToken",
  PREVIEW_MODE: "bc_previewMode"
}, Ri = (e, o, r, n) => {
  try {
    e ? localStorage.setItem(xe.THEME_ID, e) : localStorage.removeItem(xe.THEME_ID), localStorage.setItem(xe.EDIT_MODE, String(o)), r ? localStorage.setItem(xe.EDIT_THEME_TOKEN, r) : localStorage.removeItem(xe.EDIT_THEME_TOKEN), localStorage.setItem(xe.PREVIEW_MODE, String(!!n));
  } catch (i) {
    console.error("Failed to save theme params to localStorage:", i);
  }
}, Hi = () => {
  try {
    return {
      themeId: localStorage.getItem(xe.THEME_ID),
      editMode: localStorage.getItem(xe.EDIT_MODE) === "true",
      editThemeToken: localStorage.getItem(xe.EDIT_THEME_TOKEN),
      previewMode: localStorage.getItem(xe.PREVIEW_MODE) === "true"
    };
  } catch (e) {
    return console.error("Failed to read theme params from localStorage:", e), {
      themeId: null,
      editMode: !1,
      editThemeToken: null,
      previewMode: !1
    };
  }
}, bo = () => {
  try {
    localStorage.removeItem(xe.THEME_ID), localStorage.removeItem(xe.EDIT_MODE), localStorage.removeItem(xe.EDIT_THEME_TOKEN), localStorage.removeItem(xe.PREVIEW_MODE);
  } catch (e) {
    console.error("Failed to clear theme params from localStorage:", e);
  }
}, Li = () => {
  try {
    const e = new URLSearchParams(window.location.search), o = e.get("themeId"), r = e.get("editMode") === "true", n = e.get("editThemeToken"), i = e.get("previewMode") === "true";
    o && Ri(o, r, n, i);
  } catch (e) {
    console.error("Failed to sync URL to storage:", e);
  }
}, fo = () => {
  try {
    const e = new URL(window.location.href);
    e.searchParams.delete("themeId"), e.searchParams.delete("editMode"), e.searchParams.delete("editThemeToken"), e.searchParams.delete("previewMode"), e.searchParams.delete("origin"), window.history.replaceState({}, "", e.toString());
  } catch (e) {
    console.error("Failed to clear URL params:", e);
  }
}, zs = (e, o, r) => {
  try {
    const n = new URL(window.location.href);
    e ? (n.searchParams.set("themeId", e), n.searchParams.set("editMode", String(o)), r ? n.searchParams.set("editThemeToken", r) : n.searchParams.delete("editThemeToken")) : (n.searchParams.delete("themeId"), n.searchParams.delete("editMode"), n.searchParams.delete("editThemeToken")), window.history.replaceState({}, "", n.toString());
  } catch (n) {
    console.error("Failed to update URL params:", n);
  }
}, gt = () => {
  const e = new URLSearchParams(window.location.search), o = e.get("themeId"), r = e.get("editMode"), n = e.get("editThemeToken"), i = e.get("origin"), s = e.get("previewMode"), l = Hi(), m = s === "true" || s === null && l.previewMode;
  return {
    themeId: o || l.themeId,
    editMode: !m && (r === "true" || r === null && l.editMode),
    editThemeToken: n || l.editThemeToken,
    origin: i,
    previewMode: m
  };
}, $e = () => {
  const [e, o] = O(gt);
  return Q(() => {
    const r = setTimeout(() => {
      const n = gt();
      o((i) => i.themeId !== n.themeId || i.editMode !== n.editMode || i.editThemeToken !== n.editThemeToken || i.origin !== n.origin || i.previewMode !== n.previewMode ? n : i);
    }, 0);
    return () => clearTimeout(r);
  }, []), e;
}, Jo = () => $e().editMode, Nr = sn(!1), Ni = ({ children: e }) => /* @__PURE__ */ t(Nr.Provider, { value: !0, children: e }), Oi = () => dn(Nr), Di = () => {
  const o = Array.from(document.getElementsByTagName("script")).find(
    (r) => {
      var n, i;
      return ((n = r.src) == null ? void 0 : n.includes("brandclub-checkout-shop-app")) || ((i = r.src) == null ? void 0 : i.includes("bc-checkout-shop-app"));
    }
  );
  if (o)
    try {
      return new URL(o.src).origin;
    } catch {
    }
  return window.location.origin;
}, Or = Di(), ve = `${Or}/api-rewards`;
Or.replace(/^https?:\/\//, "");
const Dr = {
  // Core colors
  primary: "#181d56",
  secondary: "#ffffff",
  tertiary: "#7e8fa8",
  accent: "#ffffff",
  background: "#ffffff",
  transparent: "#00000000",
  // Text colors
  textPrimary: "#181d56",
  textSecondary: "#181d56",
  textTertiary: "#7e8fa8",
  // UI colors
  borderColor: "#DCDCDC",
  buttonText: "#ffffff",
  // Semantic colors
  link: "#5572b7",
  success: "#71c285",
  error: "#ff534a",
  warning: "#ffbd32",
  info: "#5572b7"
}, ji = Object.keys(Dr), no = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, mt = (e) => {
  const o = no(e);
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, ut = (e) => {
  const o = no(e || "#000000");
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, ht = ({
  themeColors: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  isAddingColor: i,
  setIsAddingColor: s,
  newColorKey: l,
  setNewColorKey: m,
  newColorValue: p,
  setNewColorValue: y,
  onAddColor: c,
  onUpdateColor: g,
  onRenameColor: C,
  onDeleteColor: w,
  studioLockedColorKeys: k
}) => {
  const [x, f] = O(null), B = se({}), [P, u] = O({
    top: 0,
    left: 0,
    openAbove: !1
  }), [R, b] = O(null), [I, S] = O(null), [v, T] = O(null), W = se({}), [F, N] = O({
    top: 0,
    left: 0
  }), z = 300;
  Q(() => {
    if (x && B.current[x]) {
      const H = B.current[x].getBoundingClientRect(), Y = window.innerHeight - H.bottom, q = H.top, X = Y < z && q > Y;
      u({
        top: X ? H.top - 8 : H.bottom + 8,
        left: H.left + H.width / 2,
        openAbove: X
      });
    }
  }, [x]), Q(() => {
    if (!x) return;
    const H = ($) => {
      const Y = $.target;
      !Y.closest(".bc-theme-color-popover") && !Y.closest(".bc-theme-color-swatch") && f(null);
    };
    return document.addEventListener("mousedown", H), () => {
      document.removeEventListener("mousedown", H);
    };
  }, [x]), Q(() => {
    if (v && W.current[v]) {
      const H = W.current[v].getBoundingClientRect();
      N({
        top: H.bottom + 4,
        left: H.right
      });
    }
  }, [v]), Q(() => {
    if (!v) return;
    const H = ($) => {
      const Y = $.target;
      !Y.closest(".bc-theme-color-dropdown") && !Y.closest(".bc-theme-color-menu-btn") && T(null);
    };
    return document.addEventListener("mousedown", H), () => {
      document.removeEventListener("mousedown", H);
    };
  }, [v]);
  const A = (H, $) => {
    b(H), S({ name: H, value: no($) }), T(null), f(null);
  }, j = () => {
    b(null), S(null), f(null);
  }, Z = async (H) => {
    if (!I) return;
    const { name: $, value: Y } = I, q = mt(Y);
    if (!/^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/.test(q))
      return;
    $.trim() && $.trim() !== H && C && await C(H, $.trim());
    const V = mt(e[H]);
    if (q !== V) {
      const re = $.trim() || H;
      await g(re, q);
    }
    b(null), S(null), f(null);
  }, M = (H) => {
    I && S({ ...I, value: H });
  }, L = (H) => {
    I && S({ ...I, name: H });
  }, G = (H, $, Y, q) => {
    const X = x === H, V = no($), re = q && !n;
    return /* @__PURE__ */ h(D, { children: [
      re ? /* @__PURE__ */ t(
        "button",
        {
          ref: (K) => {
            B.current[H] = K;
          },
          type: "button",
          onClick: () => f(X ? null : H),
          className: "bc-theme-color-swatch",
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${d.border_glass}`,
            borderRadius: "6px",
            cursor: "pointer",
            padding: "2px",
            transition: "all 0.15s ease",
            backgroundColor: d.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          "aria-label": "Open color picker",
          children: /* @__PURE__ */ t(
            Po,
            {
              color: V,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ) : /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: "32px",
            height: "32px",
            border: `2px solid ${d.border_glass}`,
            borderRadius: "6px",
            padding: "2px",
            backgroundColor: d.white,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: /* @__PURE__ */ t(
            Po,
            {
              color: V,
              style: { width: "100%", height: "100%" },
              borderRadius: 4
            }
          )
        }
      ),
      X && re && Le.createPortal(
        /* @__PURE__ */ t(
          "div",
          {
            className: "bc-theme-color-popover",
            style: {
              position: "fixed",
              top: P.top,
              left: P.left,
              transform: P.openAbove ? "translate(-50%, -100%)" : "translateX(-50%)",
              zIndex: 1000002,
              backgroundColor: d.white,
              borderRadius: "12px",
              padding: "12px",
              boxShadow: `0 8px 24px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`
            },
            onClick: (K) => K.stopPropagation(),
            children: /* @__PURE__ */ t(Ar, { value: V, onChange: Y })
          }
        ),
        document.body
      )
    ] });
  };
  return /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ t("style", { children: `
        .bc-theme-color-swatch:hover:not(:disabled) {
          border-color: ${d.gray_border};
          transform: scale(1.05);
        }
        .bc-theme-color-menu-btn:hover:not(:disabled) {
          background: ${d.gray_light} !important;
        }
        .bc-theme-editor-row-container {
          display: flex;
          flex-direction: column;
        }
      ` }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
      /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
        "Colors",
        /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ t(
        so,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
        }
      )
    ] }),
    o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: n && Object.keys(e).length === 0 ? /* @__PURE__ */ t("div", { className: "bc-theme-editor-loading", children: "Loading colors..." }) : /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([H, $]) => {
        const Y = R === H, q = ji.includes(H), X = (k == null ? void 0 : k.has(H)) ?? !1, V = v === H, re = Y && I ? I.name : H, K = ut(Y && I ? I.value : $), te = Y && I ? I.value : $;
        return /* @__PURE__ */ h("div", { className: "bc-theme-editor-row-container", children: [
          /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
            /* @__PURE__ */ t(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: re,
                onChange: (ee) => Y && L(ee.target.value),
                readOnly: !Y,
                disabled: n,
                style: { cursor: Y ? "text" : "default" }
              }
            ),
            G(
              H,
              te,
              M,
              Y
              // only editable when in edit mode
            ),
            Y ? /* @__PURE__ */ t(
              "input",
              {
                type: "text",
                className: "bc-theme-editor-input",
                value: K,
                onChange: (ee) => {
                  const he = ee.target.value;
                  I && S({ ...I, value: he });
                },
                disabled: n,
                placeholder: "#000000 or #000000ff",
                maxLength: 9,
                style: {
                  width: "85px",
                  textAlign: "right",
                  fontFamily: "'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace"
                }
              }
            ) : /* @__PURE__ */ t(
              "span",
              {
                className: "bc-theme-editor-color-value",
                style: { cursor: "default" },
                children: K
              }
            ),
            X && !Y && /* @__PURE__ */ t(
              "span",
              {
                title: "Edit this color from Concierge Studio",
                style: {
                  display: "inline-flex",
                  alignItems: "center",
                  color: d.blue,
                  padding: "4px",
                  cursor: "help"
                },
                children: /* @__PURE__ */ t(Yo, { size: 14 })
              }
            ),
            !Y && !X && /* @__PURE__ */ t(
              "button",
              {
                ref: (ee) => {
                  W.current[H] = ee;
                },
                className: "bc-theme-color-menu-btn",
                onClick: () => T(V ? null : H),
                disabled: n,
                "aria-label": "Color options",
                style: {
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: "4px",
                  borderRadius: "4px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: d.gray_medium,
                  transition: "all 0.15s ease"
                },
                children: /* @__PURE__ */ t(Bn, { size: 16 })
              }
            ),
            V && Le.createPortal(
              /* @__PURE__ */ h(
                "div",
                {
                  className: "bc-theme-color-dropdown",
                  style: {
                    position: "fixed",
                    top: F.top,
                    left: F.left,
                    transform: "translateX(-100%)",
                    zIndex: 1000003,
                    backgroundColor: d.white,
                    borderRadius: "8px",
                    padding: "4px",
                    boxShadow: `0 4px 12px ${d.shadow_medium}, 0 0 0 1px ${d.border_glass}`,
                    minWidth: "100px"
                  },
                  onClick: (ee) => ee.stopPropagation(),
                  children: [
                    /* @__PURE__ */ t(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => A(H, $),
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: d.primary,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => ee.currentTarget.style.background = d.gray_light,
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Edit"
                      }
                    ),
                    /* @__PURE__ */ t(
                      "button",
                      {
                        className: "bc-theme-dropdown-item",
                        onClick: () => {
                          T(null), w(H);
                        },
                        disabled: q,
                        style: {
                          display: "block",
                          width: "100%",
                          padding: "8px 12px",
                          border: "none",
                          background: "transparent",
                          textAlign: "left",
                          cursor: q ? "not-allowed" : "pointer",
                          borderRadius: "4px",
                          fontSize: "13px",
                          color: q ? d.gray_medium : d.red,
                          opacity: q ? 0.5 : 1,
                          transition: "background 0.15s ease"
                        },
                        onMouseEnter: (ee) => {
                          q || (ee.currentTarget.style.background = d.gray_light);
                        },
                        onMouseLeave: (ee) => ee.currentTarget.style.background = "transparent",
                        children: "Delete"
                      }
                    )
                  ]
                }
              ),
              document.body
            )
          ] }),
          Y && /* @__PURE__ */ h(
            "div",
            {
              className: "bc-theme-editor-row-actions",
              style: {
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                marginLeft: "auto",
                justifyContent: "flex-end"
              },
              children: [
                /* @__PURE__ */ t(
                  oe,
                  {
                    variant: "primary",
                    size: "sm",
                    leftIcon: /* @__PURE__ */ t(_e, { size: 12 }),
                    onClick: () => Z(H),
                    disabled: n,
                    children: "Save"
                  }
                ),
                /* @__PURE__ */ t(
                  oe,
                  {
                    variant: "secondary",
                    size: "sm",
                    onClick: j,
                    disabled: n,
                    children: "Cancel"
                  }
                )
              ]
            }
          )
        ] }, H);
      }),
      i ? /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            className: "bc-theme-editor-input",
            placeholder: "Color name",
            value: l,
            onChange: (H) => m(H.target.value),
            disabled: n,
            autoFocus: !0
          }
        ),
        G(
          "__new_color__",
          p,
          y,
          !0
          // new color is editable
        ),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "primary",
            size: "sm",
            leftIcon: /* @__PURE__ */ t(_e, { size: 12 }),
            onClick: c,
            disabled: n || !l.trim(),
            children: "Save"
          }
        ),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "secondary",
            size: "sm",
            onClick: () => {
              s(!1), m(""), y("#000000ff");
            },
            disabled: n,
            children: "Cancel"
          }
        )
      ] }) : /* @__PURE__ */ t(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ t(Qo, { size: 12 }),
          onClick: () => s(!0),
          disabled: n,
          children: "Add Color"
        }
      )
    ] }) })
  ] });
}, Gi = (e) => {
  const o = {};
  let r = !1;
  for (const [n, i] of Object.entries(e))
    typeof i == "string" && i.startsWith("#") ? (o[n] = { type: "custom", value: i }, r = !0) : o[n] = i;
  return { migrated: o, needsMigration: r };
}, $i = (e) => {
  const o = {};
  for (const [r, n] of Object.entries(Dr))
    r in e || (o[r] = n);
  return o;
}, jr = (e) => {
  if (!e) return { processedTheme: e, needsUpdate: !1 };
  let o = !1;
  const r = { ...e };
  r.config || (r.config = {});
  const n = r.config.colors || {}, i = $i(n);
  if (Object.keys(i).length > 0 && (r.config.colors = { ...n, ...i }, o = !0), r.config.widgetConfig) {
    const s = {};
    for (const [l, m] of Object.entries(
      r.config.widgetConfig
    )) {
      const { migrated: p, needsMigration: y } = Gi(
        m
      );
      s[l] = p, y && (o = !0);
    }
    r.config.widgetConfig = s;
  }
  return { processedTheme: r, needsUpdate: o };
}, Gr = async (e, o) => {
  try {
    console.log(
      `Theme ${e} needs migration. Will be migrated on next save.`
    );
  } catch (r) {
    console.error(`Failed to migrate theme ${e}:`, r);
  }
}, Yi = async (e) => {
  const o = await fetch(
    `${ve}/brand-app-widget-theme/by-theme-id?appThemeId=${e}`
  );
  if (!o.ok)
    throw new Error("Failed to fetch widget theme");
  const r = await o.json(), { processedTheme: n, needsUpdate: i } = jr(r);
  return i && Gr(e, n.config), n;
}, Qi = async (e) => {
  const o = await fetch(
    `${ve}/brand-app-widget-theme/published-by-app-id?appId=${e}`
  );
  if (!o.ok)
    throw new Error("Failed to fetch published widget theme");
  const r = await o.json(), { processedTheme: n, needsUpdate: i } = jr(r);
  return i && (n != null && n.appThemeId) && Gr(
    n.appThemeId,
    n.config
  ), n;
}, Xi = async ({
  themeId: e,
  editThemeToken: o
}) => {
  try {
    const r = await fetch(
      `${ve}/brand-app-widget-theme/validate-edit-token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          appThemeId: e,
          editThemeToken: o
        })
      }
    );
    return r.ok ? (await r.json()).valid === !0 : !1;
  } catch {
    return !1;
  }
}, $r = async ({
  themeId: e,
  widgetId: o,
  widgetState: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ve}/brand-app-widget-theme/update-widget-config`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        widgetId: o,
        widgetState: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let s = "Failed to update widget config";
    try {
      s = (await i.json()).message || s;
    } catch {
    }
    throw new Error(s);
  }
  return i.json();
}, yt = async ({
  themeId: e,
  colorKey: o,
  colorValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ve}/brand-app-widget-theme/set-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: o,
        colorValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let s = "Failed to set theme color";
    try {
      s = (await i.json()).message || s;
    } catch {
    }
    throw new Error(s);
  }
  return i.json();
}, Ji = async ({
  themeId: e,
  colorKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${ve}/brand-app-widget-theme/delete-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        colorKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme color";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, Zi = async ({
  themeId: e,
  oldColorKey: o,
  newColorKey: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ve}/brand-app-widget-theme/rename-theme-color`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        oldColorKey: o,
        newColorKey: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let s = "Failed to rename theme color";
    try {
      s = (await i.json()).message || s;
    } catch {
    }
    throw new Error(s);
  }
  return i.json();
}, bt = async ({
  themeId: e,
  fileName: o,
  contentType: r,
  assetType: n,
  editThemeToken: i
}) => {
  const s = await fetch(
    `${ve}/brand-app-widget-theme/generate-asset-upload-url`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fileName: o,
        contentType: r,
        assetType: n,
        editThemeToken: i
      })
    }
  );
  if (!s.ok) {
    let m = "Failed to generate upload URL";
    try {
      const p = await s.json();
      m = p.errorMessage || p.message || m;
    } catch {
    }
    throw new Error(m);
  }
  const l = await s.json();
  if (l.status === "failed")
    throw new Error(l.errorMessage || "Failed to generate upload URL");
  return {
    signedUploadUrl: l.signedUploadUrl,
    objectPublicUrl: l.objectPublicUrl
  };
}, ft = async ({
  file: e,
  signedUploadUrl: o
}) => {
  if (!(await fetch(o, {
    method: "PUT",
    body: e,
    headers: {
      "Content-Type": e.type
    }
  })).ok)
    throw new Error("Failed to upload file to S3");
}, Ui = async ({
  themeId: e,
  fontKey: o,
  fontValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ve}/brand-app-widget-theme/set-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: o,
        fontValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let s = "Failed to set theme font";
    try {
      s = (await i.json()).message || s;
    } catch {
    }
    throw new Error(s);
  }
  return i.json();
}, Vi = async ({
  themeId: e,
  fontKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${ve}/brand-app-widget-theme/delete-theme-font`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        fontKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme font";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, _i = async ({
  themeId: e,
  iconKey: o,
  iconValue: r,
  editThemeToken: n
}) => {
  const i = await fetch(
    `${ve}/brand-app-widget-theme/set-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: o,
        iconValue: r,
        editThemeToken: n
      })
    }
  );
  if (!i.ok) {
    let s = "Failed to set theme icon";
    try {
      s = (await i.json()).message || s;
    } catch {
    }
    throw new Error(s);
  }
  return i.json();
}, qi = async ({
  themeId: e,
  iconKey: o,
  editThemeToken: r
}) => {
  const n = await fetch(
    `${ve}/brand-app-widget-theme/delete-theme-icon`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        appThemeId: e,
        iconKey: o,
        editThemeToken: r
      })
    }
  );
  if (!n.ok) {
    let i = "Failed to delete theme icon";
    try {
      i = (await n.json()).message || i;
    } catch {
    }
    throw new Error(i);
  }
  return n.json();
}, He = ["bc-widget-theme"], Yr = "bc-theme-updated";
let xo = null, xt = !1;
const Ki = (e) => {
  xo = e, Q(() => {
    if (xt) return;
    xt = !0;
    const o = (r) => {
      var i;
      if (r.origin !== window.location.origin || ((i = r.data) == null ? void 0 : i.type) !== Yr || !xo) return;
      const { themeId: n } = r.data.payload;
      xo.refetchQueries({
        queryKey: [...He, n]
      });
    };
    window.addEventListener("message", o);
  }, []);
}, ze = () => {
  const e = $e(), o = $o();
  return Ki(o), cn({
    queryKey: [...He, e.themeId],
    queryFn: async () => {
      if (e.themeId)
        return Yi(e.themeId);
      const r = window.location.hostname;
      return Qi(r);
    },
    staleTime: 5 * 60 * 1e3
    // 5 minutes
  });
}, Zo = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = ze();
  return {
    themeColors: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.colors) || {},
    isLoading: o,
    refreshThemeColors: async () => {
      await r();
    }
  };
}, Qr = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = ze();
  return {
    themeFonts: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.fonts) || {},
    isLoading: o,
    refreshThemeFonts: async () => {
      await r();
    }
  };
}, Xr = () => {
  var n;
  const { data: e, isLoading: o, refetch: r } = ze();
  return {
    themeIcons: ((n = e == null ? void 0 : e.config) == null ? void 0 : n.icons) || {},
    isLoading: o,
    refreshThemeIcons: async () => {
      await r();
    }
  };
}, ea = (e, o) => {
  var s, l;
  const { data: r, isLoading: n } = ze(), i = e ? (l = (s = r == null ? void 0 : r.config) == null ? void 0 : s.widgetConfig) == null ? void 0 : l[e] : void 0;
  return {
    ...o,
    ...i,
    isLoading: n,
    savedKeys: new Set(i ? Object.keys(i) : [])
  };
}, Eo = (e) => {
  const o = $o(), r = $e();
  return { updateWidgetConfig: (l, m) => {
    e && o.setQueryData(
      [...He, r.themeId],
      (p) => {
        var y, c, g;
        return p ? {
          ...p,
          config: {
            ...p == null ? void 0 : p.config,
            widgetConfig: {
              ...(y = p == null ? void 0 : p.config) == null ? void 0 : y.widgetConfig,
              [e]: {
                ...(g = (c = p == null ? void 0 : p.config) == null ? void 0 : c.widgetConfig) == null ? void 0 : g[e],
                [l]: m
              }
            }
          }
        } : {
          config: {
            widgetConfig: {
              [e]: {
                [l]: m
              }
            }
          }
        };
      }
    );
  }, removeWidgetConfigKey: (l) => {
    e && o.setQueryData(
      [...He, r.themeId],
      (m) => {
        var c, g;
        if (!((g = (c = m == null ? void 0 : m.config) == null ? void 0 : c.widgetConfig) != null && g[e])) return m;
        const { [l]: p, ...y } = m.config.widgetConfig[e];
        return {
          ...m,
          config: {
            ...m.config,
            widgetConfig: {
              ...m.config.widgetConfig,
              [e]: y
            }
          }
        };
      }
    );
  }, getWidgetState: () => {
    var m, p;
    if (!e) return;
    const l = o.getQueryData([
      ...He,
      r.themeId
    ]);
    return (p = (m = l == null ? void 0 : l.config) == null ? void 0 : m.widgetConfig) == null ? void 0 : p[e];
  } };
}, Fs = () => {
  const { data: e } = ze();
  return e == null ? void 0 : e.studioAvailability;
}, Is = () => {
  const { data: e } = ze();
  return e == null ? void 0 : e.studioAgentName;
}, oa = (e, o = 32, r = 4) => {
  const n = window.innerWidth, i = window.innerHeight, s = n < 768, l = e.left, m = n - e.right, p = e.top, y = i - e.bottom, c = o + r, g = l >= c, C = m >= c, w = p >= c, k = y >= c;
  let x = "top-left", f = {};
  return s ? C && w ? (x = "top-right", f = {
    top: e.top - r,
    left: e.right - o + r
  }) : C && k ? (x = "bottom-right", f = {
    top: e.bottom - o + r,
    left: e.right - o + r
  }) : g && w ? (x = "top-left", f = {
    top: e.top - r,
    left: e.left - r
  }) : g && k ? (x = "bottom-left", f = {
    top: e.bottom - o + r,
    left: e.left - r
  }) : (x = "top-right", f = {
    top: e.top + r,
    left: e.right - o - r
  }) : g && w ? (x = "top-left", f = {
    top: e.top - r,
    left: e.left - r
  }) : C && w ? (x = "top-right", f = {
    top: e.top - r,
    left: e.right - o + r
  }) : g && k ? (x = "bottom-left", f = {
    top: e.bottom - o + r,
    left: e.left - r
  }) : C && k ? (x = "bottom-right", f = {
    top: e.bottom - o + r,
    left: e.right - o + r
  }) : (x = "top-left", f = {
    top: e.top + r,
    left: e.left + r
  }), { position: x, style: f };
}, J = ({
  children: e,
  widgetId: o,
  displayName: r,
  editFields: n,
  editValues: i,
  onEditChange: s,
  onSave: l,
  isSaving: m = !1,
  savedKeys: p,
  studioLockedKeys: y,
  onResetField: c,
  themeColors: g = {},
  themeFonts: C = {},
  themeIcons: w = {},
  triggerMode: k = "hover",
  triggerIcon: x = "pencil",
  triggerPosition: f = "bottom-right",
  triggerLabel: B,
  wrapperStyle: P,
  containerClassName: u,
  iconOffset: R
}) => {
  const { data: b } = ze(), I = ae(() => {
    var be;
    if (y) return y;
    const U = (be = b == null ? void 0 : b.studioControlledKeys) == null ? void 0 : be.widgetConfig;
    if (!U || !o) return;
    const de = U[o];
    return de != null && de.length ? new Set(de) : void 0;
  }, [y, b, o]), [S, v] = O(!1), [T, W] = O({ x: 0, y: 0 }), [F, N] = O(null), [z, A] = O(!1), [j, Z] = O(
    null
  ), [M, L] = O(!1), [G, H] = O(!1), $ = se(null), Y = se(null), q = se(null), X = Jo(), V = Oi(), re = (k === "persistent" || M || G) && !S, K = pe(() => {
    if (q.current) {
      const U = q.current.getBoundingClientRect();
      if (k === "persistent") {
        const fe = B ? 160 : 28, le = {};
        f.includes("top") ? le.top = U.top + 12 : le.top = U.bottom - 32 - 12, f.includes("right") ? le.left = U.right - fe - 12 : le.left = U.left + 12, Z(le);
      } else {
        const { style: de } = oa(U);
        R && (R.top && (de.top = (de.top ?? 0) + R.top), R.left && (de.left = (de.left ?? 0) + R.left)), Z(de);
      }
    }
  }, [k, f, R]);
  Q(() => {
    if (!X || !re) {
      Z(null);
      return;
    }
    K();
    const U = () => K();
    return window.addEventListener("scroll", U, !0), window.addEventListener("resize", U), () => {
      window.removeEventListener("scroll", U, !0), window.removeEventListener("resize", U);
    };
  }, [X, re, K]);
  const te = pe(() => F ? JSON.stringify(i) !== JSON.stringify(F) : !1, [i, F]);
  if (Q(() => o ? Hr((de) => {
    de !== o && S && (te() ? A(!0) : v(!1));
  }) : void 0, [o, S, te]), Q(() => () => {
    $.current && clearTimeout($.current);
  }, []), !X || V)
    return /* @__PURE__ */ t(D, { children: e });
  const ee = () => {
    if (Y.current) {
      const U = Y.current.getBoundingClientRect(), de = window.innerWidth, be = window.innerHeight, fe = 620, le = 450, ge = 10, Oe = be - U.bottom, Ye = U.top, Qe = de - U.left, mo = U.right;
      let Fe;
      Oe >= le + ge ? Fe = U.bottom + ge : Ye >= le + ge ? Fe = U.top - le - ge : Oe >= Ye ? Fe = Math.max(ge, be - le - ge) : Fe = Math.max(ge, U.top - le - ge);
      let Ce;
      Qe >= fe ? Ce = U.left : mo >= fe ? Ce = U.right - fe : Ce = Math.max(
        ge,
        Math.min(de - fe - ge, U.left)
      ), Ce = Math.max(ge, Math.min(Ce, de - fe - ge)), Fe = Math.max(ge, Math.min(Fe, be - le - ge)), W({ x: Ce, y: Fe });
    }
    (!F || JSON.stringify(i) === JSON.stringify(F)) && N({ ...i }), v(!0), o && Rr(o);
  }, he = () => {
    F && Object.keys(F).forEach((U) => {
      s(U, F[U]);
    });
  }, Re = () => {
    l && l(), N({ ...i });
  }, ye = () => {
    he(), A(!1), v(!1);
  }, Be = () => {
    Re(), A(!1), v(!1);
  }, ke = () => {
    A(!1), v(!1);
  }, Pe = () => {
    if (!j) return null;
    const U = k === "persistent", de = x === "gear" ? So : wr, fe = U && B ? (
      // Labeled button for persistent mode (more discoverable)
      /* @__PURE__ */ h(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: j.top,
            left: j.left,
            height: 32,
            background: G ? d.blue_light : "rgba(255, 255, 255, 0.92)",
            border: `1px solid ${G ? d.blue : "rgba(0,0,0,0.12)"}`,
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            gap: "6px",
            padding: "0 12px 0 8px",
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.12)",
            transition: "all 0.2s ease",
            transform: G ? "scale(1.03)" : "scale(1)",
            opacity: G ? 1 : 0.85,
            zIndex: 999998,
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
            whiteSpace: "nowrap"
          },
          onMouseDown: (le) => le.stopPropagation(),
          onClick: (le) => {
            le.stopPropagation(), le.preventDefault(), ee();
          },
          onMouseEnter: () => {
            $.current && (clearTimeout($.current), $.current = null), H(!0);
          },
          onMouseLeave: () => H(!1),
          "aria-label": B,
          children: [
            /* @__PURE__ */ t(
              de,
              {
                size: 14,
                color: G ? d.blue : d.gray_dark
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: "11px",
                  fontWeight: 600,
                  color: G ? d.blue : d.gray_dark,
                  letterSpacing: "0.2px"
                },
                children: B
              }
            )
          ]
        }
      )
    ) : (
      // Icon-only button (standard for hover mode, compact for persistent without label)
      /* @__PURE__ */ t(
        "button",
        {
          ref: Y,
          style: {
            position: "fixed",
            top: j.top,
            left: j.left,
            width: U ? 28 : 32,
            height: U ? 28 : 32,
            background: G ? d.blue_light : U ? "rgba(255, 255, 255, 0.85)" : d.white,
            border: `1px solid ${G ? d.blue : U ? "rgba(0,0,0,0.1)" : d.gray_border}`,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            boxShadow: U ? "0 1px 4px rgba(0, 0, 0, 0.1)" : "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "background 0.2s, border-color 0.2s, transform 0.2s, opacity 0.2s",
            transform: G ? "scale(1.05)" : "scale(1)",
            opacity: U && !G ? 0.7 : 1,
            zIndex: 999998,
            padding: 0
          },
          onMouseDown: (le) => le.stopPropagation(),
          onClick: (le) => {
            le.stopPropagation(), le.preventDefault(), ee();
          },
          onMouseEnter: () => {
            $.current && (clearTimeout($.current), $.current = null), H(!0);
          },
          onMouseLeave: () => H(!1),
          "aria-label": x === "gear" ? "Edit layout" : "Edit widget",
          children: /* @__PURE__ */ t(de, { size: U ? 14 : 16, color: d.gray_dark })
        }
      )
    );
    return Le.createPortal(fe, document.body);
  };
  return /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: `
        .widget-wrapper {
          position: relative;
          display: inline-block;
          width: 100%;
        }

        .widget-wrapper.widget-fill-container,
        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-fill-height {
          display: flex;
          flex-direction: column;
          flex: 1;
          min-height: 0;
        }

        .widget-wrapper.widget-hovered {
          outline: 1px dashed ${d.blue};
        }

        .widget-wrapper.widget-editing {
          outline: 2px dashed ${d.blue};
        }
      ` }),
    /* @__PURE__ */ h(
      "div",
      {
        ref: q,
        className: `widget-wrapper${k === "persistent" ? " widget-fill-container" : ""}${u ? ` ${u}` : ""}${S ? " widget-editing" : re ? " widget-hovered" : ""}`,
        style: P,
        onMouseEnter: () => {
          $.current && (clearTimeout($.current), $.current = null), L(!0);
        },
        onMouseLeave: () => {
          $.current = setTimeout(() => {
            L(!1);
          }, 200);
        },
        children: [
          e,
          S && /* @__PURE__ */ t(
            Lr,
            {
              widgetId: o,
              displayName: r,
              fields: n,
              values: i,
              initialValues: F || void 0,
              onChange: s,
              onClose: () => v(!1),
              onReset: he,
              screenPosition: T,
              onSave: Re,
              isSaving: m,
              savedKeys: p,
              studioLockedKeys: I,
              onResetField: c,
              themeColors: g,
              themeFonts: C,
              themeIcons: w
            }
          ),
          z && /* @__PURE__ */ t(
            qe,
            {
              title: "Unsaved Changes",
              message: "You have unsaved changes. Would you like to save them before closing?",
              confirmLabel: "Save",
              cancelLabel: "Discard",
              onConfirm: Be,
              onCancel: ye,
              onDismiss: ke,
              isLoading: m
            }
          )
        ]
      }
    ),
    re && Pe()
  ] });
}, Jr = (e, o, r = "#000000") => e ? typeof e == "string" ? e : e.type === "custom" ? e.value : o[e.value] ?? r : r, ta = (e) => (o, r = "#000000") => Jr(o, e, r), Ps = () => {
  const { themeColors: e } = Zo();
  return pe(
    (r, n = "#000000") => Jr(r, e, n),
    [e]
  );
};
function _(e, o, r) {
  const { isLoading: n, savedKeys: i, ...s } = ea(
    e,
    o
  ), l = s, [m, p] = O(!1), { themeColors: y } = Zo(), { themeFonts: c } = Qr(), { themeIcons: g } = Xr(), C = ae(
    () => ta(y),
    [y]
  ), { data: w } = ze(), k = ae(() => {
    var W;
    const T = (W = w == null ? void 0 : w.studioControlledKeys) == null ? void 0 : W.widgetConfig;
    return !T || !e ? /* @__PURE__ */ new Set() : new Set(T[e] || []);
  }, [w, e]), x = $e(), {
    updateWidgetConfig: f,
    removeWidgetConfigKey: B,
    getWidgetState: P
  } = Eo(e), u = pe(
    (T) => {
      B(T);
    },
    [B]
  ), R = ae(() => {
    const T = {};
    return r.forEach((W) => {
      T[W.key] = W.type, W.responsive && (T[`mobile_${W.key}`] = W.type);
    }), T;
  }, [r]), b = pe(
    (T, W) => {
      if (k.has(T)) return;
      const F = R[T];
      let N = W;
      switch (F) {
        case "toggle":
          typeof W == "string" && (N = W === "true");
          break;
        case "number":
          if (typeof W == "string" && W !== "") {
            const z = parseFloat(W);
            isNaN(z) || (N = z);
          }
          break;
        case "options":
          typeof W == "string" && (W === "true" ? N = !0 : W === "false" ? N = !1 : /^\d+$/.test(W) && (N = parseInt(W, 10)));
          break;
      }
      f(T, N);
    },
    [R, f]
  ), I = !!(x.themeId && x.editThemeToken && e), S = pe(async () => {
    if (!x.themeId || !x.editThemeToken || !e) {
      console.warn("Cannot save: missing themeId or editThemeToken");
      return;
    }
    p(!0);
    try {
      const T = P() || l;
      await $r({
        themeId: x.themeId,
        widgetId: e,
        widgetState: T,
        editThemeToken: x.editThemeToken
      });
    } catch (T) {
      console.error("Failed to save widget config:", T), alert(`Failed to save: ${T.message}`);
    } finally {
      p(!1);
    }
  }, [x, e, P, l]), v = pe(() => {
    const T = { ...l };
    return r.forEach((W) => {
      const F = T[W.key];
      W.type === "options" && (typeof F == "boolean" ? T[W.key] = F ? "true" : "false" : typeof F == "number" && (T[W.key] = String(F)));
    }), T;
  }, [l, r]);
  return {
    state: l,
    isLoading: n,
    isSaving: m,
    handleEditChange: b,
    handleSave: S,
    resetField: u,
    savedKeys: i,
    studioLockedKeys: k,
    themeColors: y,
    themeFonts: c,
    themeIcons: g,
    resolveColor: C,
    canSave: I,
    getEditValues: v
  };
}
const Ne = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" }
], ie = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" },
  // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }
  // CSS doesn't have keyword for 900, use numeric
];
Ne.slice(
  0,
  4
);
const Ct = Ne.slice(1, 4), ra = Ne.slice(0, 3), na = {
  expanded: {
    shadowEnabled: !0,
    shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
    borderColor: a("borderColor"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 15,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    paddingX: 12,
    paddingY: 12,
    minHeight: 138,
    mobile_paddingX: 12,
    mobile_paddingY: 12,
    mobile_minHeight: 116
  },
  compact: {
    shadowEnabled: !0,
    shadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)",
    borderColor: a("borderColor"),
    borderColorFocus: a("borderColor"),
    borderRadiusSingleLine: 28,
    borderRadiusMultiLine: 15,
    borderWidth: 1,
    fontSize: 14,
    paddingX: 12,
    paddingY: 12,
    minHeight: 0,
    mobile_fontSize: 14,
    mobile_paddingX: 12,
    mobile_paddingY: 12,
    mobile_minHeight: 0
  }
}, ia = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Xe = {
  preset: "compact",
  // Background
  backgroundColor: a("secondary"),
  shadowEnabled: !0,
  shadow: "8px 8px 14px 0px rgba(0, 0, 0, 0.03)",
  // Border styling
  borderColor: a("borderColor"),
  borderColorFocus: a("borderColor"),
  borderRadiusSingleLine: 28,
  borderRadiusMultiLine: 15,
  borderWidth: 1,
  // Submit button
  submitButtonBgColor: a("textPrimary"),
  submitButtonBgColorHover: a("textPrimary"),
  submitButtonIconColor: a("secondary"),
  submitButtonSize: 20,
  submitButtonBorderRadius: 14,
  // Action icons (attachment, mic)
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 16,
  iconGap: 8,
  micActiveColor: a("error"),
  microphoneIcon: "default",
  // Textarea typography
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  textColor: a("textPrimary"),
  placeholderColor: a("textPrimary"),
  // Layout
  paddingX: 12,
  paddingY: 12,
  maxWidth: 768,
  minHeight: 0,
  // Visibility toggles
  showAttachmentButton: !0,
  showMicrophoneButton: !0,
  // Mobile overrides
  mobile_fontSize: 14,
  mobile_paddingX: 12,
  mobile_paddingY: 12,
  mobile_minHeight: 0
}, kt = [
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: [
      { label: "Expanded", value: "expanded" },
      { label: "Compact", value: "compact" },
      { label: "Custom", value: "custom" }
    ]
  },
  // Background
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "shadowEnabled", label: "Shadow", type: "toggle" },
  { key: "shadow", label: "Shadow Value (CSS)", type: "text" },
  // Border styling group
  { key: "borderColor", label: "Border Color", type: "color" },
  { key: "borderColorFocus", label: "Border Color (Focus)", type: "color" },
  {
    key: "borderRadiusSingleLine",
    label: "Border Radius (Single Line)",
    type: "number",
    min: 0,
    max: 100,
    step: 1
  },
  {
    key: "borderRadiusMultiLine",
    label: "Border Radius (Multi Line)",
    type: "number",
    min: 0,
    max: 50,
    step: 1
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 1
  },
  // Submit button group
  { key: "submitButtonBgColor", label: "Submit Button Color", type: "color" },
  {
    key: "submitButtonBgColorHover",
    label: "Submit Button Hover Color",
    type: "color"
  },
  {
    key: "submitButtonIconColor",
    label: "Submit Button Icon Color",
    type: "color"
  },
  {
    key: "submitButtonSize",
    label: "Submit Button Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "submitButtonBorderRadius",
    label: "Submit Button Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  // Action icons group
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "iconColorHover", label: "Icon Hover Color", type: "color" },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2
  },
  {
    key: "iconGap",
    label: "Icon Gap",
    type: "number",
    min: 4,
    max: 32,
    step: 2
  },
  { key: "micActiveColor", label: "Mic Active Color", type: "color" },
  { key: "microphoneIcon", label: "Microphone Icon", type: "icon" },
  // Typography group
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ie
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "placeholderColor", label: "Placeholder Color", type: "color" },
  // Layout group
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 2,
    responsive: !0
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 1200,
    step: 50
  },
  {
    key: "minHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 300,
    step: 10,
    responsive: !0
  },
  // Visibility toggles
  {
    key: "showAttachmentButton",
    label: "Show Attachment Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  },
  {
    key: "showMicrophoneButton",
    label: "Show Microphone Button",
    type: "options",
    options: [
      { label: "Yes", value: "true" },
      { label: "No", value: "false" }
    ]
  }
], Ts = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    resetField: y,
    savedKeys: c,
    themeColors: g,
    themeFonts: C,
    themeIcons: w,
    resolveColor: k,
    canSave: x,
    getEditValues: f
  } = _(
    o,
    { ...Xe, ...e },
    kt
  ), B = pe(
    (F, N) => {
      if (F === "preset" && N !== "custom") {
        const A = na[N];
        if (A) {
          m("preset", N), Object.entries(A).forEach(([j, Z]) => {
            m(j, Z);
          });
          return;
        }
      }
      F !== "preset" && m("preset", "custom"), m(F, N);
    },
    [m]
  ), P = i.fontFamily, u = P && P !== "inherit" ? C[P] : null, R = u && u.format === "google" ? u.url : null;
  if (Q(() => {
    R && ia(R);
  }, [R]), Q(() => {
    !s && !c.has("iconGap") && (c.has("iconSize") && i.iconSize !== Xe.iconSize && B("iconSize", Xe.iconSize), c.has("submitButtonSize") && i.submitButtonSize !== Xe.submitButtonSize && B("submitButtonSize", Xe.submitButtonSize));
  }, [s]), s)
    return /* @__PURE__ */ t(D, {});
  const b = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", I = u && u.format !== "system" && u.format !== "google", S = `chat-input-${o || "default"}`, v = `
    ${I ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${b !== "inherit" ? `.${S} { font-family: ${b} !important; }` : ""}
  `.trim(), T = {
    ...i,
    fontFamilyCss: b
  }, W = /* @__PURE__ */ h(D, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(T, w, k)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: kt,
      editValues: f(),
      onEditChange: B,
      onSave: x ? p : void 0,
      isSaving: l,
      savedKeys: c,
      onResetField: y,
      themeColors: g,
      themeFonts: C,
      themeIcons: w,
      children: W
    }
  );
}, vt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, aa = {
  // Headings - decreasing sizes with bold weight
  h1: {
    fontSize: 28,
    fontWeight: "700",
    lineHeight: 1.3,
    marginTop: 16,
    marginBottom: 12,
    color: a("textPrimary")
  },
  h2: {
    fontSize: 24,
    fontWeight: "700",
    lineHeight: 1.35,
    marginTop: 14,
    marginBottom: 10,
    color: a("textPrimary")
  },
  h3: {
    fontSize: 20,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 12,
    marginBottom: 8,
    color: a("textPrimary")
  },
  h4: {
    fontSize: 18,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 10,
    marginBottom: 6
  },
  h5: {
    fontSize: 16,
    fontWeight: "600",
    lineHeight: 1.4,
    marginTop: 8,
    marginBottom: 4
  },
  // Text elements
  p: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 0,
    marginBottom: 12,
    color: a("textPrimary")
  },
  strong: { fontWeight: "600" },
  em: { fontWeight: "500" },
  code: { fontSize: 14, fontWeight: "500", lineHeight: 1.4 },
  blockquote: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginTop: 8,
    marginBottom: 8,
    color: a("textPrimary")
  },
  // Lists
  ul: { marginTop: 8, marginBottom: 12 },
  ol: { marginTop: 8, marginBottom: 12 },
  li: {
    fontSize: 16,
    fontWeight: "500",
    lineHeight: 1.6,
    marginBottom: 4,
    color: a("textPrimary")
  },
  // Tables
  table: { fontSize: 14, marginTop: 8, marginBottom: 12 },
  thead: {
    fontWeight: "600",
    backgroundColor: a("primary"),
    color: a("primaryForeground")
  },
  tbody: { fontWeight: "500" },
  tr: {},
  th: {
    fontSize: 14,
    fontWeight: "600",
    lineHeight: 1.4,
    color: a("primaryForeground")
  },
  td: {
    fontSize: 14,
    fontWeight: "500",
    lineHeight: 1.4,
    color: a("textPrimary")
  }
}, la = {
  // Background & Colors (defaults for user message, assistant can override via widgetId)
  bgColor: a("background"),
  // blueWhite-like for user
  textColor: a("textPrimary"),
  // Border radius
  borderRadius: 23,
  borderRadiusShort: 100,
  // pill shape for short messages
  // Typography
  fontSize: 16,
  fontWeight: "500",
  fontFamily: "inherit",
  lineHeight: 1.5,
  // Padding
  paddingX: 16,
  paddingY: 12,
  // Single-line height
  singleLineHeight: 46,
  // Layout
  maxWidth: "70%",
  alignment: "left",
  // Short message threshold
  shortMessageThreshold: 50,
  // Element styles with defaults
  elementStyles: aa
}, Je = (e, o, r) => {
  const n = `elementStyles.${e}`, i = [
    {
      key: `${n}.fontFamily`,
      label: `${o} Font`,
      type: "font"
    },
    {
      key: `${n}.fontSize`,
      label: `${o} Font Size`,
      type: "number",
      min: 10,
      max: 48,
      step: 1
    },
    {
      key: `${n}.fontWeight`,
      label: `${o} Font Weight`,
      type: "options",
      options: Ne
    },
    {
      key: `${n}.color`,
      label: `${o} Color`,
      type: "color"
    }
  ];
  return r != null && r.includeBackgroundColor && i.push({
    key: `${n}.backgroundColor`,
    label: `${o} Background`,
    type: "color"
  }), i.push(
    {
      key: `${n}.lineHeight`,
      label: `${o} Line Height`,
      type: "number",
      min: 1,
      max: 2.5,
      step: 0.1
    },
    {
      key: `${n}.marginTop`,
      label: `${o} Margin Top`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    },
    {
      key: `${n}.marginBottom`,
      label: `${o} Margin Bottom`,
      type: "number",
      min: 0,
      max: 32,
      step: 2
    }
  ), i;
}, Ze = {
  h1: "H1",
  h2: "H2",
  h3: "H3",
  h4: "H4",
  h5: "H5",
  p: "Paragraph",
  strong: "Bold",
  em: "Italic",
  code: "Code",
  blockquote: "Blockquote",
  ul: "Unordered List",
  ol: "Ordered List",
  li: "List Item",
  table: "Table",
  thead: "Table Header",
  tbody: "Table Body",
  tr: "Table Row",
  th: "Header Cell",
  td: "Table Cell"
}, Zr = [
  { key: "bgColor", label: "Background Color", type: "color" },
  { key: "textColor", label: "Text Color", type: "color" },
  {
    key: "borderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "borderRadiusShort",
    label: "Short Msg Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 5
  },
  {
    key: "fontSize",
    label: "Base Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Base Font Weight",
    type: "options",
    options: ra
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  {
    key: "lineHeight",
    label: "Base Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "paddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "singleLineHeight",
    label: "Single Line Height (px)",
    type: "number",
    min: 0,
    max: 80,
    step: 1
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "alignment",
    label: "Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Right", value: "right" },
      { label: "Center", value: "center" }
    ]
  }
], sa = ["h1", "h2", "h3"], da = ["p", "blockquote"], ca = ["li"], pa = ["th", "td"], ga = ["thead"], ma = [
  ...sa.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...da.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...ca.flatMap(
    (e) => Je(e, Ze[e])
  ),
  ...ga.flatMap(
    (e) => Je(e, Ze[e], {
      includeBackgroundColor: !0
    })
  ),
  ...pa.flatMap(
    (e) => Je(e, Ze[e])
  )
], ua = [...Zr, ...ma], ha = (e, o, r, n) => {
  if (!o) return "";
  const i = [], s = [], l = /* @__PURE__ */ new Set();
  for (const [m, p] of Object.entries(o)) {
    if (!p) continue;
    const y = [];
    if (p.fontSize !== void 0 && y.push(`font-size: ${p.fontSize}px`), p.fontWeight !== void 0 && y.push(`font-weight: ${p.fontWeight}`), p.color && p.color !== "inherit") {
      const c = n(p.color);
      y.push(`color: ${c}`);
    }
    if (p.backgroundColor && p.backgroundColor !== "inherit" && p.backgroundColor !== "transparent") {
      const c = n(p.backgroundColor);
      y.push(`background-color: ${c}`);
    }
    if (p.lineHeight !== void 0 && y.push(`line-height: ${p.lineHeight}`), p.marginTop !== void 0 && y.push(`margin-top: ${p.marginTop}px`), p.marginBottom !== void 0 && y.push(`margin-bottom: ${p.marginBottom}px`), p.fontFamily && p.fontFamily !== "inherit") {
      const c = r[p.fontFamily];
      c && (c.format === "system" ? y.push(`font-family: ${c.url}`) : (y.push(`font-family: "${c.name}", sans-serif`), c.format !== "google" && !l.has(c.name) && (s.push(`
              @font-face {
                font-family: "${c.name}";
                src: url("${c.url}") format("${c.format}");
                font-display: swap;
              }
            `), l.add(c.name))));
    }
    y.length > 0 && i.push(`#concierge-mount .${e} .message-content ${m},
#concierge-mount .${e} .message-content .message-markdown ${m},
.${e} .message-content ${m},
.${e} .message-content .message-markdown ${m} {
  ${y.join(`;
  `)};
}`);
  }
  return [...s, ...i].join(`

`);
}, ya = (e, o, r) => {
  const n = o.split("."), i = { ...e };
  let s = i;
  for (let l = 0; l < n.length - 1; l++) {
    const m = n[l];
    s[m] = { ...s[m] }, s = s[m];
  }
  return s[n[n.length - 1]] = r, i;
}, ba = (e) => {
  const o = {};
  for (const [r, n] of Object.entries(e))
    if (r === "elementStyles" && typeof n == "object" && n !== null) {
      for (const [i, s] of Object.entries(
        n
      ))
        if (s && typeof s == "object")
          for (const [l, m] of Object.entries(s))
            o[`elementStyles.${i}.${l}`] = m;
    } else
      o[r] = n;
  return o;
}, Ms = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ...la, ...e },
    Zr
    // Only use base fields for type transformations
  ), w = (F, N) => {
    if (F.includes(".")) {
      const z = ya(i, F, N), A = F.split(".")[0];
      m(A, z[A]);
    } else
      m(F, N);
  }, k = ae(() => ba(i), [i]), x = i.fontFamily, f = x && x !== "inherit" ? c[x] : null, B = f && f.format === "google" ? f.url : null, P = ae(() => {
    const F = [];
    if (i.elementStyles) {
      for (const N of Object.values(i.elementStyles))
        if (N != null && N.fontFamily && N.fontFamily !== "inherit") {
          const z = c[N.fontFamily];
          (z == null ? void 0 : z.format) === "google" && z.url && !F.includes(z.url) && F.push(z.url);
        }
    }
    return F;
  }, [i.elementStyles, c]);
  Q(() => {
    B && vt(B);
    for (const F of P)
      vt(F);
  }, [B, P]);
  const u = `message-bubble-${o || "default"}`, R = ae(
    () => ha(
      u,
      i.elementStyles,
      c,
      g
    ),
    [u, i.elementStyles, c, g]
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const b = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", v = [`
    ${f && f.format !== "system" && f.format !== "google" ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${b !== "inherit" ? `.${u} { font-family: ${b} !important; }` : ""}
  `.trim(), R].filter(Boolean).join(`

`), T = {
    ...i,
    fontFamilyCss: b
  }, W = /* @__PURE__ */ h("div", { className: u, children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(T, g)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: ua,
      editValues: k,
      onEditChange: w,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, Es = {
  headings: ["h1", "h2", "h3", "h4", "h5"],
  text: ["p", "strong", "em", "code", "blockquote"],
  lists: ["ul", "ol", "li"],
  tables: ["table", "thead", "tbody", "tr", "th", "td"]
}, fa = {
  // Container
  containerBgColor: a("background"),
  containerPaddingX: 16,
  containerPaddingY: 12,
  containerBorderRadius: 18,
  containerBorderRadiusBottomLeft: 5,
  // Dots
  dotColor: a("textPrimary"),
  dotSize: 8,
  dotSpacing: 2,
  // Animation
  animationDuration: 1.4,
  // Status text
  statusTextColor: a("textPrimary"),
  statusFontSize: 12,
  statusMarginTop: 8
}, St = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "containerBorderRadiusBottomLeft",
    label: "Bottom Left Radius",
    type: "number",
    min: 0,
    max: 20,
    step: 1
  },
  // Dots
  { key: "dotColor", label: "Dot Color", type: "color" },
  {
    key: "dotSize",
    label: "Dot Size",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  },
  {
    key: "dotSpacing",
    label: "Dot Spacing",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  },
  // Animation
  {
    key: "animationDuration",
    label: "Animation Duration (s)",
    type: "number",
    min: 0.5,
    max: 3,
    step: 0.1
  },
  // Status text
  { key: "statusTextColor", label: "Status Text Color", type: "color" },
  {
    key: "statusFontSize",
    label: "Status Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "statusMarginTop",
    label: "Status Margin Top",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  }
], Ws = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...fa, ...e },
    St
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: St,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, wt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, oo = ({ width: e }) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      width: `${e}px`,
      height: "32px",
      borderRadius: "9999px",
      backgroundColor: "#e5e7eb",
      animation: "pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), xa = {
  // Preset
  preset: "inline",
  // Title
  showTitle: !0,
  titleText: "Get expert advice on this product",
  titleFontSize: 20,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  // Title icon & behavior
  showSparkleIcon: !0,
  collapsible: !1,
  // Container
  containerGap: 16,
  containerMarginTop: 16,
  containerMarginBottom: 16,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Suggestion pills
  pillPaddingX: 12,
  pillPaddingY: 4,
  pillBorderRadius: 50,
  pillBorderColor: a("primary"),
  pillBorderWidth: 1.5,
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 16,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Ca = {
  inline: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  highlighted: {
    showTitle: !0,
    showSparkleIcon: !0,
    collapsible: !1,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  accordion: {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  },
  "accordion-highlighted": {
    showTitle: !0,
    showSparkleIcon: !1,
    collapsible: !0,
    titleFontSize: 20,
    titleFontWeight: "semibold",
    titleColor: a("textPrimary"),
    containerGap: 16,
    containerMarginTop: 16,
    containerMarginBottom: 16,
    containerBgColor: a("background"),
    containerPaddingX: 16,
    containerPaddingY: 16,
    containerBorderRadius: 0,
    pillPaddingX: 12,
    pillPaddingY: 4,
    pillBorderRadius: 50,
    pillBorderColor: a("primary"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 16,
    pillFontWeight: "medium"
  }
}, ka = [
  { label: "Inline Pills (V1)", value: "inline" },
  { label: "Highlighted (V2)", value: "highlighted" },
  { label: "Accordion (V3)", value: "accordion" },
  { label: "Accordion Highlighted (V4)", value: "accordion-highlighted" },
  { label: "Custom", value: "custom" }
], Bt = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: ka
  },
  // Title section
  { key: "showTitle", label: "Show Title", type: "toggle" },
  { key: "showSparkleIcon", label: "Show Sparkle Icon", type: "toggle" },
  { key: "collapsible", label: "Collapsible (Accordion)", type: "toggle" },
  { key: "titleText", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ie]
  },
  { key: "titleFontFamily", label: "Title Font Family", type: "font" },
  { key: "titleColor", label: "Title Color", type: "color" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Title and Pills",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 64,
    step: 4
  },
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 2,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ie]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" }
], Ur = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, va = ({
  color: e = "currentColor"
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "19",
    viewBox: "0 0 19 19",
    fill: "none",
    style: { flexShrink: 0 },
    children: /* @__PURE__ */ t(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.6375 8.97842L15.9115 8.19942C13.4152 7.49564 11.4643 5.54472 10.7605 3.04842L9.98148 0.32242C9.90136 0.12736 9.71136 0 9.50048 0C9.2896 0 9.09961 0.12736 9.01948 0.32242L8.24048 3.04842C7.5367 5.54472 5.58578 7.49564 3.08948 8.19942L0.36348 8.97842C0.14841 9.03946 0 9.23586 0 9.45942C0 9.68298 0.14841 9.87938 0.36348 9.94042L3.08948 10.7194C5.58578 11.4232 7.53671 13.3741 8.24048 15.8704L9.01948 18.5964C9.08052 18.8115 9.27692 18.9599 9.50048 18.9599C9.72404 18.9599 9.92044 18.8115 9.98148 18.5964L10.7605 15.8704C11.4642 13.3741 13.4152 11.4232 15.9115 10.7194L18.6375 9.94042C18.8526 9.87938 19.001 9.68298 19.001 9.45942C19.001 9.23586 18.8526 9.03946 18.6375 8.97842Z",
        fill: e
      }
    )
  }
), Sa = ({
  expanded: e,
  color: o = "currentColor"
}) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: {
      flexShrink: 0,
      transition: "transform 0.2s ease",
      transform: e ? "rotate(180deg)" : "rotate(0deg)"
    },
    children: /* @__PURE__ */ t("polyline", { points: "6 9 12 15 18 9" })
  }
), wa = ({ question: e, onClick: o, state: r, resolveColor: n }) => {
  const [i, s] = O(!1);
  return /* @__PURE__ */ t(
    "button",
    {
      onClick: o,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      style: {
        padding: `${r.pillPaddingY}px ${r.pillPaddingX}px`,
        borderRadius: `${r.pillBorderRadius}px`,
        border: `${r.pillBorderWidth}px solid ${n(r.pillBorderColor)}`,
        backgroundColor: n(i ? r.pillBgColorHover : r.pillBgColor),
        color: n(r.pillTextColor),
        fontSize: `${r.pillFontSize}px`,
        fontWeight: Ur[r.pillFontWeight] || 500,
        fontFamily: r.pillFontFamilyCss || "inherit",
        cursor: "pointer",
        transition: "background-color 0.15s ease",
        textAlign: "left",
        lineHeight: "32px"
      },
      children: e
    }
  );
}, As = ({
  widgetId: e = "conversation-starters",
  displayName: o = "Conversation Starters",
  initialState: r = {},
  questions: n,
  isLoading: i = !1,
  onQuestionClick: s
}) => {
  const {
    state: l,
    isLoading: m,
    isSaving: p,
    handleEditChange: y,
    handleSave: c,
    themeColors: g,
    themeFonts: C,
    resolveColor: w,
    canSave: k
  } = _(
    e,
    { ...xa, ...r },
    Bt
  ), [x, f] = O(!1), B = (G, H) => {
    if (G === "preset" && H !== "custom") {
      const Y = Ca[H];
      if (Y) {
        y("preset", H), Object.entries(Y).forEach(([q, X]) => {
          y(q, X);
        });
        return;
      }
    }
    y(G, H);
  }, P = l.pillFontFamily, u = P && P !== "inherit" ? C[P] : null, R = l.titleFontFamily, b = R && R !== "inherit" ? C[R] : null, I = u && u.format === "google" ? u.url : null, S = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    I && wt(I);
  }, [I]), Q(() => {
    S && wt(S);
  }, [S]), m || !i && n.length === 0)
    return null;
  const v = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", T = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", W = u && u.format !== "system" && u.format !== "google", F = b && b.format !== "system" && b.format !== "google", N = `conversation-starters-${e || "default"}`, z = `
    @keyframes pulse {
      0%, 100% { opacity: 1; }
      50% { opacity: 0.5; }
    }
    ${W ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${F ? `
      @font-face {
        font-family: "${b.name}";
        src: url("${b.url}") format("${b.format}");
        font-display: swap;
      }
    ` : ""}
  `.trim(), A = {
    ...l,
    pillFontFamilyCss: v,
    titleFontFamilyCss: T
  }, j = l.collapsible ? x : !0, Z = w(l.containerBgColor), M = Z && Z !== "transparent" && Z !== "", L = /* @__PURE__ */ h(D, { children: [
    z && /* @__PURE__ */ t("style", { children: z }),
    /* @__PURE__ */ h(
      "div",
      {
        className: N,
        style: {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: j ? `${l.containerGap}px` : "0px",
          marginTop: `${l.containerMarginTop}px`,
          marginBottom: `${l.containerMarginBottom}px`,
          backgroundColor: M ? Z : void 0,
          padding: M || l.containerPaddingX || l.containerPaddingY ? `${l.containerPaddingY}px ${l.containerPaddingX}px` : void 0,
          borderRadius: l.containerBorderRadius > 0 ? `${l.containerBorderRadius}px` : void 0
        },
        children: [
          l.showTitle && /* @__PURE__ */ h(
            "h3",
            {
              onClick: l.collapsible ? () => f((G) => !G) : void 0,
              style: {
                fontSize: `${l.titleFontSize}px`,
                fontWeight: Ur[l.titleFontWeight] || 600,
                fontFamily: T,
                color: w(l.titleColor),
                margin: 0,
                display: "flex",
                alignItems: "center",
                gap: "8px",
                cursor: l.collapsible ? "pointer" : void 0,
                userSelect: l.collapsible ? "none" : void 0
              },
              children: [
                l.showSparkleIcon && /* @__PURE__ */ t(va, { color: w(l.titleColor) }),
                /* @__PURE__ */ t("span", { style: { flex: 1 }, children: l.titleText }),
                l.collapsible && /* @__PURE__ */ t(
                  Sa,
                  {
                    expanded: x,
                    color: w(l.titleColor)
                  }
                )
              ]
            }
          ),
          j && /* @__PURE__ */ t(D, { children: i ? /* @__PURE__ */ h(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start"
              },
              children: [
                /* @__PURE__ */ t(oo, { width: 180 }),
                /* @__PURE__ */ t(oo, { width: 140 }),
                /* @__PURE__ */ t(oo, { width: 200 }),
                /* @__PURE__ */ t(oo, { width: 160 })
              ]
            }
          ) : /* @__PURE__ */ t(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                alignItems: "flex-start",
                width: "100%"
              },
              children: n.map((G, H) => /* @__PURE__ */ t(
                wa,
                {
                  question: G,
                  onClick: () => s(G),
                  state: A,
                  resolveColor: w
                },
                H
              ))
            }
          ) })
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Bt,
      editValues: l,
      onEditChange: B,
      onSave: k ? c : void 0,
      isSaving: p,
      themeColors: g,
      themeFonts: C,
      children: L
    }
  );
}, Ue = 60, zt = 420, Ft = ({
  showSettings: e,
  viewMode: o,
  editorMode: r = "iframe"
}) => `
  /* Reset and base styles */
  .bc-theme-editor-shell {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  .bc-theme-editor-shell * {
    box-sizing: border-box;
  }

  /* Top Bar */
  .bc-theme-editor-topbar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: ${Ue}px;
    background: #f5f5f7;
    border-bottom: 1px solid ${d.border_glass};
    display: flex;
    align-items: center;
    padding: 0 20px;
    gap: 16px;
    z-index: 1000001;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  }

  /* Logo/Brand */
  .bc-theme-editor-logo {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-right: 16px;
    border-right: 1px solid ${d.border_glass};
  }

  .bc-theme-editor-logo-icon {
    width: 32px;
    height: 32px;
    background: linear-gradient(135deg, ${d.blue_dark} 0%, #252b6e 100%);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
  }

  .bc-theme-editor-logo-text {
    font-size: 14px;
    font-weight: 600;
    color: ${d.primary};
    letter-spacing: -0.3px;
  }

  /* Theme ID */
  .bc-theme-editor-theme-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-theme-label {
    font-size: 12px;
    color: ${d.gray_medium};
    font-weight: 500;
  }

  .bc-theme-editor-theme-id {
    font-size: 12px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${d.primary};
    background: ${d.white};
    padding: 6px 12px;
    border-radius: 8px;
    border: 1px solid ${d.border_glass};
  }

  .bc-theme-editor-live-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 600;
    color: #4caf50;
    margin-left: 8px;
  }

  .bc-theme-editor-live-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #4caf50;
  }

  /* Viewport Toggle */
  .bc-theme-editor-viewport-toggle {
    display: flex;
    background: ${d.white};
    border-radius: 10px;
    padding: 4px;
    margin-left: 16px;
    border: 1px solid ${d.border_glass};
    gap: 2px;
  }

  /* Spacer */
  .bc-theme-editor-spacer {
    flex: 1;
  }

  /* Action Buttons */
  .bc-theme-editor-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }

  /* Preview Area */
  .bc-theme-editor-preview {
    position: fixed;
    top: ${Ue}px;
    left: 0;
    right: ${e ? zt : 0}px;
    bottom: 0;
    background: #e8e8ed;
    transition: right 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    overflow: auto;
  }

  .bc-theme-editor-preview-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    padding: ${o === "mobile" ? "24px" : "0"};
    transition: padding 0.3s ease;
  }

  .bc-theme-editor-iframe-wrapper {
    width: ${o === "desktop" ? "100%" : "375px"};
    height: ${o === "desktop" ? "100%" : "calc(100% - 48px)"};
    background: white;
    transition: all 0.3s ease;
    ${o === "mobile" ? `
      border-radius: 24px;
      box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(0, 0, 0, 0.05);
      overflow: hidden;
    ` : ""}
  }

  .bc-theme-editor-iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }

  /* Side Panel */
  @keyframes bc-slide-in {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes bc-slide-out {
    from {
      transform: translateX(0);
    }
    to {
      transform: translateX(100%);
    }
  }

  .bc-theme-editor-sidepanel {
    position: fixed;
    top: ${Ue}px;
    right: 0;
    bottom: 0;
    width: ${zt}px;
    background: #fff;
    border-left: 1px solid ${d.border_subtle};
    z-index: 1000000;
    overflow-y: auto;
    animation: bc-slide-in 0.3s ease;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.15);
  }

  .bc-theme-editor-sidepanel-header {
    position: sticky;
    top: 0;
    background: ${d.glass_bg_strong};
    backdrop-filter: blur(20px);
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1;
  }

  .bc-theme-editor-sidepanel-title {
    font-size: 16px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  .bc-theme-editor-sidepanel-close {
    width: 32px;
    height: 32px;
    border: none;
    background: ${d.overlay_light};
    border-radius: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    color: ${d.gray_medium};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-sidepanel-close:hover {
    background: ${d.gray_light};
    color: ${d.primary};
  }

  .bc-theme-editor-sidepanel-content {
    padding: 24px;
  }

  /* Messages */
  .bc-theme-editor-message {
    padding: 12px 16px;
    border-radius: 10px;
    margin-bottom: 20px;
    font-size: 13px;
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-message-success {
    background: rgba(113, 194, 133, 0.15);
    color: ${d.green};
    border: 1px solid rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-message-error {
    background: rgba(255, 83, 74, 0.1);
    color: ${d.red};
    border: 1px solid rgba(255, 83, 74, 0.2);
  }

  /* Sections */
  .bc-theme-editor-section {
    margin-bottom: 8px;
    background: ${d.white};
    border-radius: 12px;
    border: 1px solid ${d.border_glass};
    overflow: hidden;
  }

  .bc-theme-editor-section:last-child {
    margin-bottom: 0;
  }

  .bc-theme-editor-section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    cursor: pointer;
    transition: background 0.15s ease;
    user-select: none;
  }

  .bc-theme-editor-section-header:hover {
    background: ${d.bg_light};
  }

  .bc-theme-editor-section-title {
    font-size: 12px;
    font-weight: 600;
    color: ${d.primary};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bc-theme-editor-section-count {
    font-size: 11px;
    font-weight: 500;
    color: ${d.gray_medium};
    background: ${d.bg_light};
    padding: 2px 8px;
    border-radius: 10px;
  }

  .bc-theme-editor-section-chevron {
    color: ${d.gray_medium};
    transition: transform 0.2s ease;
  }

  .bc-theme-editor-section-chevron.expanded {
    transform: rotate(90deg);
  }

  .bc-theme-editor-section-content {
    padding: 0 16px 16px;
  }

  /* Color/Asset Lists */
  .bc-theme-editor-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .bc-theme-editor-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    background: ${d.overlay_light};
    border-radius: 12px;
    border: 1px solid ${d.border_glass};
    transition: all 0.15s ease;
  }

  .bc-theme-editor-row:hover {
    background: ${d.white};
    box-shadow: 0 2px 8px ${d.shadow_soft};
  }

  .bc-theme-editor-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid ${d.border_glass};
    border-radius: 8px;
    font-size: 13px;
    background: ${d.white};
    color: ${d.primary};
    outline: none;
    transition: all 0.15s ease;
    min-width: 0;
  }

  .bc-theme-editor-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .bc-theme-editor-input:disabled {
    background: transparent;
    border-color: transparent;
    padding-left: 0;
  }

  .bc-theme-editor-color-picker {
    width: 44px;
    height: 36px;
    border: 2px solid ${d.border_glass};
    border-radius: 8px;
    cursor: pointer;
    outline: none;
    padding: 2px;
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-color-picker:hover:not(:disabled) {
    border-color: ${d.gray_border};
    transform: scale(1.05);
  }

  .bc-theme-editor-color-picker:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  .bc-theme-editor-color-value {
    font-size: 11px;
    font-family: 'SF Mono', 'Menlo', 'Monaco', 'Courier New', monospace;
    color: ${d.gray_medium};
    width: 85px;
    text-align: right;
    background: ${d.bg_light};
    padding: 5px 8px;
    border-radius: 4px;
    flex-shrink: 0;
    display: inline-block;
  }

  /* Buttons */
  .bc-theme-editor-btn-small {
    padding: 8px 12px;
    border: none;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .bc-theme-editor-btn-delete {
    background: linear-gradient(135deg, ${d.red} 0%, #e63e37 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(255, 83, 74, 0.2);
  }

  .bc-theme-editor-btn-delete:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(255, 83, 74, 0.3);
  }

  .bc-theme-editor-btn-save {
    background: linear-gradient(135deg, ${d.green} 0%, #5fb077 100%);
    color: white;
    box-shadow: 0 2px 4px rgba(113, 194, 133, 0.2);
  }

  .bc-theme-editor-btn-save:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 3px 8px rgba(113, 194, 133, 0.3);
  }

  .bc-theme-editor-btn-cancel {
    background: ${d.gray_light};
    color: ${d.gray_dark};
  }

  .bc-theme-editor-btn-cancel:hover:not(:disabled) {
    background: ${d.gray_border};
  }

  .bc-theme-editor-btn-small:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .bc-theme-editor-btn-add {
    width: fit-content;
    padding: 10px 16px;
    background: transparent;
    color: ${d.blue};
    border: 2px dashed ${d.gray_border};
    border-radius: 10px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none;
    margin-top: 4px;
  }

  .bc-theme-editor-btn-add:hover:not(:disabled) {
    background: ${d.blue_light};
    border-color: ${d.blue};
    border-style: solid;
  }

  .bc-theme-editor-btn-add:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  /* Delete button (minimal red X) */
  .bc-theme-editor-delete-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${d.gray_medium};
    transition: all 0.15s ease;
    flex-shrink: 0;
  }

  .bc-theme-editor-delete-btn:hover:not(:disabled) {
    background: rgba(255, 83, 74, 0.1);
    color: ${d.red};
  }

  .bc-theme-editor-delete-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  /* Font section specific */
  .bc-font-row {
    justify-content: space-between;
  }

  .bc-font-preview-name {
    font-size: 15px;
    color: ${d.primary};
    flex: 1;
    min-width: 0;
  }

  /* Asset specific */
  .bc-theme-editor-asset-preview {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: ${d.bg_light};
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    flex-shrink: 0;
  }

  .bc-theme-editor-asset-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }

  .bc-theme-editor-asset-format {
    font-size: 10px;
    color: ${d.gray_medium};
    background: ${d.bg_light};
    padding: 3px 6px;
    border-radius: 4px;
    text-transform: uppercase;
    flex-shrink: 0;
  }

  .bc-theme-editor-file-wrapper {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .bc-theme-editor-file-btn {
    padding: 6px 10px;
    background: ${d.overlay_light};
    border: 1px solid ${d.border_glass};
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: ${d.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .bc-theme-editor-file-btn:hover:not(:disabled) {
    background: ${d.white};
    border-color: ${d.blue};
    color: ${d.blue};
  }

  .bc-theme-editor-file-name {
    font-size: 11px;
    color: ${d.gray_medium};
    max-width: 80px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .bc-theme-editor-loading {
    text-align: center;
    padding: 24px;
    color: ${d.gray_medium};
    font-size: 13px;
  }

  /* Inline mode specific styles */
  ${r === "inline" ? `
  /* Push page content below the fixed top bar */
  body {
    padding-top: ${Ue}px !important;
  }

  /* In inline mode, shell doesn't cover the entire viewport */
  .bc-theme-editor-shell {
    position: relative;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
  }

  /* Hide viewport toggle in inline mode (no mobile preview available) */
  .bc-theme-editor-viewport-toggle {
    display: none;
  }
  ` : ""}
`, It = {
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
}, Ba = [
  { label: "Classic", value: "magnifying-glass" },
  { label: "Alternate", value: "magnifying-glass-alt" },
  { label: "Bold", value: "magnifying-glass-bold" },
  { label: "Slim", value: "magnifying-glass-slim" },
  { label: "Dot", value: "magnifying-glass-dot" }
], Co = ({
  variant: e = "magnifying-glass",
  size: o,
  color: r,
  strokeWidth: n = 2,
  style: i
}) => {
  const s = {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: r,
    strokeWidth: n,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, ...i }
  };
  switch (e) {
    case "magnifying-glass-alt":
      return /* @__PURE__ */ h("svg", { ...s, children: [
        /* @__PURE__ */ t("path", { d: "M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" }),
        /* @__PURE__ */ t("path", { d: "M21 21l-6-6" })
      ] });
    case "magnifying-glass-bold":
      return /* @__PURE__ */ h("svg", { ...s, strokeWidth: n + 0.75, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "7" }),
        /* @__PURE__ */ t("line", { x1: "16.5", y1: "16.5", x2: "21", y2: "21" })
      ] });
    case "magnifying-glass-slim":
      return /* @__PURE__ */ h("svg", { ...s, strokeWidth: Math.max(1, n - 0.5), children: [
        /* @__PURE__ */ t("circle", { cx: "10.5", cy: "10.5", r: "8.5" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "17", y2: "17" })
      ] });
    case "magnifying-glass-dot":
      return /* @__PURE__ */ h("svg", { ...s, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" }),
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "1.5", fill: r, stroke: "none" })
      ] });
    case "magnifying-glass":
    default:
      return /* @__PURE__ */ h("svg", { ...s, children: [
        /* @__PURE__ */ t("circle", { cx: "11", cy: "11", r: "8" }),
        /* @__PURE__ */ t("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })
      ] });
  }
}, za = ({
  size: e,
  color: o
}) => /* @__PURE__ */ h(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    style: { flexShrink: 0, cursor: "pointer" },
    children: [
      /* @__PURE__ */ t("line", { x1: "18", y1: "6", x2: "6", y2: "18" }),
      /* @__PURE__ */ t("line", { x1: "6", y1: "6", x2: "18", y2: "18" })
    ]
  }
), Ge = {
  // Trigger icon
  triggerIconStyle: "magnifying-glass",
  triggerIconThemeIcon: "default",
  triggerIconSize: 20,
  triggerIconColor: a("textPrimary"),
  triggerIconStrokeWidth: 2,
  // Panel
  panelBgColor: a("background"),
  // Search bar
  searchBarBgColor: a("background"),
  searchBarBorderRadius: 30,
  searchBarMaxWidth: 800,
  searchBarHeight: 56,
  searchBarHeightMobile: 40,
  searchBarPlaceholder: "Search or ask concierge",
  searchBarFontSize: 14,
  searchBarFontSizeMobile: 12,
  searchBarTextColor: a("textPrimary"),
  searchBarPlaceholderColor: a("textPrimary"),
  searchBarIconSize: 24,
  searchBarIconSizeMobile: 16,
  // Ask concierge button
  askButtonBgColor: a("textPrimary"),
  askButtonTextColor: a("secondary"),
  askButtonBorderRadius: 100,
  askButtonFontSize: 14,
  askButtonFontSizeMobile: 10,
  askButtonText: "Ask concierge",
  askButtonPaddingX: 16,
  askButtonPaddingY: 4,
  // Close button
  closeIconSize: 24,
  closeIconSizeMobile: 20,
  closeIconColor: a("textPrimary"),
  // Section headers
  sectionHeaderFontSize: 16,
  sectionHeaderFontSizeMobile: 14,
  sectionHeaderFontWeight: "semibold",
  sectionHeaderColor: a("textPrimary"),
  // Body / question text
  bodyFontSize: 14,
  bodyColor: a("textPrimary"),
  bodyLineHeight: 24,
  // Products
  productImageSize: 72,
  productImageSizeMobile: 56,
  productNameFontSize: 14,
  productPriceFontSize: 14,
  productPriceFontWeight: "semibold",
  productColumns: 2,
  // Trending searches
  trendingFontSize: 14,
  trendingColor: a("textPrimary"),
  trendingLineHeight: 24,
  // Empty state
  noResultsText: "No search results found. Please try again.",
  noResultsWithSuggestionsText: "No search results found . Here's some ideas to get you started.",
  noSuggestionsText: "No suggestions found",
  noProductsText: "No products found",
  noSearchesText: "No searches found",
  // Spacing
  sectionGap: 32,
  contentPaddingX: 43,
  contentPaddingXMobile: 20,
  contentPaddingTop: 24,
  // Mobile dividers
  showMobileDividers: !0,
  dividerColor: a("background"),
  // Font
  fontFamily: "inherit"
}, Vr = [
  {
    key: "triggerIconThemeIcon",
    label: "Custom Icon",
    type: "icon",
    group: "Trigger Icon"
  },
  {
    key: "triggerIconStyle",
    label: "Built-in Style",
    type: "options",
    options: Ba,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 48,
    step: 2,
    group: "Trigger Icon"
  },
  {
    key: "triggerIconColor",
    label: "Icon Color",
    type: "color",
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  },
  {
    key: "triggerIconStrokeWidth",
    label: "Stroke Width",
    type: "number",
    min: 1,
    max: 4,
    step: 0.5,
    group: "Trigger Icon",
    condition: {
      field: "triggerIconThemeIcon",
      value: "default",
      operator: "equals"
    }
  }
], _r = [
  {
    key: "searchBarBgColor",
    label: "Background",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2,
    group: "Search Bar"
  },
  {
    key: "searchBarMaxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Search Bar"
  },
  {
    key: "searchBarHeight",
    label: "Height (Desktop)",
    type: "number",
    min: 36,
    max: 72,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarHeightMobile",
    label: "Height (Mobile)",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholder",
    label: "Placeholder Text",
    type: "text",
    group: "Search Bar"
  },
  {
    key: "searchBarFontSize",
    label: "Font Size (Desktop)",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Search Bar"
  },
  {
    key: "searchBarTextColor",
    label: "Text Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "searchBarPlaceholderColor",
    label: "Placeholder Color",
    type: "color",
    group: "Search Bar"
  },
  {
    key: "askButtonBgColor",
    label: "Button Background",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Ask Button"
  },
  {
    key: "askButtonBorderRadius",
    label: "Button Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4,
    group: "Ask Button"
  },
  {
    key: "askButtonText",
    label: "Button Text",
    type: "text",
    group: "Ask Button"
  },
  {
    key: "closeIconSize",
    label: "Close Icon Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Close Button"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Close Button"
  }
], Wo = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderFontWeight",
    label: "Header Font Weight",
    type: "options",
    options: [...ie],
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "bodyFontSize",
    label: "Body Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Body Text"
  },
  { key: "bodyColor", label: "Body Color", type: "color", group: "Body Text" }
], Ao = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "productImageSize",
    label: "Image Size (Desktop)",
    type: "number",
    min: 48,
    max: 96,
    step: 8,
    group: "Products"
  },
  {
    key: "productImageSizeMobile",
    label: "Image Size (Mobile)",
    type: "number",
    min: 40,
    max: 72,
    step: 8,
    group: "Products"
  },
  {
    key: "productColumns",
    label: "Columns (Desktop)",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Products"
  },
  {
    key: "productNameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Products"
  },
  {
    key: "productPriceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...ie],
    group: "Products"
  }
], Ro = [
  {
    key: "sectionHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Section Header"
  },
  {
    key: "sectionHeaderColor",
    label: "Header Color",
    type: "color",
    group: "Section Header"
  },
  {
    key: "trendingFontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Trending"
  },
  { key: "trendingColor", label: "Color", type: "color", group: "Trending" }
], qr = [
  {
    key: "panelBgColor",
    label: "Panel Background",
    type: "color",
    group: "Panel"
  },
  { key: "fontFamily", label: "Font Family", type: "font", group: "Panel" },
  {
    key: "sectionGap",
    label: "Section Gap",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingX",
    label: "Padding X (Desktop)",
    type: "number",
    min: 16,
    max: 80,
    step: 4,
    group: "Spacing"
  },
  {
    key: "contentPaddingXMobile",
    label: "Padding X (Mobile)",
    type: "number",
    min: 12,
    max: 40,
    step: 4,
    group: "Spacing"
  },
  {
    key: "noResultsText",
    label: "No Results Text",
    type: "text",
    group: "Empty States"
  },
  {
    key: "noResultsWithSuggestionsText",
    label: "No Results (with suggestions)",
    type: "text",
    group: "Empty States"
  },
  {
    key: "showMobileDividers",
    label: "Show Mobile Dividers",
    type: "toggle",
    group: "Dividers"
  },
  {
    key: "dividerColor",
    label: "Divider Color",
    type: "color",
    group: "Dividers"
  }
], Fa = [
  ...Vr,
  ..._r,
  ...Wo,
  ...Ao,
  ...Ro,
  ...qr
], We = ({ width: e }) => /* @__PURE__ */ t(
  "div",
  {
    style: {
      width: e,
      height: "18px",
      borderRadius: "3px",
      backgroundColor: "#e5e7eb",
      animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
    }
  }
), ko = ({ imageSize: e }) => /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: "12px" }, children: [
  /* @__PURE__ */ t(
    "div",
    {
      style: {
        width: e,
        height: e,
        borderRadius: "8px",
        backgroundColor: "#e5e7eb",
        flexShrink: 0,
        animation: "searchPanelPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite"
      }
    }
  ),
  /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
    /* @__PURE__ */ t(We, { width: "140px" }),
    /* @__PURE__ */ t(We, { width: "60px" })
  ] })
] }), Pt = ({
  product: e,
  imageSize: o,
  nameSize: r,
  priceSize: n,
  priceWeight: i,
  textColor: s,
  nameMaxWidth: l,
  onClick: m
}) => /* @__PURE__ */ h(
  "div",
  {
    style: {
      display: "flex",
      alignItems: "center",
      gap: "12px",
      cursor: m ? "pointer" : void 0
    },
    onClick: m,
    children: [
      /* @__PURE__ */ t(
        "img",
        {
          src: e.imageUrl,
          alt: e.name,
          style: {
            width: o,
            height: o,
            objectFit: "contain",
            flexShrink: 0,
            borderRadius: "4px"
          }
        }
      ),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            minWidth: 0,
            maxWidth: l
          },
          children: [
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: `${r}px`,
                  fontWeight: 400,
                  lineHeight: "20px",
                  color: s,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden"
                },
                children: e.name
              }
            ),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: `${n}px`,
                  fontWeight: i,
                  lineHeight: "20px",
                  color: s
                },
                children: e.price
              }
            )
          ]
        }
      )
    ]
  }
), Rs = ({
  widgetId: e = "search-panel",
  displayName: o = "Search Panel",
  initialState: r = {},
  conciergeQuestions: n,
  popularProducts: i,
  trendingSearches: s,
  isOpen: l,
  searchQuery: m,
  isLoading: p = !1,
  hasSearched: y = !1,
  onOpen: c,
  onClose: g,
  onSearchChange: C,
  onSearchSubmit: w,
  onAskConcierge: k,
  onQuestionClick: x,
  onProductClick: f,
  onTrendingClick: B,
  brandLogo: P
}) => {
  var Ko;
  const {
    state: u,
    isLoading: R,
    isSaving: b,
    handleEditChange: I,
    handleSave: S,
    themeColors: v,
    themeFonts: T,
    themeIcons: W,
    resolveColor: F,
    canSave: N
  } = _(
    e,
    { ...Ge, ...r },
    Fa
  ), z = se(null), [A, j] = O(!1), Z = Jo();
  Q(() => {
    const ne = () => j(window.innerWidth < 768);
    return ne(), window.addEventListener("resize", ne), () => window.removeEventListener("resize", ne);
  }, []), Q(() => {
    if (l && z.current) {
      const ne = setTimeout(() => {
        var Se;
        return (Se = z.current) == null ? void 0 : Se.focus();
      }, 100);
      return () => clearTimeout(ne);
    }
  }, [l]), Q(() => {
    if (!l) return;
    const ne = (Se) => {
      Se.key === "Escape" && g();
    };
    return document.addEventListener("keydown", ne), () => document.removeEventListener("keydown", ne);
  }, [l, g]);
  const M = pe(
    (ne) => {
      ne.key === "Enter" && w(m);
    },
    [m, w]
  );
  if (R && !l)
    return /* @__PURE__ */ t(
      "div",
      {
        onClick: c,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: /* @__PURE__ */ t(
          Co,
          {
            variant: Ge.triggerIconStyle,
            size: Ge.triggerIconSize,
            color: typeof Ge.triggerIconColor == "string" ? Ge.triggerIconColor : "#4f4b47",
            strokeWidth: Ge.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
  if (R) return null;
  const L = F(u.triggerIconColor), G = u.triggerIconThemeIcon, H = G && G !== "default" ? (Ko = W[G]) == null ? void 0 : Ko.url : void 0;
  if (!l) {
    const ne = /* @__PURE__ */ t(
      "div",
      {
        onClick: c,
        style: {
          display: "inline-flex",
          alignItems: "center",
          cursor: "pointer"
        },
        children: H ? /* @__PURE__ */ t(
          "img",
          {
            src: H,
            alt: "Search",
            style: {
              width: u.triggerIconSize,
              height: u.triggerIconSize,
              objectFit: "contain",
              cursor: "pointer",
              flexShrink: 0
            }
          }
        ) : /* @__PURE__ */ t(
          Co,
          {
            variant: u.triggerIconStyle,
            size: u.triggerIconSize,
            color: L,
            strokeWidth: u.triggerIconStrokeWidth,
            style: { cursor: "pointer" }
          }
        )
      }
    );
    return /* @__PURE__ */ t(
      J,
      {
        widgetId: e,
        displayName: "Search Icon",
        editFields: Vr,
        editValues: u,
        onEditChange: I,
        onSave: N ? S : void 0,
        isSaving: b,
        themeColors: v,
        themeFonts: T,
        themeIcons: W,
        wrapperStyle: { display: "inline-flex", width: "auto" },
        iconOffset: { top: -16, left: 24 },
        children: ne
      }
    );
  }
  const $ = F(u.panelBgColor), Y = F(u.searchBarBgColor), q = F(u.searchBarTextColor);
  F(u.searchBarPlaceholderColor);
  const X = F(u.askButtonBgColor), V = F(u.askButtonTextColor), re = F(u.closeIconColor), K = F(u.sectionHeaderColor), te = F(u.bodyColor), ee = F(u.trendingColor), he = F(u.dividerColor), Re = It[u.sectionHeaderFontWeight] || 600, ye = It[u.productPriceFontWeight] || 600, Be = A ? u.searchBarHeightMobile : u.searchBarHeight, ke = A ? u.searchBarFontSizeMobile : u.searchBarFontSize, Pe = A ? u.searchBarIconSizeMobile : u.searchBarIconSize, U = A ? u.closeIconSizeMobile : u.closeIconSize, de = A ? u.sectionHeaderFontSizeMobile : u.sectionHeaderFontSize, be = A ? u.productImageSizeMobile : u.productImageSize, fe = A ? u.contentPaddingXMobile : u.contentPaddingX, le = A ? u.askButtonFontSizeMobile : u.askButtonFontSize, ge = n.length > 0, Oe = i.length > 0, Ye = s.length > 0, Qe = ge || Oe || Ye, mo = y && !p, Fe = !y || Qe, Ce = (ne) => /* @__PURE__ */ t(
    "h3",
    {
      style: {
        margin: 0,
        fontSize: `${de}px`,
        fontWeight: Re,
        lineHeight: A ? "24px" : "32px",
        color: K
      },
      children: ne
    }
  ), Uo = () => p ? /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    Ce("Ask Concierge"),
    /* @__PURE__ */ t(We, { width: "80%" }),
    /* @__PURE__ */ t(We, { width: "70%" }),
    /* @__PURE__ */ t(We, { width: "60%" })
  ] }) : /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "12px" }, children: [
    Ce("Ask Concierge"),
    ge ? n.map((ne, Se) => /* @__PURE__ */ t(
      "p",
      {
        onClick: () => x(ne),
        style: {
          margin: 0,
          fontSize: `${u.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${u.bodyLineHeight}px`,
          color: te,
          cursor: "pointer"
        },
        children: ne
      },
      Se
    )) : /* @__PURE__ */ t(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${u.bodyFontSize}px`,
          fontWeight: 400,
          lineHeight: `${u.bodyLineHeight}px`,
          color: te,
          opacity: 0.7
        },
        children: u.noSuggestionsText
      }
    )
  ] }), Vo = () => {
    if (p)
      return /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
        Ce("Popular products"),
        /* @__PURE__ */ t(ko, { imageSize: be }),
        /* @__PURE__ */ t(ko, { imageSize: be }),
        /* @__PURE__ */ t(ko, { imageSize: be })
      ] });
    const ne = A ? 1 : u.productColumns, Se = [];
    if (Oe) {
      const Te = Math.ceil(i.length / ne);
      for (let Me = 0; Me < ne; Me++)
        Se.push(
          i.slice(Me * Te, (Me + 1) * Te)
        );
    }
    return /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
      Ce("Popular products"),
      Oe ? /* @__PURE__ */ t(
        "div",
        {
          style: {
            display: A ? "flex" : "grid",
            gridTemplateColumns: A ? void 0 : `repeat(${ne}, 1fr)`,
            flexDirection: A ? "column" : void 0,
            gap: A ? "16px" : "24px"
          },
          children: A ? i.map((Te, Me) => /* @__PURE__ */ t(
            Pt,
            {
              product: Te,
              imageSize: be,
              nameSize: u.productNameFontSize,
              priceSize: u.productPriceFontSize,
              priceWeight: ye,
              textColor: te,
              onClick: Te.onClick ?? (() => f(Te))
            },
            Me
          )) : Se.map((Te, Me) => /* @__PURE__ */ t(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: "20px"
              },
              children: Te.map((ho, an) => /* @__PURE__ */ t(
                Pt,
                {
                  product: ho,
                  imageSize: be,
                  nameSize: u.productNameFontSize,
                  priceSize: u.productPriceFontSize,
                  priceWeight: ye,
                  textColor: te,
                  nameMaxWidth: 250,
                  onClick: ho.onClick ?? (() => f(ho))
                },
                an
              ))
            },
            Me
          ))
        }
      ) : /* @__PURE__ */ t(
        "p",
        {
          style: {
            margin: 0,
            fontSize: `${u.bodyFontSize}px`,
            fontWeight: 400,
            color: te,
            opacity: 0.7
          },
          children: u.noProductsText
        }
      )
    ] });
  }, _o = () => p ? /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "16px" }, children: [
    Ce("Trending searches"),
    /* @__PURE__ */ t(We, { width: "75%" }),
    /* @__PURE__ */ t(We, { width: "65%" }),
    /* @__PURE__ */ t(We, { width: "80%" })
  ] }) : /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "8px" }, children: [
    Ce("Trending searches"),
    Ye ? s.map((ne, Se) => /* @__PURE__ */ t(
      "p",
      {
        onClick: () => B(ne),
        style: {
          margin: 0,
          fontSize: `${u.trendingFontSize}px`,
          fontWeight: 400,
          lineHeight: `${u.trendingLineHeight}px`,
          color: ee,
          cursor: "pointer"
        },
        children: ne
      },
      Se
    )) : /* @__PURE__ */ t(
      "p",
      {
        style: {
          margin: 0,
          fontSize: `${u.bodyFontSize}px`,
          fontWeight: 400,
          color: te,
          opacity: 0.7
        },
        children: u.noSearchesText
      }
    )
  ] }), qo = () => !A || !u.showMobileDividers ? null : /* @__PURE__ */ t(
    "div",
    {
      style: {
        height: "1px",
        backgroundColor: he,
        margin: `${u.sectionGap / 2}px 0`
      }
    }
  ), uo = Z ? Ue : 0, nn = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: `
        @keyframes searchPanelPulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        @keyframes searchPanelSlideDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes searchPanelFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      ` }),
    /* @__PURE__ */ t(
      "div",
      {
        onClick: g,
        style: {
          position: "fixed",
          top: uo,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2147483645,
          backgroundColor: A ? "transparent" : "rgba(0, 0, 0, 0.15)",
          animation: "searchPanelFadeIn 0.25s ease-out"
        }
      }
    ),
    /* @__PURE__ */ h(
      "div",
      {
        style: {
          position: "fixed",
          top: uo,
          left: 0,
          right: 0,
          ...A ? { bottom: 0 } : {},
          zIndex: 2147483646,
          backgroundColor: $,
          display: "flex",
          flexDirection: "column",
          overflow: A ? "auto" : "visible",
          fontFamily: u.fontFamilyCss || "inherit",
          animation: "searchPanelSlideDown 0.3s cubic-bezier(0.16, 1, 0.3, 1)",
          ...A ? {} : {
            maxHeight: `calc(100vh - ${uo}px)`,
            boxShadow: "0 8px 32px rgba(0, 0, 0, 0.12)"
          }
        },
        children: [
          /* @__PURE__ */ t(
            J,
            {
              widgetId: e ? `${e}__search-bar` : void 0,
              displayName: "Search Bar",
              editFields: _r,
              editValues: u,
              onEditChange: I,
              onSave: N ? S : void 0,
              isSaving: b,
              themeColors: v,
              themeFonts: T,
              wrapperStyle: { display: "flex", width: "100%" },
              children: /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: A ? "12px" : "24px",
                    padding: A ? "24px 20px 0 20px" : `36px ${fe}px 0 ${fe}px`,
                    flexShrink: 0,
                    width: "100%"
                  },
                  children: [
                    !A && P && /* @__PURE__ */ t("div", { style: { flexShrink: 0 }, children: P }),
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 0,
                          display: "flex",
                          alignItems: "center",
                          backgroundColor: Y,
                          borderRadius: `${u.searchBarBorderRadius}px`,
                          maxWidth: `${u.searchBarMaxWidth}px`,
                          margin: "0 auto",
                          height: `${Be}px`,
                          padding: A ? "0 8px 0 12px" : "0 12px 0 16px",
                          gap: A ? "8px" : "12px"
                        },
                        children: [
                          H ? /* @__PURE__ */ t(
                            "img",
                            {
                              src: H,
                              alt: "Search",
                              style: {
                                width: Pe,
                                height: Pe,
                                objectFit: "contain",
                                flexShrink: 0
                              }
                            }
                          ) : /* @__PURE__ */ t(
                            Co,
                            {
                              variant: u.triggerIconStyle,
                              size: Pe,
                              color: q
                            }
                          ),
                          /* @__PURE__ */ t(
                            "input",
                            {
                              ref: z,
                              type: "text",
                              value: m,
                              onChange: (ne) => C(ne.target.value),
                              onKeyDown: M,
                              placeholder: u.searchBarPlaceholder,
                              style: {
                                flex: 1,
                                border: "none",
                                background: "transparent",
                                outline: "none",
                                fontSize: `${ke}px`,
                                fontWeight: 400,
                                lineHeight: A ? "16px" : "24px",
                                color: q,
                                fontFamily: "inherit"
                              }
                            }
                          ),
                          /* @__PURE__ */ t(
                            "button",
                            {
                              onClick: () => k(m),
                              style: {
                                flexShrink: 0,
                                backgroundColor: X,
                                color: V,
                                border: "none",
                                borderRadius: `${u.askButtonBorderRadius}px`,
                                padding: A ? "6px 8px" : `${u.askButtonPaddingY}px ${u.askButtonPaddingX}px`,
                                fontSize: `${le}px`,
                                fontWeight: 500,
                                lineHeight: A ? "16px" : "32px",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                fontFamily: "inherit"
                              },
                              children: u.askButtonText
                            }
                          )
                        ]
                      }
                    ),
                    /* @__PURE__ */ t(
                      "div",
                      {
                        onClick: g,
                        style: { flexShrink: 0, cursor: "pointer", padding: "4px" },
                        role: "button",
                        "aria-label": "Close search panel",
                        children: /* @__PURE__ */ t(za, { size: U, color: re })
                      }
                    )
                  ]
                }
              )
            }
          ),
          /* @__PURE__ */ h(
            "div",
            {
              style: {
                ...A ? { flex: 1 } : {},
                padding: `${u.contentPaddingTop}px ${fe}px ${fe}px`,
                overflow: "auto"
              },
              children: [
                mo && /* @__PURE__ */ t(
                  "p",
                  {
                    style: {
                      margin: `0 0 ${u.sectionGap}px`,
                      fontSize: `${u.sectionHeaderFontSize}px`,
                      fontWeight: Re,
                      lineHeight: "32px",
                      color: K,
                      textAlign: Qe ? "center" : void 0
                    },
                    children: Qe ? u.noResultsWithSuggestionsText : u.noResultsText
                  }
                ),
                Fe && /* @__PURE__ */ t(D, { children: A ? (
                  /* ---- Mobile: stacked single column ---- */
                  /* @__PURE__ */ h(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        gap: `${u.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Wo,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: Uo()
                          }
                        ),
                        qo(),
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Ao,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: Vo()
                          }
                        ),
                        qo(),
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Ro,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: _o()
                          }
                        )
                      ]
                    }
                  )
                ) : (
                  /* ---- Desktop: 3-column layout ---- */
                  /* @__PURE__ */ h(
                    "div",
                    {
                      style: {
                        display: "grid",
                        gridTemplateColumns: "minmax(200px, 1fr) minmax(350px, 2fr) minmax(200px, 1fr)",
                        gap: `${u.sectionGap}px`
                      },
                      children: [
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__questions` : void 0,
                            displayName: "Ask Concierge",
                            editFields: Wo,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: Uo()
                          }
                        ),
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__products` : void 0,
                            displayName: "Popular Products",
                            editFields: Ao,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: Vo()
                          }
                        ),
                        /* @__PURE__ */ t(
                          J,
                          {
                            widgetId: e ? `${e}__trending` : void 0,
                            displayName: "Trending Searches",
                            editFields: Ro,
                            editValues: u,
                            onEditChange: I,
                            onSave: N ? S : void 0,
                            isSaving: b,
                            themeColors: v,
                            themeFonts: T,
                            children: _o()
                          }
                        )
                      ]
                    }
                  )
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: qr,
      editValues: u,
      onEditChange: I,
      onSave: N ? S : void 0,
      isSaving: b,
      themeColors: v,
      themeFonts: T,
      children: nn
    }
  );
}, Ia = {
  // Pill styling (matching Figma design)
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "500",
  pillBorderRadius: 100,
  // Pill shape
  pillPaddingX: 12,
  pillPaddingY: 12,
  // Border styling
  pillBorderWidth: 1,
  pillBorderColor: a("primary"),
  // Selected state styling
  pillBgColorSelected: a("primary"),
  pillTextColorSelected: a("secondary"),
  pillBorderColorSelected: a("primary"),
  // Container
  containerGap: 8,
  maxWidthDesktop: "100%",
  maxWidthMobile: "100%"
}, Tt = [
  // Default state styling
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  // Border styling
  {
    key: "pillBorderWidth",
    label: "Border Width (px)",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  { key: "pillBorderColor", label: "Border Color", type: "color" },
  // Selected state styling
  { key: "pillBgColorSelected", label: "Selected Background", type: "color" },
  { key: "pillTextColorSelected", label: "Selected Text Color", type: "color" },
  {
    key: "pillBorderColorSelected",
    label: "Selected Border Color",
    type: "color"
  },
  // Typography
  {
    key: "pillFontSize",
    label: "Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Font Weight",
    type: "options",
    options: Ne
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "pillPaddingX",
    label: "Horizontal Padding (px)",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Vertical Padding (px)",
    type: "number",
    min: 2,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills (px)",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "maxWidthDesktop",
    label: "Max Width (Desktop)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "80%", value: "80%" },
      { label: "70%", value: "70%" },
      { label: "60%", value: "60%" }
    ]
  },
  {
    key: "maxWidthMobile",
    label: "Max Width (Mobile)",
    type: "options",
    options: [
      { label: "100%", value: "100%" },
      { label: "90%", value: "90%" },
      { label: "80%", value: "80%" }
    ]
  }
], Hs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...Ia, ...e },
    Tt
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Tt,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, Pa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Ta = {
  // Background
  backgroundColor: a("transparent"),
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 18,
  titleFontWeight: "semibold",
  titleFontFamily: "inherit",
  // Icon styling (shared defaults)
  iconColor: a("textPrimary"),
  iconColorHover: a("tertiary"),
  iconSize: 20,
  // Individual icon overrides
  homeIconSize: 22,
  homeIconColor: void 0,
  sidebarIconSize: 20,
  sidebarIconColor: void 0,
  composeIconSize: 18,
  composeIconColor: void 0,
  cartIconSize: 22,
  cartIconColor: void 0,
  // Button styling
  buttonSize: 44,
  buttonBorderRadius: 8,
  buttonHoverBgColor: a("background"),
  // Badge styling (cart count)
  badgeBgColor: a("primary"),
  badgeTextColor: a("secondary"),
  badgeFontSize: 12,
  badgeMinWidth: 18,
  // Layout
  height: 56,
  paddingX: 16,
  paddingY: 8,
  maxWidth: 768
}, Mt = [
  // Layout group
  {
    key: "backgroundColor",
    label: "Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "height",
    label: "Height",
    type: "number",
    min: 40,
    max: 80,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Layout"
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Layout"
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 400,
    max: 1200,
    step: 50,
    group: "Layout"
  },
  // Title group
  { key: "titleColor", label: "Color", type: "color", group: "Title" },
  {
    key: "titleFontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ie],
    group: "Title"
  },
  {
    key: "titleFontFamily",
    label: "Font Family",
    type: "font",
    group: "Title"
  },
  // Home Icon group
  {
    key: "homeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Home Icon"
  },
  {
    key: "homeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Home Icon"
  },
  // Sidebar Icon group
  {
    key: "sidebarIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Sidebar Icon"
  },
  {
    key: "sidebarIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Sidebar Icon"
  },
  // Compose Icon group
  {
    key: "composeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Compose Icon"
  },
  {
    key: "composeIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Compose Icon"
  },
  // Cart Icon group
  {
    key: "cartIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 1,
    group: "Cart Icon"
  },
  {
    key: "cartIconColor",
    label: "Color (optional)",
    type: "color",
    group: "Cart Icon"
  },
  // Shared Icons group (default color applies to all without individual override)
  {
    key: "iconColor",
    label: "Default Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  {
    key: "iconColorHover",
    label: "Hover Color",
    type: "color",
    group: "All Icons (Defaults)"
  },
  // Buttons group
  {
    key: "buttonSize",
    label: "Size",
    type: "number",
    min: 32,
    max: 56,
    step: 4,
    group: "Buttons"
  },
  {
    key: "buttonBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Buttons"
  },
  {
    key: "buttonHoverBgColor",
    label: "Hover Background",
    type: "color",
    group: "Buttons"
  },
  // Badge group
  { key: "badgeBgColor", label: "Background", type: "color", group: "Badge" },
  { key: "badgeTextColor", label: "Text Color", type: "color", group: "Badge" },
  {
    key: "badgeFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Badge"
  },
  {
    key: "badgeMinWidth",
    label: "Min Width",
    type: "number",
    min: 14,
    max: 24,
    step: 2,
    group: "Badge"
  }
], Ls = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ...Ta, ...e },
    Mt
  ), w = i.titleFontFamily, k = w && w !== "inherit" ? c[w] : null, x = k && k.format === "google" ? k.url : null;
  if (Q(() => {
    x && Pa(x);
  }, [x]), s)
    return /* @__PURE__ */ t(D, {});
  const f = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", B = k && k.format !== "system" && k.format !== "google", P = `header-${o || "default"}`, u = `
    ${B ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${P} [data-title-text] { font-family: ${f} !important; }` : ""}
  `.trim(), R = {
    ...i,
    titleFontFamilyCss: f
  }, b = /* @__PURE__ */ h(D, { children: [
    u && /* @__PURE__ */ t("style", { children: u }),
    n(R, g)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Mt,
      editValues: i,
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: b
    }
  );
}, Ma = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Et = {
  // Text content
  titleContent: "CONCIERGE",
  titleFontSize: 14,
  titleFontWeight: "bold",
  titleFontFamily: "inherit",
  titleColor: a("textPrimary"),
  titleLetterSpacing: 2,
  titleTextTransform: "uppercase",
  titleTextAlign: "center",
  titleLineHeight: 1,
  // Button colors - default to textPrimary theme color
  closeButtonColor: a("textPrimary"),
  maximizeButtonColor: a("textPrimary"),
  historyButtonColor: a("textPrimary")
}, Wt = [
  // Text content
  { key: "titleContent", label: "Title Text", type: "text" },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleLetterSpacing",
    label: "Title Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "titleTextTransform",
    label: "Title Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "titleTextAlign",
    label: "Title Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 0.8,
    max: 2,
    step: 0.1
  },
  // Button colors
  { key: "closeButtonColor", label: "Close Button Color", type: "color" },
  {
    key: "maximizeButtonColor",
    label: "Maximize Button Color",
    type: "color"
  },
  {
    key: "historyButtonColor",
    label: "History Button Color",
    type: "color"
  }
], Ea = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 400, Ns = ({
  showMaximize: e = !0,
  isMaximized: o = !1,
  onMaximize: r,
  onMinimize: n,
  onClose: i,
  onHistoryClick: s,
  title: l = "CONCIERGE",
  widgetId: m = "concierge-widget-header",
  displayName: p = "Concierge Header",
  initialState: y = {},
  // mobileBrandLogoUrl,
  // showMobileLogo = false,
  bottomContent: c
}) => {
  const {
    state: g,
    isLoading: C,
    isSaving: w,
    handleEditChange: k,
    handleSave: x,
    themeColors: f,
    themeFonts: B,
    resolveColor: P,
    canSave: u
  } = _(
    m,
    {
      ...Et,
      titleContent: (l == null ? void 0 : l.toUpperCase()) || Et.titleContent,
      ...y
    },
    Wt
  ), R = g.titleFontFamily, b = R && R !== "inherit" ? B[R] : null, I = b && b.format === "google" ? b.url : null;
  if (Q(() => {
    I && Ma(I);
  }, [I]), C)
    return /* @__PURE__ */ t(
      "div",
      {
        className: "tw:flex tw:items-center tw:justify-between tw:p-4",
        "data-concierge-header": !0
      }
    );
  const S = b ? b.format === "system" ? b.url : `"${b.name}", sans-serif` : "inherit", v = b && b.format !== "system" && b.format !== "google", T = `concierge-header-${m || "default"}`, W = (N) => {
    if (N.startsWith("#")) {
      const z = N.slice(1), A = z.length === 3 ? parseInt(z[0] + z[0], 16) : parseInt(z.slice(0, 2), 16), j = z.length === 3 ? parseInt(z[1] + z[1], 16) : parseInt(z.slice(2, 4), 16), Z = z.length === 3 ? parseInt(z[2] + z[2], 16) : parseInt(z.slice(4, 6), 16);
      return `rgba(${A}, ${j}, ${Z}, 0.7)`;
    }
    return N.startsWith("rgba") ? N.replace(/,\s*[\d.]+\)$/, ", 0.7)") : N.startsWith("rgb") ? N.replace("rgb", "rgba").replace(")", ", 0.7)") : N;
  }, F = /* @__PURE__ */ h(
    "div",
    {
      style: {
        borderBottom: "1px solid #F3F3F3",
        boxShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
        backgroundColor: "#ffffff"
      },
      children: [
        /* @__PURE__ */ t("style", { children: `
        ${v ? `
          @font-face {
            font-family: "${b.name}";
            src: url("${b.url}") format("${b.format}");
            font-display: swap;
          }
        ` : ""}
        ${S !== "inherit" ? `.${T} [data-title-text] { font-family: ${S} !important; }` : ""}
        .${T} .concierge-maximize-icon {
          color: ${P(g.maximizeButtonColor)};
          transition: color 0.2s ease;
        }
        .${T} .concierge-maximize-icon:hover {
          color: ${W(P(g.maximizeButtonColor))};
        }
        .${T} .concierge-close-icon {
          color: ${P(g.closeButtonColor)};
          transition: color 0.2s ease;
        }
        .${T} .concierge-close-icon:hover {
          color: ${W(P(g.closeButtonColor))};
        }
        .${T} .concierge-history-icon {
          color: ${P(g.historyButtonColor)};
          transition: color 0.2s ease;
        }
        .${T} .concierge-history-icon:hover {
          color: ${W(P(g.historyButtonColor))};
        }
      ` }),
        /* @__PURE__ */ h(
          "div",
          {
            className: `tw:flex tw:items-center tw:justify-between tw:p-4 ${T}`,
            "data-concierge-header": !0,
            children: [
              /* @__PURE__ */ h(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1",
                  style: { minWidth: "80px" },
                  children: [
                    o && n && /* @__PURE__ */ t(
                      "button",
                      {
                        onClick: n,
                        className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                        "aria-label": "Minimize to widget",
                        children: /* @__PURE__ */ t(Rn, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                      }
                    ),
                    !o && e && r && /* @__PURE__ */ t(
                      "button",
                      {
                        onClick: r,
                        className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                        "aria-label": "Expand to full view",
                        children: /* @__PURE__ */ t(Wn, { className: "tw:w-5 tw:h-5 concierge-maximize-icon" })
                      }
                    )
                  ]
                }
              ),
              /* @__PURE__ */ t(
                "span",
                {
                  "data-title-text": !0,
                  style: {
                    fontSize: `${g.titleFontSize}px`,
                    fontWeight: Ea(g.titleFontWeight),
                    fontFamily: S !== "inherit" ? S : void 0,
                    color: P(g.titleColor),
                    letterSpacing: `${g.titleLetterSpacing}px`,
                    textTransform: g.titleTextTransform,
                    textAlign: "center",
                    lineHeight: g.titleLineHeight,
                    flex: 1
                  },
                  children: g.titleContent
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  className: "tw:flex tw:items-center tw:gap-1 tw:justify-end",
                  style: { minWidth: "80px" },
                  children: /* @__PURE__ */ t(
                    "button",
                    {
                      onClick: i,
                      className: "tw:p-2 tw:rounded-lg tw:transition-colors tw:cursor-pointer tw:border-none tw:bg-transparent tw:group",
                      "aria-label": "Close",
                      children: /* @__PURE__ */ t(Ae, { className: "tw:w-5 tw:h-5 concierge-close-icon" })
                    }
                  )
                }
              )
            ]
          }
        ),
        c
      ]
    }
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: m,
      displayName: p,
      editFields: Wt,
      editValues: g,
      onEditChange: k,
      onSave: u ? x : void 0,
      isSaving: w,
      themeColors: f,
      themeFonts: B,
      children: F
    }
  );
}, Wa = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Aa = {
  // Logo / Brand Icon
  logoIcon: "default",
  logoIconSize: 22,
  // Brand Link
  brandLinkText: "example.com",
  brandLinkPrefix: "Visit ",
  brandLinkFontSize: 14,
  brandLinkColor: a("textPrimary"),
  // Layout
  expandedWidth: 248,
  collapsedWidth: 40,
  expandedBgColor: a("background"),
  collapsedBgColor: a("secondary"),
  borderColor: a("borderColor"),
  // Navigation Icons
  sidebarIconSize: 20,
  sidebarIconColor: a("textPrimary"),
  composeIconSize: 18,
  composeIconColor: a("textPrimary"),
  closeIconColor: a("textPrimary"),
  // Labels
  openSidebarLabel: "Open sidebar",
  closeSidebarLabel: "Close sidebar",
  newChatLabel: "New chat",
  signOutLabel: "Sign out",
  labelFontSize: 16,
  labelFontWeight: "medium",
  labelColor: a("textPrimary"),
  // Tooltips
  tooltipBgColor: a("textPrimary"),
  tooltipTextColor: a("secondary"),
  tooltipFontSize: 12,
  tooltipBorderRadius: 8,
  // Chat History
  chatHistoryTitle: "Chat history",
  chatHistoryTitleFontSize: 16,
  chatHistoryTitleFontWeight: "medium",
  chatHistoryTitleColor: a("textPrimary"),
  chatItemFontSize: 14,
  chatItemFontWeight: "medium",
  chatItemColor: a("textPrimary"),
  chatItemActiveBgColor: a("background"),
  chatItemHoverBgColor: a("background"),
  chatItemPaddingX: 8,
  chatItemPaddingY: 4,
  chatItemBorderRadius: 5,
  chatItemLineClamp: 1,
  // Typography
  fontFamily: "inherit",
  // Avatar
  avatarSize: 20,
  avatarBgColor: a("textPrimary"),
  avatarTextColor: a("secondary"),
  avatarFontSize: 8,
  avatarFontWeight: "semibold"
}, to = ie.slice(0, 4), At = [
  // ── Logo / Brand Icon ──────────────────────────────────────────────────
  { key: "logoIcon", label: "Logo Icon", type: "icon", group: "Logo" },
  {
    key: "logoIconSize",
    label: "Icon Size",
    type: "number",
    min: 0,
    max: 100,
    step: 1,
    group: "Logo"
  },
  // ── Brand Link ─────────────────────────────────────────────────────────
  {
    key: "brandLinkPrefix",
    label: "Prefix Text",
    type: "text",
    group: "Brand Link"
  },
  {
    key: "brandLinkFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Brand Link"
  },
  {
    key: "brandLinkColor",
    label: "Color",
    type: "color",
    group: "Brand Link"
  },
  // ── Layout ─────────────────────────────────────────────────────────────
  {
    key: "expandedWidth",
    label: "Expanded Width",
    type: "number",
    min: 200,
    max: 320,
    step: 4,
    group: "Layout"
  },
  {
    key: "collapsedWidth",
    label: "Collapsed Width",
    type: "number",
    min: 36,
    max: 56,
    step: 2,
    group: "Layout"
  },
  {
    key: "expandedBgColor",
    label: "Expanded Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "collapsedBgColor",
    label: "Collapsed Background",
    type: "color",
    group: "Layout"
  },
  {
    key: "borderColor",
    label: "Border Color",
    type: "color",
    group: "Layout"
  },
  // ── Navigation Icons ───────────────────────────────────────────────────
  {
    key: "sidebarIconSize",
    label: "Sidebar Icon Size",
    type: "number",
    min: 16,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "sidebarIconColor",
    label: "Sidebar Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "composeIconSize",
    label: "Compose Icon Size",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Icons"
  },
  {
    key: "composeIconColor",
    label: "Compose Icon Color",
    type: "color",
    group: "Icons"
  },
  {
    key: "closeIconColor",
    label: "Close Icon Color",
    type: "color",
    group: "Icons"
  },
  // ── Labels ─────────────────────────────────────────────────────────────
  {
    key: "openSidebarLabel",
    label: "Open Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "closeSidebarLabel",
    label: "Close Sidebar Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "newChatLabel",
    label: "New Chat Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "signOutLabel",
    label: "Sign Out Label",
    type: "text",
    group: "Labels"
  },
  {
    key: "labelFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Labels"
  },
  {
    key: "labelFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...to],
    group: "Labels"
  },
  { key: "labelColor", label: "Color", type: "color", group: "Labels" },
  // ── Tooltips ───────────────────────────────────────────────────────────
  {
    key: "tooltipBgColor",
    label: "Background",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipTextColor",
    label: "Text Color",
    type: "color",
    group: "Tooltips"
  },
  {
    key: "tooltipFontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Tooltips"
  },
  {
    key: "tooltipBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Tooltips"
  },
  // ── Chat History ───────────────────────────────────────────────────────
  {
    key: "chatHistoryTitle",
    label: "Section Title",
    type: "text",
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...to],
    group: "Chat History"
  },
  {
    key: "chatHistoryTitleColor",
    label: "Title Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemFontSize",
    label: "Item Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemFontWeight",
    label: "Item Font Weight",
    type: "options",
    options: [...to],
    group: "Chat History"
  },
  {
    key: "chatItemColor",
    label: "Item Text Color",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemActiveBgColor",
    label: "Active Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemHoverBgColor",
    label: "Hover Item Background",
    type: "color",
    group: "Chat History"
  },
  {
    key: "chatItemPaddingX",
    label: "Item Padding X",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemPaddingY",
    label: "Item Padding Y",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Chat History"
  },
  {
    key: "chatItemBorderRadius",
    label: "Item Border Radius",
    type: "number",
    min: 0,
    max: 12,
    step: 1,
    group: "Chat History"
  },
  {
    key: "chatItemLineClamp",
    label: "Item Max Lines",
    type: "number",
    min: 1,
    max: 3,
    step: 1,
    group: "Chat History"
  },
  // ── Typography ─────────────────────────────────────────────────────────
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // ── Avatar ─────────────────────────────────────────────────────────────
  {
    key: "avatarSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 32,
    step: 2,
    group: "Avatar"
  },
  {
    key: "avatarBgColor",
    label: "Background",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarTextColor",
    label: "Text Color",
    type: "color",
    group: "Avatar"
  },
  {
    key: "avatarFontSize",
    label: "Font Size",
    type: "number",
    min: 6,
    max: 14,
    step: 1,
    group: "Avatar"
  },
  {
    key: "avatarFontWeight",
    label: "Font Weight",
    type: "options",
    options: [...to],
    group: "Avatar"
  }
], Os = ({
  widgetId: e = "concierge-sidebar",
  displayName: o = "Concierge Sidebar",
  initialState: r = {},
  wrapperStyle: n,
  children: i
}) => {
  const {
    state: s,
    isLoading: l,
    isSaving: m,
    handleEditChange: p,
    handleSave: y,
    themeColors: c,
    themeFonts: g,
    themeIcons: C,
    resolveColor: w,
    canSave: k
  } = _(
    e,
    { ...Aa, ...r },
    At
  ), x = s.logoIcon && s.logoIcon !== "default" ? C[s.logoIcon] : null, f = {
    logoIconUrl: x ? x.url : null
  }, B = s.fontFamily, P = B && B !== "inherit" ? g[B] : null, u = P && P.format === "google" ? P.url : null;
  if (Q(() => {
    u && Wa(u);
  }, [u]), l)
    return /* @__PURE__ */ t(D, {});
  const R = P ? P.format === "system" ? P.url : `"${P.name}", sans-serif` : "inherit", I = P && P.format !== "system" && P.format !== "google" ? `@font-face {
        font-family: "${P.name}";
        src: url("${P.url}") format("${P.format}");
        font-display: swap;
      }` : "", S = {
    ...s,
    fontFamilyCss: R
  }, v = /* @__PURE__ */ h(D, { children: [
    I && /* @__PURE__ */ t("style", { children: I }),
    i(S, f, w)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: At,
      editValues: s,
      onEditChange: p,
      onSave: k ? y : void 0,
      isSaving: m,
      themeColors: c,
      themeFonts: g,
      themeIcons: C,
      wrapperStyle: n,
      children: v
    }
  );
}, Ra = {
  filled: {
    backgroundColor: a("primary"),
    backgroundColorHover: a("primary"),
    iconColor: a("secondary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.25,
    shadowBlur: 50,
    shadowSpread: -12,
    shadowOffsetY: 25
  },
  light: {
    backgroundColor: a("background"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 0,
    borderColor: a("transparent"),
    shadowOpacity: 0.12,
    shadowBlur: 24,
    shadowSpread: -4,
    shadowOffsetY: 8
  },
  outlined: {
    backgroundColor: a("secondary"),
    backgroundColorHover: a("background"),
    iconColor: a("primary"),
    borderWidth: 1.5,
    borderColor: a("textPrimary"),
    shadowOpacity: 0,
    shadowBlur: 0,
    shadowSpread: 0,
    shadowOffsetY: 0
  }
}, Ha = {
  "rounded-square": { borderRadius: 25 },
  circle: { borderRadius: 50 }
}, La = {
  // Preset selectors
  buttonShape: "circle",
  buttonStyle: "filled",
  // Position
  position: "bottom-right",
  horizontalOffset: 20,
  verticalOffset: 20,
  // Size
  size: 44,
  // Colors (using theme colors) — derived from "filled" style
  backgroundColor: a("primary"),
  backgroundColorHover: a("primary"),
  iconColor: a("secondary"),
  // Border — derived from "filled" style
  borderWidth: 0,
  borderColor: a("transparent"),
  // Shape — derived from "circle" shape
  borderRadius: 50,
  // percentage - 50 = circle
  // Shadow — derived from "filled" style
  shadowColor: a("primary"),
  shadowOpacity: 0.25,
  shadowBlur: 50,
  shadowSpread: -12,
  shadowOffsetY: 25,
  // Icon
  iconStyle: "chat-ai",
  iconSize: 22,
  // Animation
  hoverScale: 1.1,
  animationDuration: 200,
  // Suggested Messages
  showSuggestedMessages: !0,
  suggestedMessages: void 0,
  suggestedMessageRotationMs: 4e3,
  // Suggested Pills Styling
  pillBackgroundColor: "#ffffff",
  pillTextColor: "#1f2937",
  pillBorderRadius: 12,
  pillFontSize: 14,
  pillPaddingX: 16,
  pillPaddingY: 10,
  pillShadowOpacity: 0.12,
  pillsToShow: 2,
  // Header Styling
  pillHeaderText: void 0,
  pillHeaderColor: "#6b7280",
  pillHeaderFontSize: 11,
  // Feature Prompt Pill
  featurePromptBgColor: a("primary"),
  featurePromptTextColor: a("secondary")
}, Rt = [
  // --- Preset selectors ---
  {
    key: "iconStyle",
    label: "Icon",
    type: "options",
    options: [
      { label: "Chat AI", value: "chat-ai" },
      { label: "Search Sparkle", value: "search-sparkle" },
      { label: "Three Sparkles", value: "three-sparkles" },
      { label: "Diamond Sparkles", value: "diamond-sparkles" },
      { label: "Search Star", value: "search-star" },
      { label: "Search Sparkle Alt", value: "search-sparkle-alt" }
    ]
  },
  {
    key: "buttonShape",
    label: "Shape",
    type: "options",
    options: [
      { label: "Circle", value: "circle" },
      { label: "Rounded Square", value: "rounded-square" }
    ]
  },
  {
    key: "buttonStyle",
    label: "Style",
    type: "options",
    options: [
      { label: "Filled", value: "filled" },
      { label: "Light", value: "light" },
      { label: "Outlined", value: "outlined" }
    ]
  },
  // --- Size & Position ---
  {
    key: "size",
    label: "Button Size",
    type: "number",
    min: 32,
    max: 72,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Size & Position"
  },
  {
    key: "position",
    label: "Position",
    type: "options",
    options: [
      { label: "Bottom Right", value: "bottom-right" },
      { label: "Bottom Left", value: "bottom-left" },
      { label: "Top Right", value: "top-right" },
      { label: "Top Left", value: "top-left" }
    ],
    group: "Size & Position"
  },
  {
    key: "horizontalOffset",
    label: "Horizontal Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  {
    key: "verticalOffset",
    label: "Vertical Offset (px)",
    type: "number",
    min: 8,
    max: 100,
    step: 4,
    group: "Size & Position"
  },
  // --- Colors ---
  { key: "backgroundColor", label: "Background Color", type: "color", group: "Colors" },
  { key: "backgroundColorHover", label: "Hover Background", type: "color", group: "Colors" },
  { key: "iconColor", label: "Icon Color", type: "color", group: "Colors" },
  // --- Shape ---
  {
    key: "borderRadius",
    label: "Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shape"
  },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 4,
    step: 0.5,
    group: "Shape"
  },
  { key: "borderColor", label: "Border Color", type: "color", group: "Shape" },
  // --- Shadow ---
  { key: "shadowColor", label: "Shadow Color", type: "color", group: "Shadow" },
  {
    key: "shadowOpacity",
    label: "Shadow Opacity",
    type: "number",
    min: 0,
    max: 1,
    step: 0.05,
    group: "Shadow"
  },
  {
    key: "shadowBlur",
    label: "Shadow Blur",
    type: "number",
    min: 0,
    max: 100,
    step: 5,
    group: "Shadow"
  },
  {
    key: "shadowSpread",
    label: "Shadow Spread",
    type: "number",
    min: -20,
    max: 20,
    step: 2,
    group: "Shadow"
  },
  {
    key: "shadowOffsetY",
    label: "Shadow Offset Y",
    type: "number",
    min: 0,
    max: 50,
    step: 5,
    group: "Shadow"
  },
  // Animation
  {
    key: "hoverScale",
    label: "Hover Scale",
    type: "number",
    min: 1,
    max: 1.3,
    step: 0.05
  },
  {
    key: "animationDuration",
    label: "Animation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  },
  // Suggested Messages
  {
    key: "showSuggestedMessages",
    label: "Show Suggested Messages",
    type: "toggle"
  },
  {
    key: "suggestedMessageRotationMs",
    label: "Message Rotation (ms)",
    type: "number",
    min: 2e3,
    max: 1e4,
    step: 500
  },
  {
    key: "pillsToShow",
    label: "Number of Pills",
    type: "number",
    min: 1,
    max: 4,
    step: 1
  },
  // Pill Styling
  { key: "pillBackgroundColor", label: "Pill Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 10,
    max: 18,
    step: 1
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillShadowOpacity",
    label: "Pill Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  // Header Styling
  {
    key: "pillHeaderText",
    label: "Header Text (Override)",
    type: "text"
  },
  { key: "pillHeaderColor", label: "Header Text Color", type: "color" },
  {
    key: "pillHeaderFontSize",
    label: "Header Font Size",
    type: "number",
    min: 9,
    max: 14,
    step: 1
  },
  // Feature Prompt Pill
  {
    key: "featurePromptBgColor",
    label: "Prompt Pill Background",
    type: "color",
    group: "Feature Prompt"
  },
  {
    key: "featurePromptTextColor",
    label: "Prompt Pill Text Color",
    type: "color",
    group: "Feature Prompt"
  }
], Na = (e) => {
  const { position: o, horizontalOffset: r, verticalOffset: n, size: i } = e, s = {
    position: "fixed",
    zIndex: 2147483647
    // Max z-index to ensure it's on top
  };
  return o.startsWith("bottom") ? s.bottom = n + i - 8 : s.top = n - 8, o.endsWith("left") ? s.left = r + i - 8 : s.right = r - 8, s;
}, Ds = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const [i, s] = O(!1), [l, m] = O({ x: 0, y: 0 }), [p, y] = O(null), [c, g] = O(!1), [C, w] = O(!1), k = se(null), x = Jo(), {
    state: f,
    isLoading: B,
    isSaving: P,
    handleEditChange: u,
    handleSave: R,
    themeColors: b,
    resolveColor: I,
    canSave: S,
    studioLockedKeys: v
  } = _(
    o,
    { ...La, ...e },
    Rt
  ), T = pe(
    (M, L) => {
      if (u(M, L), M === "buttonStyle") {
        const G = Ra[L];
        G && Object.entries(G).forEach(([H, $]) => {
          u(H, $);
        });
      }
      if (M === "buttonShape") {
        const G = Ha[L];
        G && u("borderRadius", G.borderRadius);
      }
    },
    [u]
  ), W = pe(() => p ? JSON.stringify(f) !== JSON.stringify(p) : !1, [f, p]);
  if (Q(() => o ? Hr((L) => {
    L !== o && i && (W() ? g(!0) : s(!1));
  }) : void 0, [o, i, W]), B)
    return /* @__PURE__ */ t(D, {});
  const F = n(f, I);
  if (!x)
    return /* @__PURE__ */ t(D, { children: F });
  const N = () => {
    if (k.current) {
      const M = k.current.getBoundingClientRect(), L = window.innerWidth, G = window.innerHeight, H = 620, $ = 450, Y = 10, q = G - M.bottom, X = M.top, V = L - M.left, re = M.right;
      let K;
      q >= $ + Y ? K = M.bottom + Y : X >= $ + Y ? K = M.top - $ - Y : q >= X ? K = Math.max(Y, G - $ - Y) : K = Math.max(Y, M.top - $ - Y);
      let te;
      V >= H ? te = M.left : re >= H ? te = M.right - H : te = Math.max(
        Y,
        Math.min(L - H - Y, M.left)
      ), te = Math.max(Y, Math.min(te, L - H - Y)), K = Math.max(Y, Math.min(K, G - $ - Y)), m({ x: te, y: K });
    }
    y({ ...f }), s(!0), o && Rr(o);
  }, z = () => {
    p && Object.keys(p).forEach((M) => {
      T(M, p[M]);
    });
  }, A = () => {
    R && S && R(), y({ ...f });
  }, j = () => {
    g(!1), s(!1);
  }, Z = () => {
    A(), g(!1), s(!1);
  };
  return /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: `
        .floating-button-edit-icon {
          width: 32px;
          height: 32px;
          background: ${d.white};
          border: 1px solid ${d.gray_border};
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          transition: all 0.2s;
          padding: 0;
          opacity: 0;
          pointer-events: none;
        }

        .floating-button-edit-icon.visible {
          opacity: 1;
          pointer-events: auto;
        }

        .floating-button-edit-icon:hover {
          background: ${d.blue_light};
          border-color: ${d.blue};
        }
      ` }),
    /* @__PURE__ */ h(
      "div",
      {
        onMouseEnter: () => w(!0),
        onMouseLeave: () => w(!1),
        style: { display: "contents" },
        children: [
          F,
          /* @__PURE__ */ t(
            "button",
            {
              ref: k,
              className: `floating-button-edit-icon ${C || i ? "visible" : ""}`,
              style: Na(f),
              onMouseDown: (M) => {
                M.stopPropagation();
              },
              onClick: (M) => {
                M.stopPropagation(), M.preventDefault(), N();
              },
              "aria-label": "Edit widget",
              children: /* @__PURE__ */ t(wr, { size: 16, color: d.gray_dark })
            }
          )
        ]
      }
    ),
    i && /* @__PURE__ */ t(
      Lr,
      {
        widgetId: o,
        displayName: r,
        fields: Rt,
        values: f,
        initialValues: p || void 0,
        onChange: T,
        onClose: () => s(!1),
        onReset: z,
        screenPosition: l,
        onSave: A,
        isSaving: P,
        themeColors: b,
        studioLockedKeys: v
      }
    ),
    c && /* @__PURE__ */ t(
      qe,
      {
        title: "Unsaved Changes",
        message: "You have unsaved changes. Would you like to save them before closing?",
        confirmLabel: "Save",
        cancelLabel: "Discard",
        onConfirm: Z,
        onCancel: j,
        isLoading: P
      }
    )
  ] });
}, Oa = {
  // Icon container
  iconContainerSize: 80,
  iconContainerBgColor: a("background"),
  iconContainerBorderRadius: 50,
  // Icon
  iconSize: 40,
  iconColor: a("textPrimary"),
  // Title
  titleFontSize: 28,
  titleFontWeight: "semibold",
  titleColor: a("textPrimary"),
  titleMarginBottom: 12,
  // Description
  descriptionFontSize: 16,
  descriptionColor: a("textPrimary"),
  descriptionMaxWidth: 500,
  descriptionLineHeight: 1.5,
  descriptionMarginBottom: 32,
  // Suggestions section title
  suggestionsTitleFontSize: 16,
  suggestionsTitleFontWeight: "medium",
  suggestionsTitleColor: a("textPrimary"),
  suggestionsTitleMarginBottom: 16,
  // Suggestion pills
  suggestionPillPaddingX: 16,
  suggestionPillPaddingY: 10,
  suggestionPillBorderRadius: 20,
  suggestionPillBorderColor: a("background"),
  suggestionPillBgColor: a("transparent"),
  suggestionPillBgColorHover: a("background"),
  suggestionPillTextColor: a("textPrimary"),
  suggestionPillFontSize: 14,
  suggestionPillGap: 8,
  // Container
  containerPadding: 20
}, Ht = [
  // Icon container
  {
    key: "iconContainerSize",
    label: "Icon Container Size",
    type: "number",
    min: 40,
    max: 120,
    step: 8
  },
  {
    key: "iconContainerBgColor",
    label: "Icon Container Background",
    type: "color"
  },
  {
    key: "iconContainerBorderRadius",
    label: "Icon Container Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Icon
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 20,
    max: 80,
    step: 4
  },
  { key: "iconColor", label: "Icon Color", type: "color" },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ie]
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleMarginBottom",
    label: "Title Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  // Description
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionMaxWidth",
    label: "Description Max Width",
    type: "number",
    min: 300,
    max: 700,
    step: 50
  },
  {
    key: "descriptionLineHeight",
    label: "Description Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "descriptionMarginBottom",
    label: "Description Margin Bottom",
    type: "number",
    min: 16,
    max: 64,
    step: 4
  },
  // Suggestions section title
  {
    key: "suggestionsTitleFontSize",
    label: "Suggestions Title Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "suggestionsTitleFontWeight",
    label: "Suggestions Title Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "suggestionsTitleColor",
    label: "Suggestions Title Color",
    type: "color"
  },
  {
    key: "suggestionsTitleMarginBottom",
    label: "Suggestions Title Margin",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Suggestion pills
  {
    key: "suggestionPillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "suggestionPillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 16,
    step: 2
  },
  {
    key: "suggestionPillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 30,
    step: 2
  },
  {
    key: "suggestionPillBorderColor",
    label: "Pill Border Color",
    type: "color"
  },
  { key: "suggestionPillBgColor", label: "Pill Background", type: "color" },
  {
    key: "suggestionPillBgColorHover",
    label: "Pill Background (Hover)",
    type: "color"
  },
  { key: "suggestionPillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "suggestionPillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "suggestionPillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Container
  {
    key: "containerPadding",
    label: "Container Padding",
    type: "number",
    min: 0,
    max: 40,
    step: 4
  }
], js = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...Oa, ...e },
    Ht
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Ht,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, Da = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ja = {
  // Carousel gap
  carouselGap: 16,
  // Card container
  cardBorderRadius: 10,
  // "Explore now" pill
  pillBgColor: a("secondary"),
  pillBorderColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillPaddingX: 12,
  pillPaddingY: 6,
  pillBorderRadius: 50,
  // Arrow button
  arrowBgColor: a("secondary"),
  arrowBorderColor: a("secondary"),
  arrowIconColor: a("textPrimary"),
  // Title
  titleColor: a("textPrimary"),
  titleFontWeight: "semibold",
  titleFontFamily: "inherit"
}, Lt = [
  // Carousel gap
  {
    key: "carouselGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  },
  // Card container
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // "Explore now" pill
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 20,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 12,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 4,
    max: 50,
    step: 2
  },
  // Arrow button
  { key: "arrowBgColor", label: "Arrow Background", type: "color" },
  { key: "arrowBorderColor", label: "Arrow Border Color", type: "color" },
  { key: "arrowIconColor", label: "Arrow Icon Color", type: "color" },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font"
  }
], Gs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C,
    getEditValues: w
  } = _(
    o,
    { ...ja, ...e },
    Lt
  ), k = i.titleFontFamily, x = k && k !== "inherit" ? c[k] : null, f = x && x.format === "google" ? x.url : null;
  if (Q(() => {
    f && Da(f);
  }, [f]), s)
    return /* @__PURE__ */ t(D, {});
  const B = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", P = x && x.format !== "system" && x.format !== "google", u = `trending-card-${o || "default"}`, R = `
    ${P ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${B !== "inherit" ? `.${u} [data-title-text] { font-family: ${B} !important; }` : ""}
  `.trim(), b = {
    ...i,
    titleFontFamilyCss: B
  }, I = /* @__PURE__ */ h(D, { children: [
    R && /* @__PURE__ */ t("style", { children: R }),
    n(b, g)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Lt,
      editValues: w(),
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: I
    }
  );
}, Ga = {
  // Container
  backgroundColor: a("secondary"),
  borderColor: a("primary"),
  borderWidth: 1,
  borderRadius: 9999,
  // pill shape
  paddingX: 12,
  paddingY: 8,
  // Text
  textColor: a("textPrimary"),
  textColorLoading: a("textPrimary"),
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  // Product images
  imageSize: 24,
  imageBorderColor: a("borderColor"),
  imageOverlap: 12,
  imageBorderRadius: 9999,
  // circle
  // Counter (+N)
  counterTextColor: a("textPrimary"),
  counterFontSize: 14,
  // Placeholder (loading state)
  placeholderBgColor: a("background")
}, Nt = [
  // Container
  { key: "backgroundColor", label: "Background Color", type: "color" },
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "paddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "paddingY",
    label: "Vertical Padding",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  // Text
  { key: "textColor", label: "Text Color", type: "color" },
  { key: "textColorLoading", label: "Text Color (Loading)", type: "color" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ie
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  // Product images
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2
  },
  { key: "imageBorderColor", label: "Image Border Color", type: "color" },
  {
    key: "imageOverlap",
    label: "Image Overlap",
    type: "number",
    min: 0,
    max: 20,
    step: 2
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 2
  },
  // Counter
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Placeholder
  { key: "placeholderBgColor", label: "Placeholder Background", type: "color" }
], $s = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    themeIcons: g,
    resolveColor: C,
    canSave: w
  } = _(
    o,
    { ...Ga, ...e },
    Nt
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const k = n(i, C);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Nt,
      editValues: i,
      onEditChange: m,
      onSave: w ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      themeIcons: g,
      children: k
    }
  );
}, $a = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Ya = {
  // Preset
  preset: "plain",
  // Layout direction
  layout: "vertical",
  // Container
  containerGap: 8,
  containerBgColor: a("transparent"),
  containerPaddingX: 0,
  containerPaddingY: 0,
  containerBorderRadius: 0,
  // Icon
  showIcon: !1,
  // Suggestion pills
  pillPaddingX: 16,
  pillPaddingY: 12,
  pillBorderRadius: 8,
  pillBorderColor: a("borderColor"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !1,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillFontFamily: "inherit"
}, Qa = {
  // --- Base: transparent bg, thin light border ---
  plain: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "plain-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Highlighted: container bg, no pill border ---
  highlighted: {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "highlighted-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("transparent"),
    pillBorderWidth: 0,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Container bg with thin border on pills ---
  "container-bg": {
    showIcon: !1,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "container-bg-icon": {
    showIcon: !0,
    containerGap: 8,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 12,
    pillBorderRadius: 8,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  // --- Extras: stronger border treatment ---
  bordered: {
    showIcon: !1,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-icon": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 0,
    containerPaddingY: 0,
    containerBorderRadius: 0,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  },
  "bordered-highlighted": {
    showIcon: !0,
    containerGap: 6,
    containerBgColor: a("transparent"),
    containerPaddingX: 12,
    containerPaddingY: 12,
    containerBorderRadius: 12,
    pillPaddingX: 16,
    pillPaddingY: 14,
    pillBorderRadius: 10,
    pillBorderColor: a("borderColor"),
    pillBorderWidth: 1.5,
    pillBgColor: a("secondary"),
    pillBgColorHover: a("background"),
    pillTextColor: a("textPrimary"),
    pillFontSize: 14,
    pillFontWeight: "medium"
  }
}, Xa = [
  { label: "Plain", value: "plain" },
  { label: "Plain + Icon", value: "plain-icon" },
  { label: "Highlighted", value: "highlighted" },
  { label: "Highlighted + Icon", value: "highlighted-icon" },
  { label: "Container BG", value: "container-bg" },
  { label: "Container BG + Icon", value: "container-bg-icon" },
  { label: "Bordered", value: "bordered" },
  { label: "Bordered + Icon", value: "bordered-icon" },
  { label: "Bordered Highlighted", value: "bordered-highlighted" },
  { label: "Custom", value: "custom" }
], Ot = [
  // Preset selector (top of panel)
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Xa
  },
  // Layout direction
  {
    key: "layout",
    label: "Layout",
    type: "options",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  // Icon toggle
  { key: "showIcon", label: "Show Arrow Icon", type: "toggle" },
  // Container
  {
    key: "containerGap",
    label: "Gap Between Pills",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "containerPaddingX",
    label: "Container Padding X",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerPaddingY",
    label: "Container Padding Y",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5
  },
  { key: "pillBorderColor", label: "Pill Border Color", type: "color" },
  { key: "pillBgColor", label: "Pill Background", type: "color" },
  { key: "pillBgColorHover", label: "Pill Hover Background", type: "color" },
  { key: "pillTextColor", label: "Pill Text Color", type: "color" },
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Shadow Value (CSS)", type: "text" },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ie]
  },
  { key: "pillFontFamily", label: "Pill Font Family", type: "font" },
  // Shadow
  { key: "pillShadowEnabled", label: "Pill Shadow", type: "toggle" },
  { key: "pillShadow", label: "Pill Shadow CSS", type: "text" }
], Ys = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ...Ya, ...e },
    Ot
  ), w = (T, W) => {
    if (T === "preset" && W !== "custom") {
      const N = Qa[W];
      if (N) {
        m("preset", W), Object.entries(N).forEach(([z, A]) => {
          m(z, A);
        });
        return;
      }
    }
    m(T, W);
  }, k = i.pillFontFamily, x = k && k !== "inherit" ? c[k] : null, f = x && x.format === "google" ? x.url : null;
  if (Q(() => {
    f && $a(f);
  }, [f]), s)
    return /* @__PURE__ */ t(D, {});
  const B = x ? x.format === "system" ? x.url : `"${x.name}", sans-serif` : "inherit", P = x && x.format !== "system" && x.format !== "google", u = `suggestion-list-${o || "default"}`, R = `
    ${P ? `
      @font-face {
        font-family: "${x.name}";
        src: url("${x.url}") format("${x.format}");
        font-display: swap;
      }
    ` : ""}
    ${B !== "inherit" ? `.${u} { font-family: ${B} !important; }` : ""}
  `.trim(), b = {
    ...i,
    pillFontFamilyCss: B
  }, I = g(i.containerBgColor), S = I && I !== "transparent" && I !== "", v = /* @__PURE__ */ h(D, { children: [
    R && /* @__PURE__ */ t("style", { children: R }),
    /* @__PURE__ */ t(
      "div",
      {
        className: u,
        style: {
          backgroundColor: S ? I : void 0,
          padding: S || i.containerPaddingX || i.containerPaddingY ? `${i.containerPaddingY}px ${i.containerPaddingX}px` : void 0,
          borderRadius: i.containerBorderRadius > 0 ? `${i.containerBorderRadius}px` : void 0
        },
        children: n(b, g)
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Ot,
      editValues: i,
      onEditChange: w,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: v
    }
  );
}, Ja = {
  "vertical-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: a("borderColor"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 0
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillBorderRadius: 8,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      borderColor: a("borderColor"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 0
    }
  },
  "vertical-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "vertical",
      pillShowIcon: !1,
      pillBorderRadius: 8,
      pillBorderColor: a("transparent"),
      pillBorderWidth: 0,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 12,
      inputBorderColor: a("borderColor"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 100
    },
    suggestionList: {
      layout: "vertical",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 12,
      containerPaddingY: 12,
      containerBorderRadius: 12,
      pillBorderRadius: 8,
      pillBorderColor: a("transparent"),
      pillBorderWidth: 0,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      borderColor: a("borderColor"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 100
    }
  },
  "horizontal-compact": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: a("borderColor"),
      inputBorderWidth: 1,
      inputBorderRadius: 100,
      inputMinHeight: 0
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      borderColor: a("borderColor"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 100,
      borderRadiusMultiLine: 15,
      minHeight: 0
    }
  },
  "horizontal-expanded": {
    panel: {
      mainBgColor: a("transparent"),
      pillLayout: "horizontal",
      pillShowIcon: !1,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillTextColor: a("textPrimary"),
      pillContainerBgColor: a("transparent"),
      pillContainerBorderRadius: 0,
      inputBorderColor: a("borderColor"),
      inputBorderWidth: 1,
      inputBorderRadius: 20,
      inputMinHeight: 100
    },
    suggestionList: {
      layout: "horizontal",
      showIcon: !1,
      containerBgColor: a("transparent"),
      containerPaddingX: 0,
      containerPaddingY: 0,
      containerBorderRadius: 0,
      pillPaddingX: 16,
      pillPaddingY: 10,
      pillBorderRadius: 100,
      pillBorderColor: a("borderColor"),
      pillBorderWidth: 1,
      pillBgColor: a("secondary"),
      pillBgColorHover: a("background"),
      pillTextColor: a("textPrimary")
    },
    chatInput: {
      borderColor: a("borderColor"),
      borderColorFocus: a("primary"),
      borderWidth: 1,
      borderRadiusSingleLine: 20,
      borderRadiusMultiLine: 15,
      minHeight: 100
    }
  }
}, Za = [
  { label: "Vertical + Compact Input", value: "vertical-compact" },
  { label: "Vertical + Expanded Input", value: "vertical-expanded" },
  { label: "Horizontal + Compact Input", value: "horizontal-compact" },
  { label: "Horizontal + Expanded Input", value: "horizontal-expanded" },
  { label: "Custom", value: "custom" }
], Dt = [
  // --- General ---
  {
    key: "preset",
    label: "Preset",
    type: "options",
    options: Za
  },
  { key: "mainBgColor", label: "Background", type: "color" },
  // --- Suggestion Pills group ---
  {
    key: "pillLayout",
    label: "Layout",
    type: "options",
    group: "Suggestion Pills",
    options: [
      { label: "Vertical", value: "vertical" },
      { label: "Horizontal", value: "horizontal" }
    ]
  },
  {
    key: "pillShowIcon",
    label: "Show Icon",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderColor",
    label: "Border Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 0.5,
    group: "Suggestion Pills"
  },
  {
    key: "pillBgColor",
    label: "Background",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillTextColor",
    label: "Text Color",
    type: "color",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Suggestion Pills"
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Suggestion Pills"
  },
  // --- Input Box group ---
  {
    key: "inputBorderColor",
    label: "Border Color",
    type: "color",
    group: "Input Box"
  },
  {
    key: "inputBorderWidth",
    label: "Border Width",
    type: "number",
    min: 0,
    max: 5,
    step: 0.5,
    group: "Input Box"
  },
  {
    key: "inputBorderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Input Box"
  },
  {
    key: "inputMinHeight",
    label: "Min Height (0=auto)",
    type: "number",
    min: 0,
    max: 200,
    step: 10,
    group: "Input Box"
  },
  {
    key: "inputShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Input Box"
  },
  {
    key: "inputShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Input Box"
  }
], Ua = {
  preset: "vertical-compact",
  mainBgColor: a("transparent"),
  // Pill defaults
  pillLayout: "vertical",
  pillShowIcon: !1,
  pillBorderRadius: 8,
  pillBorderColor: a("borderColor"),
  pillBorderWidth: 1,
  pillBgColor: a("secondary"),
  pillTextColor: a("textPrimary"),
  pillShadowEnabled: !1,
  pillShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)",
  pillContainerBgColor: a("transparent"),
  pillContainerBorderRadius: 0,
  // Input defaults
  inputBorderColor: a("borderColor"),
  inputBorderWidth: 1,
  inputBorderRadius: 100,
  inputMinHeight: 0,
  inputShadowEnabled: !1,
  inputShadow: "8px 8px 14px 0 rgba(0, 0, 0, 0.03)"
}, Qs = ({
  widgetId: e = "concierge-panel",
  displayName: o = "Concierge Panel",
  initialState: r = {},
  suggestionListWidgetId: n = "concierge-suggestion-list",
  chatInputWidgetId: i = "concierge-chat-input",
  suppressChildEdits: s = !0,
  children: l
}) => {
  const {
    state: m,
    isLoading: p,
    isSaving: y,
    handleEditChange: c,
    handleSave: g,
    themeColors: C,
    themeFonts: w,
    resolveColor: k,
    canSave: x
  } = _(
    e,
    { ...Ua, ...r },
    Dt
  ), { updateWidgetConfig: f } = Eo(
    n
  ), { updateWidgetConfig: B } = Eo(i), P = {
    pillLayout: "layout",
    pillShowIcon: "showIcon",
    pillBorderRadius: "pillBorderRadius",
    pillBorderColor: "pillBorderColor",
    pillBorderWidth: "pillBorderWidth",
    pillBgColor: "pillBgColor",
    pillTextColor: "pillTextColor",
    pillShadowEnabled: "pillShadowEnabled",
    pillShadow: "pillShadow",
    pillContainerBgColor: "containerBgColor",
    pillContainerBorderRadius: "containerBorderRadius"
  }, u = {
    inputBorderColor: "borderColor",
    inputBorderWidth: "borderWidth",
    inputBorderRadius: "borderRadiusSingleLine",
    inputMinHeight: "minHeight",
    inputShadowEnabled: "shadowEnabled",
    inputShadow: "shadow"
  }, R = pe(
    (S, v) => {
      if (S === "preset" && v !== "custom") {
        const W = Ja[v];
        if (W) {
          c("preset", v), W.panel && Object.entries(W.panel).forEach(([F, N]) => {
            c(F, N);
          }), Object.entries(W.suggestionList).forEach(([F, N]) => {
            f(F, N);
          }), Object.entries(W.chatInput).forEach(([F, N]) => {
            B(F, N);
          });
          return;
        }
      }
      if (S in P) {
        c("preset", "custom"), c(S, v), f(P[S], v);
        return;
      }
      if (S in u) {
        c("preset", "custom"), c(S, v), B(u[S], v);
        return;
      }
      c(S, v);
    },
    [c, f, B]
  );
  if (p)
    return /* @__PURE__ */ t(D, {});
  const b = l(m, k);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Dt,
      editValues: m,
      onEditChange: R,
      onSave: x ? g : void 0,
      isSaving: y,
      themeColors: C,
      themeFonts: w,
      containerClassName: "widget-fill-height",
      children: s ? /* @__PURE__ */ t(Ni, { children: b }) : b
    }
  );
}, jt = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, Va = {
  // Card/Pill container
  borderColor: a("borderColor"),
  borderColorSelected: a("primary"),
  backgroundColor: a("secondary"),
  backgroundColorHover: a("background"),
  borderRadius: 8,
  // Rectangle card dimensions
  cardWidth: 88,
  cardGap: 12,
  cardImageSize: 72,
  // Compact pill dimensions
  pillImageSize: 32,
  pillGap: 8,
  pillPaddingY: 6,
  pillPaddingX: 12,
  // Checkmark badge
  checkmarkBgColor: a("primary"),
  checkmarkIconColor: a("secondary"),
  checkmarkSize: 16,
  // Price text
  priceColor: a("textPrimary"),
  priceFontSize: 16,
  priceFontWeightNormal: "medium",
  priceFontWeightSelected: "semibold",
  priceFontFamily: "inherit",
  // Variant name text
  nameColor: a("textPrimary"),
  nameFontSize: 14,
  nameFontSizeCompact: 14,
  nameFontWeightNormal: "medium",
  nameFontWeightSelected: "semibold",
  nameFontFamily: "inherit",
  // Divider
  dividerColor: a("background"),
  dividerColorSelected: a("primary")
}, Gt = [
  // Card/Pill container
  { key: "borderColor", label: "Border Color", type: "color" },
  {
    key: "borderColorSelected",
    label: "Border Color (Selected)",
    type: "color"
  },
  { key: "backgroundColor", label: "Background Color", type: "color" },
  {
    key: "backgroundColorHover",
    label: "Background Color (Hover)",
    type: "color"
  },
  {
    key: "borderRadius",
    label: "Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  // Rectangle card dimensions
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 60,
    max: 120,
    step: 4
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 2
  },
  {
    key: "cardImageSize",
    label: "Card Image Size",
    type: "number",
    min: 48,
    max: 96,
    step: 4
  },
  // Compact pill dimensions
  {
    key: "pillImageSize",
    label: "Pill Image Size",
    type: "number",
    min: 24,
    max: 48,
    step: 4
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Checkmark badge
  { key: "checkmarkBgColor", label: "Checkmark Background", type: "color" },
  { key: "checkmarkIconColor", label: "Checkmark Icon Color", type: "color" },
  {
    key: "checkmarkSize",
    label: "Checkmark Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Price text
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  {
    key: "priceFontWeightNormal",
    label: "Price Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "priceFontWeightSelected",
    label: "Price Weight (Selected)",
    type: "options",
    options: [...ie]
  },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font"
  },
  // Variant name text
  { key: "nameColor", label: "Name Color", type: "color" },
  {
    key: "nameFontSize",
    label: "Name Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "nameFontSizeCompact",
    label: "Name Font Size (Compact)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "nameFontWeightNormal",
    label: "Name Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "nameFontWeightSelected",
    label: "Name Weight (Selected)",
    type: "options",
    options: [...ie]
  },
  {
    key: "nameFontFamily",
    label: "Name Font Family",
    type: "font"
  },
  // Divider
  { key: "dividerColor", label: "Divider Color", type: "color" },
  {
    key: "dividerColorSelected",
    label: "Divider Color (Selected)",
    type: "color"
  }
], Xs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ...Va, ...e },
    Gt
  ), w = i.priceFontFamily, k = w && w !== "inherit" ? c[w] : null, x = i.nameFontFamily, f = x && x !== "inherit" ? c[x] : null, B = k && k.format === "google" ? k.url : null, P = f && f.format === "google" ? f.url : null;
  if (Q(() => {
    B && jt(B);
  }, [B]), Q(() => {
    P && jt(P);
  }, [P]), s)
    return /* @__PURE__ */ t(D, {});
  const u = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", R = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", b = k && k.format !== "system" && k.format !== "google", I = f && f.format !== "system" && f.format !== "google", S = `variant-picker-${o || "default"}`, v = `
    ${b ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${u !== "inherit" ? `.${S} [data-price-text] { font-family: ${u} !important; }` : ""}
    ${R !== "inherit" ? `.${S} [data-name-text] { font-family: ${R} !important; }` : ""}
  `.trim(), T = {
    ...i,
    priceFontFamilyCss: u,
    nameFontFamilyCss: R
  }, W = /* @__PURE__ */ h(D, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(T, g)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Gt,
      editValues: i,
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, _a = {
  overlayBgColor: Ie("rgba(0, 0, 0, 0.45)"),
  dialogBgColor: a("secondary"),
  dialogBorderRadius: 12,
  titleColor: a("textPrimary"),
  messageColor: a("textPrimary"),
  cancelButtonBgColor: a("secondary"),
  cancelButtonBorderColor: a("borderColor"),
  cancelButtonTextColor: a("textPrimary"),
  confirmButtonBgColor: a("primary"),
  confirmButtonTextColor: a("primaryForeground")
}, $t = [
  { key: "overlayBgColor", label: "Overlay Background", type: "color" },
  { key: "dialogBgColor", label: "Dialog Background", type: "color" },
  {
    key: "dialogBorderRadius",
    label: "Dialog Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  { key: "titleColor", label: "Title Color", type: "color" },
  { key: "messageColor", label: "Message Color", type: "color" },
  {
    key: "cancelButtonBgColor",
    label: "Cancel Button Background",
    type: "color"
  },
  {
    key: "cancelButtonBorderColor",
    label: "Cancel Button Border",
    type: "color"
  },
  {
    key: "cancelButtonTextColor",
    label: "Cancel Button Text",
    type: "color"
  },
  {
    key: "confirmButtonBgColor",
    label: "Confirm Button Background",
    type: "color"
  },
  {
    key: "confirmButtonTextColor",
    label: "Confirm Button Text",
    type: "color"
  }
], Js = ({ initialState: e = {}, widgetId: o, displayName: r, overlay: n, children: i }) => {
  const {
    state: s,
    isLoading: l,
    isSaving: m,
    handleEditChange: p,
    handleSave: y,
    themeColors: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ..._a, ...e },
    $t
  );
  if (l)
    return /* @__PURE__ */ t(D, {});
  const w = n ? n(s, g) : null, k = i(s, g);
  return /* @__PURE__ */ h(D, { children: [
    w,
    /* @__PURE__ */ t(
      J,
      {
        widgetId: o,
        displayName: r,
        editFields: $t,
        editValues: s,
        onEditChange: p,
        onSave: C ? y : void 0,
        isSaving: m,
        themeColors: c,
        triggerMode: "persistent",
        triggerPosition: "top-right",
        wrapperStyle: { width: "100%", maxWidth: "28rem" },
        children: k
      }
    )
  ] });
}, qa = {
  // ============================================
  // 1. HEADER SECTION (Search results toggle)
  // ============================================
  headerIconColor: a("textPrimary"),
  headerIconSize: 14,
  headerLabelText: "Search results",
  headerLabelColor: a("textPrimary"),
  headerLabelFontSize: 14,
  headerLabelFontWeight: "medium",
  headerLabelFontFamily: "inherit",
  headerChevronColor: a("textPrimary"),
  headerChevronSize: 16,
  headerGap: 6,
  headerMarginBottom: 16,
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  containerMarginBottom: 12,
  pillsGap: 8,
  pillsSectionMarginBottom: 24,
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  defaultExpanded: !0,
  autoCollapse: !0,
  autoCollapseDelay: 1500,
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  thinkingEnabled: !0,
  thinkingText: "Thinking...",
  thinkingTextColor: a("textPrimary"),
  thinkingTextFontSize: 14,
  thinkingBgColor: a("secondary"),
  thinkingPaddingX: 16,
  thinkingPaddingY: 12,
  thinkingBorderRadius: 18,
  thinkingBorderRadiusBottomLeft: 5,
  shimmerDuration: 1.5,
  shimmerColor: a("background"),
  // ============================================
  // 5. ANIMATION
  // ============================================
  animationsEnabled: !0,
  productAnimationDuration: 800,
  chevronRotationDuration: 200
}, Yt = [
  // ============================================
  // 1. HEADER SECTION
  // ============================================
  { key: "headerIconColor", label: "Header Icon Color", type: "color" },
  {
    key: "headerIconSize",
    label: "Header Icon Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  { key: "headerLabelText", label: "Header Label Text", type: "text" },
  { key: "headerLabelColor", label: "Header Label Color", type: "color" },
  {
    key: "headerLabelFontSize",
    label: "Header Label Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  {
    key: "headerLabelFontWeight",
    label: "Header Label Font Weight",
    type: "options",
    options: ie
  },
  {
    key: "headerLabelFontFamily",
    label: "Header Label Font Family",
    type: "font"
  },
  { key: "headerChevronColor", label: "Header Chevron Color", type: "color" },
  {
    key: "headerChevronSize",
    label: "Header Chevron Size",
    type: "number",
    min: 12,
    max: 24,
    step: 1
  },
  {
    key: "headerGap",
    label: "Header Gap",
    type: "number",
    min: 2,
    max: 16,
    step: 1
  },
  {
    key: "headerMarginBottom",
    label: "Header Margin Bottom",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  // ============================================
  // 2. CONTAINER & LAYOUT
  // ============================================
  {
    key: "containerMarginBottom",
    label: "Container Margin Bottom",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "pillsGap",
    label: "Pills Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2
  },
  {
    key: "pillsSectionMarginBottom",
    label: "Pills Section Margin Bottom",
    type: "number",
    min: 8,
    max: 48,
    step: 4
  },
  // ============================================
  // 3. COLLAPSIBLE BEHAVIOR
  // ============================================
  { key: "defaultExpanded", label: "Default Expanded", type: "toggle" },
  { key: "autoCollapse", label: "Auto Collapse", type: "toggle" },
  {
    key: "autoCollapseDelay",
    label: "Auto Collapse Delay (ms)",
    type: "number",
    min: 500,
    max: 5e3,
    step: 100
  },
  // ============================================
  // 4. THINKING INDICATOR
  // ============================================
  {
    key: "thinkingEnabled",
    label: "Thinking Indicator Enabled",
    type: "toggle"
  },
  { key: "thinkingText", label: "Thinking Text", type: "text" },
  { key: "thinkingTextColor", label: "Thinking Text Color", type: "color" },
  {
    key: "thinkingTextFontSize",
    label: "Thinking Text Font Size",
    type: "number",
    min: 10,
    max: 20,
    step: 1
  },
  { key: "thinkingBgColor", label: "Thinking Background", type: "color" },
  {
    key: "thinkingPaddingX",
    label: "Thinking Padding X",
    type: "number",
    min: 8,
    max: 32,
    step: 2
  },
  {
    key: "thinkingPaddingY",
    label: "Thinking Padding Y",
    type: "number",
    min: 6,
    max: 24,
    step: 2
  },
  {
    key: "thinkingBorderRadius",
    label: "Thinking Border Radius",
    type: "number",
    min: 0,
    max: 32,
    step: 2
  },
  {
    key: "thinkingBorderRadiusBottomLeft",
    label: "Thinking Bottom Left Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 1
  },
  {
    key: "shimmerDuration",
    label: "Shimmer Duration (s)",
    type: "number",
    min: 0.5,
    max: 4,
    step: 0.1
  },
  { key: "shimmerColor", label: "Shimmer Color", type: "color" },
  // ============================================
  // 5. ANIMATION
  // ============================================
  { key: "animationsEnabled", label: "Animations Enabled", type: "toggle" },
  {
    key: "productAnimationDuration",
    label: "Product Animation Duration (ms)",
    type: "number",
    min: 200,
    max: 2e3,
    step: 100
  },
  {
    key: "chevronRotationDuration",
    label: "Chevron Rotation Duration (ms)",
    type: "number",
    min: 100,
    max: 500,
    step: 50
  }
], Zs = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    themeIcons: g,
    resolveColor: C,
    canSave: w
  } = _(
    o,
    { ...qa, ...e },
    Yt
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const k = n(i, C);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: Yt,
      editValues: i,
      onEditChange: m,
      onSave: w ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      themeIcons: g,
      children: k
    }
  );
}, Ka = {
  // Container styling
  containerBgColor: a("secondary"),
  containerBorderRadius: 16,
  containerPaddingX: 24,
  containerPaddingY: 24,
  containerBorderWidth: 1,
  containerBorderColor: a("background"),
  // Icon styling
  iconBgColor: a("primary"),
  iconColor: a("secondary"),
  iconSize: 40,
  // Title styling
  titleColor: a("textPrimary"),
  titleFontSize: 16,
  titleFontWeight: "700",
  // Description styling
  descriptionColor: a("textPrimary"),
  descriptionFontSize: 14,
  // Button styling
  buttonBgColor: a("primary"),
  buttonTextColor: a("secondary"),
  buttonFontSize: 14,
  buttonFontWeight: "600",
  buttonBorderRadius: 10,
  buttonPaddingX: 20,
  buttonPaddingY: 10
}, Qt = [
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerBorderRadius",
    label: "Container Border Radius",
    type: "number",
    min: 0,
    max: 24
  },
  {
    key: "containerBorderWidth",
    label: "Container Border Width",
    type: "number",
    min: 0,
    max: 4
  },
  { key: "containerBorderColor", label: "Container Border Color", type: "color" },
  { key: "iconBgColor", label: "Icon Background", type: "color" },
  { key: "iconColor", label: "Icon Color", type: "color" },
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 24
  },
  { key: "descriptionColor", label: "Description Color", type: "color" },
  {
    key: "descriptionFontSize",
    label: "Description Font Size",
    type: "number",
    min: 10,
    max: 20
  },
  { key: "buttonBgColor", label: "Button Background", type: "color" },
  { key: "buttonTextColor", label: "Button Text Color", type: "color" },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius",
    type: "number",
    min: 0,
    max: 24
  }
], el = ({ size: e, color: o }) => /* @__PURE__ */ h(
  "svg",
  {
    width: e * 0.5,
    height: e * 0.5,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ t("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
      /* @__PURE__ */ t("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
    ]
  }
), Us = ({
  widgetId: e,
  title: o,
  description: r,
  buttonText: n,
  onSignIn: i,
  initialState: s
}) => {
  const {
    state: l,
    handleEditChange: m,
    handleSave: p,
    isSaving: y,
    getEditValues: c,
    resolveColor: g,
    themeColors: C,
    themeFonts: w,
    themeIcons: k
  } = _(
    e,
    { ...Ka, ...s },
    Qt
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: "Login Wall",
      editFields: Qt,
      editValues: c(),
      onEditChange: m,
      onSave: p,
      isSaving: y,
      themeColors: C,
      themeFonts: w,
      themeIcons: k,
      children: /* @__PURE__ */ h(
        "div",
        {
          style: {
            backgroundColor: g(l.containerBgColor),
            borderRadius: `${l.containerBorderRadius}px`,
            padding: `${l.containerPaddingY}px ${l.containerPaddingX}px`,
            border: `${l.containerBorderWidth}px solid ${g(l.containerBorderColor)}`,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
            width: "100%",
            boxSizing: "border-box",
            textAlign: "center",
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06), 0 1px 2px rgba(0, 0, 0, 0.04)"
          },
          children: [
            /* @__PURE__ */ t(
              "div",
              {
                style: {
                  width: `${l.iconSize}px`,
                  height: `${l.iconSize}px`,
                  borderRadius: "50%",
                  backgroundColor: g(l.iconBgColor),
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0
                },
                children: /* @__PURE__ */ t(
                  el,
                  {
                    size: l.iconSize,
                    color: g(l.iconColor)
                  }
                )
              }
            ),
            /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: "6px" }, children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    color: g(l.titleColor),
                    fontSize: `${l.titleFontSize}px`,
                    fontWeight: l.titleFontWeight,
                    lineHeight: 1.4
                  },
                  children: o
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    color: g(l.descriptionColor),
                    fontSize: `${l.descriptionFontSize}px`,
                    lineHeight: 1.5
                  },
                  children: r
                }
              )
            ] }),
            i && /* @__PURE__ */ t(
              "button",
              {
                onClick: i,
                style: {
                  backgroundColor: g(l.buttonBgColor),
                  color: g(l.buttonTextColor),
                  fontSize: `${l.buttonFontSize}px`,
                  fontWeight: l.buttonFontWeight,
                  borderRadius: `${l.buttonBorderRadius}px`,
                  padding: `${l.buttonPaddingY}px ${l.buttonPaddingX}px`,
                  border: "none",
                  cursor: "pointer",
                  transition: "opacity 0.15s ease",
                  width: "100%",
                  maxWidth: "200px",
                  letterSpacing: "0.01em"
                },
                onMouseEnter: (x) => {
                  x.currentTarget.style.opacity = "0.88";
                },
                onMouseLeave: (x) => {
                  x.currentTarget.style.opacity = "1";
                },
                children: n
              }
            )
          ]
        }
      )
    }
  );
}, Xt = [
  "concierge-home-greeting",
  "concierge-home-subtitle",
  "concierge-home-starters",
  "concierge-home-logo",
  "concierge-home-brand-label",
  "concierge-chat-input"
], we = {
  "concierge-home-greeting": {
    greetingFontWeight: "semibold"
  },
  "concierge-home-subtitle": {
    fontWeight: "semibold"
  },
  "concierge-chat-input": {
    iconSize: 24,
    submitButtonSize: 24,
    iconGap: 12
  }
}, ol = {
  // =========================================================================
  // A-Series: Minimal / brand-focused layouts
  // =========================================================================
  /** A1 - Minimal: Logo only + search bar */
  A1: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      searchInputGap: 32,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A2 - Logo + Subtitle: Logo with assistant intro text */
  A2: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-hero-logo",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A3 - Branded Logo: "CONCIERGE BY" label above logo */
  A3: {
    layout: {
      logoPosition: "hero",
      brandLabelPosition: "above-hero-logo",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "hidden",
      startersMode: "hidden",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      mobile_logoPosition: "hero",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A4 - Subtitle + Pills: Subtitle text with pill starters, logo in footer */
  A4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !1,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 16,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A5 - Greeting + Pills: Personalized greeting with pill starters */
  A5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 16,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A6 - Inline Icon Greeting + Pills: Greeting with inline icon before text and pill starters */
  A6: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "inline",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 16,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** A7 - Icon Above Greeting + Pills: Greeting with icon above text and pill starters */
  A7: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !0,
      greetingIconPosition: "above",
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 32,
      searchInputGap: 24,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      "concierge-home-greeting": {
        greetingFontSize: 28,
        greetingFontWeight: "semibold"
      },
      "concierge-home-subtitle": {
        fontSize: 32,
        fontWeight: "semibold",
        lineHeight: 1,
        letterSpacing: 0.08,
        maxWidth: 800,
        marginBottom: 0
      },
      "concierge-home-starters": {
        pillPaddingX: 24,
        pillPaddingY: 12,
        pillBgColor: a("secondary"),
        pillFontWeight: "medium",
        pillShadowEnabled: !0,
        pillShadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)"
      },
      "concierge-chat-input": {
        shadowEnabled: !0,
        shadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
        borderColor: a("borderColor"),
        borderColorFocus: a("borderColor"),
        borderRadiusSingleLine: 15,
        borderRadiusMultiLine: 15,
        submitButtonIconColor: a("secondary"),
        submitButtonSize: 24,
        iconSize: 24,
        iconGap: 12,
        fontSize: 12,
        placeholderColor: a("primary"),
        paddingX: 24,
        paddingY: 24,
        minHeight: 138,
        mobile_minHeight: 116
      }
    }
  },
  // =========================================================================
  // B-Series: Greeting + conversation starters focused
  // =========================================================================
  /** B1 - Card Starters Row: Greeting with 4 cards in a horizontal row */
  B1: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-row",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 64,
      mobile_logoPosition: "header",
      mobile_startersMode: "cards-grid"
    },
    childWidgets: {
      ...we
    }
  },
  /** B2 - Icon Pills: Greeting with 3 icon-pill starters, logo after content */
  B2: {
    layout: {
      logoPosition: "after-content",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 56,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** B3 - Icon Pills + Branded Footer: 3 icon-pill starters with "CONCIERGE BY" footer */
  B3: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills-icons",
      maxStarters: 3,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 56,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  },
  /** B4 - Card Grid: Greeting with 2x2 inline-icon card grid */
  B4: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "hidden",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "cards-grid",
      maxStarters: 4,
      cardLayoutDirection: "inline",
      footerGap: 8,
      footerPaddingBottom: 56,
      mobile_logoPosition: "header",
      mobile_startersMode: "pills-icons-list"
    },
    childWidgets: {
      ...we
    }
  },
  /** B5 - Pills + Branded Footer: Greeting with pills and "EMBER BY" footer */
  B5: {
    layout: {
      logoPosition: "footer",
      brandLabelPosition: "above-footer-logo",
      showGreeting: !0,
      showGreetingIcon: !1,
      subtitlePosition: "under-greeting",
      startersMode: "pills",
      maxStarters: 4,
      cardLayoutDirection: "stacked",
      footerGap: 8,
      footerPaddingBottom: 56,
      mobile_logoPosition: "header",
      mobile_startersMode: "inherit"
    },
    childWidgets: {
      ...we
    }
  }
}, tl = {
  A1: "A1 - Minimal (Logo only)",
  A2: "A2 - Logo + Subtitle",
  A3: "A3 - Branded Logo",
  A4: "A4 - Subtitle + Pills",
  A5: "A5 - Greeting + Pills",
  A6: "A6 - Inline Icon Greeting + Pills",
  A7: "A7 - Icon Above Greeting + Pills",
  B1: "B1 - Card Starters (Row)",
  B2: "B2 - Icon Pills",
  B3: "B3 - Icon Pills + Branded Footer",
  B4: "B4 - Card Starters (Grid)",
  B5: "B5 - Pills + Branded Footer",
  custom: "Custom"
}, rl = {
  layoutPreset: "A1",
  backgroundStyle: "colored",
  backgroundColor: a("background"),
  elementStyle: "default",
  logoPosition: "hero",
  brandLabelPosition: "hidden",
  showGreeting: !1,
  showGreetingIcon: !1,
  greetingIconPosition: "above",
  subtitlePosition: "hidden",
  startersMode: "hidden",
  maxStarters: 4,
  cardLayoutDirection: "stacked",
  footerGap: 8,
  footerPaddingBottom: 16,
  searchInputGap: 32,
  mobile_logoPosition: "hero",
  mobile_startersMode: "inherit"
}, nl = Object.entries(tl).map(([e, o]) => ({
  label: o,
  value: e
})), Jt = [
  // Preset
  {
    key: "layoutPreset",
    label: "Layout Preset",
    type: "options",
    options: nl,
    group: "Preset"
  },
  // Background
  {
    key: "backgroundStyle",
    label: "Background",
    type: "options",
    options: [
      { label: "Colored", value: "colored" },
      { label: "White", value: "white" }
    ],
    group: "Background"
  },
  {
    key: "backgroundColor",
    label: "Background Color",
    type: "color",
    group: "Background",
    condition: { field: "backgroundStyle", value: "colored" }
  },
  {
    key: "elementStyle",
    label: "Element Style",
    type: "options",
    options: [
      { label: "Default", value: "default" },
      { label: "Grey Fill", value: "grey-fill" },
      { label: "Grey Fill + Stroke", value: "grey-fill-stroke" }
    ],
    group: "Background"
  },
  // Sections
  {
    key: "logoPosition",
    label: "Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "After Content", value: "after-content" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "brandLabelPosition",
    label: "Brand Label",
    type: "options",
    options: [
      { label: "Above Hero Logo", value: "above-hero-logo" },
      { label: "Above Footer Logo", value: "above-footer-logo" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "showGreeting",
    label: "Show Greeting",
    type: "toggle",
    group: "Sections"
  },
  {
    key: "showGreetingIcon",
    label: "Show Greeting Icon",
    type: "toggle",
    group: "Sections",
    condition: "showGreeting"
  },
  {
    key: "greetingIconPosition",
    label: "Icon Position",
    type: "options",
    options: [
      { label: "Above Greeting", value: "above" },
      { label: "Inline (before text)", value: "inline" }
    ],
    group: "Sections",
    condition: "showGreetingIcon"
  },
  {
    key: "subtitlePosition",
    label: "Subtitle Position",
    type: "options",
    options: [
      { label: "Under Hero Logo", value: "under-hero-logo" },
      { label: "Under Greeting", value: "under-greeting" },
      { label: "Hidden", value: "hidden" }
    ],
    group: "Sections"
  },
  {
    key: "startersMode",
    label: "Starters Layout",
    type: "options",
    options: [
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Sections"
  },
  {
    key: "maxStarters",
    label: "Max Starters",
    type: "number",
    min: 1,
    max: 6,
    step: 1,
    group: "Sections",
    condition: { field: "startersMode", value: "hidden", operator: "not_equals" }
  },
  {
    key: "cardLayoutDirection",
    label: "Card Layout",
    type: "options",
    options: [
      { label: "Stacked (icon above text)", value: "stacked" },
      { label: "Inline (icon beside text)", value: "inline" }
    ],
    group: "Sections",
    condition: { field: "startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "footerGap",
    label: "Footer / After-Content Gap",
    type: "number",
    min: 0,
    max: 80,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: ["footer", "after-content"], operator: "includes" }
  },
  {
    key: "footerPaddingBottom",
    label: "Footer Bottom Padding",
    type: "number",
    min: 0,
    max: 120,
    step: 4,
    group: "Sections",
    condition: { field: "logoPosition", value: "footer" }
  },
  {
    key: "searchInputGap",
    label: "Search Input Gap",
    type: "number",
    min: 0,
    max: 64,
    step: 4,
    group: "Sections"
  },
  // Mobile overrides (responsive)
  {
    key: "mobile_logoPosition",
    label: "Mobile Logo Position",
    type: "options",
    options: [
      { label: "Hero (center)", value: "hero" },
      { label: "Header (top bar)", value: "header" },
      { label: "Footer (bottom)", value: "footer" },
      { label: "Hidden", value: "hidden" },
      { label: "Inherit from Desktop", value: "inherit" }
    ],
    group: "Mobile"
  },
  {
    key: "mobile_startersMode",
    label: "Mobile Starters Layout",
    type: "options",
    options: [
      { label: "Inherit from Desktop", value: "inherit" },
      { label: "Hidden", value: "hidden" },
      { label: "Pills (text)", value: "pills" },
      { label: "Pills (with icons)", value: "pills-icons" },
      { label: "Pills + Icons (list)", value: "pills-icons-list" },
      { label: "Cards (row)", value: "cards-row" },
      { label: "Cards (2x2 grid)", value: "cards-grid" }
    ],
    group: "Mobile"
  }
], Vs = ({
  widgetId: e = "concierge-home-layout",
  displayName: o = "Home Layout",
  initialState: r = {},
  children: n
}) => {
  const i = $o(), s = $e(), l = se(/* @__PURE__ */ new Set()), {
    state: m,
    isLoading: p,
    isSaving: y,
    handleEditChange: c,
    handleSave: g,
    resetField: C,
    savedKeys: w,
    themeColors: k,
    resolveColor: x,
    canSave: f
  } = _(
    e,
    { ...rl, ...r },
    Jt
  ), B = pe(
    (b) => {
      const I = b.childWidgets ?? {};
      Xt.forEach(
        (S) => l.current.add(S)
      ), i.setQueryData(
        [...He, s.themeId],
        (S) => {
          var T;
          if (!S) return S;
          const v = {
            ...(T = S == null ? void 0 : S.config) == null ? void 0 : T.widgetConfig
          };
          for (const W of Xt)
            W in I ? v[W] = {
              ...I[W]
            } : delete v[W];
          return {
            ...S,
            config: {
              ...S == null ? void 0 : S.config,
              widgetConfig: v
            }
          };
        }
      );
    },
    [i, s.themeId]
  ), P = pe(async () => {
    if (await g(), l.current.size > 0 && s.themeId && s.editThemeToken) {
      const b = i.getQueryData([
        ...He,
        s.themeId
      ]), I = Array.from(l.current).map(
        (S) => {
          var T, W;
          const v = (W = (T = b == null ? void 0 : b.config) == null ? void 0 : T.widgetConfig) == null ? void 0 : W[S];
          return $r({
            themeId: s.themeId,
            widgetId: S,
            widgetState: v ?? {},
            editThemeToken: s.editThemeToken
          });
        }
      );
      try {
        await Promise.all(I), l.current.clear();
      } catch (S) {
        console.error("Failed to save child widget configs:", S);
      }
    }
  }, [g, i, s]), u = pe(
    (b, I) => {
      if (b === "layoutPreset" && I !== "custom") {
        const S = ol[I];
        S && (Object.entries(S.layout).forEach(([v, T]) => {
          c(v, T);
        }), B(S));
      }
      c(b, I);
    },
    [c, B]
  );
  if (p)
    return /* @__PURE__ */ t("div", { style: { flex: 1, display: "flex", flexDirection: "column" } });
  const R = n(m, x);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Jt,
      editValues: m,
      onEditChange: u,
      onSave: f ? P : void 0,
      isSaving: y,
      savedKeys: w,
      onResetField: C,
      themeColors: k,
      triggerMode: "persistent",
      triggerIcon: "gear",
      triggerPosition: "bottom-right",
      triggerLabel: "Edit Home Layout",
      children: R
    }
  );
}, il = {
  logoIcon: "default",
  logoWidth: 200,
  logoMaxHeight: 80,
  logoOpacity: 1,
  mobile_logoWidth: 140
}, Zt = [
  {
    key: "logoIcon",
    label: "Logo Image",
    type: "icon"
  },
  {
    key: "logoWidth",
    label: "Logo Width",
    type: "number",
    min: 60,
    max: 400,
    step: 10,
    responsive: !0
  },
  {
    key: "logoMaxHeight",
    label: "Max Height",
    type: "number",
    min: 30,
    max: 200,
    step: 10
  },
  {
    key: "logoOpacity",
    label: "Opacity",
    type: "number",
    min: 0.1,
    max: 1,
    step: 0.1
  }
], _s = ({
  widgetId: e = "concierge-home-logo",
  displayName: o = "Brand Logo",
  initialState: r = {},
  logoUrl: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeIcons: c,
    canSave: g
  } = _(
    e,
    { ...il, ...r },
    Zt
  ), C = i.logoIcon && i.logoIcon !== "default" ? c[i.logoIcon] : null, w = C ? C.url : n;
  if (s || !w)
    return /* @__PURE__ */ t(D, {});
  const k = /* @__PURE__ */ t(
    "div",
    {
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%"
      },
      children: /* @__PURE__ */ t(
        "img",
        {
          src: w,
          alt: C ? C.name : "Brand logo",
          style: {
            width: i.logoWidth,
            maxHeight: i.logoMaxHeight,
            opacity: i.logoOpacity,
            objectFit: "contain"
          }
        }
      )
    }
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Zt,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeIcons: c,
      children: k
    }
  );
}, al = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ll = {
  text: "CONCIERGE BY",
  fontSize: 14,
  fontWeight: "medium",
  fontFamily: "inherit",
  color: a("textPrimary"),
  letterSpacing: 2,
  textTransform: "uppercase",
  marginBottom: 8
}, Ut = [
  { key: "text", label: "Label Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: 0,
    max: 10,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  }
], qs = ({
  widgetId: e = "concierge-home-brand-label",
  displayName: o = "Brand Label",
  initialState: r = {}
}) => {
  const {
    state: n,
    isLoading: i,
    isSaving: s,
    handleEditChange: l,
    handleSave: m,
    themeColors: p,
    themeFonts: y,
    resolveColor: c,
    canSave: g
  } = _(
    e,
    { ...ll, ...r },
    Ut
  ), C = n.fontFamily, w = C && C !== "inherit" ? y[C] : null, k = w && w.format === "google" ? w.url : null;
  if (Q(() => {
    k && al(k);
  }, [k]), i)
    return /* @__PURE__ */ t(D, {});
  const x = w ? w.format === "system" ? w.url : `"${w.name}", sans-serif` : "inherit", f = w && w.format !== "system" && w.format !== "google", B = `brand-label-${e || "default"}`, P = `
    ${f ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${x !== "inherit" ? `.${B} { font-family: ${x} !important; }` : ""}
  `.trim(), u = n.fontWeight === "normal" ? 400 : n.fontWeight === "medium" ? 500 : n.fontWeight === "semibold" ? 600 : 700, R = /* @__PURE__ */ h(D, { children: [
    P && /* @__PURE__ */ t("style", { children: P }),
    /* @__PURE__ */ t(
      "div",
      {
        className: x !== "inherit" ? B : void 0,
        style: {
          textAlign: "center",
          marginBottom: n.marginBottom
        },
        children: /* @__PURE__ */ t(
          "span",
          {
            style: {
              fontSize: n.fontSize,
              fontWeight: u,
              color: c(n.color),
              letterSpacing: n.letterSpacing,
              textTransform: n.textTransform
            },
            children: n.text
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Ut,
      editValues: n,
      onEditChange: l,
      onSave: g ? m : void 0,
      isSaving: s,
      themeColors: p,
      themeFonts: y,
      children: R
    }
  );
}, sl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, dl = ({
  size: e,
  color: o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M48 22.8232H29.0836L46.1268 14.4962L45.1182 12.3764L28.0749 20.7034L39.8703 5.69848L38.0548 4.23074L26.2622 19.2357L30.4697 0.52336L28.2104 0L24 18.7123L19.7896 0L17.5274 0.52336L21.7378 19.2357L9.94236 4.23074L8.12968 5.69848L19.9222 20.7034L2.87896 12.3764L1.8732 14.4962L18.9164 22.8232H0V25.1768H18.9164L1.8732 33.5038L2.87896 35.6265L19.9222 27.2995L8.12968 42.3044L9.94236 43.7722L21.7378 28.7673L17.5274 47.4766L19.7896 48L24 29.2906L28.2104 48L30.4697 47.4766L26.2622 28.7673L38.0548 43.7722L39.8703 42.3044L28.0749 27.2995L45.1182 35.6265L46.1268 33.5038L29.0836 25.1768H48V22.8232Z",
        fill: o
      }
    )
  }
), cl = {
  greetingTemplate: "Hi, {name}.",
  greetingFontSize: 28,
  greetingFontWeight: "semibold",
  greetingFontFamily: "inherit",
  greetingColor: a("textPrimary"),
  showUserName: !0,
  iconType: "brand-icon",
  emoji: "👋",
  brandIcon: "",
  iconSize: 32,
  iconColor: a("primary"),
  iconRotationAnimation: !0,
  iconRotationDuration: 8,
  iconMarginBottom: 8,
  greetingMarginBottom: 8,
  mobile_greetingFontSize: 18,
  mobile_iconSize: 28
}, Vt = [
  // Greeting text
  {
    key: "greetingTemplate",
    label: "Greeting Text",
    type: "text",
    group: "Greeting Text"
  },
  {
    key: "showUserName",
    label: "Show User Name",
    type: "toggle",
    group: "Greeting Text"
  },
  {
    key: "greetingFontSize",
    label: "Font Size",
    type: "number",
    min: 16,
    max: 40,
    step: 2,
    group: "Greeting Text",
    responsive: !0
  },
  {
    key: "greetingFontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Greeting Text"
  },
  {
    key: "greetingFontFamily",
    label: "Font Family",
    type: "font",
    group: "Greeting Text"
  },
  {
    key: "greetingColor",
    label: "Color",
    type: "color",
    group: "Greeting Text"
  },
  {
    key: "greetingMarginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 32,
    step: 4,
    group: "Greeting Text"
  },
  // Icon
  {
    key: "iconType",
    label: "Icon Type",
    type: "options",
    options: [
      { label: "Brand Icon", value: "brand-icon" },
      { label: "Emoji", value: "emoji" }
    ],
    group: "Greeting Icon"
  },
  {
    key: "emoji",
    label: "Emoji",
    type: "text",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "emoji" }
  },
  {
    key: "brandIcon",
    label: "Icon",
    type: "icon",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 16,
    max: 64,
    step: 4,
    group: "Greeting Icon",
    responsive: !0
  },
  {
    key: "iconColor",
    label: "Icon Color",
    type: "color",
    group: "Greeting Icon",
    condition: { field: "iconType", value: "brand-icon" }
  },
  {
    key: "iconRotationAnimation",
    label: "Rotation Animation",
    type: "toggle",
    group: "Greeting Icon"
  },
  {
    key: "iconRotationDuration",
    label: "Rotation Speed (seconds)",
    type: "number",
    min: 1,
    max: 30,
    step: 1,
    group: "Greeting Icon",
    condition: "iconRotationAnimation"
  },
  {
    key: "iconMarginBottom",
    label: "Icon Spacing Below",
    type: "number",
    min: 0,
    max: 24,
    step: 4,
    group: "Greeting Icon"
  }
], Ks = ({
  widgetId: e = "concierge-home-greeting",
  displayName: o = "Greeting",
  initialState: r = {},
  userName: n,
  showIcon: i = !1,
  iconPosition: s = "above"
}) => {
  const {
    state: l,
    isLoading: m,
    isSaving: p,
    handleEditChange: y,
    handleSave: c,
    resetField: g,
    savedKeys: C,
    themeColors: w,
    themeFonts: k,
    themeIcons: x,
    resolveColor: f,
    canSave: B
  } = _(
    e,
    { ...cl, ...r },
    Vt
  ), P = l.greetingFontFamily, u = P && P !== "inherit" ? k[P] : null, R = u && u.format === "google" ? u.url : null;
  if (Q(() => {
    R && sl(R);
  }, [R]), m)
    return /* @__PURE__ */ t(D, {});
  const b = u ? u.format === "system" ? u.url : `"${u.name}", sans-serif` : "inherit", I = u && u.format !== "system" && u.format !== "google", S = `greeting-${e || "default"}`, v = l.mobile_greetingFontSize ?? l.greetingFontSize, T = l.mobile_iconSize ?? l.iconSize, W = `
    ${I ? `
      @font-face {
        font-family: "${u.name}";
        src: url("${u.url}") format("${u.format}");
        font-display: swap;
      }
    ` : ""}
    ${b !== "inherit" ? `.${S} { font-family: ${b} !important; }` : ""}
    @media (max-width: 767px) {
      .${S}-text {
        font-size: ${v}px !important;
      }
      .${S}-icon {
        width: ${T}px !important;
        height: ${T}px !important;
      }
      .${S}-icon svg {
        width: ${T}px !important;
        height: ${T}px !important;
      }
    }
  `.trim();
  let F = l.greetingTemplate;
  l.showUserName && n ? F = F.replace("{name}", n) : (F = F.replace(/,?\s*\{name\}/g, "").replace(/^Hi\.$/, "Hello!"), F.trim() || (F = "Hello!"));
  const N = l.greetingFontWeight === "normal" ? 400 : l.greetingFontWeight === "medium" ? 500 : l.greetingFontWeight === "semibold" ? 600 : 700, z = f(l.iconColor), A = `greeting-icon-spin-${e || "default"}`, j = l.iconRotationAnimation ? `@keyframes ${A} { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }` : "", Z = l.iconRotationAnimation ? {
    animation: `${A} ${l.iconRotationDuration}s linear infinite`
  } : {}, M = () => {
    if (!i) return null;
    let H = null;
    return l.iconType === "emoji" ? H = /* @__PURE__ */ t("span", { style: { fontSize: l.iconSize }, children: l.emoji }) : l.brandIcon && x[l.brandIcon] ? H = /* @__PURE__ */ t(
      "div",
      {
        style: {
          width: l.iconSize,
          height: l.iconSize,
          backgroundColor: z,
          WebkitMaskImage: `url(${x[l.brandIcon].url})`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskImage: `url(${x[l.brandIcon].url})`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          maskPosition: "center"
        }
      }
    ) : H = /* @__PURE__ */ t(dl, { size: l.iconSize, color: z }), /* @__PURE__ */ t(
      "div",
      {
        className: `${S}-icon`,
        style: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ...Z
        },
        children: H
      }
    );
  }, L = s === "inline", G = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: W }),
    j && /* @__PURE__ */ t("style", { children: j }),
    /* @__PURE__ */ h(
      "div",
      {
        className: b !== "inherit" ? S : void 0,
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          marginBottom: l.greetingMarginBottom
        },
        children: [
          i && !L && /* @__PURE__ */ t("div", { style: { marginBottom: l.iconMarginBottom }, children: M() }),
          /* @__PURE__ */ h(
            "span",
            {
              className: `${S}-text`,
              style: {
                display: "inline-flex",
                alignItems: "center",
                gap: L && i ? 8 : 0,
                fontSize: l.greetingFontSize,
                fontWeight: N,
                color: f(l.greetingColor),
                lineHeight: 1.3
              },
              children: [
                i && L && M(),
                F
              ]
            }
          )
        ]
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Vt,
      editValues: l,
      onEditChange: y,
      onSave: B ? c : void 0,
      isSaving: p,
      savedKeys: C,
      onResetField: g,
      themeColors: w,
      themeFonts: k,
      themeIcons: x,
      children: G
    }
  );
}, pl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, gl = {
  textTemplate: "I'm {concierge_name}, your shopping assistant for {brand}.",
  fontSize: 32,
  fontWeight: "semibold",
  fontFamily: "inherit",
  color: a("textPrimary"),
  lineHeight: 1,
  letterSpacing: 0.08,
  maxWidth: 800,
  marginBottom: 0,
  mobile_fontSize: 24
}, _t = [
  { key: "textTemplate", label: "Subtitle Text", type: "text" },
  {
    key: "fontSize",
    label: "Font Size",
    type: "number",
    min: 14,
    max: 32,
    step: 1,
    responsive: !0
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ]
  },
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font"
  },
  { key: "color", label: "Color", type: "color" },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing",
    type: "number",
    min: -1,
    max: 2,
    step: 0.01
  },
  {
    key: "maxWidth",
    label: "Max Width",
    type: "number",
    min: 200,
    max: 800,
    step: 50
  },
  {
    key: "marginBottom",
    label: "Spacing Below",
    type: "number",
    min: 0,
    max: 48,
    step: 4
  }
], ed = ({
  widgetId: e = "concierge-home-subtitle",
  displayName: o = "Subtitle",
  initialState: r = {},
  brandName: n = "",
  conciergeName: i = "Concierge"
}) => {
  const {
    state: s,
    isLoading: l,
    isSaving: m,
    handleEditChange: p,
    handleSave: y,
    resetField: c,
    savedKeys: g,
    themeColors: C,
    themeFonts: w,
    resolveColor: k,
    canSave: x
  } = _(
    e,
    { ...gl, ...r },
    _t
  ), f = s.fontFamily, B = f && f !== "inherit" ? w[f] : null, P = B && B.format === "google" ? B.url : null;
  if (Q(() => {
    P && pl(P);
  }, [P]), l)
    return /* @__PURE__ */ t(D, {});
  const u = B ? B.format === "system" ? B.url : `"${B.name}", sans-serif` : "inherit", R = B && B.format !== "system" && B.format !== "google", b = `subtitle-${e || "default"}`, I = s.mobile_fontSize ?? s.fontSize, S = `
    ${R ? `
      @font-face {
        font-family: "${B.name}";
        src: url("${B.url}") format("${B.format}");
        font-display: swap;
      }
    ` : ""}
    ${u !== "inherit" ? `.${b} { font-family: ${u} !important; }` : ""}
    @media (max-width: 767px) {
      .${b}-text {
        font-size: ${I}px !important;
      }
    }
  `.trim(), v = s.textTemplate.replace("{concierge_name}", i).replace("{brand}", n), T = s.fontWeight === "normal" ? 400 : s.fontWeight === "medium" ? 500 : s.fontWeight === "semibold" ? 600 : 700, W = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: S }),
    /* @__PURE__ */ t(
      "div",
      {
        className: u !== "inherit" ? b : void 0,
        style: {
          textAlign: "center",
          marginBottom: s.marginBottom,
          width: "100%"
        },
        children: /* @__PURE__ */ t(
          "p",
          {
            className: `${b}-text`,
            style: {
              fontSize: s.fontSize,
              fontWeight: T,
              color: k(s.color),
              lineHeight: s.lineHeight,
              letterSpacing: s.letterSpacing ? `${s.letterSpacing}px` : void 0,
              maxWidth: s.maxWidth,
              margin: "0 auto"
            },
            children: v
          }
        )
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: _t,
      editValues: s,
      onEditChange: p,
      onSave: x ? y : void 0,
      isSaving: m,
      savedKeys: g,
      onResetField: c,
      themeColors: C,
      themeFonts: w,
      children: W
    }
  );
}, ml = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIxKSI+CjxwYXRoIGQ9Ik0xOC4wMDE3IDAuMDAwNjI1NjFDMjcuOTQyMyAwLjAwMDYyNTYxIDM2LjAwMjkgOC4wNTg5NSAzNi4wMDI5IDE4LjAwMTdDMzYuMDAyOSAyNy45NDQ1IDI3Ljk0NDUgMzYuMDAyOSAxOC4wMDE3IDM2LjAwMjlDOC4wNTg5NSAzNi4wMDI5IDAuMDAwNjI1NjEgMjcuOTQyMyAwLjAwMDYyNTYxIDE4LjAwMTdIMTguMDAxN1YwLjAwMDYyNTYxWiIgZmlsbD0iI0Q2OTM4QSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXIxIj4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", ul = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIyKSI+CjxwYXRoIGQ9Ik0wIDM2QzAgMjYuMDU5MiA4LjA1OTIgMTggMTggMThDMjcuOTQwOCAxOCAzNiAyNi4wNTkyIDM2IDM2SDBaIiBmaWxsPSIjOEFCMkJGIi8+CjxwYXRoIGQ9Ik0zNiAwQzM2IDkuOTQwOCAyNy45NDA4IDE4IDE4IDE4QzguMDU5MiAxOCAwIDkuOTQwOCAwIDBIMzZaIiBmaWxsPSIjOEFCMkJGIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfc3RhcnRlcjIiPgo8cmVjdCB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+", hl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXIzKSI+CjxwYXRoIGQ9Ik0wIDBMMTggMThWMEgwWiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMzYgMFYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPHBhdGggZD0iTTM2IDM2TDE4IDE4VjM2SDM2WiIgZmlsbD0iIzZCOTI4NyIvPgo8cGF0aCBkPSJNMTggMThMMCAzNlYxOEgxOFoiIGZpbGw9IiM2QjkyODciLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF9zdGFydGVyMyI+CjxyZWN0IHdpZHRoPSIzNiIgaGVpZ2h0PSIzNiIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4=", yl = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwX3N0YXJ0ZXI0KSI+CjxwYXRoIGQ9Ik0zMi41NjU4IDYuODg0NjdMMjYuNTYwOSAxNS4wODA2TDM2IDE4LjAwOUwyNi41NTg3IDIwLjkyODRMMzIuNTU2OCAyOS4xMzExTDIzLjI4NTkgMjUuNjU4NEwyMy41NTI5IDM2TDE3Ljk5NDQgMjcuNDYyMkwxMi40MjkyIDM1Ljk5NTVMMTIuNzA3MyAyNS42NTM5TDMuNDMxOTkgMjkuMTE3Nkw5LjQzOTA5IDIwLjkxOTRMMCAxNy45OTFMOS40NDEzNCAxNS4wNzE2TDMuNDQzMjEgNi44NzExN0wxMi43MTQxIDEwLjM0MzlMMTIuNDQ0OSAwTDE4LjAwMzQgOC41Mzc4TDIzLjU3MDggMC4wMDQ0OTgzMUwyMy4yOTI3IDEwLjM0ODRMMzIuNTY1OCA2Ljg4NDY3WiIgZmlsbD0iIzlBNzI2MSIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwX3N0YXJ0ZXI0Ij4KPHJlY3Qgd2lkdGg9IjM2IiBoZWlnaHQ9IjM2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPg==", bl = [
  ml,
  ul,
  hl,
  yl
], fl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, xl = {
  // Pill styling
  pillPaddingX: 24,
  pillPaddingY: 12,
  pillBorderRadius: 28,
  pillBorderWidth: 1,
  pillBorderColor: a("borderColor"),
  pillBgColor: a("secondary"),
  pillBgColorHover: a("background"),
  pillTextColor: a("textPrimary"),
  pillFontSize: 14,
  pillFontWeight: "medium",
  pillShadowEnabled: !0,
  pillShadow: "8px 8px 6px 0px rgba(0, 0, 0, 0.02)",
  pillGap: 8,
  fontFamily: "inherit",
  // Card styling
  cardWidth: 183,
  cardHeight: 124,
  cardPadding: 16,
  cardBorderRadius: 12,
  cardBorderWidth: 0,
  cardBorderColor: a("borderColor"),
  cardBgColor: a("secondary"),
  cardBgColorHover: a("background"),
  cardTextColor: a("textPrimary"),
  cardFontSize: 14,
  cardGap: 12,
  cardIconSize: 32,
  // Default icons (will be replaced by bundled SVGs)
  starterIcon1: "",
  starterIcon2: "",
  starterIcon3: "",
  starterIcon4: "",
  // Container
  containerMaxWidth: 768,
  containerMarginTop: 16,
  // Mobile overrides
  mobile_pillFontSize: 12,
  mobile_pillPaddingX: 16,
  mobile_pillPaddingY: 12,
  mobile_cardGap: 8
}, qt = [
  // Pill styling
  {
    key: "pillPaddingX",
    label: "Pill Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillPaddingY",
    label: "Pill Padding Y",
    type: "number",
    min: 6,
    max: 20,
    step: 2,
    responsive: !0,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 28,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderWidth",
    label: "Pill Border Width",
    type: "number",
    min: 0,
    max: 3,
    step: 1,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBorderColor",
    label: "Pill Border Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColor",
    label: "Pill Background",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillBgColorHover",
    label: "Pill Bg (Hover)",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillTextColor",
    label: "Pill Text Color",
    type: "color",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontSize",
    label: "Pill Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Pill Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [
      { label: "Normal", value: "normal" },
      { label: "Medium", value: "medium" },
      { label: "Semibold", value: "semibold" },
      { label: "Bold", value: "bold" }
    ],
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadowEnabled",
    label: "Shadow",
    type: "toggle",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillShadow",
    label: "Shadow Value (CSS)",
    type: "text",
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  {
    key: "pillGap",
    label: "Pill Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 2,
    group: "Pill Styling",
    condition: { field: "_startersMode", value: "pills", operator: "includes" }
  },
  // Card styling
  {
    key: "cardWidth",
    label: "Card Width",
    type: "number",
    min: 120,
    max: 240,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardHeight",
    label: "Card Height",
    type: "number",
    min: 80,
    max: 180,
    step: 10,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardBgColorHover",
    label: "Card Bg (Hover)",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardTextColor",
    label: "Card Text Color",
    type: "color",
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardFontSize",
    label: "Card Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardGap",
    label: "Card Gap",
    type: "number",
    min: 4,
    max: 24,
    step: 4,
    group: "Card Styling",
    responsive: !0,
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  {
    key: "cardIconSize",
    label: "Card Icon Size",
    type: "number",
    min: 16,
    max: 48,
    step: 4,
    group: "Card Styling",
    condition: { field: "_startersMode", value: "cards", operator: "includes" }
  },
  // Icons
  {
    key: "starterIcon1",
    label: "Starter 1 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon2",
    label: "Starter 2 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon3",
    label: "Starter 3 Icon",
    type: "icon",
    group: "Icons"
  },
  {
    key: "starterIcon4",
    label: "Starter 4 Icon",
    type: "icon",
    group: "Icons"
  },
  // Typography
  {
    key: "fontFamily",
    label: "Font Family",
    type: "font",
    group: "Typography"
  },
  // Container
  {
    key: "containerMaxWidth",
    label: "Max Width",
    type: "number",
    min: 300,
    max: 900,
    step: 50,
    group: "Container"
  },
  {
    key: "containerMarginTop",
    label: "Margin Top",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Container"
  }
], od = ({
  widgetId: e = "concierge-home-starters",
  displayName: o = "Conversation Starters",
  initialState: r = {},
  mode: n,
  elementStyle: i = "default",
  cardLayoutDirection: s = "stacked",
  maxStarters: l = 4,
  queries: m,
  onSearch: p
}) => {
  const {
    state: y,
    isLoading: c,
    isSaving: g,
    handleEditChange: C,
    handleSave: w,
    resetField: k,
    savedKeys: x,
    themeColors: f,
    themeFonts: B,
    themeIcons: P,
    resolveColor: u,
    canSave: R
  } = _(
    e,
    { ...xl, ...r, _startersMode: n },
    qt
  ), b = { ...y, _startersMode: n }, I = b.fontFamily, S = I && I !== "inherit" ? B[I] : null, v = S && S.format === "google" ? S.url : null;
  if (Q(() => {
    v && fl(v);
  }, [v]), c || n === "hidden" || m.length === 0)
    return /* @__PURE__ */ t(D, {});
  const T = S ? S.format === "system" ? S.url : `"${S.name}", sans-serif` : "inherit", W = S && S.format !== "system" && S.format !== "google", F = `starters-font-${e || "default"}`, N = `
    ${W ? `
      @font-face {
        font-family: "${S.name}";
        src: url("${S.url}") format("${S.format}");
        font-display: swap;
      }
    ` : ""}
    ${T !== "inherit" ? `.${F} { font-family: ${T} !important; }` : ""}
  `.trim(), z = m.slice(0, l), A = [
    b.starterIcon1,
    b.starterIcon2,
    b.starterIcon3,
    b.starterIcon4
  ], j = (X) => {
    const V = A[X];
    return V && P[V] ? P[V].url : bl[X] || null;
  }, Z = () => {
    if (i === "grey-fill" || i === "grey-fill-stroke")
      return "#f6f8fa";
  }, M = () => {
    if (i === "grey-fill-stroke")
      return "1px solid #e5e7eb";
    if (i === "grey-fill")
      return "none";
  }, L = (X) => X === "normal" ? 400 : X === "medium" ? 500 : X === "semibold" ? 600 : 700, G = (X, V) => {
    const re = n === "pills-icons", K = j(V), te = Z(), ee = M();
    return /* @__PURE__ */ h(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => p(X),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "8px",
          padding: `${b.pillPaddingY}px ${b.pillPaddingX}px`,
          borderRadius: b.pillBorderRadius,
          border: ee ?? `${b.pillBorderWidth}px solid ${u(b.pillBorderColor)}`,
          backgroundColor: te ?? u(b.pillBgColor),
          color: u(b.pillTextColor),
          fontSize: b.pillFontSize,
          fontWeight: L(b.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          whiteSpace: "nowrap",
          boxShadow: b.pillShadowEnabled ? b.pillShadow : "none"
        },
        onMouseEnter: (he) => {
          he.currentTarget.style.backgroundColor = u(b.pillBgColorHover) || te || u(b.pillBgColor);
        },
        onMouseLeave: (he) => {
          he.currentTarget.style.backgroundColor = te ?? u(b.pillBgColor);
        },
        children: [
          re && K && /* @__PURE__ */ t(
            "img",
            {
              src: K,
              alt: "",
              style: {
                width: 24,
                height: 24,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          X
        ]
      },
      V
    );
  }, H = (X, V) => {
    const re = j(V), K = Z(), te = M(), ee = s === "inline";
    return /* @__PURE__ */ h(
      "button",
      {
        onClick: () => p(X),
        style: {
          display: "flex",
          flexDirection: ee ? "row" : "column",
          alignItems: ee ? "center" : void 0,
          gap: ee ? "16px" : "12px",
          padding: b.cardPadding,
          borderRadius: b.cardBorderRadius,
          border: te ?? (b.cardBorderWidth > 0 ? `${b.cardBorderWidth}px solid ${u(b.cardBorderColor)}` : "none"),
          backgroundColor: K ?? u(b.cardBgColor),
          color: u(b.cardTextColor),
          fontSize: b.cardFontSize,
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          width: n === "cards-grid" ? "100%" : b.cardWidth,
          minHeight: ee ? void 0 : b.cardHeight,
          flexShrink: 0
        },
        onMouseEnter: (he) => {
          he.currentTarget.style.backgroundColor = u(b.cardBgColorHover) || K || u(b.cardBgColor);
        },
        onMouseLeave: (he) => {
          he.currentTarget.style.backgroundColor = K ?? u(b.cardBgColor);
        },
        children: [
          re && /* @__PURE__ */ t(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: b.cardIconSize,
                height: b.cardIconSize,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ t("span", { style: { lineHeight: 1.4 }, children: X })
        ]
      },
      V
    );
  }, $ = (X, V) => {
    const re = j(V), K = Z(), te = M();
    return /* @__PURE__ */ h(
      "button",
      {
        className: "concierge-home-starters-pill",
        onClick: () => p(X),
        style: {
          display: "flex",
          alignItems: "center",
          gap: "12px",
          width: "100%",
          padding: `${b.pillPaddingY}px ${b.pillPaddingX}px`,
          borderRadius: b.pillBorderRadius > 20 ? 10 : b.pillBorderRadius,
          border: te ?? `${b.pillBorderWidth}px solid ${u(b.pillBorderColor)}`,
          backgroundColor: K ?? u(b.pillBgColor),
          color: u(b.pillTextColor),
          fontSize: b.pillFontSize,
          fontWeight: L(b.pillFontWeight),
          cursor: "pointer",
          textAlign: "left",
          transition: "all 0.2s ease",
          boxSizing: "border-box"
        },
        onMouseEnter: (ee) => {
          ee.currentTarget.style.backgroundColor = u(b.pillBgColorHover) || K || u(b.pillBgColor);
        },
        onMouseLeave: (ee) => {
          ee.currentTarget.style.backgroundColor = K ?? u(b.pillBgColor);
        },
        children: [
          re && /* @__PURE__ */ t(
            "img",
            {
              src: re,
              alt: "",
              style: {
                width: 16,
                height: 16,
                objectFit: "contain",
                flexShrink: 0
              }
            }
          ),
          X
        ]
      },
      V
    );
  }, Y = () => {
    if (n === "pills" || n === "pills-icons") {
      const X = b.pillShadowEnabled ? 16 : 0;
      return /* @__PURE__ */ t(
        "div",
        {
          style: {
            display: "flex",
            flexWrap: "wrap",
            gap: b.pillGap,
            justifyContent: "center",
            maxWidth: b.containerMaxWidth,
            margin: `0 auto -${X}px`,
            padding: `0 0 ${X}px`
          },
          className: "concierge-home-starters-pills",
          children: z.map((V, re) => G(V, re))
        }
      );
    }
    return n === "pills-icons-list" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          gap: b.pillGap,
          maxWidth: b.containerMaxWidth,
          margin: "0 auto",
          width: "100%"
        },
        className: "concierge-home-starters-pills-list",
        children: z.map((X, V) => $(X, V))
      }
    ) : n === "cards-row" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "flex",
          gap: b.cardGap,
          justifyContent: "center",
          maxWidth: b.containerMaxWidth,
          margin: "0 auto",
          flexWrap: "wrap"
        },
        className: "concierge-home-starters-cards-row",
        children: z.map((X, V) => H(X, V))
      }
    ) : n === "cards-grid" ? /* @__PURE__ */ t(
      "div",
      {
        style: {
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: b.cardGap,
          maxWidth: b.containerMaxWidth,
          margin: "0 auto"
        },
        className: "concierge-home-starters-cards-grid",
        children: z.map((X, V) => H(X, V))
      }
    ) : null;
  }, q = /* @__PURE__ */ h(
    "div",
    {
      className: T !== "inherit" ? F : void 0,
      style: { marginTop: b.containerMarginTop, width: "100%" },
      children: [
        /* @__PURE__ */ t("style", { children: `
        ${N || ""}
        /* Responsive: pills become horizontally scrollable on mobile */
        @media (max-width: 767px) {
          .concierge-home-starters-pills {
            flex-wrap: nowrap !important;
            justify-content: flex-start !important;
            overflow-x: auto !important;
            -webkit-overflow-scrolling: touch;
            scrollbar-width: none;
            padding-bottom: 4px;
          }
          .concierge-home-starters-pills::-webkit-scrollbar {
            display: none;
          }
          .concierge-home-starters-pill {
            padding: ${b.mobile_pillPaddingY ?? b.pillPaddingY}px ${b.mobile_pillPaddingX ?? b.pillPaddingX}px !important;
          }
          /* Cards row becomes 2-column grid on mobile */
          .concierge-home-starters-cards-row {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: ${b.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-row > button {
            width: 100% !important;
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-row > button img {
            width: 16px !important;
            height: 16px !important;
          }
          /* Cards grid stays 2-column on mobile with compact sizing */
          .concierge-home-starters-cards-grid {
            gap: ${b.mobile_cardGap}px !important;
          }
          .concierge-home-starters-cards-grid > button {
            min-height: 88px !important;
            font-size: 12px !important;
            border-radius: 10px !important;
            padding: 12px 15px !important;
            gap: 8px !important;
          }
          .concierge-home-starters-cards-grid > button img {
            width: 16px !important;
            height: 16px !important;
          }
        }
      ` }),
        Y()
      ]
    }
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: qt,
      editValues: b,
      onEditChange: C,
      onSave: R ? w : void 0,
      isSaving: g,
      savedKeys: x,
      onResetField: k,
      themeColors: f,
      themeFonts: B,
      themeIcons: P,
      children: q
    }
  );
}, Cl = {
  // Hamburger icon
  hamburgerIcon: "default",
  hamburgerIconSize: 32,
  hamburgerIconColor: a("textPrimary"),
  // Close icon
  closeIcon: "default",
  closeIconSize: 32,
  closeIconColor: a("textPrimary"),
  // Logo visibility
  showLogo: !0,
  // Layout
  navHeight: 80,
  navPaddingX: 24,
  navPaddingY: 24,
  navBgColor: a("transparent")
}, Kt = [
  // Hamburger icon
  {
    key: "hamburgerIcon",
    label: "Menu Icon",
    type: "icon",
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Menu Icon"
  },
  {
    key: "hamburgerIconColor",
    label: "Color",
    type: "color",
    group: "Menu Icon"
  },
  // Close icon
  {
    key: "closeIcon",
    label: "Close Icon",
    type: "icon",
    group: "Close Icon"
  },
  {
    key: "closeIconSize",
    label: "Size",
    type: "number",
    min: 16,
    max: 48,
    step: 2,
    group: "Close Icon"
  },
  {
    key: "closeIconColor",
    label: "Color",
    type: "color",
    group: "Close Icon"
  },
  // Logo visibility
  {
    key: "showLogo",
    label: "Show Logo",
    type: "toggle",
    group: "Logo"
  },
  // Layout
  {
    key: "navHeight",
    label: "Height",
    type: "number",
    min: 40,
    max: 120,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingX",
    label: "Horizontal Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navPaddingY",
    label: "Vertical Padding",
    type: "number",
    min: 0,
    max: 48,
    step: 4,
    group: "Layout"
  },
  {
    key: "navBgColor",
    label: "Background",
    type: "color",
    group: "Layout"
  }
], td = ({
  widgetId: e = "concierge-home-mobile-nav",
  displayName: o = "Mobile Nav Header",
  initialState: r = {},
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeIcons: c,
    resolveColor: g,
    canSave: C
  } = _(
    e,
    { ...Cl, ...r },
    Kt
  ), w = i.hamburgerIcon && i.hamburgerIcon !== "default" ? c[i.hamburgerIcon] : null, k = i.closeIcon && i.closeIcon !== "default" ? c[i.closeIcon] : null, x = {
    hamburgerIconUrl: w ? w.url : null,
    closeIconUrl: k ? k.url : null
  };
  if (s)
    return /* @__PURE__ */ t(D, {});
  const f = n(i, x, g);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: Kt,
      editValues: i,
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeIcons: c,
      children: f
    }
  );
}, kl = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, vl = {
  // Carousel properties
  carouselGap: 15,
  itemWidth: 248,
  // Card container
  cardBorderColor: a("borderColor"),
  cardBorderRadius: 18,
  cardBgColor: a("transparent"),
  cardBgColorHover: a("background"),
  cardPaddingTop: 24,
  cardPaddingBottom: 16,
  cardPaddingSides: 12,
  // Title
  titleColor: a("textPrimary"),
  titleFontFamily: "inherit",
  titleFontSize: 18,
  titleFontWeight: 500,
  titleLineClamp: 2,
  titleLineHeight: 1.333,
  titleMarginTop: 4,
  // Price
  priceColor: a("textPrimary"),
  priceFontFamily: "inherit",
  priceFontSize: 24,
  priceFontSizeMobile: 16,
  priceFontWeight: 600,
  // Retailer icons
  retailerIconSize: 25,
  retailerIconSizeMobile: 15,
  showRetailers: !1,
  // Button
  buttonBgColor: a("textPrimary"),
  buttonTextColor: a("secondary"),
  buttonBorderRadius: 100,
  buttonFontSize: 16,
  buttonFontWeight: 600,
  buttonHeight: 42,
  // Review / Rating
  reviewColor: a("textPrimary"),
  reviewFontSize: 12,
  reviewFontWeight: 500,
  // Image container
  imageMaxWidth: 132
}, er = [
  // Carousel properties
  {
    key: "carouselGap",
    label: "Gap Between Items (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 1,
    group: "Carousel"
  },
  {
    key: "itemWidth",
    label: "Item Width (Desktop)",
    type: "number",
    min: 150,
    max: 300,
    step: 10,
    group: "Carousel"
  },
  // Card container
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius (px)",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardBgColorHover",
    label: "Card Hover Background",
    type: "color",
    group: "Card Container"
  },
  {
    key: "cardPaddingTop",
    label: "Card Padding Top (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingBottom",
    label: "Card Padding Bottom (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  {
    key: "cardPaddingSides",
    label: "Card Padding Sides (px)",
    type: "number",
    min: 0,
    max: 40,
    step: 2,
    group: "Card Container"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color", group: "Title" },
  {
    key: "titleFontFamily",
    label: "Title Font Family",
    type: "font",
    group: "Title"
  },
  {
    key: "titleFontSize",
    label: "Title Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Ne,
    group: "Title"
  },
  {
    key: "titleLineClamp",
    label: "Title Line Clamp",
    type: "number",
    min: 1,
    max: 5,
    step: 1,
    group: "Title"
  },
  {
    key: "titleLineHeight",
    label: "Title Line Height",
    type: "number",
    min: 1,
    max: 2,
    step: 0.1,
    group: "Title"
  },
  {
    key: "titleMarginTop",
    label: "Title Margin Top (px)",
    type: "number",
    min: 8,
    max: 32,
    step: 2,
    group: "Title"
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color", group: "Price" },
  {
    key: "priceFontFamily",
    label: "Price Font Family",
    type: "font",
    group: "Price"
  },
  {
    key: "priceFontSize",
    label: "Price Font Size (Desktop)",
    type: "number",
    min: 14,
    max: 28,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontSizeMobile",
    label: "Price Font Size (Mobile)",
    type: "number",
    min: 12,
    max: 24,
    step: 1,
    group: "Price"
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: Ct,
    group: "Price"
  },
  // Retailer icons
  {
    key: "showRetailers",
    label: "Show Retailer Icons",
    type: "toggle",
    group: "Retailer Icons"
  },
  {
    key: "retailerIconSize",
    label: "Retailer Icon Size (Desktop)",
    type: "number",
    min: 16,
    max: 40,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  {
    key: "retailerIconSizeMobile",
    label: "Retailer Icon Size (Mobile)",
    type: "number",
    min: 12,
    max: 30,
    step: 1,
    group: "Retailer Icons",
    condition: "showRetailers"
  },
  // Button
  {
    key: "buttonBgColor",
    label: "Button Background",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonTextColor",
    label: "Button Text Color",
    type: "color",
    group: "Button"
  },
  {
    key: "buttonBorderRadius",
    label: "Button Border Radius (px)",
    type: "number",
    min: 0,
    max: 100,
    step: 2,
    group: "Button"
  },
  {
    key: "buttonFontSize",
    label: "Button Font Size (px)",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Button"
  },
  {
    key: "buttonFontWeight",
    label: "Button Font Weight",
    type: "options",
    options: Ct,
    group: "Button"
  },
  {
    key: "buttonHeight",
    label: "Button Height (px)",
    type: "number",
    min: 32,
    max: 56,
    step: 2,
    group: "Button"
  },
  // Review / Rating
  {
    key: "reviewColor",
    label: "Review Color",
    type: "color",
    group: "Review"
  },
  {
    key: "reviewFontSize",
    label: "Review Font Size (px)",
    type: "number",
    min: 10,
    max: 18,
    step: 1,
    group: "Review"
  },
  {
    key: "reviewFontWeight",
    label: "Review Font Weight",
    type: "options",
    options: Ne,
    group: "Review"
  },
  // Image
  {
    key: "imageMaxWidth",
    label: "Image Max Width (px)",
    type: "number",
    min: 120,
    max: 250,
    step: 10,
    group: "Image"
  }
], Sl = (e) => ({
  cardBorderColor: e.cardBorderColor,
  cardBorderRadius: e.cardBorderRadius,
  cardBgColor: e.cardBgColor,
  cardBgColorHover: e.cardBgColorHover,
  cardPaddingTop: e.cardPaddingTop,
  cardPaddingBottom: e.cardPaddingBottom,
  cardPaddingSides: e.cardPaddingSides,
  titleColor: e.titleColor,
  titleFontFamily: e.titleFontFamily,
  titleFontSize: e.titleFontSize,
  titleFontWeight: e.titleFontWeight,
  titleLineClamp: e.titleLineClamp,
  titleLineHeight: e.titleLineHeight,
  titleMarginTop: e.titleMarginTop,
  priceColor: e.priceColor,
  priceFontFamily: e.priceFontFamily,
  priceFontSize: e.priceFontSize,
  priceFontSizeMobile: e.priceFontSizeMobile,
  priceFontWeight: e.priceFontWeight,
  retailerIconSize: e.retailerIconSize,
  retailerIconSizeMobile: e.retailerIconSizeMobile,
  showRetailers: e.showRetailers,
  buttonBgColor: e.buttonBgColor,
  buttonTextColor: e.buttonTextColor,
  buttonBorderRadius: e.buttonBorderRadius,
  buttonFontSize: e.buttonFontSize,
  buttonFontWeight: e.buttonFontWeight,
  buttonHeight: e.buttonHeight,
  reviewColor: e.reviewColor,
  reviewFontSize: e.reviewFontSize,
  reviewFontWeight: e.reviewFontWeight,
  imageMaxWidth: e.imageMaxWidth
}), wl = (e) => ({
  carouselGap: e.carouselGap,
  itemWidth: e.itemWidth
}), rd = ({ initialState: e = {}, widgetId: o, displayName: r, children: n }) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C,
    getEditValues: w
  } = _(
    o,
    { ...vl, ...e },
    er
  ), k = i.titleFontFamily, x = k && k !== "inherit" ? c[k] : null, f = x && x.format === "google" ? x.url : null, B = i.priceFontFamily, P = B && B !== "inherit" ? c[B] : null, u = P && P.format === "google" ? P.url : null, R = ae(() => {
    const v = [];
    return f && !v.includes(f) && v.push(f), u && !v.includes(u) && v.push(u), v;
  }, [f, u]);
  if (Q(() => {
    for (const v of R)
      kl(v);
  }, [R]), s)
    return /* @__PURE__ */ t(D, {});
  const b = Sl(i), I = wl(i), S = n(
    b,
    I,
    c,
    g
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: er,
      editValues: w(),
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: S
    }
  );
}, Bl = {
  // Container
  containerGap: 8,
  containerMarginTop: 8,
  // Add to Bag button (primary state)
  addButtonBgColor: a("primary"),
  addButtonTextColor: a("secondary"),
  addButtonHeight: 40,
  addButtonHeightMobile: 36,
  addButtonFontSize: 14,
  addButtonFontSizeMobile: 12,
  addButtonBorderRadius: 8,
  // Added to Bag button (success state)
  addedButtonBorderColor: a("textPrimary"),
  addedButtonBorderColorHover: a("textPrimary"),
  addedButtonTextColor: a("textPrimary"),
  addedButtonBgColorHover: a("background"),
  addedIconColor: a("textPrimary"),
  addedIconSize: 16,
  // Loading state
  loadingSpinnerColor: a("secondary"),
  loadingSpinnerSize: 14
}, or = [
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 16,
    step: 2
  },
  {
    key: "containerMarginTop",
    label: "Container Margin Top",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Add to Bag button
  { key: "addButtonBgColor", label: "Add Button Background", type: "color" },
  { key: "addButtonTextColor", label: "Add Button Text", type: "color" },
  {
    key: "addButtonHeight",
    label: "Add Button Height",
    type: "number",
    min: 32,
    max: 56,
    step: 2
  },
  {
    key: "addButtonHeightMobile",
    label: "Add Button Height (Mobile)",
    type: "number",
    min: 28,
    max: 48,
    step: 2
  },
  {
    key: "addButtonFontSize",
    label: "Add Button Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "addButtonFontSizeMobile",
    label: "Add Button Font Size (Mobile)",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "addButtonBorderRadius",
    label: "Add Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  // Added to Bag button
  {
    key: "addedButtonBorderColor",
    label: "Added Button Border",
    type: "color"
  },
  {
    key: "addedButtonBorderColorHover",
    label: "Added Button Border (Hover)",
    type: "color"
  },
  { key: "addedButtonTextColor", label: "Added Button Text", type: "color" },
  {
    key: "addedButtonBgColorHover",
    label: "Added Button Bg (Hover)",
    type: "color"
  },
  { key: "addedIconColor", label: "Added Icon Color", type: "color" },
  {
    key: "addedIconSize",
    label: "Added Icon Size",
    type: "number",
    min: 12,
    max: 24,
    step: 2
  },
  // Loading state
  { key: "loadingSpinnerColor", label: "Loading Spinner Color", type: "color" },
  {
    key: "loadingSpinnerSize",
    label: "Loading Spinner Size",
    type: "number",
    min: 10,
    max: 24,
    step: 2
  }
], nd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...Bl, ...e },
    or
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: or,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, zl = {
  // Container
  containerBgColor: a("secondary"),
  containerGap: 16,
  // Image carousel
  imageBgColor: a("background"),
  imagePadding: 22,
  carouselArrowSize: 24,
  carouselArrowBgColor: a("secondary"),
  // Title
  titleColor: a("textPrimary"),
  titleFontSize: 24,
  titleFontWeight: "semibold",
  titleLetterSpacing: 0.08,
  // Rating
  ratingStarColor: a("primary"),
  ratingTextColor: a("textPrimary"),
  ratingFontSize: 14,
  // Price
  priceColor: a("textPrimary"),
  priceFontSize: 24,
  priceFontWeight: "semibold",
  priceLetterSpacing: 0.24,
  // Feature bullets
  featureTitleColor: a("textPrimary"),
  featureTitleFontSize: 16,
  featureBulletColor: a("textPrimary"),
  featureBulletFontSize: 12,
  // Primary CTA button
  primaryButtonBgColor: a("primary"),
  primaryButtonTextColor: a("secondary"),
  primaryButtonBorderRadius: 9999,
  primaryButtonHeight: 46,
  primaryButtonFontSize: 16,
  primaryButtonFontWeight: "semibold",
  // Secondary CTA button
  secondaryButtonBorderColor: a("primary"),
  secondaryButtonTextColor: a("primary"),
  secondaryButtonBorderRadius: 9999,
  secondaryButtonHeight: 46,
  secondaryButtonFontSize: 16,
  secondaryButtonFontWeight: "semibold",
  // Content section
  contentPadding: 0,
  contentGap: 12
}, tr = [
  // Container
  { key: "containerBgColor", label: "Container Background", type: "color" },
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 0,
    max: 24,
    step: 4
  },
  // Image carousel
  { key: "imageBgColor", label: "Image Background", type: "color" },
  {
    key: "imagePadding",
    label: "Image Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "carouselArrowSize",
    label: "Carousel Arrow Size",
    type: "number",
    min: 20,
    max: 40,
    step: 2
  },
  {
    key: "carouselArrowBgColor",
    label: "Carousel Arrow Background",
    type: "color"
  },
  // Title
  { key: "titleColor", label: "Title Color", type: "color" },
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 14,
    max: 24,
    step: 1
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: [...ie]
  },
  // Rating
  { key: "ratingStarColor", label: "Rating Star Color", type: "color" },
  { key: "ratingTextColor", label: "Rating Text Color", type: "color" },
  {
    key: "ratingFontSize",
    label: "Rating Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  // Price
  { key: "priceColor", label: "Price Color", type: "color" },
  {
    key: "priceFontSize",
    label: "Price Font Size",
    type: "number",
    min: 18,
    max: 36,
    step: 2
  },
  {
    key: "priceFontWeight",
    label: "Price Font Weight",
    type: "options",
    options: [...ie]
  },
  // Feature bullets
  { key: "featureTitleColor", label: "Features Title Color", type: "color" },
  {
    key: "featureTitleFontSize",
    label: "Features Title Size",
    type: "number",
    min: 14,
    max: 20,
    step: 1
  },
  { key: "featureBulletColor", label: "Feature Bullet Color", type: "color" },
  {
    key: "featureBulletFontSize",
    label: "Feature Bullet Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  // Primary CTA button
  {
    key: "primaryButtonBgColor",
    label: "Primary Button Background",
    type: "color"
  },
  {
    key: "primaryButtonTextColor",
    label: "Primary Button Text",
    type: "color"
  },
  {
    key: "primaryButtonBorderRadius",
    label: "Primary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "primaryButtonHeight",
    label: "Primary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "primaryButtonFontSize",
    label: "Primary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Secondary CTA button
  {
    key: "secondaryButtonBorderColor",
    label: "Secondary Button Border",
    type: "color"
  },
  {
    key: "secondaryButtonTextColor",
    label: "Secondary Button Text",
    type: "color"
  },
  {
    key: "secondaryButtonBorderRadius",
    label: "Secondary Button Radius",
    type: "number",
    min: 0,
    max: 9999,
    step: 4
  },
  {
    key: "secondaryButtonHeight",
    label: "Secondary Button Height",
    type: "number",
    min: 36,
    max: 60,
    step: 2
  },
  {
    key: "secondaryButtonFontSize",
    label: "Secondary Button Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1
  },
  // Content section
  {
    key: "contentPadding",
    label: "Content Padding",
    type: "number",
    min: 0,
    max: 32,
    step: 4
  },
  {
    key: "contentGap",
    label: "Content Gap",
    type: "number",
    min: 8,
    max: 32,
    step: 4
  }
], id = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...zl, ...e },
    tr
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: tr,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, Fl = {
  // Card styling
  cardBgColor: a("secondary"),
  cardBorderColor: a("borderColor"),
  cardBorderRadius: 8,
  cardShadowColor: a("primary"),
  cardShadowOpacity: 0.08,
  cardPadding: 12,
  // Retailer logo
  logoContainerSize: 40,
  logoContainerBgColor: a("background"),
  logoContainerBorderRadius: 50,
  // Card text
  cardTitleFontSize: 14,
  cardTitleFontWeight: "semibold",
  cardTitleColor: a("textPrimary"),
  cardSubtitleFontSize: 12,
  cardSubtitleColor: a("textPrimary"),
  // Card button
  cardButtonBgColor: a("background"),
  cardButtonTextColor: a("textPrimary"),
  cardButtonFontSize: 12,
  cardButtonBorderRadius: 18,
  cardButtonPaddingX: 14,
  cardButtonPaddingY: 4,
  // Search bar
  searchBgColor: a("secondary"),
  searchBorderColor: a("borderColor"),
  searchBorderRadius: 100,
  searchHeight: 44,
  searchPlaceholderColor: a("textPrimary"),
  searchTextColor: a("textPrimary"),
  searchIconColor: a("textPrimary"),
  // Detail panel
  panelBgColor: a("secondary"),
  panelWidth: 300,
  panelBorderRadius: 10,
  panelImageHeight: 164,
  // Status colors
  statusOpenColor: a("success"),
  statusClosedColor: a("error"),
  // Section titles
  sectionTitleFontSize: 12,
  sectionTitleFontWeight: "bold",
  sectionTitleColor: a("textPrimary"),
  // Loading/empty states
  loadingBgColor: a("background"),
  emptyStateTextColor: a("textPrimary"),
  emptyStateFontSize: 14
}, rr = [
  // Card styling
  { key: "cardBgColor", label: "Card Background", type: "color" },
  { key: "cardBorderColor", label: "Card Border Color", type: "color" },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  { key: "cardShadowColor", label: "Card Shadow Color", type: "color" },
  {
    key: "cardShadowOpacity",
    label: "Card Shadow Opacity",
    type: "number",
    min: 0,
    max: 0.5,
    step: 0.02
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  // Retailer logo
  {
    key: "logoContainerSize",
    label: "Logo Container Size",
    type: "number",
    min: 24,
    max: 56,
    step: 4
  },
  {
    key: "logoContainerBgColor",
    label: "Logo Container Background",
    type: "color"
  },
  {
    key: "logoContainerBorderRadius",
    label: "Logo Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Card text
  {
    key: "cardTitleFontSize",
    label: "Card Title Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  },
  {
    key: "cardTitleFontWeight",
    label: "Card Title Weight",
    type: "options",
    options: [...ie]
  },
  { key: "cardTitleColor", label: "Card Title Color", type: "color" },
  {
    key: "cardSubtitleFontSize",
    label: "Card Subtitle Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  { key: "cardSubtitleColor", label: "Card Subtitle Color", type: "color" },
  // Card button
  { key: "cardButtonBgColor", label: "Card Button Background", type: "color" },
  { key: "cardButtonTextColor", label: "Card Button Text", type: "color" },
  {
    key: "cardButtonFontSize",
    label: "Card Button Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "cardButtonBorderRadius",
    label: "Card Button Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingX",
    label: "Card Button Padding X",
    type: "number",
    min: 8,
    max: 24,
    step: 2
  },
  {
    key: "cardButtonPaddingY",
    label: "Card Button Padding Y",
    type: "number",
    min: 2,
    max: 12,
    step: 2
  },
  // Search bar
  { key: "searchBgColor", label: "Search Background", type: "color" },
  { key: "searchBorderColor", label: "Search Border Color", type: "color" },
  {
    key: "searchBorderRadius",
    label: "Search Border Radius",
    type: "number",
    min: 0,
    max: 100,
    step: 4
  },
  {
    key: "searchHeight",
    label: "Search Height",
    type: "number",
    min: 36,
    max: 56,
    step: 2
  },
  {
    key: "searchPlaceholderColor",
    label: "Search Placeholder Color",
    type: "color"
  },
  { key: "searchTextColor", label: "Search Text Color", type: "color" },
  { key: "searchIconColor", label: "Search Icon Color", type: "color" },
  // Detail panel
  { key: "panelBgColor", label: "Panel Background", type: "color" },
  {
    key: "panelWidth",
    label: "Panel Width",
    type: "number",
    min: 240,
    max: 400,
    step: 20
  },
  {
    key: "panelBorderRadius",
    label: "Panel Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2
  },
  {
    key: "panelImageHeight",
    label: "Panel Image Height",
    type: "number",
    min: 100,
    max: 240,
    step: 10
  },
  // Status colors
  { key: "statusOpenColor", label: "Status Open Color", type: "color" },
  { key: "statusClosedColor", label: "Status Closed Color", type: "color" },
  // Section titles
  {
    key: "sectionTitleFontSize",
    label: "Section Title Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1
  },
  {
    key: "sectionTitleFontWeight",
    label: "Section Title Weight",
    type: "options",
    options: [...ie]
  },
  { key: "sectionTitleColor", label: "Section Title Color", type: "color" },
  // Loading/empty states
  { key: "loadingBgColor", label: "Loading Background", type: "color" },
  { key: "emptyStateTextColor", label: "Empty State Text", type: "color" },
  {
    key: "emptyStateFontSize",
    label: "Empty State Font Size",
    type: "number",
    min: 12,
    max: 18,
    step: 1
  }
], ad = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...Fl, ...e },
    rr
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: rr,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, Il = {
  // Container
  maxWidth: 600,
  paddingX: 16,
  paddingY: 16,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Order card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Order info
  orderIdFontSize: 14,
  orderIdFontWeight: "semibold",
  orderIdColor: "#1a1a1a",
  orderDateFontSize: 13,
  orderDateColor: "#6b7280",
  orderStatusFontSize: 12,
  // Item styling
  itemImageSize: 48,
  itemTitleFontSize: 14,
  itemTitleColor: "#1a1a1a",
  itemPriceFontSize: 14,
  itemPriceColor: "#374151",
  // Total
  totalFontSize: 15,
  totalFontWeight: "semibold",
  totalColor: "#1a1a1a",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ho = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, Kr = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Pl = (e) => new Date(e).toLocaleDateString("en-US", {
  year: "numeric",
  month: "short",
  day: "numeric"
}), Tl = ({ size: e, color: o }) => /* @__PURE__ */ h("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M3.27002 6.96L12 12.01L20.73 6.96", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M12 22.08V12", strokeLinecap: "round", strokeLinejoin: "round" })
] }), nr = ({ size: e, color: o }) => /* @__PURE__ */ h("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M6 2L3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6L18 2H6Z", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M3 6H21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M16 10C16 11.0609 15.5786 12.0783 14.8284 12.8284C14.0783 13.5786 13.0609 14 12 14C10.9391 14 9.92172 13.5786 9.17157 12.8284C8.42143 12.0783 8 11.0609 8 10", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ml = ({ item: e, state: o, onClick: r }) => /* @__PURE__ */ h(
  "div",
  {
    onClick: r,
    style: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      cursor: r ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.itemImageSize,
            height: o.itemImageSize,
            borderRadius: 8,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0
          },
          children: e.imageUrl ? /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title || e.retailerSku,
              style: { width: "100%", height: "100%", objectFit: "cover" }
            }
          ) : /* @__PURE__ */ t(Tl, { size: o.itemImageSize * 0.5, color: "#9ca3af" })
        }
      ),
      /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.itemTitleFontSize,
              color: o.itemTitleColor,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            },
            children: e.title || e.retailerSku
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            style: {
              display: "flex",
              gap: 8,
              fontSize: o.itemPriceFontSize,
              color: o.itemPriceColor
            },
            children: [
              /* @__PURE__ */ t("span", { children: Kr(e.price) }),
              /* @__PURE__ */ h("span", { children: [
                "× ",
                e.quantity
              ] })
            ]
          }
        )
      ] })
    ]
  }
), El = ({ order: e, state: o, onOrderClick: r, onItemClick: n }) => /* @__PURE__ */ h(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default"
    },
    children: [
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            marginBottom: 12
          },
          children: [
            /* @__PURE__ */ h("div", { children: [
              /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    fontSize: o.orderIdFontSize,
                    fontWeight: Ho(o.orderIdFontWeight),
                    color: o.orderIdColor
                  },
                  children: [
                    "Order #",
                    e.orderId.slice(-8).toUpperCase()
                  ]
                }
              ),
              e.retailerName && /* @__PURE__ */ t("div", { style: { fontSize: o.orderDateFontSize, color: o.orderDateColor, marginTop: 2 }, children: e.retailerName })
            ] }),
            /* @__PURE__ */ h("div", { style: { textAlign: "right" }, children: [
              /* @__PURE__ */ t("div", { style: { fontSize: o.orderDateFontSize, color: o.orderDateColor }, children: Pl(e.orderDate) }),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: o.orderStatusFontSize,
                    color: e.status === "delivered" ? "#10b981" : "#f59e0b",
                    marginTop: 2,
                    textTransform: "capitalize"
                  },
                  children: e.status
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ h("div", { style: { display: "flex", flexDirection: "column", gap: 10 }, children: [
        e.items.slice(0, 2).map((i, s) => /* @__PURE__ */ t(
          Ml,
          {
            item: i,
            state: o,
            onClick: n ? () => n(i) : void 0
          },
          s
        )),
        e.items.length > 2 && /* @__PURE__ */ h("div", { style: { fontSize: o.itemTitleFontSize, color: o.orderDateColor }, children: [
          "+",
          e.items.length - 2,
          " more item",
          e.items.length - 2 !== 1 ? "s" : ""
        ] })
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            marginTop: 12,
            paddingTop: 12,
            borderTop: `1px solid ${o.cardBorderColor}`
          },
          children: [
            /* @__PURE__ */ t("span", { style: { fontSize: o.totalFontSize, color: o.orderDateColor }, children: "Total" }),
            /* @__PURE__ */ t(
              "span",
              {
                style: {
                  fontSize: o.totalFontSize,
                  fontWeight: Ho(o.totalFontWeight),
                  color: o.totalColor
                },
                children: Kr(e.totalAmount)
              }
            )
          ]
        }
      )
    ]
  }
), ld = ({
  widgetId: e,
  orders: o,
  isAuthenticated: r = !0,
  isLoading: n = !1,
  error: i,
  onOrderClick: s,
  onItemClick: l,
  emptyMessage: m = "No orders yet",
  className: p,
  children: y
}) => {
  const { state: c } = _(
    e,
    Il,
    []
    // No edit fields for now
  );
  return y ? /* @__PURE__ */ t(D, { children: y(c, o) }) : n ? /* @__PURE__ */ t(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor }, children: "Loading orders..." })
    }
  ) : i ? /* @__PURE__ */ t(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: "#ef4444" }, children: i })
    }
  ) : r ? o.length === 0 ? /* @__PURE__ */ h(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ t(nr, { size: c.emptyIconSize, color: c.emptyTextColor }),
        /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: m })
      ]
    }
  ) : /* @__PURE__ */ h(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        backgroundColor: c.backgroundColor,
        borderRadius: c.borderRadius
      },
      children: [
        /* @__PURE__ */ h(
          "h3",
          {
            style: {
              fontSize: c.headerFontSize,
              fontWeight: Ho(c.headerFontWeight),
              color: c.headerColor,
              marginBottom: c.headerMarginBottom,
              margin: 0,
              marginBlockEnd: c.headerMarginBottom
            },
            children: [
              o.length,
              " Order",
              o.length !== 1 ? "s" : ""
            ]
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: c.cardGap }, children: o.map((g) => /* @__PURE__ */ t(
          El,
          {
            order: g,
            state: c,
            onOrderClick: s ? () => s(g) : void 0,
            onItemClick: l ? (C) => l(C, g) : void 0
          },
          g.orderId
        )) })
      ]
    }
  ) : /* @__PURE__ */ h(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ t(nr, { size: c.emptyIconSize, color: c.emptyTextColor }),
        /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: "Please login to view your order history" })
      ]
    }
  );
}, Wl = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 64,
  imageBorderRadius: 8,
  // Content
  titleFontSize: 14,
  titleFontWeight: "medium",
  titleColor: "#1a1a1a",
  brandNameFontSize: 12,
  brandNameColor: "#6b7280",
  // Price
  priceFontSize: 14,
  priceColor: "#1a1a1a",
  // Reward badge
  rewardFontSize: 13,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Urgency badge
  urgencyFontSize: 11,
  urgencyColor: "#dc2626",
  urgencyBgColor: "#fef2f2",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Al = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], ir = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Image
  {
    key: "imageSize",
    label: "Image Size",
    type: "number",
    min: 48,
    max: 120,
    step: 8,
    group: "Image"
  },
  {
    key: "imageBorderRadius",
    label: "Image Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Image"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Al,
    group: "Title"
  },
  // Brand
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  }
], Lo = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, No = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Rl = ({
  size: e,
  color: o
}) => /* @__PURE__ */ t(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: o,
    strokeWidth: "2",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
), Hl = ({ deal: e, state: o, onClick: r }) => /* @__PURE__ */ h(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.imageUrl && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.imageSize,
            height: o.imageSize,
            borderRadius: o.imageBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.brandNameFontSize,
              color: o.brandNameColor,
              marginBottom: 2
            },
            children: e.brandName
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: Lo(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: 4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.title
          }
        ),
        e.price && /* @__PURE__ */ t("div", { style: { fontSize: o.priceFontSize, color: o.priceColor }, children: No(e.price) }),
        e.retailerName && /* @__PURE__ */ h(
          "div",
          {
            style: {
              fontSize: o.brandNameFontSize,
              color: o.brandNameColor,
              marginTop: 4
            },
            children: [
              "at ",
              e.retailerName
            ]
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 6,
            flexShrink: 0
          },
          children: [
            /* @__PURE__ */ h(
              "div",
              {
                style: {
                  fontSize: o.rewardFontSize,
                  fontWeight: Lo(o.rewardFontWeight),
                  color: o.rewardColor,
                  backgroundColor: o.rewardBgColor,
                  padding: "6px 10px",
                  borderRadius: o.rewardBorderRadius,
                  whiteSpace: "nowrap"
                },
                children: [
                  "+",
                  No(e.rewardAmount)
                ]
              }
            ),
            (e.isLimitedQuantity || e.expiresAt) && /* @__PURE__ */ t(
              "div",
              {
                style: {
                  fontSize: o.urgencyFontSize,
                  color: o.urgencyColor,
                  backgroundColor: o.urgencyBgColor,
                  padding: "3px 8px",
                  borderRadius: 4,
                  whiteSpace: "nowrap"
                },
                children: e.isLimitedQuantity ? "🔥 Limited" : "⏰ Limited Time"
              }
            )
          ]
        }
      )
    ]
  }
), sd = ({
  widgetId: e,
  displayName: o = "Daily Deals",
  deals: r,
  isLoading: n = !1,
  error: i,
  onDealClick: s,
  headerText: l,
  showHeader: m = !0,
  emptyMessage: p = "No daily deals available right now",
  className: y,
  children: c
}) => {
  const {
    state: g,
    handleEditChange: C,
    handleSave: w,
    isSaving: k,
    themeColors: x,
    themeFonts: f,
    canSave: B
  } = _(
    e,
    Wl,
    ir
  );
  if (c)
    return /* @__PURE__ */ t(D, { children: c(g, r) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: g.emptyTextFontSize,
              color: g.emptyTextColor
            },
            children: "Finding today's deals..."
          }
        )
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (r.length === 0)
    return /* @__PURE__ */ h(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t(Rl, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ t(
            "div",
            {
              style: {
                fontSize: g.emptyTextFontSize,
                color: g.emptyTextColor,
                marginTop: 12
              },
              children: p
            }
          )
        ]
      }
    );
  const P = r.reduce((b, I) => b + I.rewardAmount, 0), u = l || `${r.length} Daily Deal${r.length !== 1 ? "s" : ""} (${No(P)} cashback)`, R = /* @__PURE__ */ h(
    "div",
    {
      className: y,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        m && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: Lo(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: u
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: { display: "flex", flexDirection: "column", gap: g.cardGap },
            children: r.map((b) => /* @__PURE__ */ t(
              Hl,
              {
                deal: b,
                state: g,
                onClick: s ? () => s(b) : void 0
              },
              b.stacklineSku
            ))
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: ir,
      editValues: g,
      onEditChange: C,
      onSave: B ? w : void 0,
      isSaving: k,
      themeColors: x,
      themeFonts: f,
      children: R
    }
  );
}, en = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Brand logo
  brandLogoSize: 48,
  brandLogoBorderRadius: 8,
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#181d56",
  // Brandclub primary color
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Meta info
  metaFontSize: 12,
  metaColor: "#9ca3af",
  // Reward badge
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Survey badge
  surveyBadgeFontSize: 11,
  surveyBadgeColor: "#1d4ed8",
  surveyBadgeBgColor: "#dbeafe",
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Ll = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" }
], ar = [
  // Card styling
  {
    key: "cardBgColor",
    label: "Card Background",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderColor",
    label: "Card Border Color",
    type: "color",
    group: "Card"
  },
  {
    key: "cardBorderRadius",
    label: "Card Border Radius",
    type: "number",
    min: 0,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardPadding",
    label: "Card Padding",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  {
    key: "cardGap",
    label: "Gap Between Cards",
    type: "number",
    min: 8,
    max: 24,
    step: 2,
    group: "Card"
  },
  // Brand logo
  {
    key: "brandLogoSize",
    label: "Logo Size",
    type: "number",
    min: 32,
    max: 80,
    step: 4,
    group: "Logo"
  },
  {
    key: "brandLogoBorderRadius",
    label: "Logo Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Logo"
  },
  // Title
  {
    key: "titleFontSize",
    label: "Title Font Size",
    type: "number",
    min: 12,
    max: 20,
    step: 1,
    group: "Title"
  },
  {
    key: "titleColor",
    label: "Title Color",
    type: "color",
    group: "Title"
  },
  {
    key: "titleFontWeight",
    label: "Title Font Weight",
    type: "options",
    options: Ll,
    group: "Title"
  },
  // Brand name
  {
    key: "brandNameFontSize",
    label: "Brand Font Size",
    type: "number",
    min: 10,
    max: 16,
    step: 1,
    group: "Brand"
  },
  {
    key: "brandNameColor",
    label: "Brand Color",
    type: "color",
    group: "Brand"
  },
  // Reward
  {
    key: "rewardFontSize",
    label: "Reward Font Size",
    type: "number",
    min: 11,
    max: 18,
    step: 1,
    group: "Reward"
  },
  {
    key: "rewardColor",
    label: "Reward Text Color",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBgColor",
    label: "Reward Background",
    type: "color",
    group: "Reward"
  },
  {
    key: "rewardBorderRadius",
    label: "Reward Border Radius",
    type: "number",
    min: 0,
    max: 16,
    step: 2,
    group: "Reward"
  },
  // Survey badge
  {
    key: "surveyBadgeColor",
    label: "Badge Text Color",
    type: "color",
    group: "Badge"
  },
  {
    key: "surveyBadgeBgColor",
    label: "Badge Background",
    type: "color",
    group: "Badge"
  }
], Oo = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, on = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Nl = ({ size: e, color: o }) => /* @__PURE__ */ h("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("path", { d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("rect", { x: "8", y: "2", width: "8", height: "4", rx: "1", ry: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M9 12h6", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M9 16h6", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Ol = ({ survey: e, state: o, onClick: r }) => /* @__PURE__ */ h(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      (e.previewImageUrl || e.brandLogoUrl) && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.brandLogoSize,
            height: o.brandLogoSize,
            borderRadius: o.brandLogoBorderRadius,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.previewImageUrl || e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }, children: [
          /* @__PURE__ */ t(
            "span",
            {
              style: {
                fontSize: o.surveyBadgeFontSize,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: 4,
                backgroundColor: o.surveyBadgeBgColor,
                color: o.surveyBadgeColor,
                whiteSpace: "nowrap"
              },
              children: "📋 Survey"
            }
          ),
          /* @__PURE__ */ t("span", { style: { fontSize: o.brandNameFontSize, color: o.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: Oo(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        /* @__PURE__ */ h("div", { style: { display: "flex", gap: 12, marginTop: 6 }, children: [
          e.estimatedMinutes && /* @__PURE__ */ h("span", { style: { fontSize: o.metaFontSize, color: o.metaColor }, children: [
            "~",
            e.estimatedMinutes,
            " min"
          ] }),
          e.questionCount && /* @__PURE__ */ h("span", { style: { fontSize: o.metaFontSize, color: o.metaColor }, children: [
            e.questionCount,
            " questions"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            fontWeight: Oo(o.rewardFontWeight),
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "6px 10px",
            borderRadius: o.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            on(e.rewardAmount)
          ]
        }
      )
    ]
  }
), dd = ({
  widgetId: e,
  displayName: o = "Surveys",
  surveys: r,
  isLoading: n = !1,
  error: i,
  onSurveyClick: s,
  headerText: l,
  showHeader: m = !0,
  emptyMessage: p = "No surveys available right now",
  className: y,
  children: c
}) => {
  const {
    state: g,
    handleEditChange: C,
    handleSave: w,
    isSaving: k,
    themeColors: x,
    themeFonts: f,
    canSave: B
  } = _(
    e,
    en,
    ar
  );
  if (c)
    return /* @__PURE__ */ t(D, { children: c(g, r) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor }, children: "Finding available surveys..." })
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: g.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (r.length === 0)
    return /* @__PURE__ */ h(
      "div",
      {
        className: y,
        style: {
          maxWidth: g.maxWidth,
          padding: `${g.paddingY}px ${g.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t(Nl, { size: g.emptyIconSize, color: g.emptyTextColor }),
          /* @__PURE__ */ t("div", { style: { fontSize: g.emptyTextFontSize, color: g.emptyTextColor, marginTop: 12 }, children: p })
        ]
      }
    );
  const P = r.reduce((b, I) => b + I.rewardAmount, 0), u = l || `${r.length} Survey${r.length !== 1 ? "s" : ""} (${on(P)} potential)`, R = /* @__PURE__ */ h(
    "div",
    {
      className: y,
      style: {
        maxWidth: g.maxWidth,
        padding: `${g.paddingY}px ${g.paddingX}px`,
        backgroundColor: g.backgroundColor,
        borderRadius: g.borderRadius
      },
      children: [
        m && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: g.headerFontSize,
              fontWeight: Oo(g.headerFontWeight),
              color: g.headerColor,
              marginBottom: g.headerMarginBottom,
              margin: 0,
              marginBlockEnd: g.headerMarginBottom
            },
            children: u
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: g.cardGap }, children: r.map((b) => /* @__PURE__ */ t(
          Ol,
          {
            survey: b,
            state: g,
            onClick: s ? () => s(b) : void 0
          },
          b.campaignId
        )) })
      ]
    }
  );
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: e,
      displayName: o,
      editFields: ar,
      editValues: g,
      onEditChange: C,
      onSave: B ? w : void 0,
      isSaving: k,
      themeColors: x,
      themeFonts: f,
      children: R
    }
  );
}, Dl = "#181d56", lr = {
  bg: "rgba(162, 34, 114, 0.3)",
  text: "rgb(162, 34, 114)"
}, jl = "https://media.brandclub.com/brandclub/image_asset/survey-reward-icon.webp", Gl = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, $l = (e) => `https://media.brandclub.com/b/428x428/${e}.jpg`, Yl = ({
  size: e = 40,
  color: o = "#9ca3af"
}) => /* @__PURE__ */ h(
  "svg",
  {
    width: e,
    height: e,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5C15 6.10457 14.1046 7 13 7H11C9.89543 7 9 6.10457 9 5Z",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 12H15",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ t(
        "path",
        {
          d: "M9 16H13",
          stroke: o,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }
      )
    ]
  }
), cd = ({
  survey: e,
  state: o,
  onClick: r,
  className: n,
  width: i = 280
}) => {
  const [s, l] = O(!1);
  ({ ...en, ...o });
  const m = () => {
    r ? r() : window.location.href = `/survey/${e.campaignId}`;
  }, p = e.brandLogoUrl || (e.brandId ? $l(e.brandId) : void 0), y = !!p;
  return /* @__PURE__ */ h(
    "div",
    {
      className: n,
      onClick: m,
      onMouseEnter: () => l(!0),
      onMouseLeave: () => l(!1),
      style: {
        width: typeof i == "number" ? `${i}px` : i,
        backgroundColor: "#ffffff",
        border: "1px solid #e5e7eb",
        borderRadius: 16,
        overflow: "hidden",
        cursor: "pointer",
        transition: "all 0.2s ease",
        boxShadow: s ? "0 2px 8px rgba(0,0,0,0.06)" : "none",
        display: "flex",
        flexDirection: "column"
      },
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              height: 160,
              backgroundColor: "#ffffff",
              borderBottom: "1px solid #e5e7eb",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 20
            },
            children: y ? /* @__PURE__ */ t(
              "img",
              {
                src: p,
                alt: e.brandName,
                style: {
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain"
                }
              }
            ) : /* @__PURE__ */ t(Yl, { size: 48, color: "#d1d5db" })
          }
        ),
        /* @__PURE__ */ h(
          "div",
          {
            style: {
              padding: 16,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#f9fafb"
            },
            children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: 15,
                    fontWeight: 600,
                    color: Dl,
                    lineHeight: 1.4,
                    marginBottom: 6,
                    height: 42,
                    // Fixed height for 2 lines (15px * 1.4 * 2)
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.title
                }
              ),
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    fontSize: 13,
                    color: "#6b7280",
                    lineHeight: 1.5,
                    marginBottom: 12,
                    height: 20,
                    // Fixed height for 1 line
                    display: "-webkit-box",
                    WebkitLineClamp: 1,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden"
                  },
                  children: e.description || `Share your feedback with ${e.brandName}.`
                }
              ),
              /* @__PURE__ */ h(
                "div",
                {
                  style: {
                    display: "flex",
                    alignItems: "center",
                    gap: 7
                  },
                  children: [
                    /* @__PURE__ */ h(
                      "div",
                      {
                        style: {
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          backgroundColor: lr.bg,
                          color: lr.text,
                          borderRadius: 25,
                          padding: "5px 13px",
                          fontSize: 14,
                          fontWeight: 600
                        },
                        children: [
                          /* @__PURE__ */ t(
                            "img",
                            {
                              src: jl,
                              alt: "survey-reward-icon",
                              style: {
                                width: 14,
                                height: 14,
                                objectFit: "contain"
                              }
                            }
                          ),
                          /* @__PURE__ */ t("span", { children: Gl(e.rewardAmount) })
                        ]
                      }
                    ),
                    /* @__PURE__ */ t(
                      "span",
                      {
                        style: {
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#181d56"
                        },
                        children: "survey reward"
                      }
                    )
                  ]
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ql = {
  // Container
  maxWidth: 600,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 16,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 12,
  // Card styling
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 16,
  cardGap: 12,
  // Type badge
  typeBadgeFontSize: 11,
  typeBadgePaddingX: 8,
  typeBadgePaddingY: 4,
  typeBadgeBorderRadius: 4,
  surveyBadgeBgColor: "#dbeafe",
  surveyBadgeTextColor: "#1d4ed8",
  contentBadgeBgColor: "#fce7f3",
  contentBadgeTextColor: "#be185d",
  membershipBadgeBgColor: "#d1fae5",
  membershipBadgeTextColor: "#047857",
  reviewBadgeBgColor: "#fef3c7",
  reviewBadgeTextColor: "#b45309",
  referralBadgeBgColor: "#e0e7ff",
  referralBadgeTextColor: "#4338ca",
  affiliateBadgeBgColor: "#f3e8ff",
  affiliateBadgeTextColor: "#7c3aed",
  // Content
  titleFontSize: 15,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  descriptionFontSize: 13,
  descriptionColor: "#6b7280",
  brandNameFontSize: 13,
  brandNameColor: "#6b7280",
  // Reward amount
  rewardFontSize: 14,
  rewardFontWeight: "bold",
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  rewardBorderRadius: 6,
  // Brand logo
  brandLogoSize: 40,
  // Empty state
  emptyIconSize: 48,
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, Do = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, tn = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, Xl = {
  survey: "📋 Survey",
  content: "🎬 Content",
  membership: "🏆 Club",
  review: "⭐ Review",
  referral: "👥 Referral",
  affiliate: "🔗 Affiliate"
}, Jl = ({ size: e, color: o }) => /* @__PURE__ */ h("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "2", children: [
  /* @__PURE__ */ t("rect", { x: "3", y: "8", width: "18", height: "4", rx: "1", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M12 8V21", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M19 12V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V12", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ t("path", { d: "M7.5 8C6.67157 8 6 7.32843 6 6.5C6 5.67157 6.67157 5 7.5 5C9.5 5 12 8 12 8C12 8 14.5 5 16.5 5C17.3284 5 18 5.67157 18 6.5C18 7.32843 17.3284 8 16.5 8", strokeLinecap: "round", strokeLinejoin: "round" })
] }), Zl = ({ type: e, state: o }) => {
  const n = ((i) => {
    switch (i) {
      case "survey":
        return { bg: o.surveyBadgeBgColor, text: o.surveyBadgeTextColor };
      case "content":
        return { bg: o.contentBadgeBgColor, text: o.contentBadgeTextColor };
      case "membership":
        return { bg: o.membershipBadgeBgColor, text: o.membershipBadgeTextColor };
      case "review":
        return { bg: o.reviewBadgeBgColor, text: o.reviewBadgeTextColor };
      case "referral":
        return { bg: o.referralBadgeBgColor, text: o.referralBadgeTextColor };
      case "affiliate":
        return { bg: o.affiliateBadgeBgColor, text: o.affiliateBadgeTextColor };
      default:
        return { bg: "#f3f4f6", text: "#374151" };
    }
  })(e);
  return /* @__PURE__ */ t(
    "span",
    {
      style: {
        fontSize: o.typeBadgeFontSize,
        fontWeight: 600,
        padding: `${o.typeBadgePaddingY}px ${o.typeBadgePaddingX}px`,
        borderRadius: o.typeBadgeBorderRadius,
        backgroundColor: n.bg,
        color: n.text,
        whiteSpace: "nowrap"
      },
      children: Xl[e] || e
    }
  );
}, Ul = ({ opportunity: e, state: o, onClick: r }) => /* @__PURE__ */ h(
  "div",
  {
    onClick: r,
    style: {
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      cursor: r ? "pointer" : "default",
      display: "flex",
      gap: 12,
      alignItems: "flex-start",
      transition: "box-shadow 0.15s ease"
    },
    onMouseEnter: (n) => {
      r && (n.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)");
    },
    onMouseLeave: (n) => {
      n.currentTarget.style.boxShadow = "none";
    },
    children: [
      e.brandLogoUrl && /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.brandLogoSize,
            height: o.brandLogoSize,
            borderRadius: 8,
            overflow: "hidden",
            flexShrink: 0,
            backgroundColor: "#f9fafb"
          },
          children: /* @__PURE__ */ t(
            "img",
            {
              src: e.brandLogoUrl,
              alt: e.brandName,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          )
        }
      ),
      /* @__PURE__ */ h("div", { style: { flex: 1, minWidth: 0 }, children: [
        /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }, children: [
          /* @__PURE__ */ t(Zl, { type: e.type, state: o }),
          /* @__PURE__ */ t("span", { style: { fontSize: o.brandNameFontSize, color: o.brandNameColor }, children: e.brandName })
        ] }),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.titleFontSize,
              fontWeight: Do(o.titleFontWeight),
              color: o.titleColor,
              marginBottom: e.description ? 4 : 0
            },
            children: e.title
          }
        ),
        e.description && /* @__PURE__ */ t(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              lineHeight: 1.4,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden"
            },
            children: e.description
          }
        ),
        e.estimatedMinutes && /* @__PURE__ */ h(
          "div",
          {
            style: {
              fontSize: o.descriptionFontSize,
              color: o.descriptionColor,
              marginTop: 4
            },
            children: [
              "~",
              e.estimatedMinutes,
              " min"
            ]
          }
        )
      ] }),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            fontWeight: Do(o.rewardFontWeight),
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "6px 10px",
            borderRadius: o.rewardBorderRadius,
            whiteSpace: "nowrap",
            flexShrink: 0
          },
          children: [
            "+",
            tn(e.rewardAmount)
          ]
        }
      )
    ]
  }
), pd = ({
  widgetId: e,
  opportunities: o,
  isLoading: r = !1,
  error: n,
  onOpportunityClick: i,
  headerText: s,
  showHeader: l = !0,
  emptyMessage: m = "No reward opportunities available",
  className: p,
  children: y
}) => {
  const { state: c } = _(
    e,
    Ql,
    []
    // No edit fields for now
  );
  if (y)
    return /* @__PURE__ */ t(D, { children: y(c, o) });
  if (r)
    return /* @__PURE__ */ t(
      "div",
      {
        className: p,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor }, children: "Finding reward opportunities..." })
      }
    );
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: p,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: "#ef4444" }, children: n })
      }
    );
  if (o.length === 0)
    return /* @__PURE__ */ h(
      "div",
      {
        className: p,
        style: {
          maxWidth: c.maxWidth,
          padding: `${c.paddingY}px ${c.paddingX}px`,
          textAlign: "center"
        },
        children: [
          /* @__PURE__ */ t(Jl, { size: c.emptyIconSize, color: c.emptyTextColor }),
          /* @__PURE__ */ t("div", { style: { fontSize: c.emptyTextFontSize, color: c.emptyTextColor, marginTop: 12 }, children: m })
        ]
      }
    );
  const g = o.reduce((w, k) => w + k.rewardAmount, 0), C = s || `${o.length} Reward Opportunity${o.length !== 1 ? "s" : ""} (${tn(g)} potential)`;
  return /* @__PURE__ */ h(
    "div",
    {
      className: p,
      style: {
        maxWidth: c.maxWidth,
        padding: `${c.paddingY}px ${c.paddingX}px`,
        backgroundColor: c.backgroundColor,
        borderRadius: c.borderRadius
      },
      children: [
        l && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: c.headerFontSize,
              fontWeight: Do(c.headerFontWeight),
              color: c.headerColor,
              marginBottom: c.headerMarginBottom,
              margin: 0,
              marginBlockEnd: c.headerMarginBottom
            },
            children: C
          }
        ),
        /* @__PURE__ */ t("div", { style: { display: "flex", flexDirection: "column", gap: c.cardGap }, children: o.map((w) => /* @__PURE__ */ t(
          Ul,
          {
            opportunity: w,
            state: c,
            onClick: i ? () => i(w) : void 0
          },
          w.id || w.campaignId || `${w.type}-${w.title}`
        )) })
      ]
    }
  );
}, Vl = {
  // Container
  maxWidth: 900,
  paddingX: 0,
  paddingY: 0,
  backgroundColor: "transparent",
  borderRadius: 0,
  // Header
  headerFontSize: 18,
  headerFontWeight: "semibold",
  headerColor: "#1a1a1a",
  headerMarginBottom: 16,
  // Product card
  cardBgColor: "#ffffff",
  cardBorderColor: "#e5e7eb",
  cardBorderWidth: 1,
  cardBorderRadius: 12,
  cardPadding: 12,
  cardGap: 12,
  // Product image
  imageSize: 120,
  imageBorderRadius: 8,
  // Product title
  titleFontSize: 14,
  titleFontWeight: "semibold",
  titleColor: "#1a1a1a",
  titleMaxLines: 2,
  // Brand name
  brandFontSize: 12,
  brandColor: "#6b7280",
  // Price
  priceFontSize: 16,
  priceFontWeight: "bold",
  priceColor: "#1a1a1a",
  // Reward
  rewardFontSize: 12,
  rewardColor: "#059669",
  rewardBgColor: "#ecfdf5",
  // Rating
  ratingStarSize: 14,
  ratingStarColor: "#f59e0b",
  ratingStarEmptyColor: "#d1d5db",
  ratingTextFontSize: 12,
  ratingTextColor: "#6b7280",
  // Comparison table
  rowBgColor: "#ffffff",
  rowBgColorAlt: "#f9fafb",
  rowBorderColor: "#e5e7eb",
  labelFontSize: 13,
  labelFontWeight: "medium",
  labelColor: "#374151",
  valueFontSize: 13,
  valueColor: "#1a1a1a",
  // Highlight
  highlightBgColor: "#ecfdf5",
  highlightBorderColor: "#10b981",
  // Empty state
  emptyTextFontSize: 14,
  emptyTextColor: "#6b7280"
}, io = (e) => ({
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700
})[e] || 500, jo = (e) => {
  const o = Number(e);
  return `$${Number.isFinite(o) ? o.toFixed(2) : "0.00"}`;
}, _l = ({ rating: e, maxRating: o = 5, starSize: r, starColor: n, emptyColor: i }) => {
  const s = [];
  for (let l = 1; l <= o; l++) {
    const m = Math.min(Math.max(e - l + 1, 0), 1) * 100;
    s.push(
      /* @__PURE__ */ h("svg", { width: r, height: r, viewBox: "0 0 24 24", children: [
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ h("linearGradient", { id: `star-fill-${l}-${e}`, children: [
          /* @__PURE__ */ t("stop", { offset: `${m}%`, stopColor: n }),
          /* @__PURE__ */ t("stop", { offset: `${m}%`, stopColor: i })
        ] }) }),
        /* @__PURE__ */ t(
          "path",
          {
            fill: `url(#star-fill-${l}-${e})`,
            d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          }
        )
      ] }, l)
    );
  }
  return /* @__PURE__ */ t("div", { style: { display: "flex", gap: 2 }, children: s });
}, ql = ({ size: e, color: o }) => /* @__PURE__ */ t("svg", { width: e, height: e, viewBox: "0 0 24 24", fill: "none", stroke: o, strokeWidth: "1.5", children: /* @__PURE__ */ t("path", { d: "M16.5 9.4L7.5 4.21M21 16V8C20.9996 7.6481 20.9071 7.3024 20.7315 6.99847C20.556 6.69454 20.3037 6.44327 20 6.27L13 2.27C12.696 2.09674 12.3511 2.0053 12 2.0053C11.6489 2.0053 11.304 2.09674 11 2.27L4 6.27C3.69626 6.44327 3.44398 6.69454 3.26846 6.99847C3.09294 7.3024 3.00036 7.6481 3 8V16C3.00036 16.3519 3.09294 16.6976 3.26846 17.0015C3.44398 17.3055 3.69626 17.5567 4 17.73L11 21.73C11.304 21.9033 11.6489 21.9947 12 21.9947C12.3511 21.9947 12.696 21.9033 13 21.73L20 17.73C20.3037 17.5567 20.556 17.3055 20.7315 17.0015C20.9071 16.6976 20.9996 16.3519 21 16Z", strokeLinecap: "round", strokeLinejoin: "round" }) }), Kl = ({
  product: e,
  state: o,
  onClick: r,
  onAddToCart: n,
  showAddToCart: i
}) => /* @__PURE__ */ h(
  "div",
  {
    style: {
      flex: 1,
      minWidth: 150,
      maxWidth: 220,
      backgroundColor: o.cardBgColor,
      border: `${o.cardBorderWidth}px solid ${o.cardBorderColor}`,
      borderRadius: o.cardBorderRadius,
      padding: o.cardPadding,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 8,
      cursor: r ? "pointer" : "default"
    },
    onClick: r,
    children: [
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            width: o.imageSize,
            height: o.imageSize,
            borderRadius: o.imageBorderRadius,
            overflow: "hidden",
            backgroundColor: "#f3f4f6",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          children: e.imageUrl ? /* @__PURE__ */ t(
            "img",
            {
              src: e.imageUrl,
              alt: e.title,
              style: { width: "100%", height: "100%", objectFit: "contain" }
            }
          ) : /* @__PURE__ */ t(ql, { size: o.imageSize * 0.4, color: "#9ca3af" })
        }
      ),
      e.brand && /* @__PURE__ */ t("div", { style: { fontSize: o.brandFontSize, color: o.brandColor }, children: e.brand }),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            fontSize: o.titleFontSize,
            fontWeight: io(o.titleFontWeight),
            color: o.titleColor,
            textAlign: "center",
            display: "-webkit-box",
            WebkitLineClamp: o.titleMaxLines,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            lineHeight: 1.3
          },
          children: e.title
        }
      ),
      /* @__PURE__ */ t(
        "div",
        {
          style: {
            fontSize: o.priceFontSize,
            fontWeight: io(o.priceFontWeight),
            color: o.priceColor
          },
          children: jo(e.price)
        }
      ),
      e.rewardAmount && e.rewardAmount > 0 && /* @__PURE__ */ h(
        "div",
        {
          style: {
            fontSize: o.rewardFontSize,
            color: o.rewardColor,
            backgroundColor: o.rewardBgColor,
            padding: "4px 8px",
            borderRadius: 4
          },
          children: [
            "+",
            jo(e.rewardAmount),
            " reward"
          ]
        }
      ),
      e.reviewsRating !== void 0 && /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: 4 }, children: [
        /* @__PURE__ */ t(
          _l,
          {
            rating: e.reviewsRating,
            starSize: o.ratingStarSize,
            starColor: o.ratingStarColor,
            emptyColor: o.ratingStarEmptyColor
          }
        ),
        e.reviewsCount !== void 0 && /* @__PURE__ */ h("span", { style: { fontSize: o.ratingTextFontSize, color: o.ratingTextColor }, children: [
          "(",
          e.reviewsCount,
          ")"
        ] })
      ] }),
      i && n && /* @__PURE__ */ t(
        "button",
        {
          onClick: (s) => {
            s.stopPropagation(), n();
          },
          style: {
            marginTop: 8,
            padding: "8px 16px",
            fontSize: 13,
            fontWeight: 600,
            color: "#ffffff",
            backgroundColor: "#1a1a1a",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            width: "100%"
          },
          children: "Add to Cart"
        }
      )
    ]
  }
), es = (e) => {
  const o = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    r.attributes && Object.keys(r.attributes).forEach((n) => o.add(n));
  }), Array.from(o).map((r) => ({
    key: r,
    label: r.charAt(0).toUpperCase() + r.slice(1).replace(/([A-Z])/g, " $1"),
    format: "text"
  }));
}, gd = ({
  widgetId: e,
  products: o,
  attributes: r,
  isLoading: n = !1,
  error: i,
  onProductClick: s,
  onAddToCart: l,
  showAddToCart: m = !1,
  headerText: p,
  showHeader: y = !0,
  className: c,
  children: g
}) => {
  const { state: C } = _(
    e,
    Vl,
    []
    // No edit fields for now
  );
  if (g)
    return /* @__PURE__ */ t(D, { children: g(C, o) });
  if (n)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: C.maxWidth,
          padding: `${C.paddingY}px ${C.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: C.emptyTextFontSize, color: C.emptyTextColor }, children: "Comparing products..." })
      }
    );
  if (i)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: C.maxWidth,
          padding: `${C.paddingY}px ${C.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: C.emptyTextFontSize, color: "#ef4444" }, children: i })
      }
    );
  if (o.length < 2)
    return /* @__PURE__ */ t(
      "div",
      {
        className: c,
        style: {
          maxWidth: C.maxWidth,
          padding: `${C.paddingY}px ${C.paddingX}px`,
          textAlign: "center"
        },
        children: /* @__PURE__ */ t("div", { style: { fontSize: C.emptyTextFontSize, color: C.emptyTextColor }, children: "At least 2 products are needed for comparison" })
      }
    );
  const w = r || es(o), k = p || `Comparing ${o.length} Products`;
  return /* @__PURE__ */ h(
    "div",
    {
      className: c,
      style: {
        maxWidth: C.maxWidth,
        padding: `${C.paddingY}px ${C.paddingX}px`,
        backgroundColor: C.backgroundColor,
        borderRadius: C.borderRadius,
        overflowX: "auto"
      },
      children: [
        y && /* @__PURE__ */ t(
          "h3",
          {
            style: {
              fontSize: C.headerFontSize,
              fontWeight: io(C.headerFontWeight),
              color: C.headerColor,
              marginBottom: C.headerMarginBottom,
              margin: 0,
              marginBlockEnd: C.headerMarginBottom
            },
            children: k
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            style: {
              display: "flex",
              gap: C.cardGap,
              marginBottom: w.length > 0 ? 16 : 0
            },
            children: o.map((x) => /* @__PURE__ */ t(
              Kl,
              {
                product: x,
                state: C,
                onClick: s ? () => s(x) : void 0,
                onAddToCart: l ? () => l(x) : void 0,
                showAddToCart: m
              },
              x.stacklineSku
            ))
          }
        ),
        w.length > 0 && /* @__PURE__ */ t(
          "div",
          {
            style: {
              border: `1px solid ${C.rowBorderColor}`,
              borderRadius: 8,
              overflow: "hidden"
            },
            children: w.map((x, f) => /* @__PURE__ */ h(
              "div",
              {
                style: {
                  display: "flex",
                  backgroundColor: f % 2 === 0 ? C.rowBgColor : C.rowBgColorAlt,
                  borderBottom: f < w.length - 1 ? `1px solid ${C.rowBorderColor}` : "none"
                },
                children: [
                  /* @__PURE__ */ t(
                    "div",
                    {
                      style: {
                        width: 120,
                        flexShrink: 0,
                        padding: "10px 12px",
                        fontSize: C.labelFontSize,
                        fontWeight: io(C.labelFontWeight),
                        color: C.labelColor,
                        borderRight: `1px solid ${C.rowBorderColor}`
                      },
                      children: x.label
                    }
                  ),
                  o.map((B) => {
                    var R;
                    const P = (R = B.attributes) == null ? void 0 : R[x.key];
                    let u = "-";
                    return P != null && (x.format === "currency" && typeof P == "number" ? u = jo(P) : x.format === "boolean" ? u = P ? "✓" : "✗" : u = String(P)), /* @__PURE__ */ t(
                      "div",
                      {
                        style: {
                          flex: 1,
                          minWidth: 150,
                          maxWidth: 220,
                          padding: "10px 12px",
                          fontSize: C.valueFontSize,
                          color: C.valueColor,
                          textAlign: "center",
                          borderRight: `1px solid ${C.rowBorderColor}`
                        },
                        children: u
                      },
                      B.stacklineSku
                    );
                  })
                ]
              },
              x.key
            ))
          }
        )
      ]
    }
  );
}, os = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, ts = {
  content: "Default Text",
  fontFamily: "inherit",
  fontSize: 16,
  fontWeight: "medium",
  color: {
    type: "theme",
    value: "textPrimary"
  },
  textAlign: "left",
  lineHeight: 1.5,
  letterSpacing: 0,
  textTransform: "none"
}, sr = [
  { key: "content", label: "Text Content", type: "text" },
  { key: "fontFamily", label: "Font Family", type: "font" },
  {
    key: "fontSize",
    label: "Font Size (px)",
    type: "number",
    min: 12,
    max: 72,
    step: 1
  },
  {
    key: "fontWeight",
    label: "Font Weight",
    type: "options",
    options: ie
  },
  { key: "color", label: "Text Color", type: "color" },
  {
    key: "textAlign",
    label: "Text Alignment",
    type: "options",
    options: [
      { label: "Left", value: "left" },
      { label: "Center", value: "center" },
      { label: "Right", value: "right" }
    ]
  },
  {
    key: "lineHeight",
    label: "Line Height",
    type: "number",
    min: 1,
    max: 3,
    step: 0.1
  },
  {
    key: "letterSpacing",
    label: "Letter Spacing (px)",
    type: "number",
    min: -2,
    max: 5,
    step: 0.5
  },
  {
    key: "textTransform",
    label: "Text Transform",
    type: "options",
    options: [
      { label: "None", value: "none" },
      { label: "Uppercase", value: "uppercase" },
      { label: "Lowercase", value: "lowercase" },
      { label: "Capitalize", value: "capitalize" }
    ]
  }
], md = ({
  initialState: e = {},
  widgetId: o,
  displayName: r
}) => {
  const {
    state: n,
    isLoading: i,
    isSaving: s,
    handleEditChange: l,
    handleSave: m,
    themeColors: p,
    themeFonts: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...ts, ...e },
    sr
  ), C = n.fontFamily, w = C && C !== "inherit" ? y[C] : null, k = w && w.format === "google" ? w.url : null;
  if (Q(() => {
    k && os(k);
  }, [k]), i)
    return /* @__PURE__ */ t(D, {});
  const x = (b) => {
    const I = {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700
    }, S = parseInt(b, 10);
    return isNaN(S) ? I[b] || 500 : S;
  }, f = w ? w.format === "system" ? w.url : `"${w.name}", sans-serif` : "inherit", B = `textbox-${o || "default"}`, u = `
    ${w && w.format !== "system" && w.format !== "google" ? `
      @font-face {
        font-family: "${w.name}";
        src: url("${w.url}") format("${w.format}");
        font-display: swap;
      }
    ` : ""}
    ${f !== "inherit" ? `.${B} { font-family: ${f} !important; }` : ""}
  `.trim(), R = /* @__PURE__ */ h(D, { children: [
    u && /* @__PURE__ */ t("style", { children: u }),
    /* @__PURE__ */ t(
      "span",
      {
        className: `textbox-content ${B}`,
        style: {
          // font-family is set via CSS class with !important, only use inline for inherit
          ...f === "inherit" ? { fontFamily: "inherit" } : {},
          fontSize: `${n.fontSize}px`,
          fontWeight: x(n.fontWeight),
          color: c(n.color),
          textAlign: n.textAlign,
          lineHeight: n.lineHeight,
          letterSpacing: `${n.letterSpacing}px`,
          textTransform: n.textTransform,
          display: "inline-block",
          width: "100%"
        },
        children: n.content
      }
    )
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: sr,
      editValues: n,
      onEditChange: l,
      onSave: g ? m : void 0,
      isSaving: s,
      themeColors: p,
      themeFonts: y,
      children: R
    }
  );
}, dr = (e) => {
  if (document.querySelector(`link[href="${e}"]`)) return;
  const r = document.createElement("link");
  r.rel = "stylesheet", r.href = e, document.head.appendChild(r);
}, rs = {
  // Instant reward (DailyDeals) - orange
  instantBgColor: Ie("rgba(236, 121, 46, 0.3)"),
  instantTextColor: Ie("rgb(236, 121, 46)"),
  // Purchase reward - magenta
  purchaseBgColor: Ie("rgba(162, 34, 114, 0.3)"),
  purchaseTextColor: Ie("rgb(162, 34, 114)"),
  // Affiliate reward - teal
  affiliateBgColor: Ie("rgba(22, 148, 155, 0.2)"),
  affiliateTextColor: Ie("rgb(22, 148, 155)"),
  // Content/Survey reward - magenta
  contentBgColor: Ie("rgba(162, 34, 114, 0.3)"),
  contentTextColor: Ie("rgb(162, 34, 114)"),
  // Pill styling
  pillBorderRadius: 25,
  pillPaddingMultiplier: 0.95,
  // Icon
  iconSizeMultiplier: 1,
  iconMarginMultiplier: 0.416,
  // Text
  pillFontWeight: "semibold",
  pillFontFamily: "inherit",
  subfixTextColor: a("textPrimary"),
  subfixFontWeight: "semibold",
  subfixFontFamily: "inherit",
  // Container
  containerGap: 7
}, cr = [
  // Instant reward
  { key: "instantBgColor", label: "Instant Reward Background", type: "color" },
  { key: "instantTextColor", label: "Instant Reward Text", type: "color" },
  // Purchase reward
  {
    key: "purchaseBgColor",
    label: "Purchase Reward Background",
    type: "color"
  },
  { key: "purchaseTextColor", label: "Purchase Reward Text", type: "color" },
  // Affiliate reward
  {
    key: "affiliateBgColor",
    label: "Affiliate Reward Background",
    type: "color"
  },
  { key: "affiliateTextColor", label: "Affiliate Reward Text", type: "color" },
  // Content/Survey reward
  { key: "contentBgColor", label: "Content Reward Background", type: "color" },
  { key: "contentTextColor", label: "Content Reward Text", type: "color" },
  // Pill styling
  {
    key: "pillBorderRadius",
    label: "Pill Border Radius",
    type: "number",
    min: 0,
    max: 50,
    step: 2
  },
  {
    key: "pillPaddingMultiplier",
    label: "Pill Padding Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.05
  },
  // Icon
  {
    key: "iconSizeMultiplier",
    label: "Icon Size Multiplier",
    type: "number",
    min: 0.5,
    max: 1.5,
    step: 0.1
  },
  {
    key: "iconMarginMultiplier",
    label: "Icon Margin Multiplier",
    type: "number",
    min: 0.2,
    max: 0.8,
    step: 0.05
  },
  // Text
  {
    key: "pillFontWeight",
    label: "Pill Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "pillFontFamily",
    label: "Pill Font Family",
    type: "font"
  },
  { key: "subfixTextColor", label: "Subfix Text Color", type: "color" },
  {
    key: "subfixFontWeight",
    label: "Subfix Font Weight",
    type: "options",
    options: [...ie]
  },
  {
    key: "subfixFontFamily",
    label: "Subfix Font Family",
    type: "font"
  },
  // Container
  {
    key: "containerGap",
    label: "Container Gap",
    type: "number",
    min: 4,
    max: 16,
    step: 1
  }
], ud = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    themeFonts: c,
    resolveColor: g,
    canSave: C
  } = _(
    o,
    { ...rs, ...e },
    cr
  ), w = i.pillFontFamily, k = w && w !== "inherit" ? c[w] : null, x = i.subfixFontFamily, f = x && x !== "inherit" ? c[x] : null, B = k && k.format === "google" ? k.url : null, P = f && f.format === "google" ? f.url : null;
  if (Q(() => {
    B && dr(B);
  }, [B]), Q(() => {
    P && dr(P);
  }, [P]), s)
    return /* @__PURE__ */ t(D, {});
  const u = k ? k.format === "system" ? k.url : `"${k.name}", sans-serif` : "inherit", R = f ? f.format === "system" ? f.url : `"${f.name}", sans-serif` : "inherit", b = k && k.format !== "system" && k.format !== "google", I = f && f.format !== "system" && f.format !== "google", S = `reward-pill-${o || "default"}`, v = `
    ${b ? `
      @font-face {
        font-family: "${k.name}";
        src: url("${k.url}") format("${k.format}");
        font-display: swap;
      }
    ` : ""}
    ${I ? `
      @font-face {
        font-family: "${f.name}";
        src: url("${f.url}") format("${f.format}");
        font-display: swap;
      }
    ` : ""}
    ${u !== "inherit" ? `.${S} [data-pill-text] { font-family: ${u} !important; }` : ""}
    ${R !== "inherit" ? `.${S} [data-subfix-text] { font-family: ${R} !important; }` : ""}
  `.trim(), T = {
    ...i,
    pillFontFamilyCss: u,
    subfixFontFamilyCss: R
  }, W = /* @__PURE__ */ h(D, { children: [
    v && /* @__PURE__ */ t("style", { children: v }),
    n(T, g)
  ] });
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: cr,
      editValues: i,
      onEditChange: m,
      onSave: C ? p : void 0,
      isSaving: l,
      themeColors: y,
      themeFonts: c,
      children: W
    }
  );
}, ns = {
  // Icon size
  iconSize: 18,
  iconSizeMobile: 15,
  // Overlap and spacing
  overlapRatio: 0.46,
  counterMarginLeft: 7,
  // Border styling
  iconBorderRadius: 50,
  // percentage - 50 = circle
  // Counter text
  counterTextColor: a("textPrimary"),
  counterFontSize: 11,
  counterFontWeight: "semibold",
  // Display limits
  maxVisibleIcons: 4
}, pr = [
  // Icon size
  {
    key: "iconSize",
    label: "Icon Size",
    type: "number",
    min: 12,
    max: 32,
    step: 2
  },
  {
    key: "iconSizeMobile",
    label: "Icon Size (Mobile)",
    type: "number",
    min: 10,
    max: 24,
    step: 1
  },
  // Overlap and spacing
  {
    key: "overlapRatio",
    label: "Overlap Ratio",
    type: "number",
    min: 0,
    max: 0.7,
    step: 0.05
  },
  {
    key: "counterMarginLeft",
    label: "Counter Margin Left",
    type: "number",
    min: 0,
    max: 16,
    step: 1
  },
  // Border styling
  {
    key: "iconBorderRadius",
    label: "Icon Border Radius (%)",
    type: "number",
    min: 0,
    max: 50,
    step: 5
  },
  // Counter text
  { key: "counterTextColor", label: "Counter Text Color", type: "color" },
  {
    key: "counterFontSize",
    label: "Counter Font Size",
    type: "number",
    min: 8,
    max: 16,
    step: 1
  },
  {
    key: "counterFontWeight",
    label: "Counter Font Weight",
    type: "options",
    options: [...ie]
  },
  // Display limits
  {
    key: "maxVisibleIcons",
    label: "Max Visible Icons",
    type: "number",
    min: 1,
    max: 8,
    step: 1
  }
], hd = ({
  initialState: e = {},
  widgetId: o,
  displayName: r,
  children: n
}) => {
  const {
    state: i,
    isLoading: s,
    isSaving: l,
    handleEditChange: m,
    handleSave: p,
    themeColors: y,
    resolveColor: c,
    canSave: g
  } = _(
    o,
    { ...ns, ...e },
    pr
  );
  if (s)
    return /* @__PURE__ */ t(D, {});
  const C = n(i, c);
  return /* @__PURE__ */ t(
    J,
    {
      widgetId: o,
      displayName: r,
      editFields: pr,
      editValues: i,
      onEditChange: m,
      onSave: g ? p : void 0,
      isSaving: l,
      themeColors: y,
      children: C
    }
  );
}, is = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black"
}, E = (e) => e.map((o) => ({
  weight: o,
  label: is[o] || `Weight ${o}`
})), ao = [
  // === SANS-SERIF ===
  {
    name: "Inter",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Roboto",
    category: "sans-serif",
    variants: E([100, 300, 400, 500, 700, 900]),
    popular: !0
  },
  {
    name: "Open Sans",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Lato",
    category: "sans-serif",
    variants: E([100, 300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Montserrat",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Poppins",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Nunito Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Sans 3",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Raleway",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Work Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Oswald",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Rubik",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Quicksand",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Mulish",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Barlow Condensed",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Kanit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Manrope",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "DM Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Outfit",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Plus Jakarta Sans",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Figtree",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cabin",
    category: "sans-serif",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Karla",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Archivo",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Josefin Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Lexend",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Exo 2",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Titillium Web",
    category: "sans-serif",
    variants: E([200, 300, 400, 600, 700, 900])
  },
  {
    name: "Sora",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Space Grotesk",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Albert Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Be Vietnam Pro",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Asap",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu",
    category: "sans-serif",
    variants: E([300, 400, 500, 700]),
    popular: !0
  },
  {
    name: "Dosis",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Noto Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Noto Sans Display",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fira Sans",
    category: "sans-serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "PT Sans",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "PT Sans Narrow",
    category: "sans-serif",
    variants: E([400, 700])
  },
  {
    name: "Mukta",
    category: "sans-serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Hind",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Rajdhani",
    category: "sans-serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Varela Round",
    category: "sans-serif",
    variants: E([400])
  },
  {
    name: "Comic Neue",
    category: "sans-serif",
    variants: E([300, 400, 700])
  },
  // === SERIF ===
  {
    name: "Playfair Display",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900]),
    popular: !0
  },
  {
    name: "Merriweather",
    category: "serif",
    variants: E([300, 400, 700, 900]),
    popular: !0
  },
  {
    name: "Lora",
    category: "serif",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "PT Serif",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Noto Serif",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Source Serif 4",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Libre Baskerville",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Crimson Text",
    category: "serif",
    variants: E([400, 600, 700])
  },
  {
    name: "Crimson Pro",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Bitter",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant Garamond",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "EB Garamond",
    category: "serif",
    variants: E([400, 500, 600, 700, 800])
  },
  {
    name: "DM Serif Display",
    category: "serif",
    variants: E([400])
  },
  {
    name: "Spectral",
    category: "serif",
    variants: E([200, 300, 400, 500, 600, 700, 800])
  },
  {
    name: "Cardo",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Libre Caslon Text",
    category: "serif",
    variants: E([400, 700])
  },
  {
    name: "Bodoni Moda",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Fraunces",
    category: "serif",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Cormorant",
    category: "serif",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Cinzel",
    category: "serif",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Playfair Display SC",
    category: "serif",
    variants: E([400, 700, 900])
  },
  // === DISPLAY ===
  {
    name: "Bebas Neue",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Abril Fatface",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Righteous",
    category: "display",
    variants: E([400])
  },
  {
    name: "Alfa Slab One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fredoka",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Comfortaa",
    category: "display",
    variants: E([300, 400, 500, 600, 700])
  },
  {
    name: "Lobster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Staatliches",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee",
    category: "display",
    variants: E([400])
  },
  {
    name: "Monoton",
    category: "display",
    variants: E([400])
  },
  {
    name: "Black Ops One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Permanent Marker",
    category: "display",
    variants: E([400])
  },
  {
    name: "Russo One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Fugaz One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bangers",
    category: "display",
    variants: E([400])
  },
  {
    name: "Anton",
    category: "display",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Creepster",
    category: "display",
    variants: E([400])
  },
  {
    name: "Orbitron",
    category: "display",
    variants: E([400, 500, 600, 700, 800, 900])
  },
  {
    name: "Audiowide",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Inline",
    category: "display",
    variants: E([400])
  },
  {
    name: "Bungee Shade",
    category: "display",
    variants: E([400])
  },
  {
    name: "Faster One",
    category: "display",
    variants: E([400])
  },
  {
    name: "Press Start 2P",
    category: "display",
    variants: E([400])
  },
  // === HANDWRITING ===
  {
    name: "Dancing Script",
    category: "handwriting",
    variants: E([400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "Pacifico",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat",
    category: "handwriting",
    variants: E([400, 500, 600, 700])
  },
  {
    name: "Great Vibes",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Satisfy",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Sacramento",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Kalam",
    category: "handwriting",
    variants: E([300, 400, 700])
  },
  {
    name: "Shadows Into Light",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Indie Flower",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Amatic SC",
    category: "handwriting",
    variants: E([400, 700])
  },
  {
    name: "Patrick Hand",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Courgette",
    category: "handwriting",
    variants: E([400])
  },
  {
    name: "Shadows Into Light Two",
    category: "handwriting",
    variants: E([400]),
    popular: !0
  },
  {
    name: "Caveat Brush",
    category: "handwriting",
    variants: E([400])
  },
  // === MONOSPACE ===
  {
    name: "Fira Code",
    category: "monospace",
    variants: E([300, 400, 500, 600, 700]),
    popular: !0
  },
  {
    name: "JetBrains Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800]),
    popular: !0
  },
  {
    name: "Source Code Pro",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Roboto Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "IBM Plex Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700])
  },
  {
    name: "Space Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Inconsolata",
    category: "monospace",
    variants: E([200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Ubuntu Mono",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Noto Sans Mono",
    category: "monospace",
    variants: E([100, 200, 300, 400, 500, 600, 700, 800, 900])
  },
  {
    name: "Courier Prime",
    category: "monospace",
    variants: E([400, 700])
  },
  {
    name: "Fira Mono",
    category: "monospace",
    variants: E([400, 500, 700])
  }
], as = (e, o = [500]) => {
  const r = e.replace(/ /g, "+"), n = o.join(";");
  return `https://fonts.googleapis.com/css2?family=${r}:wght@${n}&display=swap`;
}, ls = (e) => `https://fonts.googleapis.com/css2?${e.map((r) => {
  const n = r.name.replace(/ /g, "+"), i = r.weights.join(";");
  return `family=${n}:wght@${i}`;
}).join("&")}&display=swap`, ss = (e) => {
  const o = ao.find(
    (r) => r.name.toLowerCase() === e.toLowerCase()
  );
  return (o == null ? void 0 : o.variants) || [{ weight: 500, label: "Medium" }];
};
let ro = null;
const rn = () => ro || (ro = new Promise((e) => {
  const o = ao.map((i) => ({
    name: i.name,
    weights: [400, 500]
  })), r = ls(o), n = document.createElement("link");
  n.href = r, n.rel = "stylesheet", n.onload = () => {
    e();
  }, n.onerror = () => {
    console.warn("Failed to preload Google Fonts"), e();
  }, document.head.appendChild(n);
}), ro), ds = (e) => {
  if (!e) return "#000000ff";
  const o = e.startsWith("#") ? e : `#${e}`;
  return o.length === 9 ? o : o.length === 7 ? `${o}ff` : o.padEnd(9, "f").slice(0, 9);
}, gr = (e) => {
  const o = ds(e);
  return o.length === 9 && o.slice(7, 9).toLowerCase() === "ff" ? o.slice(0, 7) : o;
}, Ee = (e, o, r) => {
  var i;
  const n = {
    type: Yr,
    payload: { updateType: o, themeId: r }
  };
  (i = e == null ? void 0 : e.current) != null && i.contentWindow ? e.current.contentWindow.postMessage(
    n,
    window.location.origin
  ) : window.postMessage(n, window.location.origin);
}, cs = (e) => {
  var r;
  switch ((r = e.split(".").pop()) == null ? void 0 : r.toLowerCase()) {
    case "woff2":
      return "woff2";
    case "woff":
      return "woff";
    case "ttf":
      return "truetype";
    case "otf":
      return "opentype";
    default:
      return "woff2";
  }
}, ps = ({
  themeId: e,
  editThemeToken: o,
  iframeRef: r,
  refreshThemeColors: n,
  refreshThemeFonts: i,
  refreshThemeIcons: s
}) => {
  const [l, m] = O(!1), [p, y] = O(null), [c, g] = O(null), [C, w] = O(!1), [k, x] = O(""), [f, B] = O("#000000ff"), [P, u] = O(
    null
  ), R = async () => {
    if (!k.trim()) {
      y("Color name is required");
      return;
    }
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    m(!0), y(null), g(null);
    try {
      await yt({
        themeId: e,
        colorKey: k.trim(),
        colorValue: gr(f),
        editThemeToken: o
      }), await n(), Ee(r, "colors", e), x(""), B("#000000ff"), w(!1), g("Color added successfully"), setTimeout(() => g(null), 2e3);
    } catch (M) {
      y(M.message || "Failed to add color");
    } finally {
      m(!1);
    }
  }, b = async (M, L) => {
    if (!(!o || !e)) {
      m(!0), y(null), g(null);
      try {
        await yt({
          themeId: e,
          colorKey: M,
          colorValue: gr(L),
          editThemeToken: o
        }), await n(), Ee(r, "colors", e), g("Color updated successfully"), setTimeout(() => g(null), 2e3);
      } catch (G) {
        y(G.message || "Failed to update color");
      } finally {
        m(!1);
      }
    }
  }, I = async (M, L) => {
    if (!(!o || !e)) {
      if (!L.trim()) {
        y("Color name is required");
        return;
      }
      if (M !== L.trim()) {
        m(!0), y(null), g(null);
        try {
          await Zi({
            themeId: e,
            oldColorKey: M,
            newColorKey: L.trim(),
            editThemeToken: o
          }), await n(), Ee(r, "colors", e), g("Color renamed successfully"), setTimeout(() => g(null), 2e3);
        } catch (G) {
          y(G.message || "Failed to rename color");
        } finally {
          m(!1);
        }
      }
    }
  }, S = (M) => {
    !o || !e || u({ type: "color", key: M });
  }, v = async (M) => {
    if (!(!o || !e)) {
      m(!0), y(null), g(null);
      try {
        await Ji({
          themeId: e,
          colorKey: M,
          editThemeToken: o
        }), await n(), Ee(r, "colors", e), g("Color deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (L) {
        y(L.message || "Failed to delete color");
      } finally {
        m(!1);
      }
    }
  }, T = async (M) => {
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    m(!0), y(null), g(null);
    try {
      let L, G;
      switch (M.type) {
        case "system":
          L = M.value || M.name, G = "system";
          break;
        case "google":
          const $ = ss(M.name).map((X) => X.weight);
          $.includes(800) || $.push(800), $.includes(900) || $.push(900), L = as(M.name, $), G = "google";
          break;
        case "upload":
          if (!M.file)
            throw new Error("No font file provided");
          const { signedUploadUrl: Y, objectPublicUrl: q } = await bt({
            themeId: e,
            fileName: M.file.name,
            contentType: M.file.type || "font/woff2",
            assetType: "font",
            editThemeToken: o
          });
          await ft({
            file: M.file,
            signedUploadUrl: Y
          }), L = q, G = cs(M.file.name);
          break;
        default:
          throw new Error("Unknown font type");
      }
      await Ui({
        themeId: e,
        fontKey: M.name.toLowerCase().replace(/\s+/g, "-"),
        fontValue: {
          name: M.name,
          url: L,
          format: G
        },
        editThemeToken: o
      }), await i(), Ee(r, "fonts", e), g("Font added successfully"), setTimeout(() => g(null), 2e3);
    } catch (L) {
      y(L.message || "Failed to add font");
    } finally {
      m(!1);
    }
  }, W = (M) => {
    !o || !e || u({ type: "font", key: M });
  }, F = async (M) => {
    if (!(!o || !e)) {
      m(!0), y(null), g(null);
      try {
        await Vi({
          themeId: e,
          fontKey: M,
          editThemeToken: o
        }), await i(), Ee(r, "fonts", e), g("Font deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (L) {
        y(L.message || "Failed to delete font");
      } finally {
        m(!1);
      }
    }
  }, N = async (M) => {
    if (!o || !e) {
      y("Theme ID and edit token are required");
      return;
    }
    m(!0), y(null), g(null);
    try {
      let L;
      switch (M.type) {
        case "lucide":
          if (L = M.url || "", !L)
            throw new Error("No icon URL provided");
          break;
        case "upload":
          if (!M.file)
            throw new Error("No icon file provided");
          const { signedUploadUrl: G, objectPublicUrl: H } = await bt({
            themeId: e,
            fileName: M.file.name,
            contentType: M.file.type || (M.file.name.endsWith(".svg") ? "image/svg+xml" : "application/octet-stream"),
            assetType: "icon",
            editThemeToken: o
          });
          await ft({
            file: M.file,
            signedUploadUrl: G
          }), L = H;
          break;
        default:
          throw new Error("Unknown icon type");
      }
      await _i({
        themeId: e,
        iconKey: M.name.toLowerCase().replace(/\s+/g, "-"),
        iconValue: {
          name: M.name,
          url: L
        },
        editThemeToken: o
      }), await s(), Ee(r, "icons", e), g("Icon added successfully"), setTimeout(() => g(null), 2e3);
    } catch (L) {
      y(L.message || "Failed to add icon");
    } finally {
      m(!1);
    }
  }, z = (M) => {
    !o || !e || u({ type: "icon", key: M });
  }, A = async (M) => {
    if (!(!o || !e)) {
      m(!0), y(null), g(null);
      try {
        await qi({
          themeId: e,
          iconKey: M,
          editThemeToken: o
        }), await s(), Ee(r, "icons", e), g("Icon deleted successfully"), setTimeout(() => g(null), 2e3);
      } catch (L) {
        y(L.message || "Failed to delete icon");
      } finally {
        m(!1);
      }
    }
  };
  return {
    // Loading and messages
    isLoading: l,
    error: p,
    successMessage: c,
    // Color state
    isAddingColor: C,
    setIsAddingColor: w,
    newColorKey: k,
    setNewColorKey: x,
    newColorValue: f,
    setNewColorValue: B,
    // Color Handlers
    handleAddColor: R,
    handleUpdateColor: b,
    handleRenameColor: I,
    handleDeleteColor: S,
    // Font Handlers
    handleAddFont: T,
    handleDeleteFont: W,
    // Icon Handlers
    handleAddIcon: N,
    handleDeleteIcon: z,
    // Delete confirmation
    pendingDelete: P,
    confirmDelete: async () => {
      if (!P) return;
      const { type: M, key: L } = P;
      switch (u(null), M) {
        case "color":
          await v(L);
          break;
        case "font":
          await F(L);
          break;
        case "icon":
          await A(L);
          break;
      }
    },
    cancelDelete: () => {
      u(null);
    }
  };
}, mr = ({
  onClose: e,
  successMessage: o,
  error: r,
  children: n
}) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel", children: [
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel-header", children: [
    /* @__PURE__ */ t("h2", { className: "bc-theme-editor-sidepanel-title", children: "Theme Settings" }),
    /* @__PURE__ */ t(
      oe,
      {
        variant: "icon",
        size: "sm",
        onClick: e,
        "aria-label": "Close settings",
        children: /* @__PURE__ */ t(Ae, { size: 16 })
      }
    )
  ] }),
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-sidepanel-content", children: [
    o && /* @__PURE__ */ h("div", { className: "bc-theme-editor-message bc-theme-editor-message-success", children: [
      /* @__PURE__ */ t(kn, { size: 14 }),
      " ",
      o
    ] }),
    r && /* @__PURE__ */ h("div", { className: "bc-theme-editor-message bc-theme-editor-message-error", children: [
      /* @__PURE__ */ t(Sn, { size: 14 }),
      " ",
      r
    ] }),
    n
  ] })
] }), ur = ({
  themeFonts: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  onDeleteFont: i,
  onOpenFontPicker: s,
  studioLockedFontKeys: l
}) => {
  const [m, p] = O(!1);
  Q(() => {
    o && !m && rn().then(() => p(!0));
  }, [o, m]);
  const y = (c) => {
    switch (c) {
      case "google":
        return "Google Fonts";
      case "system":
        return "System";
      case "woff2":
      case "woff":
      case "truetype":
      case "opentype":
        return "Uploaded";
      default:
        return c;
    }
  };
  return /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
      /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
        "Fonts",
        /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
      ] }),
      /* @__PURE__ */ t(
        so,
        {
          size: 16,
          className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
        }
      )
    ] }),
    o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
      Object.entries(e).map(([c, g]) => {
        const C = (l == null ? void 0 : l.has(c)) ?? !1;
        return /* @__PURE__ */ h("div", { className: "bc-theme-editor-row bc-font-row", children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: "bc-font-preview-name",
              style: {
                fontFamily: m ? `'${g.name}', sans-serif` : "inherit"
              },
              children: g.name
            }
          ),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-asset-format", children: C ? "Concierge Studio" : y(g.format) }),
          C ? /* @__PURE__ */ t(
            "span",
            {
              title: "Edit this font from Concierge Studio",
              style: {
                display: "inline-flex",
                alignItems: "center",
                color: d.blue,
                padding: "4px",
                cursor: "help"
              },
              children: /* @__PURE__ */ t(Yo, { size: 14 })
            }
          ) : /* @__PURE__ */ t(
            "button",
            {
              className: "bc-theme-editor-delete-btn",
              onClick: () => i(c),
              disabled: n,
              "aria-label": "Delete font",
              children: /* @__PURE__ */ t(Ae, { size: 16 })
            }
          )
        ] }, c);
      }),
      /* @__PURE__ */ t(
        oe,
        {
          variant: "ghost",
          size: "sm",
          leftIcon: /* @__PURE__ */ t(Qo, { size: 12 }),
          onClick: s,
          disabled: n,
          children: "Add Font"
        }
      )
    ] }) })
  ] });
}, hr = ({
  themeIcons: e,
  isExpanded: o,
  onToggle: r,
  isLoading: n,
  onDeleteIcon: i,
  onOpenIconPicker: s
}) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-section", children: [
  /* @__PURE__ */ h("div", { className: "bc-theme-editor-section-header", onClick: r, children: [
    /* @__PURE__ */ h("h3", { className: "bc-theme-editor-section-title", children: [
      "Images and Icons",
      /* @__PURE__ */ t("span", { className: "bc-theme-editor-section-count", children: Object.keys(e).length })
    ] }),
    /* @__PURE__ */ t(
      so,
      {
        size: 16,
        className: `bc-theme-editor-section-chevron ${o ? "expanded" : ""}`
      }
    )
  ] }),
  o && /* @__PURE__ */ t("div", { className: "bc-theme-editor-section-content", children: /* @__PURE__ */ h("div", { className: "bc-theme-editor-list", children: [
    Object.entries(e).map(([l, m]) => /* @__PURE__ */ h("div", { className: "bc-theme-editor-row", children: [
      /* @__PURE__ */ t("div", { className: "bc-theme-editor-asset-preview", children: /* @__PURE__ */ t("img", { src: m.url, alt: m.name }) }),
      /* @__PURE__ */ t(
        "input",
        {
          type: "text",
          className: "bc-theme-editor-input",
          value: m.name,
          disabled: !0
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          className: "bc-theme-editor-delete-btn",
          onClick: () => i(l),
          disabled: n,
          "aria-label": "Delete icon",
          children: /* @__PURE__ */ t(Ae, { size: 16 })
        }
      )
    ] }, l)),
    /* @__PURE__ */ t(
      oe,
      {
        variant: "ghost",
        size: "sm",
        leftIcon: /* @__PURE__ */ t(Qo, { size: 12 }),
        onClick: s,
        disabled: n,
        children: "Add Image"
      }
    )
  ] }) })
] }), yr = [
  // Sans-serif
  {
    name: "System UI",
    value: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    category: "sans-serif"
  },
  {
    name: "SF Pro",
    value: "-apple-system, BlinkMacSystemFont, 'SF Pro Display', sans-serif",
    category: "sans-serif"
  },
  {
    name: "Helvetica",
    value: "Helvetica, Arial, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Arial",
    value: "Arial, Helvetica, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Segoe UI",
    value: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Verdana",
    value: "Verdana, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Tahoma",
    value: "Tahoma, Geneva, sans-serif",
    category: "sans-serif"
  },
  {
    name: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    category: "sans-serif"
  },
  // Serif
  {
    name: "New York",
    value: "'New York', 'Iowan Old Style', Georgia, serif",
    category: "serif"
  },
  {
    name: "Georgia",
    value: "Georgia, 'Times New Roman', serif",
    category: "serif"
  },
  {
    name: "Times New Roman",
    value: "'Times New Roman', Times, serif",
    category: "serif"
  },
  {
    name: "Palatino",
    value: "'Palatino Linotype', Palatino, 'Book Antiqua', serif",
    category: "serif"
  },
  {
    name: "Garamond",
    value: "Garamond, 'Times New Roman', serif",
    category: "serif"
  },
  // Monospace
  {
    name: "SF Mono",
    value: "'SF Mono', Menlo, Monaco, monospace",
    category: "monospace"
  },
  {
    name: "Menlo",
    value: "Menlo, Monaco, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Monaco",
    value: "Monaco, Menlo, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Consolas",
    value: "Consolas, 'Courier New', monospace",
    category: "monospace"
  },
  {
    name: "Courier New",
    value: "'Courier New', Courier, monospace",
    category: "monospace"
  }
], gs = () => `
  /* Overlay */
  .font-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: font-picker-fade-in 0.2s ease;
  }

  @keyframes font-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .font-picker-modal {
    background: ${d.white};
    border-radius: 16px;
    width: 90%;
    max-width: 560px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: font-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes font-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .font-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  /* Search */
  .font-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
    position: relative;
  }

  .font-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${d.gray_medium};
  }

  .font-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-search-input:focus {
    border-color: ${d.blue};
    background: ${d.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .font-picker-search-input::placeholder {
    color: ${d.gray_medium};
  }

  /* Tabs */
  .font-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${d.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .font-picker-tab:hover {
    color: ${d.primary};
  }

  .font-picker-tab.active {
    color: ${d.primary};
  }

  .font-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${d.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .font-picker-content {
    flex: 1;
    overflow-y: auto;
    padding: 0;
  }

  .font-picker-description {
    font-size: 13px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Font List */
  .font-picker-list {
    padding-bottom: 16px;
  }

  .font-picker-category {
    margin-bottom: 8px;
  }

  .font-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
  }

  .font-picker-item {
    display: flex;
    align-items: center;
    padding: 14px 24px;
    cursor: pointer;
    transition: background 0.15s ease;
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-item:hover {
    background: ${d.bg_light};
  }

  .font-picker-item.selected {
    background: rgba(85, 114, 183, 0.08);
  }

  .font-picker-item-name {
    flex: 1;
    font-size: 16px;
    color: ${d.primary};
  }

  .font-picker-popular {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    color: ${d.blue};
    background: rgba(85, 114, 183, 0.1);
    padding: 3px 8px;
    border-radius: 4px;
    margin-right: 12px;
  }

  .font-picker-check {
    color: ${d.blue};
    flex-shrink: 0;
  }

  /* Variant Selector */
  .font-picker-variant-selector {
    padding: 8px 24px 8px 48px;
    background: ${d.bg_light};
    border-bottom: 1px solid ${d.border_glass};
  }

  .font-picker-variant-select {
    padding: 8px 32px 8px 12px;
    border: 1px solid ${d.border_glass};
    border-radius: 8px;
    font-size: 13px;
    color: ${d.primary};
    background: ${d.white};
    cursor: pointer;
    outline: none;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%237e8fa8' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 10px center;
    transition: all 0.15s ease;
  }

  .font-picker-variant-select:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Upload Tab */
  .font-picker-upload {
    padding: 16px 24px;
  }

  .font-picker-upload-zone {
    border: 2px dashed ${d.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .font-picker-upload-zone:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .font-picker-upload-icon {
    color: ${d.gray_medium};
  }

  .font-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
  }

  .font-picker-upload-hint {
    font-size: 12px;
    color: ${d.gray_medium};
  }

  .font-picker-upload-preview {
    margin-top: 16px;
  }

  .font-picker-upload-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: ${d.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .font-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .font-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .font-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${d.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .font-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .font-picker-upload-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .font-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${d.border_glass};
    background: ${d.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, br = ({
  isOpen: e,
  onClose: o,
  onSelect: r,
  isLoading: n = !1
}) => {
  const [i, s] = O("system"), [l, m] = O(""), [p, y] = O(null), [c, g] = O(null), [C, w] = O(""), k = se(null), [x, f] = O(!1);
  Q(() => {
    e && (m(""), y(null), g(null), w(""));
  }, [e]), Q(() => {
    i === "google" && !x && rn().then(() => {
      f(!0);
    });
  }, [i, x]);
  const B = ae(() => {
    if (!l) return yr;
    const z = l.toLowerCase();
    return yr.filter(
      (A) => A.name.toLowerCase().includes(z) || A.category.toLowerCase().includes(z)
    );
  }, [l]), P = ae(() => {
    if (!l) return ao;
    const z = l.toLowerCase();
    return ao.filter(
      (A) => A.name.toLowerCase().includes(z) || A.category.toLowerCase().includes(z)
    );
  }, [l]), u = (z) => {
    y({
      type: "system",
      name: z.name,
      value: z.value
    });
  }, R = (z) => {
    y({
      type: "google",
      name: z.name
    });
  }, b = (z) => {
    var j;
    const A = (j = z.target.files) == null ? void 0 : j[0];
    if (A) {
      g(A);
      const Z = A.name.replace(/\.[^/.]+$/, "");
      w(Z), y({
        type: "upload",
        name: Z,
        file: A,
        format: I(A.name)
      });
    }
  }, I = (z) => {
    var j;
    switch ((j = z.split(".").pop()) == null ? void 0 : j.toLowerCase()) {
      case "woff2":
        return "woff2";
      case "woff":
        return "woff";
      case "ttf":
        return "truetype";
      case "otf":
        return "opentype";
      default:
        return "woff2";
    }
  }, S = (z) => {
    w(z), (p == null ? void 0 : p.type) === "upload" && c && y({
      ...p,
      name: z
    });
  }, v = () => {
    p && (r(p), o());
  }, T = n || !p || p.type === "upload" && (!c || !C.trim()), W = ae(() => {
    const z = {};
    return P.forEach((A) => {
      z[A.category] || (z[A.category] = []), z[A.category].push(A);
    }), z;
  }, [P]), F = ae(() => {
    const z = {};
    return B.forEach((A) => {
      z[A.category] || (z[A.category] = []), z[A.category].push(A);
    }), z;
  }, [B]);
  if (!e) return null;
  const N = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: gs() }),
    /* @__PURE__ */ t("div", { className: "font-picker-overlay", onClick: o, children: /* @__PURE__ */ h("div", { className: "font-picker-modal", onClick: (z) => z.stopPropagation(), children: [
      /* @__PURE__ */ h("div", { className: "font-picker-header", children: [
        /* @__PURE__ */ t("h2", { className: "font-picker-title", children: "Select font" }),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: o,
            "aria-label": "Close",
            children: /* @__PURE__ */ t(Ae, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-search", children: [
        /* @__PURE__ */ t(co, { size: 16, className: "font-picker-search-icon" }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            placeholder: "Search",
            value: l,
            onChange: (z) => m(z.target.value),
            className: "font-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-tabs", children: [
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "system" ? "active" : ""}`,
            onClick: () => s("system"),
            children: "System Fonts"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "google" ? "active" : ""}`,
            onClick: () => s("google"),
            children: "Google Fonts"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `font-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => s("upload"),
            children: "Upload"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-content", children: [
        i === "system" && /* @__PURE__ */ h("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "These fonts load faster and might appear differently on various devices." }),
          Object.entries(F).map(
            ([z, A]) => /* @__PURE__ */ h("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ t("h4", { className: "font-picker-category-title", children: z.charAt(0).toUpperCase() + z.slice(1) }),
              A.map((j) => /* @__PURE__ */ h(
                "div",
                {
                  className: `font-picker-item ${(p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === j.name ? "selected" : ""}`,
                  onClick: () => u(j),
                  children: [
                    /* @__PURE__ */ t(
                      "span",
                      {
                        className: "font-picker-item-name",
                        style: { fontFamily: j.value },
                        children: j.name
                      }
                    ),
                    (p == null ? void 0 : p.type) === "system" && (p == null ? void 0 : p.name) === j.name && /* @__PURE__ */ t(_e, { size: 16, className: "font-picker-check" })
                  ]
                },
                j.name
              ))
            ] }, z)
          )
        ] }),
        i === "google" && /* @__PURE__ */ h("div", { className: "font-picker-list", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "These fonts are downloaded onto a visitor's computer and might cause slower load times." }),
          Object.entries(W).map(
            ([z, A]) => /* @__PURE__ */ h("div", { className: "font-picker-category", children: [
              /* @__PURE__ */ t("h4", { className: "font-picker-category-title", children: z.charAt(0).toUpperCase() + z.slice(1) }),
              A.map((j) => {
                const Z = (p == null ? void 0 : p.type) === "google" && (p == null ? void 0 : p.name) === j.name;
                return /* @__PURE__ */ t("div", { children: /* @__PURE__ */ h(
                  "div",
                  {
                    className: `font-picker-item ${Z ? "selected" : ""}`,
                    onClick: () => R(j),
                    children: [
                      /* @__PURE__ */ t(
                        "span",
                        {
                          className: "font-picker-item-name",
                          style: {
                            fontFamily: x ? `'${j.name}', sans-serif` : "inherit"
                          },
                          children: j.name
                        }
                      ),
                      Z && /* @__PURE__ */ t(
                        _e,
                        {
                          size: 16,
                          className: "font-picker-check"
                        }
                      )
                    ]
                  }
                ) }, j.name);
              })
            ] }, z)
          )
        ] }),
        i === "upload" && /* @__PURE__ */ h("div", { className: "font-picker-upload", children: [
          /* @__PURE__ */ t("p", { className: "font-picker-description", children: "Upload your own font file. Supported formats: WOFF2, WOFF, TTF, OTF." }),
          /* @__PURE__ */ t(
            "input",
            {
              ref: k,
              type: "file",
              accept: ".woff2,.woff,.ttf,.otf",
              onChange: b,
              style: { display: "none" }
            }
          ),
          c ? /* @__PURE__ */ h("div", { className: "font-picker-upload-preview", children: [
            /* @__PURE__ */ h("div", { className: "font-picker-upload-file", children: [
              /* @__PURE__ */ t("span", { className: "font-picker-upload-filename", children: c.name }),
              /* @__PURE__ */ t(
                oe,
                {
                  variant: "ghost",
                  size: "sm",
                  onClick: () => {
                    var z;
                    return (z = k.current) == null ? void 0 : z.click();
                  },
                  children: "Change"
                }
              )
            ] }),
            /* @__PURE__ */ h("div", { className: "font-picker-upload-name", children: [
              /* @__PURE__ */ t("label", { className: "font-picker-upload-label", children: "Font name" }),
              /* @__PURE__ */ t(
                "input",
                {
                  type: "text",
                  value: C,
                  onChange: (z) => S(z.target.value),
                  placeholder: "Enter font name",
                  className: "font-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ h(
            "div",
            {
              className: "font-picker-upload-zone",
              onClick: () => {
                var z;
                return (z = k.current) == null ? void 0 : z.click();
              },
              children: [
                /* @__PURE__ */ t(Fr, { size: 32, className: "font-picker-upload-icon" }),
                /* @__PURE__ */ t("span", { className: "font-picker-upload-text", children: "Click to upload font file" }),
                /* @__PURE__ */ t("span", { className: "font-picker-upload-hint", children: "WOFF2, WOFF, TTF, or OTF" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "font-picker-footer", children: [
        /* @__PURE__ */ t(oe, { variant: "outline", onClick: o, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "primary",
            onClick: v,
            disabled: T,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Le.createPortal(N, po());
}, fr = [
  "arrows",
  "commerce",
  "communication",
  "devices",
  "files",
  "layout",
  "media",
  "navigation",
  "social",
  "symbols",
  "text",
  "weather"
], lo = [
  // === ARROWS ===
  { name: "arrow-up", tags: ["up", "direction"], category: "arrows" },
  { name: "arrow-down", tags: ["down", "direction"], category: "arrows" },
  {
    name: "arrow-left",
    tags: ["left", "direction", "back"],
    category: "arrows"
  },
  {
    name: "arrow-right",
    tags: ["right", "direction", "forward"],
    category: "arrows"
  },
  {
    name: "arrow-up-right",
    tags: ["diagonal", "external"],
    category: "arrows"
  },
  { name: "arrow-down-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-up-left", tags: ["diagonal"], category: "arrows" },
  { name: "arrow-down-right", tags: ["diagonal"], category: "arrows" },
  { name: "chevron-up", tags: ["up", "expand"], category: "arrows" },
  { name: "chevron-down", tags: ["down", "collapse"], category: "arrows" },
  { name: "chevron-left", tags: ["left", "back"], category: "arrows" },
  { name: "chevron-right", tags: ["right", "forward"], category: "arrows" },
  { name: "chevrons-up", tags: ["up", "double"], category: "arrows" },
  { name: "chevrons-down", tags: ["down", "double"], category: "arrows" },
  { name: "chevrons-left", tags: ["left", "double"], category: "arrows" },
  { name: "chevrons-right", tags: ["right", "double"], category: "arrows" },
  { name: "move", tags: ["drag", "reorder"], category: "arrows" },
  { name: "move-horizontal", tags: ["drag", "resize"], category: "arrows" },
  { name: "move-vertical", tags: ["drag", "resize"], category: "arrows" },
  {
    name: "refresh-cw",
    tags: ["reload", "sync", "refresh"],
    category: "arrows"
  },
  { name: "refresh-ccw", tags: ["reload", "undo"], category: "arrows" },
  { name: "rotate-cw", tags: ["rotate", "clockwise"], category: "arrows" },
  { name: "rotate-ccw", tags: ["rotate", "counter"], category: "arrows" },
  { name: "undo", tags: ["back", "reverse"], category: "arrows" },
  { name: "redo", tags: ["forward"], category: "arrows" },
  { name: "repeat", tags: ["loop", "cycle"], category: "arrows" },
  { name: "corner-down-left", tags: ["enter", "return"], category: "arrows" },
  { name: "corner-down-right", tags: ["turn"], category: "arrows" },
  { name: "corner-up-left", tags: ["turn"], category: "arrows" },
  { name: "corner-up-right", tags: ["turn"], category: "arrows" },
  // === COMMERCE ===
  {
    name: "shopping-cart",
    tags: ["cart", "buy", "ecommerce"],
    category: "commerce"
  },
  { name: "shopping-bag", tags: ["bag", "buy", "store"], category: "commerce" },
  {
    name: "credit-card",
    tags: ["payment", "card", "money"],
    category: "commerce"
  },
  { name: "wallet", tags: ["money", "payment"], category: "commerce" },
  { name: "receipt", tags: ["invoice", "bill"], category: "commerce" },
  { name: "tag", tags: ["label", "price"], category: "commerce" },
  { name: "tags", tags: ["labels", "prices"], category: "commerce" },
  { name: "percent", tags: ["discount", "sale"], category: "commerce" },
  {
    name: "dollar-sign",
    tags: ["money", "currency", "price"],
    category: "commerce"
  },
  {
    name: "banknote",
    tags: ["money", "cash", "payment"],
    category: "commerce"
  },
  { name: "coins", tags: ["money", "currency"], category: "commerce" },
  { name: "gift", tags: ["present", "reward"], category: "commerce" },
  {
    name: "package",
    tags: ["box", "shipping", "delivery"],
    category: "commerce"
  },
  { name: "truck", tags: ["delivery", "shipping"], category: "commerce" },
  { name: "store", tags: ["shop", "retail"], category: "commerce" },
  { name: "barcode", tags: ["scan", "product"], category: "commerce" },
  { name: "qr-code", tags: ["scan", "code"], category: "commerce" },
  // === COMMUNICATION ===
  {
    name: "mail",
    tags: ["email", "message", "envelope"],
    category: "communication"
  },
  { name: "mail-open", tags: ["email", "read"], category: "communication" },
  { name: "inbox", tags: ["email", "messages"], category: "communication" },
  {
    name: "send",
    tags: ["email", "message", "submit"],
    category: "communication"
  },
  {
    name: "message-circle",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "message-square",
    tags: ["chat", "comment"],
    category: "communication"
  },
  {
    name: "messages-square",
    tags: ["chat", "conversation"],
    category: "communication"
  },
  { name: "phone", tags: ["call", "contact"], category: "communication" },
  { name: "phone-call", tags: ["calling", "ring"], category: "communication" },
  {
    name: "phone-incoming",
    tags: ["call", "receive"],
    category: "communication"
  },
  { name: "phone-outgoing", tags: ["call", "dial"], category: "communication" },
  { name: "phone-missed", tags: ["call", "missed"], category: "communication" },
  {
    name: "video",
    tags: ["camera", "call", "meeting"],
    category: "communication"
  },
  {
    name: "video-off",
    tags: ["camera", "disabled"],
    category: "communication"
  },
  {
    name: "mic",
    tags: ["microphone", "audio", "voice"],
    category: "communication"
  },
  { name: "mic-off", tags: ["mute", "silent"], category: "communication" },
  { name: "bell", tags: ["notification", "alert"], category: "communication" },
  {
    name: "bell-off",
    tags: ["notification", "mute"],
    category: "communication"
  },
  {
    name: "bell-ring",
    tags: ["notification", "alert"],
    category: "communication"
  },
  { name: "at-sign", tags: ["email", "mention"], category: "communication" },
  // === DEVICES ===
  {
    name: "smartphone",
    tags: ["phone", "mobile", "device"],
    category: "devices"
  },
  { name: "tablet", tags: ["ipad", "device"], category: "devices" },
  { name: "laptop", tags: ["computer", "device"], category: "devices" },
  {
    name: "monitor",
    tags: ["screen", "display", "desktop"],
    category: "devices"
  },
  { name: "tv", tags: ["television", "screen"], category: "devices" },
  { name: "watch", tags: ["time", "wearable"], category: "devices" },
  { name: "headphones", tags: ["audio", "music"], category: "devices" },
  { name: "speaker", tags: ["audio", "sound"], category: "devices" },
  { name: "camera", tags: ["photo", "picture"], category: "devices" },
  { name: "printer", tags: ["print", "document"], category: "devices" },
  { name: "keyboard", tags: ["input", "type"], category: "devices" },
  { name: "mouse", tags: ["input", "click"], category: "devices" },
  { name: "gamepad", tags: ["game", "controller"], category: "devices" },
  { name: "cpu", tags: ["processor", "chip"], category: "devices" },
  { name: "hard-drive", tags: ["storage", "disk"], category: "devices" },
  { name: "usb", tags: ["cable", "port"], category: "devices" },
  {
    name: "wifi",
    tags: ["internet", "network", "wireless"],
    category: "devices"
  },
  { name: "bluetooth", tags: ["wireless", "connect"], category: "devices" },
  { name: "battery", tags: ["power", "charge"], category: "devices" },
  { name: "battery-charging", tags: ["power", "charge"], category: "devices" },
  { name: "plug", tags: ["power", "electric"], category: "devices" },
  // === FILES ===
  { name: "file", tags: ["document", "page"], category: "files" },
  { name: "file-text", tags: ["document", "text"], category: "files" },
  { name: "file-image", tags: ["picture", "photo"], category: "files" },
  { name: "file-video", tags: ["movie", "media"], category: "files" },
  { name: "file-audio", tags: ["music", "sound"], category: "files" },
  { name: "file-code", tags: ["code", "programming"], category: "files" },
  { name: "file-json", tags: ["data", "code"], category: "files" },
  { name: "file-spreadsheet", tags: ["excel", "data"], category: "files" },
  { name: "file-archive", tags: ["zip", "compress"], category: "files" },
  { name: "file-plus", tags: ["add", "new"], category: "files" },
  { name: "file-minus", tags: ["remove", "delete"], category: "files" },
  { name: "file-check", tags: ["done", "complete"], category: "files" },
  { name: "file-x", tags: ["delete", "remove"], category: "files" },
  { name: "folder", tags: ["directory"], category: "files" },
  { name: "folder-open", tags: ["directory", "open"], category: "files" },
  { name: "folder-plus", tags: ["add", "new"], category: "files" },
  { name: "folder-minus", tags: ["remove"], category: "files" },
  { name: "clipboard", tags: ["copy", "paste"], category: "files" },
  { name: "clipboard-check", tags: ["done", "complete"], category: "files" },
  { name: "copy", tags: ["duplicate", "clipboard"], category: "files" },
  { name: "scissors", tags: ["cut"], category: "files" },
  { name: "download", tags: ["save", "get"], category: "files" },
  { name: "upload", tags: ["send", "share"], category: "files" },
  { name: "cloud", tags: ["storage", "online"], category: "files" },
  { name: "cloud-download", tags: ["download", "sync"], category: "files" },
  { name: "cloud-upload", tags: ["upload", "sync"], category: "files" },
  { name: "archive", tags: ["box", "storage"], category: "files" },
  { name: "trash", tags: ["delete", "remove"], category: "files" },
  { name: "trash-2", tags: ["delete", "remove"], category: "files" },
  // === LAYOUT ===
  { name: "layout", tags: ["template", "design"], category: "layout" },
  { name: "layout-grid", tags: ["grid", "template"], category: "layout" },
  { name: "layout-list", tags: ["list", "rows"], category: "layout" },
  {
    name: "layout-dashboard",
    tags: ["dashboard", "widgets"],
    category: "layout"
  },
  { name: "grid-2x2", tags: ["grid", "squares"], category: "layout" },
  { name: "grid-3x3", tags: ["grid", "squares"], category: "layout" },
  { name: "list", tags: ["items", "menu"], category: "layout" },
  { name: "list-ordered", tags: ["numbers", "ol"], category: "layout" },
  { name: "list-checks", tags: ["todo", "tasks"], category: "layout" },
  { name: "table", tags: ["data", "spreadsheet"], category: "layout" },
  { name: "columns", tags: ["layout", "split"], category: "layout" },
  { name: "rows", tags: ["layout", "split"], category: "layout" },
  { name: "sidebar", tags: ["panel", "nav"], category: "layout" },
  { name: "panel-left", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-right", tags: ["sidebar", "layout"], category: "layout" },
  { name: "panel-top", tags: ["header", "layout"], category: "layout" },
  { name: "panel-bottom", tags: ["footer", "layout"], category: "layout" },
  { name: "maximize", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "maximize-2", tags: ["fullscreen", "expand"], category: "layout" },
  { name: "minimize", tags: ["exit", "shrink"], category: "layout" },
  { name: "minimize-2", tags: ["exit", "shrink"], category: "layout" },
  { name: "split", tags: ["divide", "separate"], category: "layout" },
  { name: "merge", tags: ["combine", "join"], category: "layout" },
  // === MEDIA ===
  { name: "play", tags: ["start", "video", "audio"], category: "media" },
  { name: "pause", tags: ["stop", "wait"], category: "media" },
  { name: "stop-circle", tags: ["end", "halt"], category: "media" },
  { name: "skip-back", tags: ["previous", "rewind"], category: "media" },
  { name: "skip-forward", tags: ["next", "forward"], category: "media" },
  { name: "rewind", tags: ["backward", "reverse"], category: "media" },
  { name: "fast-forward", tags: ["forward", "speed"], category: "media" },
  { name: "volume", tags: ["sound", "audio"], category: "media" },
  { name: "volume-1", tags: ["sound", "low"], category: "media" },
  { name: "volume-2", tags: ["sound", "high"], category: "media" },
  { name: "volume-x", tags: ["mute", "silent"], category: "media" },
  { name: "music", tags: ["audio", "song"], category: "media" },
  { name: "music-2", tags: ["audio", "notes"], category: "media" },
  { name: "music-3", tags: ["audio", "notes"], category: "media" },
  { name: "music-4", tags: ["audio", "notes"], category: "media" },
  { name: "image", tags: ["picture", "photo"], category: "media" },
  { name: "images", tags: ["pictures", "gallery"], category: "media" },
  { name: "film", tags: ["movie", "video"], category: "media" },
  { name: "clapperboard", tags: ["movie", "film"], category: "media" },
  { name: "disc", tags: ["cd", "dvd", "music"], category: "media" },
  { name: "radio", tags: ["music", "broadcast"], category: "media" },
  { name: "podcast", tags: ["audio", "broadcast"], category: "media" },
  { name: "cast", tags: ["stream", "broadcast"], category: "media" },
  { name: "airplay", tags: ["stream", "mirror"], category: "media" },
  { name: "screen-share", tags: ["present", "stream"], category: "media" },
  { name: "screen-share-off", tags: ["stop", "stream"], category: "media" },
  // === NAVIGATION ===
  { name: "home", tags: ["house", "main"], category: "navigation" },
  { name: "menu", tags: ["hamburger", "nav"], category: "navigation" },
  {
    name: "more-horizontal",
    tags: ["dots", "options"],
    category: "navigation"
  },
  { name: "more-vertical", tags: ["dots", "options"], category: "navigation" },
  { name: "grip-horizontal", tags: ["drag", "handle"], category: "navigation" },
  { name: "grip-vertical", tags: ["drag", "handle"], category: "navigation" },
  { name: "search", tags: ["find", "magnify"], category: "navigation" },
  { name: "zoom-in", tags: ["magnify", "enlarge"], category: "navigation" },
  { name: "zoom-out", tags: ["shrink", "reduce"], category: "navigation" },
  { name: "filter", tags: ["sort", "funnel"], category: "navigation" },
  {
    name: "settings",
    tags: ["gear", "config", "preferences"],
    category: "navigation"
  },
  { name: "settings-2", tags: ["sliders", "config"], category: "navigation" },
  {
    name: "sliders-horizontal",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  {
    name: "sliders-vertical",
    tags: ["settings", "adjust"],
    category: "navigation"
  },
  { name: "map", tags: ["location", "navigation"], category: "navigation" },
  { name: "map-pin", tags: ["location", "marker"], category: "navigation" },
  { name: "navigation", tags: ["direction", "arrow"], category: "navigation" },
  {
    name: "compass",
    tags: ["direction", "navigation"],
    category: "navigation"
  },
  { name: "globe", tags: ["world", "earth", "web"], category: "navigation" },
  { name: "locate", tags: ["gps", "position"], category: "navigation" },
  { name: "crosshair", tags: ["target", "aim"], category: "navigation" },
  { name: "bookmark", tags: ["save", "favorite"], category: "navigation" },
  { name: "flag", tags: ["mark", "report"], category: "navigation" },
  { name: "hash", tags: ["tag", "number"], category: "navigation" },
  { name: "link", tags: ["url", "chain"], category: "navigation" },
  { name: "link-2", tags: ["url", "chain"], category: "navigation" },
  { name: "unlink", tags: ["break", "disconnect"], category: "navigation" },
  {
    name: "external-link",
    tags: ["open", "new window"],
    category: "navigation"
  },
  { name: "log-in", tags: ["sign in", "enter"], category: "navigation" },
  { name: "log-out", tags: ["sign out", "exit"], category: "navigation" },
  // === SOCIAL ===
  { name: "user", tags: ["person", "account", "profile"], category: "social" },
  { name: "user-plus", tags: ["add", "follow"], category: "social" },
  { name: "user-minus", tags: ["remove", "unfollow"], category: "social" },
  { name: "user-check", tags: ["verified", "approved"], category: "social" },
  { name: "user-x", tags: ["delete", "remove"], category: "social" },
  { name: "users", tags: ["people", "team", "group"], category: "social" },
  { name: "user-circle", tags: ["avatar", "profile"], category: "social" },
  { name: "contact", tags: ["person", "card"], category: "social" },
  { name: "heart", tags: ["like", "love", "favorite"], category: "social" },
  { name: "thumbs-up", tags: ["like", "approve"], category: "social" },
  { name: "thumbs-down", tags: ["dislike", "disapprove"], category: "social" },
  { name: "star", tags: ["favorite", "rating"], category: "social" },
  { name: "award", tags: ["achievement", "badge"], category: "social" },
  { name: "trophy", tags: ["winner", "achievement"], category: "social" },
  { name: "medal", tags: ["achievement", "award"], category: "social" },
  { name: "share", tags: ["social", "send"], category: "social" },
  { name: "share-2", tags: ["social", "network"], category: "social" },
  { name: "rss", tags: ["feed", "subscribe"], category: "social" },
  { name: "smile", tags: ["emoji", "happy"], category: "social" },
  { name: "frown", tags: ["emoji", "sad"], category: "social" },
  { name: "meh", tags: ["emoji", "neutral"], category: "social" },
  { name: "laugh", tags: ["emoji", "happy"], category: "social" },
  { name: "angry", tags: ["emoji", "mad"], category: "social" },
  // === SYMBOLS ===
  { name: "check", tags: ["done", "complete", "yes"], category: "symbols" },
  { name: "check-circle", tags: ["done", "success"], category: "symbols" },
  { name: "check-square", tags: ["done", "checkbox"], category: "symbols" },
  { name: "x", tags: ["close", "cancel", "no"], category: "symbols" },
  { name: "x-circle", tags: ["close", "error"], category: "symbols" },
  { name: "x-square", tags: ["close", "cancel"], category: "symbols" },
  { name: "plus", tags: ["add", "new", "create"], category: "symbols" },
  { name: "plus-circle", tags: ["add", "new"], category: "symbols" },
  { name: "plus-square", tags: ["add", "new"], category: "symbols" },
  { name: "minus", tags: ["remove", "subtract"], category: "symbols" },
  { name: "minus-circle", tags: ["remove"], category: "symbols" },
  { name: "minus-square", tags: ["remove"], category: "symbols" },
  { name: "circle", tags: ["shape", "dot"], category: "symbols" },
  { name: "square", tags: ["shape", "box"], category: "symbols" },
  { name: "triangle", tags: ["shape", "warning"], category: "symbols" },
  { name: "octagon", tags: ["stop", "shape"], category: "symbols" },
  { name: "info", tags: ["information", "help"], category: "symbols" },
  { name: "alert-circle", tags: ["warning", "error"], category: "symbols" },
  { name: "alert-triangle", tags: ["warning", "caution"], category: "symbols" },
  { name: "help-circle", tags: ["question", "support"], category: "symbols" },
  { name: "ban", tags: ["block", "forbidden"], category: "symbols" },
  { name: "shield", tags: ["security", "protect"], category: "symbols" },
  { name: "shield-check", tags: ["secure", "verified"], category: "symbols" },
  { name: "lock", tags: ["secure", "private"], category: "symbols" },
  { name: "unlock", tags: ["open", "public"], category: "symbols" },
  { name: "key", tags: ["password", "access"], category: "symbols" },
  { name: "eye", tags: ["view", "visible", "show"], category: "symbols" },
  { name: "eye-off", tags: ["hide", "invisible"], category: "symbols" },
  { name: "zap", tags: ["lightning", "fast", "power"], category: "symbols" },
  { name: "flame", tags: ["fire", "hot", "trending"], category: "symbols" },
  { name: "sparkles", tags: ["magic", "new", "ai"], category: "symbols" },
  { name: "wand", tags: ["magic", "transform"], category: "symbols" },
  { name: "target", tags: ["goal", "aim"], category: "symbols" },
  { name: "clock", tags: ["time", "schedule"], category: "symbols" },
  { name: "timer", tags: ["countdown", "stopwatch"], category: "symbols" },
  {
    name: "calendar",
    tags: ["date", "schedule", "event"],
    category: "symbols"
  },
  { name: "hourglass", tags: ["time", "wait"], category: "symbols" },
  { name: "infinity", tags: ["endless", "loop"], category: "symbols" },
  // === TEXT ===
  { name: "type", tags: ["text", "font"], category: "text" },
  { name: "bold", tags: ["text", "strong"], category: "text" },
  { name: "italic", tags: ["text", "emphasis"], category: "text" },
  { name: "underline", tags: ["text", "format"], category: "text" },
  { name: "strikethrough", tags: ["text", "delete"], category: "text" },
  { name: "align-left", tags: ["text", "paragraph"], category: "text" },
  { name: "align-center", tags: ["text", "paragraph"], category: "text" },
  { name: "align-right", tags: ["text", "paragraph"], category: "text" },
  { name: "align-justify", tags: ["text", "paragraph"], category: "text" },
  { name: "indent", tags: ["text", "tab"], category: "text" },
  { name: "outdent", tags: ["text", "tab"], category: "text" },
  { name: "heading-1", tags: ["text", "h1"], category: "text" },
  { name: "heading-2", tags: ["text", "h2"], category: "text" },
  { name: "heading-3", tags: ["text", "h3"], category: "text" },
  { name: "heading-4", tags: ["text", "h4"], category: "text" },
  { name: "heading-5", tags: ["text", "h5"], category: "text" },
  { name: "heading-6", tags: ["text", "h6"], category: "text" },
  { name: "pilcrow", tags: ["paragraph", "text"], category: "text" },
  { name: "quote", tags: ["blockquote", "cite"], category: "text" },
  { name: "code", tags: ["programming", "syntax"], category: "text" },
  { name: "braces", tags: ["code", "curly"], category: "text" },
  { name: "brackets", tags: ["code", "square"], category: "text" },
  { name: "parentheses", tags: ["code", "round"], category: "text" },
  { name: "terminal", tags: ["code", "command"], category: "text" },
  { name: "pencil", tags: ["edit", "write"], category: "text" },
  { name: "pen", tags: ["edit", "write"], category: "text" },
  { name: "highlighter", tags: ["mark", "highlight"], category: "text" },
  { name: "eraser", tags: ["delete", "remove"], category: "text" },
  { name: "text-cursor", tags: ["input", "caret"], category: "text" },
  { name: "text-cursor-input", tags: ["input", "field"], category: "text" },
  { name: "spell-check", tags: ["grammar", "correct"], category: "text" },
  { name: "languages", tags: ["translate", "i18n"], category: "text" },
  // === WEATHER ===
  { name: "sun", tags: ["day", "bright", "light"], category: "weather" },
  { name: "moon", tags: ["night", "dark"], category: "weather" },
  { name: "cloud", tags: ["weather", "overcast"], category: "weather" },
  { name: "cloud-sun", tags: ["partly cloudy"], category: "weather" },
  { name: "cloud-moon", tags: ["night", "cloudy"], category: "weather" },
  { name: "cloud-rain", tags: ["rain", "weather"], category: "weather" },
  { name: "cloud-drizzle", tags: ["light rain"], category: "weather" },
  { name: "cloud-snow", tags: ["snow", "winter"], category: "weather" },
  { name: "cloud-lightning", tags: ["storm", "thunder"], category: "weather" },
  { name: "cloud-fog", tags: ["mist", "haze"], category: "weather" },
  { name: "snowflake", tags: ["snow", "winter", "cold"], category: "weather" },
  { name: "wind", tags: ["breeze", "air"], category: "weather" },
  { name: "droplet", tags: ["water", "rain"], category: "weather" },
  { name: "droplets", tags: ["water", "humidity"], category: "weather" },
  { name: "thermometer", tags: ["temperature", "heat"], category: "weather" },
  { name: "rainbow", tags: ["weather", "colors"], category: "weather" },
  { name: "umbrella", tags: ["rain", "protection"], category: "weather" },
  { name: "sunrise", tags: ["morning", "dawn"], category: "weather" },
  { name: "sunset", tags: ["evening", "dusk"], category: "weather" }
], xr = (e) => `https://unpkg.com/lucide-static@latest/icons/${e}.svg`, ms = (e) => {
  const o = e.toLowerCase().trim();
  return o ? lo.filter(
    (r) => r.name.toLowerCase().includes(o) || r.tags.some((n) => n.toLowerCase().includes(o)) || r.category.toLowerCase().includes(o)
  ) : lo;
}, Cr = (e) => lo.filter((o) => o.category === e), us = () => `
  /* Overlay */
  .icon-picker-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(4px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000002;
    animation: icon-picker-fade-in 0.2s ease;
  }

  @keyframes icon-picker-fade-in {
    from { opacity: 0; }
    to { opacity: 1; }
  }

  /* Modal */
  .icon-picker-modal {
    background: ${d.white};
    border-radius: 16px;
    width: 90%;
    max-width: 680px;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25);
    animation: icon-picker-slide-up 0.25s ease;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }

  @keyframes icon-picker-slide-up {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Header */
  .icon-picker-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-title {
    font-size: 18px;
    font-weight: 600;
    color: ${d.primary};
    margin: 0;
  }

  /* Search */
  .icon-picker-search {
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
    position: relative;
  }

  .icon-picker-search-icon {
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
    color: ${d.gray_medium};
  }

  .icon-picker-search-input {
    width: 100%;
    padding: 12px 16px 12px 44px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.bg_light};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-search-input:focus {
    border-color: ${d.blue};
    background: ${d.white};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  .icon-picker-search-input::placeholder {
    color: ${d.gray_medium};
  }

  /* Tabs */
  .icon-picker-tabs {
    display: flex;
    padding: 0 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-tab {
    padding: 14px 20px;
    border: none;
    background: transparent;
    font-size: 13px;
    font-weight: 500;
    color: ${d.gray_medium};
    cursor: pointer;
    position: relative;
    transition: color 0.15s ease;
  }

  .icon-picker-tab:hover {
    color: ${d.primary};
  }

  .icon-picker-tab.active {
    color: ${d.primary};
  }

  .icon-picker-tab.active::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background: ${d.primary};
    border-radius: 2px 2px 0 0;
  }

  /* Content */
  .icon-picker-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
  }

  .icon-picker-description {
    font-size: 13px;
    color: ${d.gray_medium};
    padding: 16px 24px 8px;
    margin: 0;
    line-height: 1.5;
  }

  /* Category Filter */
  .icon-picker-categories {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px 24px;
    border-bottom: 1px solid ${d.border_glass};
  }

  .icon-picker-category-btn {
    padding: 6px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 20px;
    background: ${d.white};
    font-size: 12px;
    font-weight: 500;
    color: ${d.gray_dark};
    cursor: pointer;
    transition: all 0.15s ease;
  }

  .icon-picker-category-btn:hover {
    border-color: ${d.blue};
    color: ${d.blue};
  }

  .icon-picker-category-btn.active {
    background: ${d.primary};
    border-color: ${d.primary};
    color: ${d.white};
  }

  /* Icons Container */
  .icon-picker-icons-container {
    padding: 16px 24px;
  }

  .icon-picker-category-section {
    margin-bottom: 24px;
  }

  .icon-picker-category-section:last-child {
    margin-bottom: 0;
  }

  .icon-picker-category-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${d.gray_medium};
    margin: 0 0 12px 0;
  }

  /* Icons Grid */
  .icon-picker-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(52px, 1fr));
    gap: 8px;
  }

  .icon-picker-icon-item {
    position: relative;
    width: 52px;
    height: 52px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.15s ease;
    background: ${d.white};
  }

  .icon-picker-icon-item:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
    transform: scale(1.05);
  }

  .icon-picker-icon-item.selected {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.08);
    box-shadow: 0 0 0 2px rgba(85, 114, 183, 0.2);
  }

  .icon-picker-icon-preview {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }

  .icon-picker-icon-check {
    position: absolute;
    top: -6px;
    right: -6px;
    width: 18px;
    height: 18px;
    background: ${d.blue};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${d.white};
  }

  .icon-picker-empty {
    text-align: center;
    padding: 48px 24px;
    color: ${d.gray_medium};
  }

  /* Selected Icon Info */
  .icon-picker-selected-info {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 24px;
    background: ${d.bg_light};
    border-top: 1px solid ${d.border_glass};
  }

  .icon-picker-selected-preview {
    width: 32px;
    height: 32px;
    object-fit: contain;
  }

  .icon-picker-selected-name {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  /* Upload Tab */
  .icon-picker-upload {
    padding: 16px 24px;
  }

  .icon-picker-upload-zone {
    border: 2px dashed ${d.gray_border};
    border-radius: 12px;
    padding: 48px 24px;
    text-align: center;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }

  .icon-picker-upload-zone:hover {
    border-color: ${d.blue};
    background: rgba(85, 114, 183, 0.04);
  }

  .icon-picker-upload-icon {
    color: ${d.gray_medium};
  }

  .icon-picker-upload-text {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
  }

  .icon-picker-upload-hint {
    font-size: 12px;
    color: ${d.gray_medium};
  }

  .icon-picker-upload-preview {
    margin-top: 16px;
  }

  .icon-picker-upload-file {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px;
    background: ${d.bg_light};
    border-radius: 10px;
    margin-bottom: 16px;
  }

  .icon-picker-image-preview {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .icon-picker-image-preview svg {
    max-width: 100%;
    max-height: 100%;
  }

  .icon-picker-image-preview img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    border-radius: 4px;
  }

  .icon-picker-upload-file-info {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .icon-picker-upload-filename {
    font-size: 14px;
    font-weight: 500;
    color: ${d.primary};
    font-family: 'SF Mono', 'Menlo', monospace;
  }

  .icon-picker-upload-name {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .icon-picker-upload-label {
    font-size: 12px;
    font-weight: 600;
    color: ${d.gray_medium};
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .icon-picker-upload-input {
    padding: 12px 14px;
    border: 1px solid ${d.border_glass};
    border-radius: 10px;
    font-size: 14px;
    color: ${d.primary};
    background: ${d.white};
    outline: none;
    transition: all 0.15s ease;
    box-sizing: border-box;
  }

  .icon-picker-upload-input:focus {
    border-color: ${d.blue};
    box-shadow: 0 0 0 3px rgba(85, 114, 183, 0.15);
  }

  /* Footer */
  .icon-picker-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 20px 24px;
    border-top: 1px solid ${d.border_glass};
    background: ${d.bg_light};
    border-radius: 0 0 16px 16px;
  }
`, kr = ({
  isOpen: e,
  onClose: o,
  onSelect: r,
  isLoading: n = !1
}) => {
  const [i, s] = O("upload"), [l, m] = O(""), [p, y] = O(null), [c, g] = O("all"), [C, w] = O(null), [k, x] = O(""), [f, B] = O(null), [P, u] = O(null), R = se(null);
  Q(() => {
    e && (s("upload"), m(""), y(null), g("all"), w(null), x(""), B(null), u(null));
  }, [e]);
  const b = ae(() => {
    let z;
    return l ? z = ms(l) : c === "all" ? z = lo : z = Cr(c), z;
  }, [l, c]), I = ae(() => {
    if (l || c !== "all")
      return {
        [c === "all" ? "results" : c]: b
      };
    const z = {};
    return fr.forEach((A) => {
      z[A] = Cr(A);
    }), z;
  }, [b, l, c]), S = (z) => {
    y({
      type: "lucide",
      name: z.name,
      url: xr(z.name)
    });
  }, v = async (z) => {
    var j;
    const A = (j = z.target.files) == null ? void 0 : j[0];
    if (A) {
      w(A);
      const Z = A.name.replace(/\.[^/.]+$/, "");
      if (x(Z), P && (URL.revokeObjectURL(P), u(null)), B(null), A.type === "image/svg+xml" || A.name.endsWith(".svg")) {
        const L = new FileReader();
        L.onload = (G) => {
          var H;
          B((H = G.target) == null ? void 0 : H.result);
        }, L.readAsText(A);
      } else
        u(URL.createObjectURL(A));
      y({
        type: "upload",
        name: Z,
        file: A
      });
    }
  }, T = (z) => {
    x(z), (p == null ? void 0 : p.type) === "upload" && C && y({
      ...p,
      name: z
    });
  }, W = () => {
    p && (r(p), o());
  }, F = n || !p || p.type === "upload" && (!C || !k.trim());
  if (!e) return null;
  const N = /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: us() }),
    /* @__PURE__ */ t("div", { className: "icon-picker-overlay", onClick: o, children: /* @__PURE__ */ h("div", { className: "icon-picker-modal", onClick: (z) => z.stopPropagation(), children: [
      /* @__PURE__ */ h("div", { className: "icon-picker-header", children: [
        /* @__PURE__ */ t("h2", { className: "icon-picker-title", children: "Select icon" }),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "icon",
            size: "sm",
            onClick: o,
            "aria-label": "Close",
            children: /* @__PURE__ */ t(Ae, { size: 20 })
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-search", children: [
        /* @__PURE__ */ t(co, { size: 16, className: "icon-picker-search-icon" }),
        /* @__PURE__ */ t(
          "input",
          {
            type: "text",
            placeholder: "Search icons...",
            value: l,
            onChange: (z) => m(z.target.value),
            className: "icon-picker-search-input",
            autoFocus: !0
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-tabs", children: [
        /* @__PURE__ */ t(
          "button",
          {
            className: `icon-picker-tab ${i === "lucide" ? "active" : ""}`,
            onClick: () => s("lucide"),
            children: "Lucide Icons"
          }
        ),
        /* @__PURE__ */ t(
          "button",
          {
            className: `icon-picker-tab ${i === "upload" ? "active" : ""}`,
            onClick: () => s("upload"),
            children: "Upload Image"
          }
        )
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-content", children: [
        i === "lucide" && /* @__PURE__ */ h(D, { children: [
          /* @__PURE__ */ h("div", { className: "icon-picker-categories", children: [
            /* @__PURE__ */ t(
              "button",
              {
                className: `icon-picker-category-btn ${c === "all" ? "active" : ""}`,
                onClick: () => g("all"),
                children: "All"
              }
            ),
            fr.map((z) => /* @__PURE__ */ t(
              "button",
              {
                className: `icon-picker-category-btn ${c === z ? "active" : ""}`,
                onClick: () => g(z),
                children: z.charAt(0).toUpperCase() + z.slice(1)
              },
              z
            ))
          ] }),
          /* @__PURE__ */ h("div", { className: "icon-picker-icons-container", children: [
            Object.entries(I).map(([z, A]) => /* @__PURE__ */ h(
              "div",
              {
                className: "icon-picker-category-section",
                children: [
                  !l && c === "all" && /* @__PURE__ */ t("h4", { className: "icon-picker-category-title", children: z.charAt(0).toUpperCase() + z.slice(1) }),
                  /* @__PURE__ */ t("div", { className: "icon-picker-grid", children: A.map((j) => /* @__PURE__ */ h(
                    "div",
                    {
                      className: `icon-picker-icon-item ${(p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === j.name ? "selected" : ""}`,
                      onClick: () => S(j),
                      title: j.name,
                      children: [
                        /* @__PURE__ */ t(
                          "img",
                          {
                            src: xr(j.name),
                            alt: j.name,
                            className: "icon-picker-icon-preview"
                          }
                        ),
                        (p == null ? void 0 : p.type) === "lucide" && (p == null ? void 0 : p.name) === j.name && /* @__PURE__ */ t("div", { className: "icon-picker-icon-check", children: /* @__PURE__ */ t(_e, { size: 12 }) })
                      ]
                    },
                    j.name
                  )) })
                ]
              },
              z
            )),
            b.length === 0 && /* @__PURE__ */ t("div", { className: "icon-picker-empty", children: /* @__PURE__ */ h("p", { children: [
              'No icons found for "',
              l,
              '"'
            ] }) })
          ] }),
          (p == null ? void 0 : p.type) === "lucide" && /* @__PURE__ */ h("div", { className: "icon-picker-selected-info", children: [
            /* @__PURE__ */ t(
              "img",
              {
                src: p.url,
                alt: p.name,
                className: "icon-picker-selected-preview"
              }
            ),
            /* @__PURE__ */ t("span", { className: "icon-picker-selected-name", children: p.name })
          ] })
        ] }),
        i === "upload" && /* @__PURE__ */ h("div", { className: "icon-picker-upload", children: [
          /* @__PURE__ */ t("p", { className: "icon-picker-description", children: "Upload your own image or icon file." }),
          /* @__PURE__ */ t(
            "input",
            {
              ref: R,
              type: "file",
              accept: ".png,.jpg,.jpeg,.gif,.webp,.svg,image/*",
              onChange: v,
              style: { display: "none" }
            }
          ),
          C ? /* @__PURE__ */ h("div", { className: "icon-picker-upload-preview", children: [
            /* @__PURE__ */ h("div", { className: "icon-picker-upload-file", children: [
              f && /* @__PURE__ */ t(
                "div",
                {
                  className: "icon-picker-image-preview",
                  dangerouslySetInnerHTML: { __html: f }
                }
              ),
              P && /* @__PURE__ */ t("div", { className: "icon-picker-image-preview", children: /* @__PURE__ */ t("img", { src: P, alt: k }) }),
              /* @__PURE__ */ h("div", { className: "icon-picker-upload-file-info", children: [
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-filename", children: C.name }),
                /* @__PURE__ */ t(
                  oe,
                  {
                    variant: "ghost",
                    size: "sm",
                    onClick: () => {
                      var z;
                      return (z = R.current) == null ? void 0 : z.click();
                    },
                    children: "Change"
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ h("div", { className: "icon-picker-upload-name", children: [
              /* @__PURE__ */ t("label", { className: "icon-picker-upload-label", children: "Image name" }),
              /* @__PURE__ */ t(
                "input",
                {
                  type: "text",
                  value: k,
                  onChange: (z) => T(z.target.value),
                  placeholder: "Enter image name",
                  className: "icon-picker-upload-input"
                }
              )
            ] })
          ] }) : /* @__PURE__ */ h(
            "div",
            {
              className: "icon-picker-upload-zone",
              onClick: () => {
                var z;
                return (z = R.current) == null ? void 0 : z.click();
              },
              children: [
                /* @__PURE__ */ t(Fr, { size: 32, className: "icon-picker-upload-icon" }),
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-text", children: "Click to upload image" }),
                /* @__PURE__ */ t("span", { className: "icon-picker-upload-hint", children: "PNG, JPG, GIF, WEBP, SVG" })
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ h("div", { className: "icon-picker-footer", children: [
        /* @__PURE__ */ t(oe, { variant: "outline", onClick: o, disabled: n, children: "Cancel" }),
        /* @__PURE__ */ t(
          oe,
          {
            variant: "primary",
            onClick: W,
            disabled: F,
            children: n ? "Adding..." : "Select"
          }
        )
      ] })
    ] }) })
  ] });
  return Le.createPortal(N, po());
}, yd = () => {
  const e = $e(), o = Ir(), [r, n] = O("checking"), [i, s] = O("desktop"), l = se(null), [m, p] = O(!1), { data: y } = ze(), c = (y == null ? void 0 : y.themeName) || e.themeId, { themeColors: g, refreshThemeColors: C } = Zo(), { themeFonts: w, refreshThemeFonts: k } = Qr(), { themeIcons: x, refreshThemeIcons: f } = Xr(), { data: B } = ze(), P = ae(() => {
    var L;
    const M = (L = B == null ? void 0 : B.studioControlledKeys) == null ? void 0 : L.colors;
    return M != null && M.length ? new Set(M) : void 0;
  }, [B]), u = ae(() => {
    var L;
    const M = (L = B == null ? void 0 : B.studioControlledKeys) == null ? void 0 : L.fonts;
    return M != null && M.length ? new Set(M) : void 0;
  }, [B]), [R, b] = O(null), [I, S] = O(!1), [v, T] = O(!1), W = (M) => {
    b((L) => L === M ? null : M);
  }, F = ps({
    themeId: e.themeId,
    editThemeToken: e.editThemeToken,
    iframeRef: r === "iframe" ? l : null,
    refreshThemeColors: C,
    refreshThemeFonts: k,
    refreshThemeIcons: f
  });
  Q(() => {
    o || Li();
  }, [o]), Q(() => Ti(() => {
    T(!0);
  }), []), Q(() => {
    if (o || !e.themeId) return;
    (async () => {
      const L = await Xn();
      n(L ? "iframe" : "inline");
    })();
  }, [o, e.themeId]), Q(() => {
    if (o || e.previewMode || !e.themeId || !e.editThemeToken) return;
    let M = !1;
    return Xi({
      themeId: e.themeId,
      editThemeToken: e.editThemeToken
    }).then((L) => {
      M || L || (bo(), fo(), window.location.reload());
    }), () => {
      M = !0;
    };
  }, [o, e.themeId, e.editThemeToken, e.previewMode, e.origin]);
  const N = pe(() => {
    var M;
    if (l.current)
      try {
        const L = new URL(
          ((M = l.current.contentWindow) == null ? void 0 : M.location.href) || ""
        ), G = new URL(window.location.href);
        G.pathname = L.pathname;
        const H = new URLSearchParams(L.search), $ = new URLSearchParams();
        e.themeId && $.set("themeId", e.themeId), e.editMode && $.set("editMode", "true"), e.editThemeToken && $.set("editThemeToken", e.editThemeToken), H.forEach((Y, q) => {
          q !== "frameMode" && q !== "themeId" && q !== "editMode" && q !== "editThemeToken" && $.set(q, Y);
        }), G.search = $.toString(), window.history.replaceState({}, "", G.toString());
      } catch (L) {
        console.debug("Could not access iframe URL (cross-origin):", L);
      }
  }, [e]);
  if (!e.themeId || o)
    return null;
  if (e.previewMode) {
    const M = () => {
      bo(), fo();
      const L = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
      window.location.href = L;
    };
    return /* @__PURE__ */ h(D, { children: [
      /* @__PURE__ */ t("style", { children: `
          body { padding-top: 60px !important; }
        ` }),
      /* @__PURE__ */ h(
        "div",
        {
          style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            height: 60,
            background: "#f5f5f7",
            borderBottom: "1px solid rgba(0,0,0,0.08)",
            display: "flex",
            alignItems: "center",
            padding: "0 20px",
            gap: 16,
            zIndex: 1000001,
            boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
          },
          children: [
            /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: 10 }, children: [
              /* @__PURE__ */ t(
                "div",
                {
                  style: {
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  },
                  children: /* @__PURE__ */ t(Fn, { size: 18, color: "white" })
                }
              ),
              /* @__PURE__ */ t("span", { style: { fontWeight: 600, fontSize: 15, color: "#1a1a2e" }, children: "Theme Preview" })
            ] }),
            /* @__PURE__ */ h("div", { style: { display: "flex", alignItems: "center", gap: 8 }, children: [
              /* @__PURE__ */ t("span", { style: { fontSize: 12, color: "#999", textTransform: "uppercase", letterSpacing: "0.5px" }, children: "Theme:" }),
              /* @__PURE__ */ t("span", { style: { fontSize: 14, fontWeight: 500, color: "#1a1a2e" }, children: c }),
              (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ h(
                "span",
                {
                  style: {
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 4,
                    fontSize: 11,
                    fontWeight: 600,
                    color: "#22c55e",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px"
                  },
                  children: [
                    /* @__PURE__ */ t(
                      "span",
                      {
                        style: {
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: "#22c55e"
                        }
                      }
                    ),
                    "Live"
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { style: { flex: 1 } }),
            /* @__PURE__ */ t(
              oe,
              {
                variant: "ghost",
                size: "sm",
                leftIcon: /* @__PURE__ */ t(yo, { size: 14 }),
                onClick: M,
                children: "Exit Preview"
              }
            )
          ]
        }
      )
    ] });
  }
  if (r === "checking")
    return /* @__PURE__ */ h(
      "div",
      {
        style: {
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          height: 60,
          background: "#f5f5f7",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 8,
          zIndex: 999999,
          fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          fontSize: 14,
          color: "#666"
        },
        children: [
          /* @__PURE__ */ t(Tn, { size: 16, className: "bc-theme-editor-spinner" }),
          /* @__PURE__ */ t("span", { children: "Initializing Theme Editor..." }),
          /* @__PURE__ */ t("style", { children: `
          @keyframes bc-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .bc-theme-editor-spinner {
            animation: bc-spin 1s linear infinite;
          }
        ` })
        ]
      }
    );
  const z = () => {
    bo(), fo();
    const M = e.origin ? decodeURIComponent(e.origin) : "https://shopperos.stackline.com/integrations/apps";
    window.location.href = M;
  }, A = () => {
    p(!m);
  }, j = async (M) => {
    await F.handleAddFont(M);
  }, Z = async (M) => {
    await F.handleAddIcon(M);
  };
  return r === "inline" ? /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: Ft({ showSettings: m, viewMode: i, editorMode: r }) }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ h("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ t("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ t(ot, { size: 18 }) }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-id", children: c }),
          (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ h("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ t("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ t("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ t(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ t(So, { size: 14 }),
              onClick: A,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ t(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ t(yo, { size: 14 }),
              onClick: z,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      m && /* @__PURE__ */ h(
        mr,
        {
          onClose: () => p(!1),
          successMessage: F.successMessage,
          error: F.error,
          children: [
            /* @__PURE__ */ t(
              ht,
              {
                themeColors: g,
                isExpanded: R === "colors",
                onToggle: () => W("colors"),
                isLoading: F.isLoading,
                isAddingColor: F.isAddingColor,
                setIsAddingColor: F.setIsAddingColor,
                newColorKey: F.newColorKey,
                setNewColorKey: F.setNewColorKey,
                newColorValue: F.newColorValue,
                setNewColorValue: F.setNewColorValue,
                onAddColor: F.handleAddColor,
                onUpdateColor: F.handleUpdateColor,
                onRenameColor: F.handleRenameColor,
                onDeleteColor: F.handleDeleteColor,
                studioLockedColorKeys: P
              }
            ),
            /* @__PURE__ */ t(
              ur,
              {
                themeFonts: w,
                isExpanded: R === "fonts",
                onToggle: () => W("fonts"),
                isLoading: F.isLoading,
                onDeleteFont: F.handleDeleteFont,
                onOpenFontPicker: () => S(!0),
                studioLockedFontKeys: u
              }
            ),
            /* @__PURE__ */ t(
              hr,
              {
                themeIcons: x,
                isExpanded: R === "icons",
                onToggle: () => W("icons"),
                isLoading: F.isLoading,
                onDeleteIcon: F.handleDeleteIcon,
                onOpenIconPicker: () => T(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t(
        br,
        {
          isOpen: I,
          onClose: () => S(!1),
          onSelect: j,
          isLoading: F.isLoading
        }
      ),
      /* @__PURE__ */ t(
        kr,
        {
          isOpen: v,
          onClose: () => T(!1),
          onSelect: Z,
          isLoading: F.isLoading
        }
      ),
      F.pendingDelete && /* @__PURE__ */ t(
        qe,
        {
          title: `Delete ${F.pendingDelete.type}`,
          message: `Are you sure you want to delete "${F.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: F.confirmDelete,
          onCancel: F.cancelDelete,
          isLoading: F.isLoading
        }
      )
    ] })
  ] }) : /* @__PURE__ */ h(D, { children: [
    /* @__PURE__ */ t("style", { children: Ft({ showSettings: m, viewMode: i, editorMode: r }) }),
    /* @__PURE__ */ h("div", { className: "bc-theme-editor-shell", children: [
      /* @__PURE__ */ h("div", { className: "bc-theme-editor-topbar", children: [
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-logo", children: [
          /* @__PURE__ */ t("div", { className: "bc-theme-editor-logo-icon", children: /* @__PURE__ */ t(ot, { size: 18 }) }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-logo-text", children: "Theme Editor" })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-theme-info", children: [
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-label", children: "Theme:" }),
          /* @__PURE__ */ t("span", { className: "bc-theme-editor-theme-id", children: c }),
          (y == null ? void 0 : y.isPublished) && /* @__PURE__ */ h("span", { className: "bc-theme-editor-live-indicator", children: [
            /* @__PURE__ */ t("span", { className: "bc-theme-editor-live-dot" }),
            "Live"
          ] })
        ] }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-viewport-toggle", children: [
          /* @__PURE__ */ t(
            oe,
            {
              variant: i === "desktop" ? "primary" : "icon",
              size: "sm",
              onClick: () => s("desktop"),
              "aria-label": "Desktop view",
              children: /* @__PURE__ */ t(Sr, { size: 16 })
            }
          ),
          /* @__PURE__ */ t(
            oe,
            {
              variant: i === "mobile" ? "primary" : "icon",
              size: "sm",
              onClick: () => s("mobile"),
              "aria-label": "Mobile view",
              children: /* @__PURE__ */ t(zr, { size: 16 })
            }
          )
        ] }),
        /* @__PURE__ */ t("div", { className: "bc-theme-editor-spacer" }),
        /* @__PURE__ */ h("div", { className: "bc-theme-editor-actions", children: [
          /* @__PURE__ */ t(
            oe,
            {
              variant: "outline",
              size: "sm",
              pill: !0,
              leftIcon: /* @__PURE__ */ t(So, { size: 14 }),
              onClick: A,
              children: "Settings"
            }
          ),
          /* @__PURE__ */ t(
            oe,
            {
              variant: "ghost",
              size: "sm",
              leftIcon: /* @__PURE__ */ t(yo, { size: 14 }),
              onClick: z,
              children: "Exit Theme"
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ t("div", { className: "bc-theme-editor-preview", children: /* @__PURE__ */ t("div", { className: "bc-theme-editor-preview-container", children: /* @__PURE__ */ t("div", { className: "bc-theme-editor-iframe-wrapper", children: /* @__PURE__ */ t(
        "iframe",
        {
          ref: l,
          className: "bc-theme-editor-iframe",
          src: window.location.href,
          onLoad: N,
          title: "Theme Preview"
        }
      ) }) }) }),
      m && /* @__PURE__ */ h(
        mr,
        {
          onClose: () => p(!1),
          successMessage: F.successMessage,
          error: F.error,
          children: [
            /* @__PURE__ */ t(
              ht,
              {
                themeColors: g,
                isExpanded: R === "colors",
                onToggle: () => W("colors"),
                isLoading: F.isLoading,
                isAddingColor: F.isAddingColor,
                setIsAddingColor: F.setIsAddingColor,
                newColorKey: F.newColorKey,
                setNewColorKey: F.setNewColorKey,
                newColorValue: F.newColorValue,
                setNewColorValue: F.setNewColorValue,
                onAddColor: F.handleAddColor,
                onUpdateColor: F.handleUpdateColor,
                onRenameColor: F.handleRenameColor,
                onDeleteColor: F.handleDeleteColor
              }
            ),
            /* @__PURE__ */ t(
              ur,
              {
                themeFonts: w,
                isExpanded: R === "fonts",
                onToggle: () => W("fonts"),
                isLoading: F.isLoading,
                onDeleteFont: F.handleDeleteFont,
                onOpenFontPicker: () => S(!0)
              }
            ),
            /* @__PURE__ */ t(
              hr,
              {
                themeIcons: x,
                isExpanded: R === "icons",
                onToggle: () => W("icons"),
                isLoading: F.isLoading,
                onDeleteIcon: F.handleDeleteIcon,
                onOpenIconPicker: () => T(!0)
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ t(
        br,
        {
          isOpen: I,
          onClose: () => S(!1),
          onSelect: j,
          isLoading: F.isLoading
        }
      ),
      /* @__PURE__ */ t(
        kr,
        {
          isOpen: v,
          onClose: () => T(!1),
          onSelect: Z,
          isLoading: F.isLoading
        }
      ),
      F.pendingDelete && /* @__PURE__ */ t(
        qe,
        {
          title: `Delete ${F.pendingDelete.type}`,
          message: `Are you sure you want to delete "${F.pendingDelete.key}"? This action cannot be undone.`,
          confirmLabel: "Delete",
          cancelLabel: "Cancel",
          onConfirm: F.confirmDelete,
          onCancel: F.cancelDelete,
          isLoading: F.isLoading
        }
      )
    ] })
  ] });
};
export {
  oe as Button,
  nd as BuyBoxWidget,
  Zs as ChainOfThoughtWidget,
  Ts as ChatInput,
  Ns as ConciergeHeaderWidget,
  qs as ConciergeHomeBrandLabelWidget,
  Ks as ConciergeHomeGreetingWidget,
  Vs as ConciergeHomeLayoutWidget,
  _s as ConciergeHomeLogoWidget,
  td as ConciergeHomeMobileNavWidget,
  od as ConciergeHomeStartersWidget,
  ed as ConciergeHomeSubtitleWidget,
  Qs as ConciergePanelWidget,
  Os as ConciergeSidebarWidget,
  Js as ConfirmActionDialogWidget,
  As as ConversationStartersWidget,
  sd as DailyDealsWidget,
  Es as ELEMENT_GROUPS,
  Lr as EditPanel,
  id as FeaturedProductWidget,
  Ds as FloatingButtonWidget,
  Hs as FollowUpQueriesWidget,
  Ls as HeaderWidget,
  ol as LAYOUT_PRESETS,
  Us as LoginWallWidget,
  Ms as MessageBubbleWidget,
  tl as PRESET_LABELS,
  rd as ProductCardCarouselWidget,
  gd as ProductComparisonWidget,
  ld as PurchaseHistoryWidget,
  hd as RetailerIconWidget,
  pd as RewardOpportunitiesWidget,
  ud as RewardPillWidget,
  Rs as SearchPanelWidget,
  $s as SearchQueryPillWidget,
  ad as StoreLocatorWidget,
  Ys as SuggestionListWidget,
  cd as SurveyCard,
  dd as SurveysWidget,
  md as TextBox,
  yd as ThemeManager,
  Gs as TrendingCardWidget,
  Ws as TypingIndicatorWidget,
  Xs as VariantPickerWidget,
  He as WIDGET_THEME_QUERY_KEY,
  js as WelcomeScreenWidget,
  Ni as WidgetEditSuppressProvider,
  J as WidgetWrapper,
  vs as calculateRewardPercent,
  bo as clearThemeParams,
  fo as clearUrlParams,
  d as colors,
  Ie as customColor,
  Ka as defaultLoginWallState,
  Cs as formatDate,
  xs as formatMoney,
  ks as formatRelativeTime,
  ws as getFontWeightValue,
  Hi as getThemeParams,
  wi as isColorValue,
  Ri as saveThemeParams,
  Ss as slugify,
  Li as syncUrlToStorage,
  a as themeColor,
  Bs as truncateText,
  zs as updateUrlParams,
  Jo as useEditMode,
  Ps as useResolveColor,
  Is as useStudioAgentName,
  Fs as useStudioAvailability,
  Zo as useThemeColors,
  Qr as useThemeFonts,
  Xr as useThemeIcons,
  ea as useWidgetConfig,
  Eo as useWidgetEdit,
  Oi as useWidgetEditSuppressed,
  _ as useWidgetEditable,
  ze as useWidgetTheme,
  $e as useWidgetThemeParams
};
//# sourceMappingURL=index.js.map
